import { gql } from '@apollo/client';
import * as Apollo from 'src/api/apolloPatched';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  Decimal: string;
  GenericScalar: any;
  JSONString: any;
  MultiPolygon: Array<Array<Array<Array<number>>>>;
  Time: any;
};

export type AchAccountInput = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: PaymentMethodAccountType;
  routingNumber: Scalars['String'];
};

export type AchAccountNode = Node & {
  __typename: 'ACHAccountNode';
  accountNumber: Scalars['String'];
  bankName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  status: Maybe<AchStatus>;
};

export type ApBlockNode = Node & {
  __typename: 'APBlockNode';
  blockedBy: UserNode;
  blockedEntity: BlockedEntity;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  reason: Maybe<Scalars['String']>;
};

export type ApBlockNodeConnection = {
  __typename: 'APBlockNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApBlockNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `APBlockNode` and its cursor. */
export type ApBlockNodeEdge = {
  __typename: 'APBlockNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ApBlockNode>;
};

export type AcceptRequestForQuoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dispatchRequestId: Scalars['ID'];
};

export type AcceptRequestForQuotePayload = {
  __typename: 'AcceptRequestForQuotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export enum AccountType {
  Client = 'CLIENT',
  ControlCenter = 'CONTROL_CENTER',
  Coordinator = 'COORDINATOR',
  Independent = 'INDEPENDENT',
  Vendor = 'VENDOR'
}

export enum AchStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Restricted = 'RESTRICTED',
  Verified = 'VERIFIED'
}

export type ActivateMaintenancePlanMutation = {
  __typename: 'ActivateMaintenancePlanMutation';
  ok: Scalars['Boolean'];
};

export type ActivatePreventitiveMaintenanceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  maintenancePlanId: Scalars['ID'];
};

export type ActivatePreventitiveMaintenanceMutationPayload = {
  __typename: 'ActivatePreventitiveMaintenanceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type Activity = {
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  id: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type ActivityConnection = {
  __typename: 'ActivityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `Activity` and its cursor. */
export type ActivityEdge = {
  __typename: 'ActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<Activity>;
};

/** An enumeration. */
export enum ActivityFeedEntryEntryType {
  /** Ai Call Ended */
  AiCallEnded = 'AI_CALL_ENDED',
  /** Ap Batch Updated */
  ApBatchUpdated = 'AP_BATCH_UPDATED',
  /** Callback Changed */
  CallbackChanged = 'CALLBACK_CHANGED',
  /** Cancelled To Reassign Vendor */
  CancelledToReassignVendor = 'CANCELLED_TO_REASSIGN_VENDOR',
  /** Client Adjustment Invoice Created */
  ClientAdjustmentInvoiceCreated = 'CLIENT_ADJUSTMENT_INVOICE_CREATED',
  /** Client Invoice Created */
  ClientInvoiceCreated = 'CLIENT_INVOICE_CREATED',
  /** Created To Reassign Vendor */
  CreatedToReassignVendor = 'CREATED_TO_REASSIGN_VENDOR',
  /** Work Order Client Rejected */
  EntryTypeWorkOrderClientRejected = 'ENTRY_TYPE_WORK_ORDER_CLIENT_REJECTED',
  /** Equipment Changed */
  EquipmentChanged = 'EQUIPMENT_CHANGED',
  /** Invoice Confirmed */
  InvoiceConfirmed = 'INVOICE_CONFIRMED',
  /** Invoice Paid */
  InvoicePaid = 'INVOICE_PAID',
  /** Inbound Vendor Invoice Created */
  InvoiceVendorInvoiceCreated = 'INVOICE_VENDOR_INVOICE_CREATED',
  /** Inbound Vendor Invoice Deleted */
  InvoiceVendorInvoiceDeleted = 'INVOICE_VENDOR_INVOICE_DELETED',
  /** Miscellaneous Hold Fulfilled */
  MiscellaneousHoldFulfilled = 'MISCELLANEOUS_HOLD_FULFILLED',
  /** Parts Update Requested */
  PartsUpdateRequested = 'PARTS_UPDATE_REQUESTED',
  /** Payment Failed */
  PaymentFailed = 'PAYMENT_FAILED',
  /** Payment Initiated */
  PaymentInitiated = 'PAYMENT_INITIATED',
  /** Payment Refunded */
  PaymentRefunded = 'PAYMENT_REFUNDED',
  /** Post Sourcing Parts Updated */
  PostSourcingPartsUpdated = 'POST_SOURCING_PARTS_UPDATED',
  /** Quote Approved */
  QuoteApproved = 'QUOTE_APPROVED',
  /** Quote Feedback Submitted */
  QuoteFeedbackSubmitted = 'QUOTE_FEEDBACK_SUBMITTED',
  /** Quote Published */
  QuotePublished = 'QUOTE_PUBLISHED',
  /** Quote Rejected */
  QuoteRejected = 'QUOTE_REJECTED',
  /** Quote Removed */
  QuoteRemoved = 'QUOTE_REMOVED',
  /** Quote Selected */
  QuoteSelected = 'QUOTE_SELECTED',
  /** Quote Set Cancelled */
  QuoteSetCancelled = 'QUOTE_SET_CANCELLED',
  /** Quote Set Rejected */
  QuoteSetRejected = 'QUOTE_SET_REJECTED',
  /** Quote Set Reset */
  QuoteSetReset = 'QUOTE_SET_RESET',
  /** Quote Spend Approved */
  QuoteSpendApproved = 'QUOTE_SPEND_APPROVED',
  /** Quote Step Approved */
  QuoteStepApproved = 'QUOTE_STEP_APPROVED',
  /** Quote Uploaded */
  QuoteUploaded = 'QUOTE_UPLOADED',
  /** Record Of Work Created */
  RecordOfWorkCreated = 'RECORD_OF_WORK_CREATED',
  /** Record Of Work Deleted */
  RecordOfWorkDeleted = 'RECORD_OF_WORK_DELETED',
  /** Record Of Work Unapproved */
  RecordOfWorkUnapproved = 'RECORD_OF_WORK_UNAPPROVED',
  /** Resq Review Started */
  ResqReviewStarted = 'RESQ_REVIEW_STARTED',
  /** Scheduling Request Fulfilled */
  SchedulingRequestFulfilled = 'SCHEDULING_REQUEST_FULFILLED',
  /** Sourcing Parts Eta Set */
  SourcingPartsEtaSet = 'SOURCING_PARTS_ETA_SET',
  /** Sourcing Parts Fulfilled */
  SourcingPartsFulfilled = 'SOURCING_PARTS_FULFILLED',
  /** Team Member Assignment Marked As Completed */
  TeamMemberAssignmentMarkedAsCompleted = 'TEAM_MEMBER_ASSIGNMENT_MARKED_AS_COMPLETED',
  /** Team Member Assignment Marked As Unresolved */
  TeamMemberAssignmentMarkedAsUnresolved = 'TEAM_MEMBER_ASSIGNMENT_MARKED_AS_UNRESOLVED',
  /** Under Warranty Changed */
  UnderWarrantyChanged = 'UNDER_WARRANTY_CHANGED',
  /** Vendor Assigned */
  VendorAssignedToWorkOrder = 'VENDOR_ASSIGNED_TO_WORK_ORDER',
  /** Vendor Dispatch Cancelled */
  VendorDispatchCancelled = 'VENDOR_DISPATCH_CANCELLED',
  /** Vendor Dispatch Expired */
  VendorDispatchExpired = 'VENDOR_DISPATCH_EXPIRED',
  /** Vendor Dispatch Request Declined */
  VendorDispatchRequestDeclined = 'VENDOR_DISPATCH_REQUEST_DECLINED',
  /** Vendor Dispatch Request Expired */
  VendorDispatchRequestExpired = 'VENDOR_DISPATCH_REQUEST_EXPIRED',
  /** Vendor Dispatch Request Started */
  VendorDispatchRequestStarted = 'VENDOR_DISPATCH_REQUEST_STARTED',
  /** Vendor Dispatch Reset */
  VendorDispatchReset = 'VENDOR_DISPATCH_RESET',
  /** Vendor Dispatch Started */
  VendorDispatchStarted = 'VENDOR_DISPATCH_STARTED',
  /** Vendor Dispatch Started Automatically */
  VendorDispatchStartedAutomatically = 'VENDOR_DISPATCH_STARTED_AUTOMATICALLY',
  /** Vendor Flagged Invoice Expired */
  VendorFlaggedInvoiceExpired = 'VENDOR_FLAGGED_INVOICE_EXPIRED',
  /** Vendor Invoice Dispute Resolved */
  VendorInvoiceDisputeResolved = 'VENDOR_INVOICE_DISPUTE_RESOLVED',
  /** Vendor Invoice Submitted */
  VendorInvoiceSubmitted = 'VENDOR_INVOICE_SUBMITTED',
  /** Visit Ended With Next Visit Required */
  VisitEndedWithNextVisitRequired = 'VISIT_ENDED_WITH_NEXT_VISIT_REQUIRED',
  /** Visit Ended With Scheduling Required */
  VisitEndedWithSchedulingRequired = 'VISIT_ENDED_WITH_SCHEDULING_REQUIRED',
  /** Work Order Assigned */
  WorkOrderAssigned = 'WORK_ORDER_ASSIGNED',
  /** Work Order Assigned To Ops Owner */
  WorkOrderAssignedToOpsOwner = 'WORK_ORDER_ASSIGNED_TO_OPS_OWNER',
  /** Work Order Assigned To Team Member */
  WorkOrderAssignedToTeamMember = 'WORK_ORDER_ASSIGNED_TO_TEAM_MEMBER',
  /** Work Order Attributes Changed */
  WorkOrderAttributesChanged = 'WORK_ORDER_ATTRIBUTES_CHANGED',
  /** Work Order Cancelled */
  WorkOrderCancelled = 'WORK_ORDER_CANCELLED',
  /** Work Order Client Invoices Approved */
  WorkOrderClientInvoicesApproved = 'WORK_ORDER_CLIENT_INVOICES_APPROVED',
  /** Work Order Completed */
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
  /** Work Order Created */
  WorkOrderCreated = 'WORK_ORDER_CREATED',
  /** Work Order Disputed */
  WorkOrderDisputed = 'WORK_ORDER_DISPUTED',
  /** Work Order Dispute Resolved */
  WorkOrderDisputeResolved = 'WORK_ORDER_DISPUTE_RESOLVED',
  /** Work Order Escalation Created */
  WorkOrderEscalationCreated = 'WORK_ORDER_ESCALATION_CREATED',
  /** Work Order Escalation Resolved */
  WorkOrderEscalationResolved = 'WORK_ORDER_ESCALATION_RESOLVED',
  /** Work Order Flagged */
  WorkOrderFlagged = 'WORK_ORDER_FLAGGED',
  /** Work Order Internally Disputed */
  WorkOrderInternallyDisputed = 'WORK_ORDER_INTERNALLY_DISPUTED',
  /** Work Order Internal Dispute Resolved */
  WorkOrderInternalDisputeResolved = 'WORK_ORDER_INTERNAL_DISPUTE_RESOLVED',
  /** Work Order Moved Back To Awaiting Completion */
  WorkOrderMovedBackToAwaitingCompletion = 'WORK_ORDER_MOVED_BACK_TO_AWAITING_COMPLETION',
  /** Work Order Nte Updated */
  WorkOrderNteUpdated = 'WORK_ORDER_NTE_UPDATED',
  /** Work Order Overtime Approval Removed */
  WorkOrderOvertimeApprovalRemoved = 'WORK_ORDER_OVERTIME_APPROVAL_REMOVED',
  /** Work Order Overtime Approved */
  WorkOrderOvertimeApproved = 'WORK_ORDER_OVERTIME_APPROVED',
  /** Work Order Paid In Full */
  WorkOrderPaidInFull = 'WORK_ORDER_PAID_IN_FULL',
  /** Work Order Placed On Hold */
  WorkOrderPlacedOnHold = 'WORK_ORDER_PLACED_ON_HOLD',
  /** Work Order Point Of Contact Changed */
  WorkOrderPointOfContactChanged = 'WORK_ORDER_POINT_OF_CONTACT_CHANGED',
  /** Work Order Reassigned To Team Member */
  WorkOrderReassignedToTeamMember = 'WORK_ORDER_REASSIGNED_TO_TEAM_MEMBER',
  /** Work Order Rejected */
  WorkOrderRejected = 'WORK_ORDER_REJECTED',
  /** Work Order Removed From Hold */
  WorkOrderRemovedFromHold = 'WORK_ORDER_REMOVED_FROM_HOLD',
  /** Work Order Rescheduled */
  WorkOrderRescheduled = 'WORK_ORDER_RESCHEDULED',
  /** Work Order Scheduled */
  WorkOrderScheduled = 'WORK_ORDER_SCHEDULED',
  /** Work Order Sent For Triage */
  WorkOrderSentForTriage = 'WORK_ORDER_SENT_FOR_TRIAGE',
  /** Work Order Status Update Created */
  WorkOrderStatusUpdateCreated = 'WORK_ORDER_STATUS_UPDATE_CREATED',
  /** Work Order Submitted */
  WorkOrderSubmitted = 'WORK_ORDER_SUBMITTED',
  /** Work Order Tech Reassigned */
  WorkOrderTechReassigned = 'WORK_ORDER_TECH_REASSIGNED',
  /** Work Order Unassigned */
  WorkOrderUnassigned = 'WORK_ORDER_UNASSIGNED',
  /** Work Order Uncancelled */
  WorkOrderUncancelled = 'WORK_ORDER_UNCANCELLED'
}

export type ActivityFeedEntryNode = Node & {
  __typename: 'ActivityFeedEntryNode';
  activityDate: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  defaultMessage: Scalars['String'];
  entryType: ActivityFeedEntryEntryType;
  /** The ID of the object */
  id: Scalars['ID'];
  parameters: Scalars['JSONString'];
  triggeredBy: UserNode;
  visibleToClient: Scalars['Boolean'];
};

export type ActivityFeedEntryNodeConnection = {
  __typename: 'ActivityFeedEntryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivityFeedEntryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ActivityFeedEntryNode` and its cursor. */
export type ActivityFeedEntryNodeEdge = {
  __typename: 'ActivityFeedEntryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ActivityFeedEntryNode>;
};

/** An enumeration. */
export enum ActivityType {
  Appointment = 'APPOINTMENT',
  ApproveQuote = 'APPROVE_QUOTE',
  ChooseVendor = 'CHOOSE_VENDOR',
  CreateQuote = 'CREATE_QUOTE',
  Dispatch = 'DISPATCH',
  FindingQuote = 'FINDING_QUOTE',
  FindingVendor = 'FINDING_VENDOR',
  OnHold = 'ON_HOLD',
  ResqReview = 'RESQ_REVIEW',
  Scheduling = 'SCHEDULING',
  SiteVisit = 'SITE_VISIT',
  SourcingParts = 'SOURCING_PARTS'
}

export type AddAfterImagesToVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  images: Array<Scalars['String']>;
  visit: Scalars['ID'];
};

export type AddAfterImagesToVisitPayload = {
  __typename: 'AddAfterImagesToVisitPayload';
  clientMutationId: Maybe<Scalars['String']>;
  visit: VisitNode;
};

export type AddAttachmentMutation = {
  __typename: 'AddAttachmentMutation';
  attachment: AttachmentNode;
};

export type AddBarcodeMutationInput = {
  attachToId: Scalars['ID'];
  barcode: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AddBarcodeMutationPayload = {
  __typename: 'AddBarcodeMutationPayload';
  barcode: BarcodeNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type AddBeforeImagesToVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  images: Array<Scalars['String']>;
  visit: Scalars['ID'];
};

export type AddBeforeImagesToVisitPayload = {
  __typename: 'AddBeforeImagesToVisitPayload';
  clientMutationId: Maybe<Scalars['String']>;
  visit: VisitNode;
};

export type AddClientOrganizationMutation = {
  __typename: 'AddClientOrganizationMutation';
  clientOrganization: ClientOrganizationNode;
};

export type AddEquipmentMutation = {
  __typename: 'AddEquipmentMutation';
  equipment: EquipmentNode;
  ok: Scalars['Boolean'];
};

export type AddExistingUserToClientOrganizationMutation = {
  __typename: 'AddExistingUserToClientOrganizationMutation';
  ok: Scalars['Boolean'];
};

export type AddExistingUserToVendorMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleIds: Array<Scalars['ID']>;
  username: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddExistingUserToVendorMutationPayload = {
  __typename: 'AddExistingUserToVendorMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type AddExternalExpenseMutationInput = {
  allocatedAmount: Scalars['Decimal'];
  attachmentFileType?: InputMaybe<Scalars['String']>;
  attachmentLabel?: InputMaybe<Scalars['String']>;
  budgetId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  expenseDate: Scalars['Date'];
  expenseType: ExpenseType;
  facilityId?: InputMaybe<Scalars['ID']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  uploadedFileUrl?: InputMaybe<Scalars['String']>;
};

export type AddExternalExpenseMutationPayload = {
  __typename: 'AddExternalExpenseMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  externalExpense: SpendItemAllocationNode;
};

export type AddImageToWorkOrderMutation = {
  __typename: 'AddImageToWorkOrderMutation';
  ok: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export type AddNewUserToClientOrganizationMutation = {
  __typename: 'AddNewUserToClientOrganizationMutation';
  ok: Scalars['Boolean'];
};

export type AddNewUserToVendorArguments = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  roleIds: Array<Scalars['ID']>;
  username: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddNewUserToVendorMutation = {
  __typename: 'AddNewUserToVendorMutation';
  ok: Scalars['Boolean'];
};

export type AddOwnerToClientOrganizationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  username: Scalars['String'];
};

export type AddOwnerToClientOrganizationMutationPayload = {
  __typename: 'AddOwnerToClientOrganizationMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type AddressNode = Node & {
  __typename: 'AddressNode';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
};

export type AddressValidation = {
  __typename: 'AddressValidation';
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  formattedAddress: Maybe<Scalars['String']>;
  province: Maybe<Scalars['String']>;
  /** Components that have been spell checked with corrected values */
  spellCheckedComponents: Maybe<Array<Maybe<SpellCheckedAddressComponent>>>;
  /** List of unconfirmed address components */
  unconfirmedComponents: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum AfterHoursDispatchSetting {
  Accepts = 'ACCEPTS',
  DoesNotAccept = 'DOES_NOT_ACCEPT'
}

export type AgreeVendorTosInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AgreeVendorTosPayload = {
  __typename: 'AgreeVendorTOSPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorTosAgreement: VendorTosAgreementNode;
};

export type Alert = {
  __typename: 'Alert';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  incident: Incident;
  rawData: Array<AlertDataRow>;
  sent: Scalars['Boolean'];
  updatedAt: Maybe<Scalars['DateTime']>;
  value: Scalars['Float'];
};

export type AlertDataRow = {
  __typename: 'AlertDataRow';
  timestamp: Scalars['DateTime'];
  value: Scalars['Float'];
};

export enum AllocationCanActions {
  ChangeExpenseType = 'CHANGE_EXPENSE_TYPE'
}

export type AllocationNode = Node & {
  __typename: 'AllocationNode';
  allocationType: AllocationType;
  amount: Maybe<Scalars['Decimal']>;
  attachment: Maybe<AttachmentNode>;
  can: Scalars['Boolean'];
  category: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  expenseType: ExpenseType;
  facilityName: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoice: Maybe<ClientInvoiceNode>;
  submittedDate: Scalars['DateTime'];
  workOrder: Maybe<WorkOrderNode>;
};


export type AllocationNodeCanArgs = {
  perform: AllocationCanActions;
};

export type AllocationNodeConnection = {
  __typename: 'AllocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `AllocationNode` and its cursor. */
export type AllocationNodeEdge = {
  __typename: 'AllocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<AllocationNode>;
};

/** An enumeration. */
export enum AllocationType {
  Invoice = 'INVOICE',
  SpendItem = 'SPEND_ITEM',
  Upcoming = 'UPCOMING'
}

export type ApBatchNode = Node & {
  __typename: 'ApBatchNode';
  code: Scalars['String'];
  dueAtDate: Maybe<Scalars['Date']>;
  /** The ID of the object */
  id: Scalars['ID'];
  referenceDate: Maybe<Scalars['DateTime']>;
  referenceNumber: Maybe<Scalars['String']>;
  status: ApBatchStatus;
  totalAmount: Scalars['Decimal'];
  vendorInvoices: Array<VendorInvoiceNode>;
  vendorOrganization: VendorOrganizationNode;
};

export type ApBatchNodeConnection = {
  __typename: 'ApBatchNodeConnection';
  cadTotal: Scalars['Decimal'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApBatchNodeEdge>>;
  gbpTotal: Scalars['Decimal'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  usdTotal: Scalars['Decimal'];
};

/** A Relay edge containing a `ApBatchNode` and its cursor. */
export type ApBatchNodeEdge = {
  __typename: 'ApBatchNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ApBatchNode>;
};

/** An enumeration. */
export enum ApBatchStatus {
  Closed = 'CLOSED',
  PartiallyClosed = 'PARTIALLY_CLOSED',
  Unpaid = 'UNPAID'
}

export type AppointmentActivity = Activity & Node & {
  __typename: 'AppointmentActivity';
  activityType: ActivityType;
  appointment: AppointmentNode;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<AppointmentActivityOutcome>;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum AppointmentActivityOutcome {
  Fulfilled = 'FULFILLED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  Rescheduled = 'RESCHEDULED'
}

export type AppointmentNode = Node & {
  __typename: 'AppointmentNode';
  afterImages: Array<ImageNode>;
  beforeImages: Array<ImageNode>;
  cancelledAt: Maybe<Scalars['DateTime']>;
  endedAt: Maybe<Scalars['DateTime']>;
  endsAt: Maybe<Scalars['DateTime']>;
  facilityManagerName: Maybe<Scalars['String']>;
  fulfilledAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  otherReschedulingReason: Maybe<Scalars['String']>;
  permissions: AppointmentPermissions;
  reschedulingReason: Maybe<AppointmentReschedulingReasonType>;
  /** @deprecated Use ended_at instead, they are roughly the same. */
  signedOffAt: Maybe<Scalars['DateTime']>;
  startedAt: Maybe<Scalars['DateTime']>;
  startsAt: Maybe<Scalars['DateTime']>;
  technician: Maybe<UserNode>;
  vendor: Maybe<VendorOrganizationNode>;
  visit: Maybe<VisitNode>;
  visitedBy: Maybe<UserNode>;
  workOrder: WorkOrderNode;
};

export type AppointmentNodeConnection = {
  __typename: 'AppointmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `AppointmentNode` and its cursor. */
export type AppointmentNodeEdge = {
  __typename: 'AppointmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<AppointmentNode>;
};

export type AppointmentPermissions = {
  __typename: 'AppointmentPermissions';
  fulfill: Scalars['Boolean'];
  hold: Scalars['Boolean'];
  reschedule: Scalars['Boolean'];
};

/** An enumeration. */
export enum AppointmentReschedulingReason {
  AdjustTechnician = 'ADJUST_TECHNICIAN',
  CustomerChangeOfTime = 'CUSTOMER_CHANGE_OF_TIME',
  EarlierService = 'EARLIER_SERVICE',
  ManagerNeeded = 'MANAGER_NEEDED',
  NeedCustomerConfirmation = 'NEED_CUSTOMER_CONFIRMATION',
  Other = 'OTHER',
  PartsNotAvailable = 'PARTS_NOT_AVAILABLE',
  Reprioritized = 'REPRIORITIZED',
  StoreClosed = 'STORE_CLOSED',
  TechnicianDelay = 'TECHNICIAN_DELAY',
  VendorNoShow = 'VENDOR_NO_SHOW',
  WeatherDelay = 'WEATHER_DELAY'
}

export type AppointmentReschedulingReasonType = {
  __typename: 'AppointmentReschedulingReasonType';
  key: AppointmentReschedulingReason;
  label: Scalars['String'];
};

export type ApproveQuoteActivity = Activity & Node & {
  __typename: 'ApproveQuoteActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<ApproveQuoteActivityOutcome>;
  quoteSet: QuoteSetNode;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ApproveQuoteActivityOutcome {
  AnotherQuoteRequired = 'ANOTHER_QUOTE_REQUIRED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  PartsRequired = 'PARTS_REQUIRED',
  Rejected = 'REJECTED',
  ResqReviewRequired = 'RESQ_REVIEW_REQUIRED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type ApproveQuoteSetOptionForSpendInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteSetOptionId: Scalars['ID'];
};

export type ApproveQuoteSetOptionForSpendPayload = {
  __typename: 'ApproveQuoteSetOptionForSpendPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

/** Approves a record of work for invoicing. */
export type ApproveRecordOfWorkMutation = {
  __typename: 'ApproveRecordOfWorkMutation';
  recordOfWork: RecordOfWorkNode;
};

export type ApproveWorkOrderClientInvoicesArguments = {
  workOrderId: Scalars['ID'];
};

export type ApproveWorkOrderClientInvoicesMutation = {
  __typename: 'ApproveWorkOrderClientInvoicesMutation';
  invoiceApproval: WorkOrderClientInvoicesApprovalNode;
  ok: Scalars['Boolean'];
};

export type ArchiveReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportTemplateId: Scalars['ID'];
};

export type ArchiveReportTemplatePayload = {
  __typename: 'ArchiveReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']>;
  reportTemplate: ReportTemplateNode;
};

export type AssignUsersToRoleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  roleId: Scalars['ID'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AssignUsersToRoleMutationPayload = {
  __typename: 'AssignUsersToRoleMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type AssignWorkOrderEscalationInput = {
  assignedUserId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  escalationId: Scalars['ID'];
};

export type AssignWorkOrderEscalationPayload = {
  __typename: 'AssignWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type AssignWorkOrderToTeamMemberInput = {
  assignedUserId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type AssignWorkOrderToTeamMemberPayload = {
  __typename: 'AssignWorkOrderToTeamMemberPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type AssociateUserTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userProfileId: Scalars['ID'];
  userTagIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AssociateUserTagsMutationPayload = {
  __typename: 'AssociateUserTagsMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  userProfile: UserProfileNode;
};

export type AttachedTo = EquipmentNode | FacilityNode;

export type AttachedUrlInput = {
  label?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AttachedUrlNode = Node & {
  __typename: 'AttachedUrlNode';
  attachedBy: UserNode;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export enum AttachmentCanActions {
  Delete = 'DELETE'
}

export type AttachmentInput = {
  file: Scalars['String'];
  fileContentType: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
};

export type AttachmentNode = Node & {
  __typename: 'AttachmentNode';
  attachedBy: UserNode;
  can: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  file: Maybe<FileType>;
  fileContentType: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  label: Scalars['String'];
  sourceUserType: SourceUserType;
  url: Scalars['String'];
};


export type AttachmentNodeCanArgs = {
  perform: AttachmentCanActions;
};

export type AttachmentNodeConnection = {
  __typename: 'AttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `AttachmentNode` and its cursor. */
export type AttachmentNodeEdge = {
  __typename: 'AttachmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<AttachmentNode>;
};

export type AvailableTimeSlotNode = {
  __typename: 'AvailableTimeSlotNode';
  date: Scalars['Date'];
  endTime: Scalars['DateTime'];
  slot: TimeSlotType;
  startTime: Scalars['DateTime'];
};

export type AvailableVendorNode = Node & {
  __typename: 'AvailableVendorNode';
  /** The ID of the object */
  id: Scalars['ID'];
  operatingAreaMatch: Scalars['Boolean'];
  vendorOrganization: VendorOrganizationNode;
};

export type AvailableVendorNodeConnection = {
  __typename: 'AvailableVendorNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AvailableVendorNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AvailableVendorNode` and its cursor. */
export type AvailableVendorNodeEdge = {
  __typename: 'AvailableVendorNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<AvailableVendorNode>;
};

export type AverageMonthlyFacilitySpend = {
  __typename: 'AverageMonthlyFacilitySpend';
  avgMpSpend: Scalars['Decimal'];
  avgRepairSpend: Scalars['Decimal'];
  date: Scalars['DateTime'];
};

export type AverageSchedulingSpeed = {
  __typename: 'AverageSchedulingSpeed';
  days: Scalars['Int'];
  hasData: Scalars['Boolean'];
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
  months: Scalars['Int'];
};

export type BankAccountNode = Node & {
  __typename: 'BankAccountNode';
  externalBankAccount: Maybe<ExternalBankAccountNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  isVerified: Scalars['Boolean'];
  status: Maybe<BankAccountStatus>;
  type: BankAccountType;
};

export type BankAccountNodeConnection = {
  __typename: 'BankAccountNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BankAccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BankAccountNode` and its cursor. */
export type BankAccountNodeEdge = {
  __typename: 'BankAccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BankAccountNode>;
};

export enum BankAccountStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Restricted = 'RESTRICTED',
  Verified = 'VERIFIED'
}

/** An enumeration. */
export enum BankAccountType {
  ExternalOrumBankAccount = 'EXTERNAL_ORUM_BANK_ACCOUNT',
  ExternalUnitBankAccount = 'EXTERNAL_UNIT_BANK_ACCOUNT',
  ExternalUnitMasterAccount = 'EXTERNAL_UNIT_MASTER_ACCOUNT',
  InternalAccount = 'INTERNAL_ACCOUNT',
  InternalUnitMasterAccount = 'INTERNAL_UNIT_MASTER_ACCOUNT'
}

export type BarcodeNode = Node & {
  __typename: 'BarcodeNode';
  attachedBy: UserNode;
  attachedTo: Maybe<AttachedTo>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type BarcodeNodeConnection = {
  __typename: 'BarcodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BarcodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BarcodeNode` and its cursor. */
export type BarcodeNodeEdge = {
  __typename: 'BarcodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BarcodeNode>;
};

export type BatchPaymentNode = Node & {
  __typename: 'BatchPaymentNode';
  amount: Scalars['Decimal'];
  chequeNumber: Maybe<Scalars['String']>;
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID'];
  memo: Maybe<Scalars['String']>;
  organization: ClientOrganizationNode;
  paymentMethod: PaymentType;
  referenceDate: Scalars['DateTime'];
  status: PaymentStatus;
};

export type BatchPaymentNodeConnection = {
  __typename: 'BatchPaymentNodeConnection';
  cadTotal: Scalars['Decimal'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BatchPaymentNodeEdge>>;
  gbpTotal: Scalars['Decimal'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  usdTotal: Scalars['Decimal'];
};

/** A Relay edge containing a `BatchPaymentNode` and its cursor. */
export type BatchPaymentNodeEdge = {
  __typename: 'BatchPaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BatchPaymentNode>;
};

export type BillingAddressNode = Node & {
  __typename: 'BillingAddressNode';
  address: Scalars['String'];
  addressLine2: Maybe<Scalars['String']>;
  city: CityNode;
  cityName: Maybe<Scalars['String']>;
  country: CountryNode;
  /** The ID of the object */
  id: Scalars['ID'];
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  province: ProvinceNode;
};

/** An enumeration. */
export enum BillingFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export type BillingInformationNode = Node & {
  __typename: 'BillingInformationNode';
  /** The time at which the autopay field of the billing information was updated. */
  autopayUpdatedAt: Maybe<Scalars['DateTime']>;
  autopayUpdatedBy: Maybe<UserNode>;
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID'];
  isAutopay: Scalars['Boolean'];
  operatingCountry: CountryNode;
  paymentTerms: Maybe<Scalars['Int']>;
};

export type BillingInformationNodeConnection = {
  __typename: 'BillingInformationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingInformationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BillingInformationNode` and its cursor. */
export type BillingInformationNodeEdge = {
  __typename: 'BillingInformationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BillingInformationNode>;
};

export type BlockApMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type BlockApMutationPayload = {
  __typename: 'BlockAPMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type BlockedEntity = VendorOrganizationNode | WorkOrderNode;

export type BrandNode = Node & {
  __typename: 'BrandNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BrandNodeConnection = {
  __typename: 'BrandNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BrandNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BrandNode` and its cursor. */
export type BrandNodeEdge = {
  __typename: 'BrandNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BrandNode>;
};

export enum BudgetCanActions {
  CreateBudget = 'CREATE_BUDGET'
}

export type BudgetConfigurationNode = Node & {
  __typename: 'BudgetConfigurationNode';
  /** The ID of the object */
  id: Scalars['ID'];
  isCapex: Scalars['Boolean'];
  isMaintenancePlan: Scalars['Boolean'];
  isOnDemand: Scalars['Boolean'];
  isOpex: Scalars['Boolean'];
  serviceCategories: Array<ServiceCategory>;
};

export type BudgetNode = Node & {
  __typename: 'BudgetNode';
  can: Scalars['Boolean'];
  capexSpentAmount: Scalars['Decimal'];
  categorySpend: Maybe<Array<ExpensePerCategorySpendData>>;
  configuration: Maybe<BudgetConfigurationNode>;
  description: Scalars['String'];
  endDate: Scalars['Date'];
  /** @deprecated Deprecated in favour of the budget configuration */
  expenseType: Maybe<ExpenseType>;
  /** The ID of the object */
  id: Scalars['ID'];
  maintenancePlanSpentAmount: Scalars['Decimal'];
  name: Scalars['String'];
  onDemandSpentAmount: Scalars['Decimal'];
  opexSpentAmount: Scalars['Decimal'];
  organizationId: Scalars['Int'];
  spentAmount: Scalars['Decimal'];
  startDate: Scalars['Date'];
  totalAmount: Scalars['Decimal'];
  unallottedAmount: Scalars['Decimal'];
  upcomingSpendAmount: Scalars['Decimal'];
};


export type BudgetNodeCanArgs = {
  perform: BudgetCanActions;
};

export type BudgetNodeConnection = {
  __typename: 'BudgetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BudgetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BudgetNode` and its cursor. */
export type BudgetNodeEdge = {
  __typename: 'BudgetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BudgetNode>;
};

export type BulkCreateFavouriteVendorConfigurationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviterName?: InputMaybe<Scalars['String']>;
  inviterNote?: InputMaybe<Scalars['String']>;
  isInherited?: InputMaybe<Scalars['Boolean']>;
  subscribeInviter?: InputMaybe<Scalars['Boolean']>;
  vendorInvites: Array<VendorInviteValues>;
};

export type BulkCreateFavouriteVendorConfigurationPayload = {
  __typename: 'BulkCreateFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type BulkDeleteFavouriteVendorConfigurationsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientVendorRelationshipId: Scalars['ID'];
};

export type BulkDeleteFavouriteVendorConfigurationsPayload = {
  __typename: 'BulkDeleteFavouriteVendorConfigurationsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum BusinessLegalStructure {
  BCorporation = 'B_CORPORATION',
  CCorporation = 'C_CORPORATION',
  LimitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
  LimitedLiabilityPartnership = 'LIMITED_LIABILITY_PARTNERSHIP',
  NonprofitCorporation = 'NONPROFIT_CORPORATION',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  SCorporation = 'S_CORPORATION'
}

export type BusinessUnitMemberNode = Node & {
  __typename: 'BusinessUnitMemberNode';
  businessUnit: BusinessUnitNode;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Shortcut for retrieving roles of user in business unit client. */
  roles: Array<RoleNode>;
  user: UserNode;
};

export type BusinessUnitNode = Node & {
  __typename: 'BusinessUnitNode';
  billingAddress: BillingAddressNode;
  client: ClientOrganizationNode;
  clientInvoices: Array<ClientInvoiceNode>;
  clientStatements: Array<ClientMonthlyStatementNode>;
  contactEmail: Maybe<Scalars['String']>;
  contactName: Maybe<Scalars['String']>;
  facilities: Array<FacilityNode>;
  facilityCount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  isEssentialsEnabled: Scalars['Boolean'];
  memberCount: Scalars['Int'];
  members: Array<BusinessUnitMemberNode>;
  name: Scalars['String'];
  nextSubscriptionSync: Maybe<Scalars['DateTime']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  pk: Scalars['Int'];
  subscriptionId: Maybe<Scalars['String']>;
  subscriptionUnitAmount: Maybe<Scalars['Int']>;
  taggingFee: Maybe<Scalars['Decimal']>;
};

export type BusinessUnitNodeConnection = {
  __typename: 'BusinessUnitNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BusinessUnitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `BusinessUnitNode` and its cursor. */
export type BusinessUnitNodeEdge = {
  __typename: 'BusinessUnitNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<BusinessUnitNode>;
};

export type CalculatedInvoiceNode = Node & {
  __typename: 'CalculatedInvoiceNode';
  clientSubtotal: Scalars['Decimal'];
  clientTaxes: Array<ClientInvoiceTaxNode>;
  clientTotal: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  lineItemTaxes: Array<CalculatedLineItemNode>;
  vendorRevShareTotal: Scalars['Decimal'];
  vendorSubtotal: Scalars['Decimal'];
  vendorTaxes: Array<VendorInvoiceTaxNode>;
  vendorTotal: Scalars['Decimal'];
};

export type CalculatedLineItemNode = Node & {
  __typename: 'CalculatedLineItemNode';
  /** The ID of the object */
  id: Scalars['ID'];
  itemType: RecordOfWorkLineItemEnum;
  order: Scalars['Int'];
  taxRates: Array<TaxRateNode>;
  vendorTaxRates: Array<TaxRateNode>;
};

export type CancelInviteMutation = {
  __typename: 'CancelInviteMutation';
  ok: Scalars['Boolean'];
};

export type CancelMaintenancePlanMutation = {
  __typename: 'CancelMaintenancePlanMutation';
  ok: Scalars['Boolean'];
};

export type CancelWorkOrderMutation = {
  __typename: 'CancelWorkOrderMutation';
  ok: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export type CaptureVisitNotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  images: Array<Image>;
  notes: Scalars['String'];
  recommendations: Scalars['String'];
  visit: Scalars['ID'];
};

export type CaptureVisitNotesPayload = {
  __typename: 'CaptureVisitNotesPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CategoryNode = Node & {
  __typename: 'CategoryNode';
  code: Scalars['String'];
  description: Scalars['String'];
  equipmentRelated: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  trades: Array<TradeNode>;
};

export type CategoryNodeConnection = {
  __typename: 'CategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoryNode` and its cursor. */
export type CategoryNodeEdge = {
  __typename: 'CategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<CategoryNode>;
};

export type ChangePasswordArguments = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  userId: Scalars['ID'];
};

export type ChangePasswordMutation = {
  __typename: 'ChangePasswordMutation';
  ok: Scalars['Boolean'];
};

export type ChargePaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  workOrderIds: Array<Scalars['ID']>;
};

export type ChargePaymentMethodPayload = {
  __typename: 'ChargePaymentMethodPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  paymentSubmittedInvoices: Maybe<Array<ClientInvoiceNode>>;
};

export type CheckUncheckWorkOrderTaskInput = {
  checked: Scalars['Boolean'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  internalRequestId: Scalars['ID'];
  taskListItemId: Scalars['ID'];
};

export type CheckUncheckWorkOrderTaskPayload = {
  __typename: 'CheckUncheckWorkOrderTaskPayload';
  clientMutationId: Maybe<Scalars['String']>;
  taskListItem: WorkOrderTaskListItemNode;
};

export type ChooseVendorActivity = Activity & Node & {
  __typename: 'ChooseVendorActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<ChooseVendorActivityOutcome>;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ChooseVendorActivityOutcome {
  Chosen = 'CHOSEN',
  Failed = 'FAILED'
}

export type CityNode = Node & {
  __typename: 'CityNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CityNodeConnection = {
  __typename: 'CityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename: 'CityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<CityNode>;
};

/** An enumeration. */
export enum ClientFeature {
  ClientRequestMpQuote = 'CLIENT_REQUEST_MP_QUOTE',
  Iyov = 'IYOV',
  NamedCsm = 'NAMED_CSM',
  ResqGuarantee = 'RESQ_GUARANTEE'
}

export type ClientInvoiceNode = Node & {
  __typename: 'ClientInvoiceNode';
  businessUnit: Maybe<BusinessUnitNode>;
  chequeNumber: Maybe<Scalars['String']>;
  clientOrganization: Maybe<ClientOrganizationNode>;
  code: Scalars['String'];
  currency: Currency;
  dueAtDate: Scalars['Date'];
  expenseType: Maybe<ExpenseType>;
  externalReferenceNumber: Maybe<Scalars['String']>;
  /** @deprecated Client invoices are no longer linked directly to a facility. If the invoice is not subscription based, facility can be found under the work_order node. */
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoicingVersion: InvoicingVersion;
  isSubscriptionInvoice: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by "issued_at_date" */
  issuedAt: Scalars['DateTime'];
  issuedAtDate: Scalars['Date'];
  /** If payment failed, the reason for the failure. */
  latestFailureReason: Maybe<Scalars['String']>;
  legacyId: Scalars['Int'];
  lineItemsSubtotal: Scalars['Decimal'];
  memo: Maybe<Scalars['String']>;
  outstandingAmount: Scalars['Decimal'];
  paidAmount: Scalars['Float'];
  paidAt: Maybe<Scalars['DateTime']>;
  paymentInitiatedAt: Maybe<Scalars['DateTime']>;
  paymentInitiatedBy: Maybe<UserNode>;
  paymentStatus: Maybe<PaymentStatus>;
  pdfUrl: Maybe<Scalars['String']>;
  status: ClientInvoiceStatus;
  subtotal: Scalars['Decimal'];
  tax: Scalars['Decimal'];
  taxes: Array<ClientInvoiceTaxNode>;
  total: Scalars['Float'];
  workOrder: Maybe<WorkOrderNode>;
};

export type ClientInvoiceNodeConnection = {
  __typename: 'ClientInvoiceNodeConnection';
  cadTotal: Scalars['Decimal'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientInvoiceNodeEdge>>;
  gbpTotal: Scalars['Decimal'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  total: Scalars['Decimal'];
  totalCount: Scalars['Int'];
  usdTotal: Scalars['Decimal'];
};

/** A Relay edge containing a `ClientInvoiceNode` and its cursor. */
export type ClientInvoiceNodeEdge = {
  __typename: 'ClientInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientInvoiceNode>;
};

export enum ClientInvoiceStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PaymentInitiated = 'PAYMENT_INITIATED',
  Unpaid = 'UNPAID'
}

export type ClientInvoiceTaxNode = Node & {
  __typename: 'ClientInvoiceTaxNode';
  /** The ID of the object */
  id: Scalars['ID'];
  taxRate: TaxRateNode;
  total: Scalars['Decimal'];
};

export type ClientMatchingProfileNode = Node & {
  __typename: 'ClientMatchingProfileNode';
  /** Indicates if their inherited vendors have been migrated to favourite vendors. This will hide all inherited vendor and dispatch preference FE for the client on both RMC and RCC if true. */
  favouriteVendorsImported: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  optedIntoMarketplace: Scalars['Boolean'];
};

export enum ClientMembershipCanActions {
  BeAssigned = 'BE_ASSIGNED',
  Manage = 'MANAGE'
}

export type ClientMetricsNode = Node & {
  __typename: 'ClientMetricsNode';
  averageMonthlyFacilitySpend: Array<AverageMonthlyFacilitySpend>;
  averageSchedulingSpeed: AverageSchedulingSpeed;
  clientId: Scalars['ID'];
  combinedSpend: Array<SpendByPeriod>;
  combinedUninvoiced: Array<UninvoicedByPeriod>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoicesAwaitingClientApproval: Scalars['Int'];
  lastMonthSpendComparison: PeriodicSpendComparison;
  mostServicedEquipment: Array<EquipmentServiceCount>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  quotesAwaitingClientApproval: Scalars['Int'];
  reviewSummary: ReviewSummary;
  serviceCategorySpend: Array<SpendByServiceCategory>;
  spendThisPeriod: Scalars['Decimal'];
  topSpendFacilities: Array<TopSpendFacilities>;
  topSpendWorkOrders: Array<TopSpendWorkOrders>;
  transactingFacilities: Scalars['Int'];
  workOrdersAwaitingPayment: WorkOrdersAwaitingPayment;
  workOrdersAwaitingTriage: Scalars['Int'];
  workOrdersByCategory: Array<ServiceCategoryCount>;
  workOrdersByStatus: WorkOrdersByStatus;
  workOrdersCompleted: Scalars['Int'];
  workOrdersSubmitted: WorkOrdersSubmitted;
};

export type ClientMonthlyStatementNode = Node & {
  __typename: 'ClientMonthlyStatementNode';
  agingReportPdfUrl: Maybe<Scalars['String']>;
  businessUnit: BusinessUnitNode;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  month: Scalars['Int'];
  outstandingAmount: Scalars['Decimal'];
  transactionSummaryCsvUrl: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type ClientMonthlyStatementNodeConnection = {
  __typename: 'ClientMonthlyStatementNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientMonthlyStatementNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientMonthlyStatementNode` and its cursor. */
export type ClientMonthlyStatementNodeEdge = {
  __typename: 'ClientMonthlyStatementNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientMonthlyStatementNode>;
};

export type ClientOrganizationMemberNode = Node & {
  __typename: 'ClientOrganizationMemberNode';
  businessUnits: Array<BusinessUnitNode>;
  can: Scalars['Boolean'];
  client: ClientOrganizationNode;
  /** The ID of the object */
  id: Scalars['ID'];
  roles: Array<RoleNode>;
  user: UserNode;
};


export type ClientOrganizationMemberNodeCanArgs = {
  perform: ClientMembershipCanActions;
};

export type ClientOrganizationMemberNodeConnection = {
  __typename: 'ClientOrganizationMemberNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientOrganizationMemberNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientOrganizationMemberNode` and its cursor. */
export type ClientOrganizationMemberNodeEdge = {
  __typename: 'ClientOrganizationMemberNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientOrganizationMemberNode>;
};

export type ClientOrganizationNode = Node & {
  __typename: 'ClientOrganizationNode';
  allDispatchRelationships: Array<DispatchRelationshipNode>;
  billingInformation: BillingInformationNode;
  businessUnits: Array<BusinessUnitNode>;
  can: Scalars['Boolean'];
  clientStatus: Maybe<ClientOrganizationStatus>;
  code: Scalars['String'];
  contractSignedOn: Maybe<Scalars['Date']>;
  facilities: Array<FacilityNode>;
  facilityGroups: Array<FacilityGroupNode>;
  /** @deprecated Deprecated in favour of roles with onlySubsetOfUser filter */
  grantableRoles: Array<RoleNode>;
  hasEssentialsFacilities: Maybe<Scalars['Boolean']>;
  hasFacilityInCore: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invites: Array<InviteNode>;
  isEnterprise: Maybe<Scalars['Boolean']>;
  isSubscriptionLive: Scalars['Boolean'];
  isSubscriptionMigrated: Scalars['Boolean'];
  matchingProfile: Maybe<ClientMatchingProfileNode>;
  members: Array<ClientOrganizationMemberNode>;
  name: Scalars['String'];
  owner: Maybe<UserNode>;
  paymentPreference: ClientPaymentPreferenceNode;
  reportingManager: Maybe<UserNode>;
  sensitivity: Maybe<Sensitivity>;
  successOwner: Maybe<UserNode>;
  tier: Maybe<ClientTier>;
  trackingId: Scalars['Int'];
};


export type ClientOrganizationNodeCanArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  perform: OrganizationCanActions;
};

export type ClientOrganizationNodeConnection = {
  __typename: 'ClientOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientOrganizationNode` and its cursor. */
export type ClientOrganizationNodeEdge = {
  __typename: 'ClientOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientOrganizationNode>;
};

/** An enumeration. */
export enum ClientOrganizationStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export type ClientPaymentPreferenceNode = Node & {
  __typename: 'ClientPaymentPreferenceNode';
  /** The ID of the object */
  id: Scalars['ID'];
  invoiceApprovalStrategy: InvoiceApprovalStrategy;
  markupPercentage: Scalars['Decimal'];
  offlinePaymentMethod: Maybe<OfflinePaymentMethods>;
  paymentMethod: PaymentMethodType;
  quoteApprovalStrategy: QuoteApprovalStrategy;
};

export type ClientPreferredSpendThresholdNode = Node & {
  __typename: 'ClientPreferredSpendThresholdNode';
  approvalRequiredOvertimeThreshold: Scalars['Int'];
  approvalRequiredThreshold: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
};

/** An enumeration. */
export enum ClientReportFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ClientReportNode = Node & {
  __typename: 'ClientReportNode';
  csvUrl: Maybe<Scalars['String']>;
  /** The end date of the range this report was generated for. */
  endDate: Scalars['Date'];
  /** The date this report was generated and sent out. */
  generatedOn: Scalars['Date'];
  /** The ID of the object */
  id: Scalars['ID'];
  reportType: ClientReportType;
  /** The start date of the range this report was generated for. */
  startDate: Scalars['Date'];
};

export type ClientReportNodeConnection = {
  __typename: 'ClientReportNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientReportNode` and its cursor. */
export type ClientReportNodeEdge = {
  __typename: 'ClientReportNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientReportNode>;
};

export type ClientReportScheduleNode = Node & {
  __typename: 'ClientReportScheduleNode';
  frequency: ClientReportFrequency;
  /** The ID of the object */
  id: Scalars['ID'];
  lastReportOn: Maybe<Scalars['Date']>;
  nextReportOn: Maybe<Scalars['Date']>;
  recipientEmailAddresses: Array<Scalars['String']>;
  reportType: ClientReportType;
};

export type ClientReportScheduleNodeConnection = {
  __typename: 'ClientReportScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientReportScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientReportScheduleNode` and its cursor. */
export type ClientReportScheduleNodeEdge = {
  __typename: 'ClientReportScheduleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientReportScheduleNode>;
};

/** An enumeration. */
export enum ClientReportType {
  TransactionSummary = 'TRANSACTION_SUMMARY',
  WorkOrderSummary = 'WORK_ORDER_SUMMARY'
}

/** An enumeration. */
export enum ClientTier {
  ClientTier_1 = 'CLIENT_TIER_1',
  ClientTier_2 = 'CLIENT_TIER_2',
  ClientTier_3 = 'CLIENT_TIER_3'
}

export type ClientVendorRelationshipMetrics = {
  __typename: 'ClientVendorRelationshipMetrics';
  categoriesServiced: Maybe<Array<ServiceCategory>>;
  facilitiesInOperatingAreaCount: Scalars['Int'];
  facilitiesInOperatingAreaWithCompletedWoCount: Scalars['Int'];
  firstJobCompletionDate: Maybe<Scalars['DateTime']>;
  maintenancePlansServicedCount: Scalars['Int'];
  satisfactionRate: SatisfactionRate;
  totalInvoicedAmount: Scalars['Decimal'];
  totalJobsCompletedCount: Scalars['Int'];
};

export type ClientVendorRelationshipNode = Node & {
  __typename: 'ClientVendorRelationshipNode';
  client: ClientOrganizationNode;
  favouriteVendorConfigurations: Maybe<Array<FavouriteVendorConfigurationNode>>;
  /** The ID of the object */
  id: Scalars['ID'];
  invite: Maybe<InviteNode>;
  invitedBy: Maybe<UserNode>;
  metrics: ClientVendorRelationshipMetrics;
  permissions: ClientVendorRelationshipPermissions;
  source: RelationshipSource;
  vendor: VendorOrganizationNode;
};


export type ClientVendorRelationshipNodeMetricsArgs = {
  metricsRangeWeeks: Scalars['Int'];
};

export type ClientVendorRelationshipNodeConnection = {
  __typename: 'ClientVendorRelationshipNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientVendorRelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ClientVendorRelationshipNode` and its cursor. */
export type ClientVendorRelationshipNodeEdge = {
  __typename: 'ClientVendorRelationshipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ClientVendorRelationshipNode>;
};

export type ClientVendorRelationshipPermissions = {
  __typename: 'ClientVendorRelationshipPermissions';
  bulkDeleteFavourites: Scalars['Boolean'];
};

export enum ClientWorkOrderStatus {
  /** @deprecated Merged with ClientWorkOrderStatus.CREATED. */
  Assigned = 'ASSIGNED',
  AssignedToTeamMember = 'ASSIGNED_TO_TEAM_MEMBER',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Rejected = 'REJECTED',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING',
  Triage = 'TRIAGE'
}

export type CommentNode = Node & {
  __typename: 'CommentNode';
  addedOn: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  user: UserNode;
  visibility: CommentVisibility;
};

export type CommentNodeConnection = {
  __typename: 'CommentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CommentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CommentNode` and its cursor. */
export type CommentNodeEdge = {
  __typename: 'CommentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<CommentNode>;
};

export enum CommentVisibility {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type CompleteBillingEntityOnboardingStepMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
};

export type CompleteBillingEntityOnboardingStepMutationPayload = {
  __typename: 'CompleteBillingEntityOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteClientOnboardingMutation = {
  __typename: 'CompleteClientOnboardingMutation';
  ok: Scalars['Boolean'];
};

export type CompleteFacilitiesOnboardingStepMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilities?: InputMaybe<Array<InputMaybe<FacilitiesOnboardingStepInput>>>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
};

export type CompleteFacilitiesOnboardingStepMutationPayload = {
  __typename: 'CompleteFacilitiesOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteGetStartedOnboardingStepMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
};

export type CompleteGetStartedOnboardingStepMutationPayload = {
  __typename: 'CompleteGetStartedOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteInternalRequestTeamMemberAssignmentInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  assignmentId: Scalars['ID'];
  checkedTaskListItems: Array<InputMaybe<Scalars['String']>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  completionDate?: InputMaybe<Scalars['Date']>;
  cost?: InputMaybe<Scalars['Float']>;
  duration: Scalars['Int'];
  incompleteTaskNotes?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<Image>>;
};

export type CompleteInternalRequestTeamMemberAssignmentPayload = {
  __typename: 'CompleteInternalRequestTeamMemberAssignmentPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type CompletePaymentInfoOnboardingStepMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
};

export type CompletePaymentInfoOnboardingStepMutationPayload = {
  __typename: 'CompletePaymentInfoOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteRatesOnboardingStepMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
  vendorPriceRates: Array<UpdateVendorPriceRateInput>;
};

export type CompleteRatesOnboardingStepMutationPayload = {
  __typename: 'CompleteRatesOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorPriceRates: Array<VendorPriceRateNode>;
};

export type CompleteStaffOnboardingStepMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
};

export type CompleteStaffOnboardingStepMutationPayload = {
  __typename: 'CompleteStaffOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteTroubleshootingSessionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  outcome: TroubleshootingSessionOutcome;
  troubleshootingActionId?: InputMaybe<Scalars['ID']>;
  troubleshootingSessionId: Scalars['ID'];
};

export type CompleteTroubleshootingSessionMutationPayload = {
  __typename: 'CompleteTroubleshootingSessionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CompleteVendorOnboardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type CompleteVendorOnboardingMutationPayload = {
  __typename: 'CompleteVendorOnboardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type CompleteWorkOrderTeamMemberAssignmentInput = {
  assignmentId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  photos: Array<Image>;
};

export type CompleteWorkOrderTeamMemberAssignmentPayload = {
  __typename: 'CompleteWorkOrderTeamMemberAssignmentPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type CompletedWorkOrdersComparison = {
  __typename: 'CompletedWorkOrdersComparison';
  current: Scalars['Int'];
  previous: Scalars['Int'];
};

export type ConfirmVendorAgreementMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type ConfirmVendorAgreementMutationPayload = {
  __typename: 'ConfirmVendorAgreementMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: VendorOrganizationNode;
};

/** An enumeration. */
export enum ContactReason {
  Cancellation = 'CANCELLATION',
  DispatchPreference = 'DISPATCH_PREFERENCE',
  IntercomLink = 'INTERCOM_LINK',
  InvoiceInquiry = 'INVOICE_INQUIRY',
  Other = 'OTHER',
  PaymentInquiry = 'PAYMENT_INQUIRY',
  QuoteInquiry = 'QUOTE_INQUIRY',
  Scheduling = 'SCHEDULING',
  ServicePartsEta = 'SERVICE_PARTS_ETA',
  TechSupport = 'TECH_SUPPORT',
  UserProfileAdjustment = 'USER_PROFILE_ADJUSTMENT',
  VendorChange = 'VENDOR_CHANGE',
  ZendeskLink = 'ZENDESK_LINK'
}

/** An enumeration. */
export enum ContactSource {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  Partner = 'PARTNER'
}

export type CoordinatorNode = Node & {
  __typename: 'CoordinatorNode';
  /** The ID of the object */
  id: Scalars['ID'];
  slackUserId: Maybe<Scalars['String']>;
  user: UserNode;
};

/** Map the full range of internal statuses into a simplified set for coordinators. */
export enum CoordinatorStatusEnum {
  AwaitingAcceptance = 'AWAITING_ACCEPTANCE',
  AwaitingAssignment = 'AWAITING_ASSIGNMENT',
  AwaitingCompletion = 'AWAITING_COMPLETION',
  AwaitingFacilityApproval = 'AWAITING_FACILITY_APPROVAL',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingRecordOfWork = 'AWAITING_RECORD_OF_WORK',
  AwaitingResqApproval = 'AWAITING_RESQ_APPROVAL',
  AwaitingScheduling = 'AWAITING_SCHEDULING',
  AwaitingVendorPayout = 'AWAITING_VENDOR_PAYOUT',
  AwaitingVmApproval = 'AWAITING_VM_APPROVAL',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  CoordinatorAll = 'COORDINATOR_ALL',
  MissingVendorInvoice = 'MISSING_VENDOR_INVOICE',
  VendorClosed = 'VENDOR_CLOSED'
}

export type CountryNode = Node & {
  __typename: 'CountryNode';
  code: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CountryNodeConnection = {
  __typename: 'CountryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CountryNode` and its cursor. */
export type CountryNodeEdge = {
  __typename: 'CountryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<CountryNode>;
};

export type CreateBudgetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  facilityGroupAllotments?: InputMaybe<Array<InputMaybe<FacilityGroupAllotmentInput>>>;
  isCapex?: InputMaybe<Scalars['Boolean']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isOnDemand?: InputMaybe<Scalars['Boolean']>;
  isOpex?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startDate: Scalars['Date'];
  total: Scalars['Decimal'];
};

export type CreateBudgetMutationPayload = {
  __typename: 'CreateBudgetMutationPayload';
  budget: Maybe<BudgetNode>;
  clientMutationId: Maybe<Scalars['String']>;
};

export type CreateBusinessUnitArguments = {
  address: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  clientId: Scalars['ID'];
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  memberUserIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  provinceId: Scalars['ID'];
  subscriptionUnitAmount: Scalars['Decimal'];
  taggingFee?: InputMaybe<Scalars['Decimal']>;
};

export type CreateBusinessUnitMutation = {
  __typename: 'CreateBusinessUnitMutation';
  businessUnit: BusinessUnitNode;
  ok: Scalars['Boolean'];
};

export type CreateCyovDispatchInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  cyovData?: InputMaybe<CyovDataInput>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']>;
  selectedVendorId?: InputMaybe<Scalars['ID']>;
  selectedVendors?: InputMaybe<Array<Scalars['ID']>>;
  workOrderId: Scalars['ID'];
};

export type CreateCyovDispatchPayload = {
  __typename: 'CreateCYOVDispatchPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorDispatch: VendorDispatchNode;
};

export type CreateClientAdjustmentInvoiceInput = {
  adjustmentAmount: Scalars['Decimal'];
  allowNegativeWorkOrder?: InputMaybe<Scalars['Boolean']>;
  applyAsDiscount?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  taxRateIds: Array<Scalars['ID']>;
  workOrderId: Scalars['ID'];
};

export type CreateClientAdjustmentInvoicePayload = {
  __typename: 'CreateClientAdjustmentInvoicePayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type CreateClientAutoAdjustmentInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']>;
  clientInvoiceId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type CreateClientAutoAdjustmentInvoiceMutationPayload = {
  __typename: 'CreateClientAutoAdjustmentInvoiceMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type CreateCommentMutation = {
  __typename: 'CreateCommentMutation';
  ok: Scalars['Boolean'];
};

export type CreateControlCenterUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  groups: Array<Scalars['ID']>;
  isInvoiceProcessor?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locale: Scalars['String'];
  phone: Scalars['String'];
  title: Scalars['String'];
  username: Scalars['String'];
};

export type CreateControlCenterUserMutationPayload = {
  __typename: 'CreateControlCenterUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  user: UserNode;
};

export type CreateCoordinatorMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  slackUserId: Scalars['String'];
};

export type CreateCoordinatorMutationPayload = {
  __typename: 'CreateCoordinatorMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  coordinator: CoordinatorNode;
};

export type CreateDeviceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  configs: Array<DeviceConfigRequestInput>;
  deviceId: Scalars['String'];
  equipmentId: Scalars['ID'];
};

export type CreateDeviceConfigsPayload = {
  __typename: 'CreateDeviceConfigsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CreateDeviceDataExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  endDate: Scalars['Date'];
  equipmentId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type CreateDeviceDataExportPayload = {
  __typename: 'CreateDeviceDataExportPayload';
  clientMutationId: Maybe<Scalars['String']>;
  exportUrl: Scalars['String'];
};

export type CreateExternalBankAccountMutation = {
  __typename: 'CreateExternalBankAccountMutation';
  externalBankAccount: ExternalBankAccountNode;
};

export type CreateFacilityGroupInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  parentId: Scalars['ID'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateFacilityGroupPayload = {
  __typename: 'CreateFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facilityGroup: FacilityGroupNode;
};

export type CreateFacilityInput = {
  address: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  busyHours?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  daysOpened?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  goliveOn?: InputMaybe<Scalars['Date']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  isSelfServe?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notReadyForOnboardingReason?: InputMaybe<NotReadyForOnboardingReasonChoice>;
  notes?: InputMaybe<Scalars['String']>;
  onboardingStatus: OnboardingStatus;
  onsiteHours?: InputMaybe<Scalars['String']>;
  openedOn?: InputMaybe<Scalars['Date']>;
  parentGroupId?: InputMaybe<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Image>;
  plannedGoLiveOn?: InputMaybe<Scalars['Date']>;
  postalCode: Scalars['String'];
  provinceId: Scalars['ID'];
  status?: InputMaybe<FacilityStatus>;
  storeNumber?: InputMaybe<Scalars['String']>;
  taggingMethod?: InputMaybe<TaggingMethod>;
  transactionFee?: InputMaybe<Scalars['Float']>;
};

export type CreateFacilityPayload = {
  __typename: 'CreateFacilityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facility: FacilityNode;
};

export type CreateFavouriteVendorConfigurationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facilityGroupIds: Array<Scalars['ID']>;
  inviterName?: InputMaybe<Scalars['String']>;
  inviterNote?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  serviceCategories: Array<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type CreateFavouriteVendorConfigurationPayload = {
  __typename: 'CreateFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  favouriteVendorConfiguration: FavouriteVendorConfigurationNode;
};

export type CreateMaintenancePlanMutation = {
  __typename: 'CreateMaintenancePlanMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean'];
};

export type CreateMarketInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  disabledCategories?: InputMaybe<Array<ServiceCategory>>;
  name: Scalars['String'];
  operatingAreaIds: Array<Scalars['ID']>;
  pricing: MarketPricingInput;
};

export type CreateMarketPayload = {
  __typename: 'CreateMarketPayload';
  clientMutationId: Maybe<Scalars['String']>;
  market: MarketNode;
};

export type CreateOffResqCustomerMutationInput = {
  address?: InputMaybe<Scalars['String']>;
  billingContactEmail?: InputMaybe<Scalars['String']>;
  billingContactFirstName?: InputMaybe<Scalars['String']>;
  billingContactLastName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  businessDateOfIncorporation?: InputMaybe<Scalars['Date']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']>;
  cityName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  facilityName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type CreateOffResqCustomerMutationPayload = {
  __typename: 'CreateOffResqCustomerMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  offResqCustomer: OffResqCustomerNode;
};

export type CreateOrUpdateBusinessUnitOnboardingMutationInput = {
  address: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  memberUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  postalCode: Scalars['String'];
  provinceId: Scalars['ID'];
  subscriptionUnitAmount: Scalars['Decimal'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateOrUpdateBusinessUnitOnboardingMutationPayload = {
  __typename: 'CreateOrUpdateBusinessUnitOnboardingMutationPayload';
  businessUnit: BusinessUnitNode;
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CreateOriginalVendorInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type CreateOriginalVendorInvoiceMutationPayload = {
  __typename: 'CreateOriginalVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CreatePaymentMethodMutationInput = {
  achAccount?: InputMaybe<AchAccountInput>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  paymentType: PaymentMethodPaymentType;
};

export type CreatePaymentMethodMutationPayload = {
  __typename: 'CreatePaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethodNode;
};

export type CreatePmOneTimeWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  preventativeMaintenanceId: Scalars['ID'];
};

export type CreatePmOneTimeWorkOrderPayload = {
  __typename: 'CreatePmOneTimeWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type CreatePreventativeMaintenanceInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  expectedDuration?: InputMaybe<Scalars['Int']>;
  facilityId: Scalars['ID'];
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  frequencyValue: Scalars['Int'];
  nextWorkOrderCreationDate: Scalars['Date'];
  recurrenceDayOfMonth?: InputMaybe<Scalars['Int']>;
  serviceCategory: ServiceCategory;
  taskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  taskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  taskListItems: Array<Scalars['String']>;
  teamMemberIds: Array<Scalars['ID']>;
  title: Scalars['String'];
};

export type CreatePreventativeMaintenancePayload = {
  __typename: 'CreatePreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type CreateQuoteActivity = Activity & Node & {
  __typename: 'CreateQuoteActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<CreateQuoteActivityOutcome>;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum CreateQuoteActivityOutcome {
  Cancelled = 'CANCELLED',
  Created = 'CREATED'
}

export type CreateQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};

export type CreateQuoteMutationPayload = {
  __typename: 'CreateQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quote: QuoteNode;
};

export type CreateQuoteSetOptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteIds: Array<Scalars['ID']>;
  quoteSetId: Scalars['ID'];
};

export type CreateQuoteSetOptionsPayload = {
  __typename: 'CreateQuoteSetOptionsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type CreateReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdById: Scalars['ID'];
  day: ReportDay;
  description?: InputMaybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  frequency?: InputMaybe<ReportFrequency>;
  interval: Scalars['Int'];
  orderBy: Scalars['String'];
  organizationId: Scalars['ID'];
  recipients?: InputMaybe<Array<Scalars['String']>>;
  reportType: ReportType;
  title: Scalars['String'];
};

export type CreateReportTemplatePayload = {
  __typename: 'CreateReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']>;
  reportTemplate: ReportTemplateNode;
};

export type CreateRoleInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
};

export type CreateRolePayload = {
  __typename: 'CreateRolePayload';
  clientMutationId: Maybe<Scalars['String']>;
  role: RoleNode;
};

export type CreateRuleViolationsFeedbackInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  isPositive: Scalars['Boolean'];
  ruleViolationsId: Scalars['ID'];
};

export type CreateRuleViolationsFeedbackPayload = {
  __typename: 'CreateRuleViolationsFeedbackPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ruleViolations: RuleViolationsNode;
};

export type CreateRuleViolationsMutationInput = {
  allowMissingMareketplacePlan?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  recordOfWorkId: Scalars['ID'];
  violations: Array<RuleBroken>;
  workOrderId: Scalars['ID'];
};

export type CreateRuleViolationsMutationPayload = {
  __typename: 'CreateRuleViolationsMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ruleViolations: RuleViolationsNode;
};

export type CreateTroubleshootingSessionMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
  isCallback?: InputMaybe<Scalars['Boolean']>;
  matchingRuleId?: InputMaybe<Scalars['ID']>;
  serviceCategory: ServiceCategory;
  symptomId?: InputMaybe<Scalars['ID']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  troubleshootingPlanId: Scalars['ID'];
};

export type CreateTroubleshootingSessionMutationPayload = {
  __typename: 'CreateTroubleshootingSessionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
  troubleshootingSession: Maybe<TroubleshootingSessionNode>;
};

export type CreateUpdateDispatchRelationshipMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupId: Scalars['ID'];
  order?: InputMaybe<Array<Scalars['ID']>>;
  relationshipId?: InputMaybe<Scalars['ID']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  status: DispatchRelationshipStatus;
  vendorId: Scalars['ID'];
};

export type CreateUpdateDispatchRelationshipMutationPayload = {
  __typename: 'CreateUpdateDispatchRelationshipMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  dispatchRelationship: DispatchRelationshipNode;
};

export type CreateUpdateExternalReferenceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalReferenceNumber: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type CreateUpdateExternalReferenceMutationPayload = {
  __typename: 'CreateUpdateExternalReferenceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export type CreateUpdateWorkOrderExpenseTypeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  expenseType: ExpenseType;
  expenseTypeSetThrough: ExpenseTypeSetThrough;
  workOrderId: Scalars['ID'];
};

export type CreateUpdateWorkOrderExpenseTypeMutationPayload = {
  __typename: 'CreateUpdateWorkOrderExpenseTypeMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrderExpenseType: Maybe<WorkOrderExpenseTypeNode>;
};

export type CreateVendorAdjustmentInvoiceMutation = {
  __typename: 'CreateVendorAdjustmentInvoiceMutation';
  ok: Scalars['Boolean'];
  vendorInvoice: Scalars['ID'];
};

export type CreateVendorArguments = {
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Currency;
  documents: Array<VendorDocumentInput>;
  email: Scalars['String'];
  inheritedPaymentTerms?: InputMaybe<Scalars['Int']>;
  invoicingVersion?: InputMaybe<InvoicingVersion>;
  isAutoApproveEligible?: InputMaybe<Scalars['Boolean']>;
  lastResort?: InputMaybe<Scalars['Boolean']>;
  marketplacePaymentTerms?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  openToMarketplace?: InputMaybe<Scalars['Boolean']>;
  operatingCountryId: Scalars['ID'];
  ownerEmail: Scalars['String'];
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  ownerPhone: Scalars['String'];
  ownerTitle?: InputMaybe<Scalars['String']>;
  ownerUsername: Scalars['String'];
  paymentTerms: Scalars['Int'];
  phone: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  remittanceEmailAddresses?: InputMaybe<Array<Scalars['String']>>;
  revenueSharePercentage?: InputMaybe<Scalars['Decimal']>;
  schedulesInApp?: InputMaybe<Scalars['Boolean']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  servicedOperatingAreaIds: Array<Scalars['ID']>;
  sfId?: InputMaybe<Scalars['String']>;
  skillIds: Array<Scalars['ID']>;
  status: VendorStatus;
  successOwner?: InputMaybe<Scalars['ID']>;
  taxRegistrationNumber: Scalars['String'];
};

export type CreateVendorAutoAdjustmentInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  vendorInvoiceId: Scalars['ID'];
};

export type CreateVendorAutoAdjustmentInvoiceMutationPayload = {
  __typename: 'CreateVendorAutoAdjustmentInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorInvoice: VendorInvoiceNode;
};

export type CreateVendorInternalNoteArguments = {
  content: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateVendorInternalNoteMutation = {
  __typename: 'CreateVendorInternalNoteMutation';
  ok: Scalars['Boolean'];
  vendorInternalNote: VendorInternalNoteNode;
};

export type CreateVendorInvoiceBatchMutation = {
  __typename: 'CreateVendorInvoiceBatchMutation';
  vendorInvoiceBatch: ApBatchNode;
};

export type CreateVendorMutation = {
  __typename: 'CreateVendorMutation';
  ok: Scalars['Boolean'];
  vendor: VendorOrganizationNode;
};

export type CreateVisitReviewMutation = {
  __typename: 'CreateVisitReviewMutation';
  ok: Scalars['Boolean'];
};

export type CreateWorkOrderEscalationInput = {
  channel?: InputMaybe<EscalationChannel>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  escalatedBy?: InputMaybe<Scalars['ID']>;
  otherReason?: InputMaybe<Scalars['String']>;
  reason: WorkOrderEscalationReason;
  sourceOrg?: InputMaybe<Scalars['ID']>;
  workOrder: Scalars['ID'];
};

export type CreateWorkOrderEscalationPayload = {
  __typename: 'CreateWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type CreateWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type CreateWorkOrderInternalNotePayload = {
  __typename: 'CreateWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  note: WorkOrderInternalNoteNode;
};

export type CreateWorkOrderNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryNoteTemplate?: InputMaybe<Scalars['String']>;
  inquiryType?: InputMaybe<InquiryType>;
  inquiryTypeCategory?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type CreateWorkOrderNotePayload = {
  __typename: 'CreateWorkOrderNotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  note: WorkOrderNoteNode;
};

export type CreateWorkOrderReviewArguments = {
  comment: Scalars['String'];
  feedbackIds: Array<Scalars['ID']>;
  reviewRequestId?: InputMaybe<Scalars['ID']>;
  satisfied: Scalars['Boolean'];
  workOrderId: Scalars['ID'];
};

export type CreateWorkOrderReviewMutation = {
  __typename: 'CreateWorkOrderReviewMutation';
  workOrder: Maybe<WorkOrderNode>;
};

export type CreateWorkOrderV2Input = {
  assignedUserId?: InputMaybe<Scalars['ID']>;
  callbackOriginalWorkOrderId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Unique ID generated by the client to identify a new work order before the backend assigns an ID. */
  correlationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facilityAccessDetails?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['ID'];
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']>;
  images: Array<Image>;
  isCallback?: InputMaybe<Scalars['Boolean']>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']>;
  pointOfContact?: InputMaybe<WorkOrderPointOfContactInput>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  /** Name of the anonymous user submitting the work order */
  requestorName?: InputMaybe<Scalars['String']>;
  selectedVendorId?: InputMaybe<Scalars['ID']>;
  serviceCategory: ServiceCategory;
  symptomId?: InputMaybe<Scalars['ID']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  troubleshootingSessionId?: InputMaybe<Scalars['ID']>;
};

export type CreateWorkOrderV2Payload = {
  __typename: 'CreateWorkOrderV2Payload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type CreditCardPaymentNode = Node & {
  __typename: 'CreditCardPaymentNode';
  brand: Maybe<Scalars['String']>;
  cardholderName: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  number: Scalars['String'];
};

export type CreditCardPaymentPreview = {
  __typename: 'CreditCardPaymentPreview';
  brand: Scalars['String'];
  creditCardLastFour: Scalars['String'];
  facilityPreviews: Array<FacilityPaymentPreview>;
  total: Scalars['Decimal'];
  workOrders: Array<WorkOrderNode>;
};

/** An enumeration. */
export enum Currency {
  Cad = 'CAD',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CyovDataInput = {
  cyovNCallbackVendor?: InputMaybe<Scalars['Int']>;
  cyovNFavouriteVendor?: InputMaybe<Scalars['Int']>;
  cyovNResqVerifiedVendor?: InputMaybe<Scalars['Int']>;
  cyovNVendorDirectory?: InputMaybe<Scalars['Int']>;
  listIndex?: InputMaybe<Scalars['Int']>;
  selectedFrom?: InputMaybe<VendorOption>;
};

export type DeactivateEquipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  equipmentId: Scalars['ID'];
};

export type DeactivateEquipmentPayload = {
  __typename: 'DeactivateEquipmentPayload';
  clientMutationId: Maybe<Scalars['String']>;
  equipment: EquipmentNode;
};

export type DeactivateFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['String'];
};

export type DeactivateFacilityPayload = {
  __typename: 'DeactivateFacilityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facility: FacilityNode;
};

export type DeactivateOrganizationSubscriptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export type DeactivateOrganizationSubscriptionsPayload = {
  __typename: 'DeactivateOrganizationSubscriptionsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeclineVendorDispatchRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  otherReason?: InputMaybe<Scalars['String']>;
  reasonChoice?: InputMaybe<VendorDispatchRequestDeclineReasonChoices>;
  vendorDispatchRequestId: Scalars['ID'];
};

export type DeclineVendorDispatchRequestMutationPayload = {
  __typename: 'DeclineVendorDispatchRequestMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorDispatchRequest: VendorDispatchRequestNode;
};

export type DefaultVendorRevenueShareNode = Node & {
  __typename: 'DefaultVendorRevenueShareNode';
  /** The ID of the object */
  id: Scalars['ID'];
  labourPercentage: Maybe<Scalars['Decimal']>;
  otherPercentage: Maybe<Scalars['Decimal']>;
  partsPercentage: Maybe<Scalars['Decimal']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']>;
  travelPercentage: Maybe<Scalars['Decimal']>;
  truckPercentage: Maybe<Scalars['Decimal']>;
  vendor: VendorOrganizationNode;
};

export type DefaultVendorRevenueShareNodeConnection = {
  __typename: 'DefaultVendorRevenueShareNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DefaultVendorRevenueShareNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DefaultVendorRevenueShareNode` and its cursor. */
export type DefaultVendorRevenueShareNodeEdge = {
  __typename: 'DefaultVendorRevenueShareNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DefaultVendorRevenueShareNode>;
};

export type DefaultVendorRevenueShareOverrideNode = Node & {
  __typename: 'DefaultVendorRevenueShareOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  labourPercentage: Maybe<Scalars['Decimal']>;
  otherPercentage: Maybe<Scalars['Decimal']>;
  partsPercentage: Maybe<Scalars['Decimal']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']>;
  travelPercentage: Maybe<Scalars['Decimal']>;
  truckPercentage: Maybe<Scalars['Decimal']>;
  vendor: VendorOrganizationNode;
};

export type DefaultVendorRevenueShareOverrideNodeConnection = {
  __typename: 'DefaultVendorRevenueShareOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DefaultVendorRevenueShareOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DefaultVendorRevenueShareOverrideNode` and its cursor. */
export type DefaultVendorRevenueShareOverrideNodeEdge = {
  __typename: 'DefaultVendorRevenueShareOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DefaultVendorRevenueShareOverrideNode>;
};

export type DeleteAttachmentMutation = {
  __typename: 'DeleteAttachmentMutation';
  ok: Scalars['Boolean'];
};

export type DeleteBudgetMutationInput = {
  budgetId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteBudgetMutationPayload = {
  __typename: 'DeleteBudgetMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteBusinessUnitMutationInput = {
  businessUnitId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteBusinessUnitMutationPayload = {
  __typename: 'DeleteBusinessUnitMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteClientReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  reportType: ClientReportType;
};

export type DeleteClientReportScheduleMutationPayload = {
  __typename: 'DeleteClientReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteCommentMutation = {
  __typename: 'DeleteCommentMutation';
  ok: Scalars['Boolean'];
};

export type DeleteDispatchRelationshipMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  relationshipId: Scalars['ID'];
};

export type DeleteDispatchRelationshipMutationPayload = {
  __typename: 'DeleteDispatchRelationshipMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export type DeleteFacilityGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupId: Scalars['ID'];
};

export type DeleteFacilityGroupPayload = {
  __typename: 'DeleteFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export type DeleteFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['String'];
};

export type DeleteFacilityPayload = {
  __typename: 'DeleteFacilityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facility: FacilityNode;
};

export type DeleteFavouriteVendorConfigurationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  favouriteVendorConfigurationId: Scalars['ID'];
};

export type DeleteFavouriteVendorConfigurationPayload = {
  __typename: 'DeleteFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteImageFromWorkOrderMutation = {
  __typename: 'DeleteImageFromWorkOrderMutation';
  ok: Scalars['Boolean'];
};

export type DeleteInboundVendorInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inboundVendorInvoiceId: Scalars['ID'];
};

export type DeleteInboundVendorInvoiceMutationPayload = {
  __typename: 'DeleteInboundVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeletePreventativeMaintenanceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  preventativeMaintenanceId: Scalars['ID'];
};

export type DeletePreventativeMaintenancePayload = {
  __typename: 'DeletePreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['ID'];
};

export type DeleteRolePayload = {
  __typename: 'DeleteRolePayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DeleteWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  noteId: Scalars['ID'];
};

export type DeleteWorkOrderInternalNotePayload = {
  __typename: 'DeleteWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DetermineTroubleshootingPlanNode = {
  __typename: 'DetermineTroubleshootingPlanNode';
  id: Scalars['ID'];
  troubleshootingPlan: Maybe<TroubleshootingPlanNode>;
};

export type Device = {
  __typename: 'Device';
  createdAt: Scalars['DateTime'];
  equipment: EquipmentNode;
  facility: FacilityNode;
  id: Scalars['ID'];
  model: Scalars['String'];
  name: Scalars['String'];
  organization: ClientOrganizationNode;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type DeviceConfig = {
  __typename: 'DeviceConfig';
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['ID'];
  id: Scalars['ID'];
  lastPolledAt: Maybe<Scalars['DateTime']>;
  pollingLengthSeconds: Scalars['Int'];
  readingType: DeviceConfigReadingType;
  thresholdType: DeviceConfigThresholdType;
  thresholdValue: Scalars['Decimal'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum DeviceConfigReadingType {
  Humidity = 'HUMIDITY',
  Temperature = 'TEMPERATURE'
}

export type DeviceConfigRequestInput = {
  configId?: InputMaybe<Scalars['String']>;
  readingType: Scalars['String'];
  thresholdType: Scalars['String'];
  thresholdValue: Scalars['Decimal'];
};

/** An enumeration. */
export enum DeviceConfigThresholdType {
  Higher = 'HIGHER',
  Lower = 'LOWER'
}

export type DeviceData = {
  __typename: 'DeviceData';
  data: Array<DeviceDataRow>;
  deviceId: Scalars['ID'];
};

/** An enumeration. */
export enum DeviceDataInputTimescale {
  Custom = 'CUSTOM',
  Last_24Hours = 'LAST_24_HOURS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR'
}

export type DeviceDataRow = {
  __typename: 'DeviceDataRow';
  humidity: Maybe<Scalars['Decimal']>;
  temperature: Maybe<Scalars['Decimal']>;
  timestamp: Scalars['DateTime'];
};

export type DeviceDataSet = {
  __typename: 'DeviceDataSet';
  deviceSet: Array<DeviceData>;
  equipment: EquipmentNode;
  timebinInSeconds: Maybe<Scalars['Int']>;
};

export type DismissMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
};

export type DismissMutationPayload = {
  __typename: 'DismissMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DismissWorkOrderNoteMetadataMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type DismissWorkOrderNoteMetadataMutationPayload = {
  __typename: 'DismissWorkOrderNoteMetadataMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type DispatchActivity = Activity & Node & {
  __typename: 'DispatchActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dispatch: Maybe<VendorDispatchNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<DispatchActivityOutcome>;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum DispatchActivityOutcome {
  Dispatched = 'DISPATCHED',
  NoneAccepted = 'NONE_ACCEPTED',
  NoResponse = 'NO_RESPONSE'
}

export type DispatchRelationshipNode = Node & {
  __typename: 'DispatchRelationshipNode';
  dispatchrelationshipsummarySet: DispatchRelationshipSummaryNodeConnection;
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  serviceCategory: Maybe<ServiceCategory>;
  status: DispatchRelationshipStatus;
  vendor: VendorOrganizationNode;
  vendorName: Scalars['String'];
};


export type DispatchRelationshipNodeDispatchrelationshipsummarySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DispatchRelationshipNodeConnection = {
  __typename: 'DispatchRelationshipNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DispatchRelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DispatchRelationshipNode` and its cursor. */
export type DispatchRelationshipNodeEdge = {
  __typename: 'DispatchRelationshipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DispatchRelationshipNode>;
};

/** An enumeration. */
export enum DispatchRelationshipStatus {
  Always = 'ALWAYS',
  Normal = 'NORMAL',
  Preferred = 'PREFERRED'
}

export type DispatchRelationshipSummaryNode = Node & {
  __typename: 'DispatchRelationshipSummaryNode';
  dispatchRelationships: Array<DispatchRelationshipNode>;
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type DispatchRelationshipSummaryNodeConnection = {
  __typename: 'DispatchRelationshipSummaryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DispatchRelationshipSummaryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DispatchRelationshipSummaryNode` and its cursor. */
export type DispatchRelationshipSummaryNodeEdge = {
  __typename: 'DispatchRelationshipSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DispatchRelationshipSummaryNode>;
};

export type DisputeWorkOrderArguments = {
  reason: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type DisputeWorkOrderMutation = {
  __typename: 'DisputeWorkOrderMutation';
  ok: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type DjangoGroupNode = Node & {
  __typename: 'DjangoGroupNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DjangoGroupNodeConnection = {
  __typename: 'DjangoGroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DjangoGroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DjangoGroupNode` and its cursor. */
export type DjangoGroupNodeEdge = {
  __typename: 'DjangoGroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DjangoGroupNode>;
};

export type DjangoPermissionNode = Node & {
  __typename: 'DjangoPermissionNode';
  codename: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DjangoPermissionNodeConnection = {
  __typename: 'DjangoPermissionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DjangoPermissionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `DjangoPermissionNode` and its cursor. */
export type DjangoPermissionNodeEdge = {
  __typename: 'DjangoPermissionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<DjangoPermissionNode>;
};

export type EditBlockedGroupsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  facilityGroupIds: Array<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type EditBlockedGroupsPayload = {
  __typename: 'EditBlockedGroupsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  clientOrganization: ClientOrganizationNode;
  vendor: VendorOrganizationNode;
};

export type EditClientOrganizationMemberMutation = {
  __typename: 'EditClientOrganizationMemberMutation';
  member: ClientOrganizationMemberNode;
};

export type EditClientOrganizationMutation = {
  __typename: 'EditClientOrganizationMutation';
  clientOrganization: ClientOrganizationNode;
};

export type EditClientVendorRelationshipInviteInput = {
  businessName: Scalars['String'];
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  inviteId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
};

export type EditClientVendorRelationshipInvitePayload = {
  __typename: 'EditClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']>;
  invite: InviteNode;
};

export type EditEquipmentMutation = {
  __typename: 'EditEquipmentMutation';
  equipment: EquipmentNode;
  ok: Scalars['Boolean'];
};

export type EditFavouriteVendorConfigurationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupIds: Array<Scalars['ID']>;
  favouriteVendorConfigurationId: Scalars['ID'];
  serviceCategories: Array<ServiceCategory>;
};

export type EditFavouriteVendorConfigurationPayload = {
  __typename: 'EditFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  favouriteVendorConfiguration: FavouriteVendorConfigurationNode;
};

export type EditOrgOwnerMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type EditOrgOwnerMutationPayload = {
  __typename: 'EditOrgOwnerMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type EditOrganizationFeaturesMutationInput = {
  additionalFeatures?: InputMaybe<Array<Features>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  removedFeatures?: InputMaybe<Array<Features>>;
  tierId?: InputMaybe<Scalars['ID']>;
};

export type EditOrganizationFeaturesMutationPayload = {
  __typename: 'EditOrganizationFeaturesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type EditPreventativeMaintenanceInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deletedTaskListAdditionalUrls?: InputMaybe<Array<Scalars['ID']>>;
  deletedTaskListAttachments?: InputMaybe<Array<Scalars['ID']>>;
  expectedDuration?: InputMaybe<Scalars['Int']>;
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  frequencyValue: Scalars['Int'];
  newTaskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  newTaskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  nextWorkOrderCreationDate: Scalars['Date'];
  preventativeMaintenanceId: Scalars['ID'];
  recurrenceDayOfMonth?: InputMaybe<Scalars['Int']>;
  taskListItems: Array<Scalars['String']>;
  teamMemberIds: Array<Scalars['ID']>;
  title: Scalars['String'];
};

export type EditPreventativeMaintenancePayload = {
  __typename: 'EditPreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type EditQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItems: Array<LineItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  overrideNotes?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['ID'];
};

export type EditQuoteMutationPayload = {
  __typename: 'EditQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quote: QuoteNode;
};

export type EditUserDjangoGroupsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groups: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type EditUserDjangoGroupsMutationPayload = {
  __typename: 'EditUserDjangoGroupsMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  user: UserNode;
};

export type EditVendorUserDetailsMutation = {
  __typename: 'EditVendorUserDetailsMutation';
  ok: Scalars['Boolean'];
};

export type EditWorkOrderInput = {
  assignedTeamMemberId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facilityAccessInfo?: InputMaybe<Scalars['String']>;
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<Image>>;
  isCallback?: InputMaybe<Scalars['Boolean']>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']>;
  pointOfContact?: InputMaybe<WorkOrderPointOfContactInput>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  selectedVendorId?: InputMaybe<Scalars['ID']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  symptomId?: InputMaybe<Scalars['ID']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type EditWorkOrderPayload = {
  __typename: 'EditWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type EndActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  workOrder: Scalars['ID'];
};

export type EndActivityPayload = {
  __typename: 'EndActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type EndVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  holdReason?: InputMaybe<Scalars['String']>;
  images: Array<Image>;
  nextAppointmentEndsAt?: InputMaybe<Scalars['DateTime']>;
  nextAppointmentStartsAt?: InputMaybe<Scalars['DateTime']>;
  nextAppointmentTechnician?: InputMaybe<Scalars['ID']>;
  notes: Scalars['String'];
  outcome?: InputMaybe<VisitOutcome>;
  recommendations: Scalars['String'];
  sourcingPartsHoldEtaEnd?: InputMaybe<Scalars['Date']>;
  sourcingPartsHoldEtaStart?: InputMaybe<Scalars['Date']>;
  visit?: InputMaybe<Scalars['ID']>;
};

export type EndVisitPayload = {
  __typename: 'EndVisitPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type EquipmentCategoryNode = Node & {
  __typename: 'EquipmentCategoryNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  parent: Maybe<EquipmentCategoryNode>;
  path: Array<EquipmentCategoryNode>;
  serviceCategory: Maybe<EquipmentCategoryServiceCategory>;
  taxonomyNode: Maybe<TaxonomyNodeNode>;
};

export type EquipmentCategoryNodeConnection = {
  __typename: 'EquipmentCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `EquipmentCategoryNode` and its cursor. */
export type EquipmentCategoryNodeEdge = {
  __typename: 'EquipmentCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentCategoryNode>;
};

/** An enumeration. */
export enum EquipmentCategoryServiceCategory {
  /** Air Compressors */
  AirCompressors = 'AIR_COMPRESSORS',
  /** Asbestos */
  Asbestos = 'ASBESTOS',
  /** Audits */
  Audits = 'AUDITS',
  /** Awaiting Categorization */
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  /** Backflow */
  Backflow = 'BACKFLOW',
  /** Beverage Equipment */
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  /** Chowbotics */
  Chowbotics = 'CHOWBOTICS',
  /** Cleaning */
  Cleaning = 'CLEANING',
  /** Closed Circuit Television */
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  /** Cutting Board Resurfacing */
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  /** Drive Thru Items */
  DriveThuItems = 'DRIVE_THU_ITEMS',
  /** Electrical */
  Electrical = 'ELECTRICAL',
  /** Elevators & Dumbwaiters */
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  /** EMERGENCY_LIGHTS */
  EmergencyLights = 'EMERGENCY_LIGHTS',
  /** Environmental Consulting */
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  /** Fire Alarms */
  FireAlarms = 'FIRE_ALARMS',
  /** Fire Suppression */
  FireSuppression = 'FIRE_SUPPRESSION',
  /** FIXTURES */
  Fixtures = 'FIXTURES',
  /** Flooring */
  Flooring = 'FLOORING',
  /** Food Equipment */
  FoodEquipment = 'FOOD_EQUIPMENT',
  /** Fuel Oil */
  FuelOil = 'FUEL_OIL',
  /** Furniture */
  Furniture = 'FURNITURE',
  /** Gas & Boilers */
  GasBoilers = 'GAS_BOILERS',
  /** General Repair/Handywork */
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  /** Generators & Power Supply */
  Generators = 'GENERATORS',
  /** Grease Traps */
  GreaseTrap = 'GREASE_TRAP',
  /** Heating & Cooling/HVAC */
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  /** Hoods */
  Hoods = 'HOODS',
  /** Hot Water Systems */
  HotWaterTank = 'HOT_WATER_TANK',
  /** Ice Machines */
  IceMachine = 'ICE_MACHINE',
  /** Landscaping */
  Landscaping = 'LANDSCAPING',
  /** Locks & Doors */
  LocksDoors = 'LOCKS_DOORS',
  /** Medical Equipment */
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  /** Menu Screens */
  MenuScreens = 'MENU_SCREENS',
  /** Messenger Services */
  MessengerServices = 'MESSENGER_SERVICES',
  /** Miscellaneous */
  Miscellaneous = 'MISCELLANEOUS',
  /** Moving Services */
  MovingServices = 'MOVING_SERVICES',
  /** Pack Screens */
  PackScreens = 'PACK_SCREENS',
  /** Parts/Supply Order */
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  /** Pavement */
  Pavement = 'PAVEMENT',
  /** Pest Control */
  PestControl = 'PEST_CONTROL',
  /** Plumbing */
  Plumbing = 'PLUMBING',
  /** Refrigeration */
  Refrigeration = 'REFRIGERATION',
  /** Roofing */
  Roofing = 'ROOFING',
  /** Security */
  Security = 'SECURITY',
  /** Shredding */
  Shredding = 'SHREDDING',
  /** Signage */
  Signage = 'SIGNAGE',
  /** Snow Removal */
  SnowRemoval = 'SNOW_REMOVAL',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Temp Services */
  TempServices = 'TEMP_SERVICES',
  /** Tiling */
  Tiling = 'TILING',
  /** Uniforms & Laundry */
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  /** Upholstery */
  Upholstery = 'UPHOLSTERY',
  /** Vending Machines */
  VendingMachines = 'VENDING_MACHINES',
  /** Ware Washing Equipment */
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  /** Waste Removal */
  WasteRemoval = 'WASTE_REMOVAL',
  /** Water Treatment */
  WaterFiltration = 'WATER_FILTRATION',
  /** Welding */
  Welding = 'WELDING',
  /** Windows, Doors & Locks */
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  /** Windows & Glass */
  WindowsGlass = 'WINDOWS_GLASS'
}

export type EquipmentImageNode = {
  __typename: 'EquipmentImageNode';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type EquipmentManufacturerNode = Node & {
  __typename: 'EquipmentManufacturerNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EquipmentManufacturerNodeConnection = {
  __typename: 'EquipmentManufacturerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentManufacturerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `EquipmentManufacturerNode` and its cursor. */
export type EquipmentManufacturerNodeEdge = {
  __typename: 'EquipmentManufacturerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentManufacturerNode>;
};

export type EquipmentNode = Node & {
  __typename: 'EquipmentNode';
  alerts: Array<Alert>;
  barCode: Maybe<Scalars['String']>;
  /** @deprecated Replaced with service category */
  category: Maybe<CategoryNode>;
  code: Scalars['String'];
  cost: Maybe<Scalars['Decimal']>;
  description: Maybe<Scalars['String']>;
  devices: Array<Device>;
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  facility: FacilityNode;
  hasWarranty: Maybe<Scalars['Boolean']>;
  historicalSpend: Maybe<Scalars['Decimal']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** @deprecated Replaced with main_image */
  image: Maybe<Scalars['String']>;
  incidents: Array<Incident>;
  installedOn: Maybe<Scalars['Date']>;
  location: Scalars['String'];
  mainImage: Maybe<ImageType>;
  manufacturer: Maybe<Scalars['String']>;
  modelNo: Maybe<Scalars['String']>;
  modelTagImage: Maybe<ImageType>;
  name: Scalars['String'];
  /** @deprecated Replaced with main/model tag images */
  photos: Array<EquipmentImageNode>;
  serialNo: Maybe<Scalars['String']>;
  serviceCategory: Maybe<ServiceCategory>;
  shouldUpdateWarranty: Scalars['Boolean'];
  status: EquipmentStatus;
  /** @deprecated Replaced with service category */
  subcategory: Maybe<TradeNode>;
  symptoms: Array<TaxonomySymptomNode>;
  totalSpend: Maybe<Scalars['Decimal']>;
  warrantyExpiresOn: Maybe<Scalars['Date']>;
  warrantyInfoReceivedOn: Maybe<Scalars['DateTime']>;
  warrantyNotes: Maybe<Scalars['String']>;
  workOrderCount: Scalars['Int'];
  workOrders: Array<WorkOrderNode>;
};


export type EquipmentNodeIncidentsArgs = {
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
};

export type EquipmentNodeConnection = {
  __typename: 'EquipmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `EquipmentNode` and its cursor. */
export type EquipmentNodeEdge = {
  __typename: 'EquipmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentNode>;
};

export type EquipmentServiceCount = {
  __typename: 'EquipmentServiceCount';
  count: Scalars['Int'];
  equipment: EquipmentNode;
};

export enum EquipmentStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** An enumeration. */
export enum EscalationChannel {
  App = 'APP',
  Email = 'EMAIL',
  Phone = 'PHONE',
  Sms = 'SMS'
}

export type EscalationChannelType = {
  __typename: 'EscalationChannelType';
  key: EscalationChannel;
  label: Scalars['String'];
};

/** An enumeration. */
export enum ExpansionRequestType {
  FacilityExpansion = 'FACILITY_EXPANSION',
  NoExpansionPossible = 'NO_EXPANSION_POSSIBLE'
}

/** An enumeration. */
export enum ExpectedServiceTimeline {
  Asap = 'ASAP',
  ByNextBusinessDay = 'BY_NEXT_BUSINESS_DAY',
  Flexible = 'FLEXIBLE',
  SameDay = 'SAME_DAY',
  Within_7Days = 'WITHIN_7_DAYS'
}

export type ExpectedServiceTimelineType = {
  __typename: 'ExpectedServiceTimelineType';
  expectedArrivalTimestamp: Maybe<Scalars['DateTime']>;
  isValid: Maybe<Scalars['Boolean']>;
  key: ExpectedServiceTimeline;
  label: Scalars['String'];
  validatedAt: Maybe<Scalars['DateTime']>;
};

export type ExpensePerCategorySpendData = {
  __typename: 'ExpensePerCategorySpendData';
  serviceCategory: ServiceCategory;
  totalSpend: Scalars['Decimal'];
};

/** An enumeration. */
export enum ExpenseType {
  Capex = 'CAPEX',
  Opex = 'OPEX'
}

/** An enumeration. */
export enum ExpenseTypeSetThrough {
  BudgetEdit = 'BUDGET_EDIT',
  QuoteProcess = 'QUOTE_PROCESS',
  WorkOrderCreation = 'WORK_ORDER_CREATION',
  WorkOrderEdit = 'WORK_ORDER_EDIT'
}

export type ExperienceAreas = {
  __typename: 'ExperienceAreas';
  dispatch: Scalars['Boolean'];
};

export type ExternalBankAccountNode = Node & {
  __typename: 'ExternalBankAccountNode';
  accountNumber: Scalars['String'];
  address: Maybe<Scalars['String']>;
  addressLine2: Maybe<Scalars['String']>;
  city: Maybe<CityNode>;
  cityName: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  country: Maybe<CountryNode>;
  firstName: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  institutionNumber: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  province: Maybe<ProvinceNode>;
  routingNumber: Scalars['String'];
  type: ExternalBankAccountType;
};

export type ExternalBankAccountNodeConnection = {
  __typename: 'ExternalBankAccountNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalBankAccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ExternalBankAccountNode` and its cursor. */
export type ExternalBankAccountNodeEdge = {
  __typename: 'ExternalBankAccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ExternalBankAccountNode>;
};

/** An enumeration. */
export enum ExternalBankAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type FacilitiesOnboardingStepInput = {
  address?: InputMaybe<Scalars['String']>;
  busyHours?: InputMaybe<Scalars['String']>;
  cityId: Scalars['ID'];
  countryId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  onsiteHours?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provinceId: Scalars['ID'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum FacilityCanActions {
  Manage = 'MANAGE',
  ManageEquipment = 'MANAGE_EQUIPMENT',
  ManageSensors = 'MANAGE_SENSORS'
}

export type FacilityGroupAllotmentInput = {
  allotment: Scalars['Decimal'];
  facilityGroupId: Scalars['ID'];
};

export type FacilityGroupMembershipNode = Node & {
  __typename: 'FacilityGroupMembershipNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Shortcut for retrieving roles of user in facility client. */
  roles: Array<RoleNode>;
  user: UserNode;
};

export type FacilityGroupNode = Node & {
  __typename: 'FacilityGroupNode';
  allBlockedVendors: Array<VendorOrganizationNode>;
  allMemberships: Array<FacilityGroupMembershipNode>;
  blocklist: Array<VendorOrganizationNode>;
  children: Array<FacilityGroupNode>;
  computedDispatchRelationships: Array<DispatchRelationshipNode>;
  dispatchRelationships: Array<DispatchRelationshipNode>;
  facility: Maybe<FacilityNode>;
  facilityCount: Scalars['Int'];
  facilityIds: Array<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  memberships: Array<FacilityGroupMembershipNode>;
  name: Scalars['String'];
  opsOwner: Maybe<UserNode>;
  organization: ClientOrganizationNode;
  parent: Maybe<FacilityGroupNode>;
  parentId: Maybe<Scalars['ID']>;
  permissions: FacilityGroupPermissions;
};

export type FacilityGroupNodeConnection = {
  __typename: 'FacilityGroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityGroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FacilityGroupNode` and its cursor. */
export type FacilityGroupNodeEdge = {
  __typename: 'FacilityGroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FacilityGroupNode>;
};

export type FacilityGroupPermissions = {
  __typename: 'FacilityGroupPermissions';
  manage: Scalars['Boolean'];
};

export type FacilityGroupSelectionNode = Node & {
  __typename: 'FacilityGroupSelectionNode';
  facilityGroups: FacilityGroupNodeConnection;
  facilityIds: Maybe<Array<Scalars['Int']>>;
  /** The ID of the object */
  id: Scalars['ID'];
  organization: ClientOrganizationNode;
};


export type FacilityGroupSelectionNodeFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type FacilityGroupSelectionNodeConnection = {
  __typename: 'FacilityGroupSelectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityGroupSelectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FacilityGroupSelectionNode` and its cursor. */
export type FacilityGroupSelectionNodeEdge = {
  __typename: 'FacilityGroupSelectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FacilityGroupSelectionNode>;
};

export type FacilityGroupSpendNode = Node & {
  __typename: 'FacilityGroupSpendNode';
  allottedAmount: Scalars['Decimal'];
  facilityGroup: FacilityGroupNode;
  id: Scalars['ID'];
  spentAmount: Scalars['Decimal'];
  upcomingSpendAmount: Scalars['Decimal'];
  upcomingSpendCount: Scalars['Int'];
};

export type FacilityNode = Node & {
  __typename: 'FacilityNode';
  accessInfo: Scalars['String'];
  actualGoLiveOn: Maybe<Scalars['Date']>;
  address: Scalars['String'];
  addressLine2: Maybe<Scalars['String']>;
  brand: Maybe<BrandNode>;
  businessUnit: Maybe<BusinessUnitNode>;
  busyHoursJson: Maybe<Scalars['String']>;
  can: Scalars['Boolean'];
  city: CityNode;
  cityName: Maybe<Scalars['String']>;
  clientOrganization: ClientOrganizationNode;
  code: Scalars['String'];
  country: CountryNode;
  currency: Currency;
  daysOpenedJson: Maybe<Scalars['String']>;
  disabledCategories: Array<ServiceCategory>;
  email: Scalars['String'];
  equipment: Array<EquipmentNode>;
  /** @deprecated Replaced by 'equipment' */
  equipments: Array<EquipmentNode>;
  goliveOn: Maybe<Scalars['Date']>;
  group: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  isBillable: Scalars['Boolean'];
  isEssentialsEnabled: Scalars['Boolean'];
  isTaggingCharged: Maybe<Scalars['Boolean']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  maintenancePlans: Array<MaintenancePlanNode>;
  /** @deprecated Use group.memberships instead. */
  memberships: Array<FacilityGroupMembershipNode>;
  name: Scalars['String'];
  notes: Scalars['String'];
  onboardingStatus: Maybe<OnboardingStatus>;
  onsiteHoursJson: Maybe<Scalars['String']>;
  openedOn: Maybe<Scalars['Date']>;
  operatingArea: Maybe<OperatingAreaNode>;
  paymentMethod: Maybe<PaymentMethodNode>;
  paymentMethods: Maybe<Array<PaymentMethodNode>>;
  phone: Scalars['String'];
  photo: Maybe<ImageType>;
  plannedGoLiveOn: Maybe<Scalars['Date']>;
  postalCode: Scalars['String'];
  province: ProvinceNode;
  qrCode: Maybe<Scalars['String']>;
  status: FacilityStatus;
  storeNumber: Maybe<Scalars['String']>;
  subscription: Maybe<SubscriptionNode>;
  taggingMethod: Maybe<TaggingMethod>;
  timezone: Scalars['String'];
  transactionFee: Scalars['Float'];
  /** @deprecated Replaced by top-level 'workOrders' query */
  workOrders: Array<WorkOrderNode>;
  zipCode: Scalars['String'];
};


export type FacilityNodeCanArgs = {
  perform: FacilityCanActions;
};

export type FacilityNodeConnection = {
  __typename: 'FacilityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FacilityNode` and its cursor. */
export type FacilityNodeEdge = {
  __typename: 'FacilityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FacilityNode>;
};

export type FacilityPaymentPreview = {
  __typename: 'FacilityPaymentPreview';
  facility: FacilityNode;
  invoiceCount: Scalars['Decimal'];
  total: Scalars['Decimal'];
  workOrderCount: Scalars['Int'];
};

export enum FacilityStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type FacilitySubscriptionInput = {
  facilityId?: InputMaybe<Scalars['ID']>;
  goliveOn?: InputMaybe<Scalars['Date']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
};

export type FacilityVendorRelationshipMetrics = {
  __typename: 'FacilityVendorRelationshipMetrics';
  totalInvoicedAmount: Scalars['Decimal'];
  totalJobCount: Scalars['Int'];
};

export type FacilityVendorRelationshipNode = Node & {
  __typename: 'FacilityVendorRelationshipNode';
  client: ClientOrganizationNode;
  facility: FacilityNode;
  favouritedServiceCategories: Array<ServiceCategory>;
  /** The ID of the object */
  id: Scalars['ID'];
  metrics: FacilityVendorRelationshipMetrics;
  vendor: VendorOrganizationNode;
};


export type FacilityVendorRelationshipNodeMetricsArgs = {
  metricsRangeWeeks: Scalars['Int'];
};

export type FacilityVendorRelationshipNodeConnection = {
  __typename: 'FacilityVendorRelationshipNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityVendorRelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FacilityVendorRelationshipNode` and its cursor. */
export type FacilityVendorRelationshipNodeEdge = {
  __typename: 'FacilityVendorRelationshipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FacilityVendorRelationshipNode>;
};

export type FavouriteVendorConfigurationNode = Node & {
  __typename: 'FavouriteVendorConfigurationNode';
  facilityGroups: Array<FacilityGroupNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  permissions: FavouriteVendorConfigurationPermissions;
  serviceCategories: Array<ServiceCategory>;
  vendor: VendorOrganizationNode;
};

export type FavouriteVendorConfigurationNodeConnection = {
  __typename: 'FavouriteVendorConfigurationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FavouriteVendorConfigurationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FavouriteVendorConfigurationNode` and its cursor. */
export type FavouriteVendorConfigurationNodeEdge = {
  __typename: 'FavouriteVendorConfigurationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FavouriteVendorConfigurationNode>;
};

export type FavouriteVendorConfigurationPermissions = {
  __typename: 'FavouriteVendorConfigurationPermissions';
  delete: Scalars['Boolean'];
  edit: Scalars['Boolean'];
};

export type FeatureTierNode = Node & {
  __typename: 'FeatureTierNode';
  features: Array<Features>;
  hidden: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FeatureTierNodeConnection = {
  __typename: 'FeatureTierNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeatureTierNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `FeatureTierNode` and its cursor. */
export type FeatureTierNodeEdge = {
  __typename: 'FeatureTierNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<FeatureTierNode>;
};

/** An enumeration. */
export enum Features {
  AssetTrackingAndManagement = 'ASSET_TRACKING_AND_MANAGEMENT',
  BudgetManagement = 'BUDGET_MANAGEMENT',
  ConsolidatedApAndInvoicing = 'CONSOLIDATED_AP_AND_INVOICING',
  CustomizableReporting = 'CUSTOMIZABLE_REPORTING',
  CustomizableRolesAndPermissions = 'CUSTOMIZABLE_ROLES_AND_PERMISSIONS',
  CustomizableSpendControls = 'CUSTOMIZABLE_SPEND_CONTROLS',
  DedicatedAccountManager = 'DEDICATED_ACCOUNT_MANAGER',
  DefaultRolesAndPermissions = 'DEFAULT_ROLES_AND_PERMISSIONS',
  DefaultSpendControls = 'DEFAULT_SPEND_CONTROLS',
  EquipmentTroubleshooting = 'EQUIPMENT_TROUBLESHOOTING',
  InternalTechnicianManagement = 'INTERNAL_TECHNICIAN_MANAGEMENT',
  InvoiceApprovals = 'INVOICE_APPROVALS',
  InvoiceFlaggingAlgorithm = 'INVOICE_FLAGGING_ALGORITHM',
  IotTemperatureSensors = 'IOT_TEMPERATURE_SENSORS',
  PersonalizedDashboard = 'PERSONALIZED_DASHBOARD',
  PreventativeMaintenanceManagement = 'PREVENTATIVE_MAINTENANCE_MANAGEMENT',
  QuarterlyBusinessReviews = 'QUARTERLY_BUSINESS_REVIEWS',
  RepairVsReplaceTracking = 'REPAIR_VS_REPLACE_TRACKING',
  ResqOnDemand = 'RESQ_ON_DEMAND',
  SingleSignOn = 'SINGLE_SIGN_ON',
  TwentyFourSevenTechnicalSupport = 'TWENTY_FOUR_SEVEN_TECHNICAL_SUPPORT',
  UnlimitedUsers = 'UNLIMITED_USERS',
  VendorManagementAndPerformanceMetrics = 'VENDOR_MANAGEMENT_AND_PERFORMANCE_METRICS',
  WorkOrderManagement = 'WORK_ORDER_MANAGEMENT'
}

export type FileType = {
  __typename: 'FileType';
  key: Scalars['String'];
  url: Scalars['String'];
};

export type FilterInput = {
  datatype: ReportFilterDatatype;
  field: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  operator: ReportFilterOperator;
  value?: InputMaybe<Scalars['String']>;
};

export type FirstTimeFixRate = {
  __typename: 'FirstTimeFixRate';
  rate: Scalars['Decimal'];
  serviceCategory: ServiceCategory;
};

export type ForceWorkOrderCompletionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  visitDate?: InputMaybe<Scalars['DateTime']>;
  workOrderId: Scalars['ID'];
};

export type ForceWorkOrderCompletionMutationPayload = {
  __typename: 'ForceWorkOrderCompletionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum FormatOptions {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Svg = 'SVG',
  Webp = 'WEBP'
}

export type GlCodeNode = Node & {
  __typename: 'GLCodeNode';
  code: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: ServiceCategory;
};

export type GlCodeNodeConnection = {
  __typename: 'GLCodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GlCodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GLCodeNode` and its cursor. */
export type GlCodeNodeEdge = {
  __typename: 'GLCodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<GlCodeNode>;
};

export type GenerateKustomerLoginTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type GenerateKustomerLoginTokenPayload = {
  __typename: 'GenerateKustomerLoginTokenPayload';
  clientMutationId: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type GenerateVendorInvoicePdfInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItems: Array<LineItemInput>;
  notes: Scalars['String'];
  overrideNotes: Scalars['String'];
  vendorNotes: Scalars['String'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type GenerateVendorInvoicePdfPayload = {
  __typename: 'GenerateVendorInvoicePDFPayload';
  clientMutationId: Maybe<Scalars['String']>;
  pdfFile: Scalars['String'];
};

export type GetAllAlertsInput = {
  equipmentIds?: InputMaybe<Array<Scalars['ID']>>;
  incidentIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GetAllDevicesInput = {
  equipmentIds?: InputMaybe<Array<Scalars['ID']>>;
  facilityId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GetDeviceDataInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  equipmentId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
  timescale?: InputMaybe<DeviceDataInputTimescale>;
};

export type Image = {
  url?: InputMaybe<Scalars['String']>;
};

export type ImageNode = Node & {
  __typename: 'ImageNode';
  description: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  url: Scalars['String'];
};


export type ImageNodeUrlArgs = {
  height?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** GraphQL type for Django's ImageField. */
export type ImageType = {
  __typename: 'ImageType';
  key: Scalars['String'];
  url: Scalars['String'];
};


/** GraphQL type for Django's ImageField. */
export type ImageTypeUrlArgs = {
  height?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ImportPaidInvoicesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  invoicePayments: Array<InputMaybe<InvoicePaymentInput>>;
};

export type ImportPaidInvoicesPayload = {
  __typename: 'ImportPaidInvoicesPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export type InboundVendorInvoiceNode = Node & {
  __typename: 'InboundVendorInvoiceNode';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoiceFile: FileType;
  name: Scalars['String'];
  workOrder: WorkOrderNode;
};

export type InboundVendorInvoiceNodeConnection = {
  __typename: 'InboundVendorInvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboundVendorInvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InboundVendorInvoiceNode` and its cursor. */
export type InboundVendorInvoiceNodeEdge = {
  __typename: 'InboundVendorInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<InboundVendorInvoiceNode>;
};

/** An enumeration. */
export enum InboundVendorInvoiceSource {
  CreatedInPmc = 'CREATED_IN_PMC',
  Email = 'EMAIL',
  UploadedInClientApp = 'UPLOADED_IN_CLIENT_APP',
  UploadedInPartnerApp = 'UPLOADED_IN_PARTNER_APP',
  UploadedInPmc = 'UPLOADED_IN_PMC',
  UploadedInRmc = 'UPLOADED_IN_RMC'
}

export type InboundVendorInvoiceValidationNode = Node & {
  __typename: 'InboundVendorInvoiceValidationNode';
  /** The ID of the object */
  id: Scalars['ID'];
  validationResult: Maybe<InboundVendorInvoiceValidationResult>;
};

export type InboundVendorInvoiceValidationResult = {
  __typename: 'InboundVendorInvoiceValidationResult';
  canOverride: Scalars['Boolean'];
  validationMessage: Scalars['String'];
};

export type InboxItemExternalReference = VendorDispatchNode | WorkOrderNode | WorkOrderTeamMemberAssignmentNode;

export type InboxItemNode = Node & {
  __typename: 'InboxItemNode';
  archivedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  data: Maybe<Scalars['JSONString']>;
  externalReference: InboxItemExternalReference;
  externalReferenceId: Scalars['ID'];
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  itemType: InboxItemType;
  readAt: Maybe<Scalars['DateTime']>;
  title: Maybe<Scalars['String']>;
  user: UserNode;
  workOrder: Maybe<WorkOrderNode>;
};

export type InboxItemNodeConnection = {
  __typename: 'InboxItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboxItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InboxItemNode` and its cursor. */
export type InboxItemNodeEdge = {
  __typename: 'InboxItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<InboxItemNode>;
};

/** An enumeration. */
export enum InboxItemType {
  ChecklistAssigned = 'CHECKLIST_ASSIGNED',
  DispatchFailed = 'DISPATCH_FAILED',
  InvoiceApproval = 'INVOICE_APPROVAL',
  QuoteApproval = 'QUOTE_APPROVAL',
  QuoteSelection = 'QUOTE_SELECTION',
  QuoteSpendApproval = 'QUOTE_SPEND_APPROVAL',
  WorkOrderTeamMemberAssignment = 'WORK_ORDER_TEAM_MEMBER_ASSIGNMENT',
  WorkOrderTriage = 'WORK_ORDER_TRIAGE'
}

export type Incident = {
  __typename: 'Incident';
  alerts: Array<Alert>;
  config: DeviceConfig;
  createdAt: Scalars['DateTime'];
  device: Device;
  endedAt: Maybe<Scalars['DateTime']>;
  equipment: EquipmentNode;
  id: Scalars['ID'];
  snoozedUntil: Maybe<Scalars['DateTime']>;
  status: IncidentStatus;
  updatedAt: Maybe<Scalars['DateTime']>;
  workOrder: Maybe<WorkOrderNode>;
};

export type IncidentConnection = {
  __typename: 'IncidentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IncidentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `Incident` and its cursor. */
export type IncidentEdge = {
  __typename: 'IncidentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<Incident>;
};

/** An enumeration. */
export enum IncidentStatus {
  Closed = 'CLOSED',
  Ongoing = 'ONGOING',
  Resolved = 'RESOLVED'
}

export type InitiateMarketplaceOnboardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type InitiateMarketplaceOnboardingMutationPayload = {
  __typename: 'InitiateMarketplaceOnboardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  onboardingAction: OnboardingActionNode;
};

/** An enumeration. */
export enum InquiryType {
  Invoice = 'INVOICE',
  PartUpdates = 'PART_UPDATES',
  Quote = 'QUOTE'
}

export type InternalAppointmentNode = Node & {
  __typename: 'InternalAppointmentNode';
  closedAt: Maybe<Scalars['DateTime']>;
  closedBy: Maybe<UserNode>;
  date: Scalars['Date'];
  /** The ID of the object */
  id: Scalars['ID'];
  internalRequest: InternalRequestNode;
  outcome: Maybe<InternalAppointmentOutcome>;
};

export type InternalAppointmentNodeConnection = {
  __typename: 'InternalAppointmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InternalAppointmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InternalAppointmentNode` and its cursor. */
export type InternalAppointmentNodeEdge = {
  __typename: 'InternalAppointmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<InternalAppointmentNode>;
};

/** An enumeration. */
export enum InternalAppointmentOutcome {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  Rescheduled = 'RESCHEDULED',
  SentToVendor = 'SENT_TO_VENDOR'
}

export type InternalRequestCompletionNode = Node & {
  __typename: 'InternalRequestCompletionNode';
  additionalNotes: Maybe<Scalars['String']>;
  /** The date the user indicated that the work was completed on */
  completionDate: Maybe<Scalars['Date']>;
  cost: Maybe<Scalars['Decimal']>;
  /** The duration of the completion in seconds. */
  duration: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  incompleteTaskNotes: Maybe<Scalars['String']>;
  photos: Array<InternalRequestCompletionPhotoNode>;
};

export type InternalRequestCompletionPhotoNode = Node & {
  __typename: 'InternalRequestCompletionPhotoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  photo: Scalars['String'];
};

export type InternalRequestNode = Node & {
  __typename: 'InternalRequestNode';
  appointments: Maybe<Array<InternalAppointmentNode>>;
  assignments: Array<WorkOrderTeamMemberAssignmentNode>;
  closedAt: Maybe<Scalars['DateTime']>;
  closedBy: Maybe<UserNode>;
  completion: Maybe<InternalRequestCompletionNode>;
  currentAppointment: Maybe<InternalAppointmentNode>;
  deletedPreventativeMaintenanceTitle: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<InternalRequestOutcome>;
  permissions: InternalRequestPermissions;
  preventativeMaintenance: Maybe<PreventativeMaintenanceNode>;
  taskListAttachments: Array<AttachmentNode>;
  taskListUrls: Array<AttachedUrlNode>;
  tasks: Array<WorkOrderTaskListItemNode>;
  workOrder: WorkOrderNode;
};

export type InternalRequestNodeConnection = {
  __typename: 'InternalRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InternalRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InternalRequestNode` and its cursor. */
export type InternalRequestNodeEdge = {
  __typename: 'InternalRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<InternalRequestNode>;
};

/** An enumeration. */
export enum InternalRequestOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  SentToVendor = 'SENT_TO_VENDOR'
}

export type InternalRequestPermissions = {
  __typename: 'InternalRequestPermissions';
  /** Permissions to cancel internal request */
  cancel: Scalars['Boolean'];
  /** Permissions to complete internal request */
  complete: Scalars['Boolean'];
  /** Permissions to mark internal request as unresolved */
  markAsUnresolved: Scalars['Boolean'];
  /** Permissions to reassign internal request to other team members */
  reassign: Scalars['Boolean'];
  /** Permissions to submit internal request to a vendor */
  submitToVendor: Scalars['Boolean'];
};

export enum InviteCanActions {
  Cancel = 'CANCEL'
}

export type InviteMemberToClientOrganizationMutation = {
  __typename: 'InviteMemberToClientOrganizationMutation';
  invite: InviteNode;
};

export type InviteMemberToVendorArguments = {
  assignedRoleIds: Array<Scalars['ID']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type InviteMemberToVendorMutation = {
  __typename: 'InviteMemberToVendorMutation';
  ok: Scalars['Boolean'];
};

export type InviteNode = Node & {
  __typename: 'InviteNode';
  acceptedAt: Maybe<Scalars['String']>;
  assignedFacilities: Array<FacilityNode>;
  assignedFacilityGroups: Array<FacilityGroupNode>;
  assignedRoles: Array<RoleNode>;
  can: Scalars['Boolean'];
  clientOrganization: ClientOrganizationNode;
  createdAt: Scalars['DateTime'];
  emailAddress: Scalars['String'];
  expiresAt: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  hasOnboardingAction: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  lastName: Scalars['String'];
  lastSentAt: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  status: Maybe<InviteStatus>;
  subscribedUsers: Maybe<Array<Maybe<UserNode>>>;
  vendorOrganization: VendorOrganizationNode;
};


export type InviteNodeCanArgs = {
  perform: InviteCanActions;
};

export type InviteNodeConnection = {
  __typename: 'InviteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InviteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `InviteNode` and its cursor. */
export type InviteNodeEdge = {
  __typename: 'InviteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<InviteNode>;
};

export type InviteOwnerToOnboardingMutation = {
  __typename: 'InviteOwnerToOnboardingMutation';
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum InviteType {
  ClientSelfServeOnboarding = 'CLIENT_SELF_SERVE_ONBOARDING',
  Iyov = 'IYOV',
  User = 'USER'
}

export type InvoiceApprovalSettings = {
  __typename: 'InvoiceApprovalSettings';
  approvalRoles: Array<RoleNode>;
  strategy: InvoiceApprovalStrategy;
};

/** An enumeration. */
export enum InvoiceApprovalStrategy {
  Auto = 'AUTO',
  Single = 'SINGLE'
}

export type InvoicePaymentInput = {
  amount: Scalars['Decimal'];
  invoice: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  referenceDate: Scalars['Date'];
  referenceNumber: Scalars['String'];
};

export type InvoicePaymentPreview = {
  __typename: 'InvoicePaymentPreview';
  achPreviews: Maybe<Array<PreAuthorizedDebitPreview>>;
  creditCardPreviews: Maybe<Array<CreditCardPaymentPreview>>;
  eftPreviews: Maybe<Array<PreAuthorizedDebitPreview>>;
  invoiceCount: Scalars['Decimal'];
  total: Scalars['Decimal'];
  workOrderCount: Scalars['Int'];
};

export type InvoiceSetNode = Node & {
  __typename: 'InvoiceSetNode';
  client: Maybe<ClientOrganizationNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  offResqCustomer: Maybe<OffResqCustomerNode>;
  vendor: VendorOrganizationNode;
  workOrder: Maybe<WorkOrderNode>;
};

export type InvoiceValidationNode = Node & {
  __typename: 'InvoiceValidationNode';
  flaggingRulesBroken: Array<RuleBroken>;
  /** The ID of the object */
  id: Scalars['ID'];
  ranFlaggingRules: Scalars['Boolean'];
  validationMessages: Array<Scalars['String']>;
  validationResults: Array<InvoiceValidationResult>;
};

export type InvoiceValidationResult = {
  __typename: 'InvoiceValidationResult';
  validationAction: Maybe<ValidationRuleResultAction>;
  validationMessage: Scalars['String'];
};

/** An enumeration. */
export enum InvoicingVersion {
  Markup = 'MARKUP',
  RevenueShare = 'REVENUE_SHARE'
}

export type JobsPerServiceCategory = {
  __typename: 'JobsPerServiceCategory';
  count: Scalars['Int'];
  month: Scalars['DateTime'];
  serviceCategory: ServiceCategory;
};

export type JobsPerType = {
  __typename: 'JobsPerType';
  maintenancePlanJobsCount: Scalars['Int'];
  onDemandJobsCount: Scalars['Int'];
};

export type KustomerWorkOrderEscalationNode = Node & {
  __typename: 'KustomerWorkOrderEscalationNode';
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  kustomerConversationId: Scalars['String'];
  kustomerUrl: Maybe<Scalars['String']>;
  ticketNumber: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LineItemInput = {
  description?: InputMaybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  itemType: RecordOfWorkLineItemEnum;
  markup?: InputMaybe<Scalars['Decimal']>;
  order?: InputMaybe<Scalars['Int']>;
  overtime?: InputMaybe<Scalars['Boolean']>;
  partManufacturer?: InputMaybe<Scalars['String']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Decimal']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate?: InputMaybe<Scalars['Decimal']>;
  revShare?: InputMaybe<Scalars['Decimal']>;
  taxRateIds: Array<Scalars['ID']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']>>;
  warranty?: InputMaybe<Scalars['Boolean']>;
};

export type LocationAddressResolutionNode = Node & {
  __typename: 'LocationAddressResolutionNode';
  address: Maybe<Scalars['String']>;
  addressesMatch: Scalars['Boolean'];
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isOverridden: Scalars['Boolean'];
  postalCode: Maybe<Scalars['String']>;
  province: Maybe<Scalars['String']>;
  resolvedSuccessfully: Scalars['Boolean'];
  validationMessages: Array<Scalars['String']>;
};

export type LocationAddressResolutionNodeConnection = {
  __typename: 'LocationAddressResolutionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationAddressResolutionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LocationAddressResolutionNode` and its cursor. */
export type LocationAddressResolutionNodeEdge = {
  __typename: 'LocationAddressResolutionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<LocationAddressResolutionNode>;
};

export enum MaintenancePlanFrequencyUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** An enumeration. */
export enum MaintenancePlanInitialWorkOrderStatus {
  AwaitingRecordOfWork = 'AWAITING_RECORD_OF_WORK',
  AwaitingResqApproval = 'AWAITING_RESQ_APPROVAL',
  AwaitingScheduling = 'AWAITING_SCHEDULING'
}

export type MaintenancePlanNode = Node & {
  __typename: 'MaintenancePlanNode';
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  currency: Currency;
  currentWorkOrder: Maybe<WorkOrderNode>;
  facility: FacilityNode;
  /** The ID of the object */
  id: Scalars['ID'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String'];
  maintenancePlanType: MaintenancePlanTypeNode;
  /** Specifies the name of the MP, historical data backfilled with name of associated MP type */
  name: Maybe<Scalars['String']>;
  /** @deprecated Use next_work_order_creation_date instead. Removed in RESQ-1647. */
  nextExpectedServiceDate: Scalars['DateTime'];
  nextWorkOrderCreationDate: Scalars['Date'];
  opsOwner: Maybe<UserNode>;
  organization: ClientOrganizationNode;
  price: Scalars['Decimal'];
  priceAfterMarkup: Scalars['Decimal'];
  priceBeforeMarkup: Scalars['Decimal'];
  recordOfWorkTemplate: Maybe<RecordOfWorkTemplateNode>;
  scopeOfWork: Scalars['String'];
  serviceFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue: Maybe<Scalars['Int']>;
  status: MaintenancePlanStatus;
  /** @deprecated Unused. Please refer to RESQ-1943 */
  taxRate: Scalars['Decimal'];
  variablePricing: Scalars['Boolean'];
  vendor: VendorOrganizationNode;
  workOrders: Array<WorkOrderNode>;
};

export type MaintenancePlanNodeConnection = {
  __typename: 'MaintenancePlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaintenancePlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MaintenancePlanNode` and its cursor. */
export type MaintenancePlanNodeEdge = {
  __typename: 'MaintenancePlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<MaintenancePlanNode>;
};

export enum MaintenancePlanStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT'
}

export type MaintenancePlanTypeNode = Node & {
  __typename: 'MaintenancePlanTypeNode';
  defaultBillingFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  defaultBillingFrequencyValue: Maybe<Scalars['Int']>;
  defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  defaultServiceFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  defaultServiceFrequencyValue: Maybe<Scalars['Int']>;
  defaultVariablePricing: Scalars['Boolean'];
  description: Scalars['String'];
  disabled: Scalars['Boolean'];
  eligibleFacilities: Array<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  image: ImageType;
  maintenancePlans: Array<MaintenancePlanNode>;
  name: Scalars['String'];
  serviceCategory: ServiceCategory;
  /** @deprecated Replaced with service category */
  subcategory: TradeNode;
};


export type MaintenancePlanTypeNodeEligibleFacilitiesArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type MaintenancePlanTypeNodeMaintenancePlansArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type MaintenancePlanTypeNodeConnection = {
  __typename: 'MaintenancePlanTypeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaintenancePlanTypeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MaintenancePlanTypeNode` and its cursor. */
export type MaintenancePlanTypeNodeEdge = {
  __typename: 'MaintenancePlanTypeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<MaintenancePlanTypeNode>;
};

export type MarkApBatchesAsPaidMutationInput = {
  apBatchIds: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  referenceDate: Scalars['Date'];
  referenceNumber: Scalars['String'];
};

export type MarkApBatchesAsPaidMutationPayload = {
  __typename: 'MarkAPBatchesAsPaidMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type MarkApBatchesAsUnpaidMutationInput = {
  apBatchIds: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type MarkApBatchesAsUnpaidMutationPayload = {
  __typename: 'MarkAPBatchesAsUnpaidMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type MarkInboxItemReadMutation = {
  __typename: 'MarkInboxItemReadMutation';
  inboxItem: InboxItemNode;
};

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput = {
  assignmentId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  photos: Array<Image>;
};

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload = {
  __typename: 'MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type MarketCategoryPricingInput = {
  labourCost: Scalars['Decimal'];
  serviceCallCost: Scalars['Decimal'];
  serviceCategory: ServiceCategory;
};

export type MarketCategoryPricingNode = Node & {
  __typename: 'MarketCategoryPricingNode';
  /** The ID of the object */
  id: Scalars['ID'];
  labourCost: Scalars['Decimal'];
  serviceCallCost: Scalars['Decimal'];
  serviceCategory: ServiceCategory;
};

export type MarketNode = Node & {
  __typename: 'MarketNode';
  disabledCategories: Maybe<Array<ServiceCategory>>;
  /** The ID of the object */
  id: Scalars['ID'];
  isCore: Scalars['Boolean'];
  name: Scalars['String'];
  operatingAreas: Array<OperatingAreaNode>;
  pricing: MarketPricingNode;
};

export type MarketNodeConnection = {
  __typename: 'MarketNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MarketNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MarketNode` and its cursor. */
export type MarketNodeEdge = {
  __typename: 'MarketNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<MarketNode>;
};

export type MarketPricingInput = {
  categoryPricing: Array<MarketCategoryPricingInput>;
  markupPercentage: Scalars['Decimal'];
};

export type MarketPricingNode = Node & {
  __typename: 'MarketPricingNode';
  categoryPricing: Array<MarketCategoryPricingNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  markupPercentage: Scalars['Decimal'];
};

export type MarkupInputLineItemType = {
  description?: InputMaybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal'];
  order: Scalars['Int'];
  overtime?: InputMaybe<Scalars['Boolean']>;
  partManufacturer?: InputMaybe<Scalars['String']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  taxRateIds: Array<Scalars['ID']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']>>;
  warranty: Scalars['Boolean'];
};

export type MatchBadExperience = {
  __typename: 'MatchBadExperience';
  hasDispute: Scalars['Boolean'];
  hasNegativeReview: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export enum MemberPermission {
  Manage = 'MANAGE',
  Onboard = 'ONBOARD',
  Schedule = 'SCHEDULE'
}

export type MergeApBatchesMutationInput = {
  batchIds: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  dueAtDate: Scalars['Date'];
};

export type MergeApBatchesMutationPayload = {
  __typename: 'MergeAPBatchesMutationPayload';
  batch: ApBatchNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type MetricsPeriod = {
  __typename: 'MetricsPeriod';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type MiscellaneousHold = Node & {
  __typename: 'MiscellaneousHold';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this hold was cancelled. Operations that can cancel a hold: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The time at which this hold was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The vendor's description as to why the work order was placed on hold. */
  notes: Scalars['String'];
  permissions: MiscellaneousHoldPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type MiscellaneousHoldConnection = {
  __typename: 'MiscellaneousHoldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MiscellaneousHoldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `MiscellaneousHold` and its cursor. */
export type MiscellaneousHoldEdge = {
  __typename: 'MiscellaneousHoldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<MiscellaneousHold>;
};

export type MiscellaneousHoldPermissions = {
  __typename: 'MiscellaneousHoldPermissions';
  fulfill: Scalars['Boolean'];
};

export type MoveEquipmentToAnotherFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  destinationFacilityId: Scalars['String'];
  sourceFacilityId: Scalars['String'];
};

export type MoveEquipmentToAnotherFacilityPayload = {
  __typename: 'MoveEquipmentToAnotherFacilityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type MoveWorkOrderToAwaitingRecordOfWorkMutation = {
  __typename: 'MoveWorkOrderToAwaitingRecordOfWorkMutation';
  ok: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export type Mutations = {
  __typename: 'Mutations';
  acceptRequestForQuote: Maybe<AcceptRequestForQuotePayload>;
  activateMaintenancePlan: Maybe<ActivateMaintenancePlanMutation>;
  activatePreventativeMaintenance: Maybe<ActivatePreventitiveMaintenanceMutationPayload>;
  addAfterImagesToVisit: Maybe<AddAfterImagesToVisitPayload>;
  addAttachment: Maybe<AddAttachmentMutation>;
  addBarcode: Maybe<AddBarcodeMutationPayload>;
  addBeforeImagesToVisit: Maybe<AddBeforeImagesToVisitPayload>;
  addClientOrganization: Maybe<AddClientOrganizationMutation>;
  addEquipment: Maybe<AddEquipmentMutation>;
  addExistingUserToClientOrganization: Maybe<AddExistingUserToClientOrganizationMutation>;
  addExistingUserToVendor: Maybe<AddExistingUserToVendorMutationPayload>;
  addExternalExpense: Maybe<AddExternalExpenseMutationPayload>;
  addImageToWorkOrder: Maybe<AddImageToWorkOrderMutation>;
  addNewUserToClientOrganization: Maybe<AddNewUserToClientOrganizationMutation>;
  addNewUserToVendor: Maybe<AddNewUserToVendorMutation>;
  addOwnerToClientOrganization: Maybe<AddOwnerToClientOrganizationMutationPayload>;
  agreeVendorTos: Maybe<AgreeVendorTosPayload>;
  approveQuoteSetOptionForSpend: Maybe<ApproveQuoteSetOptionForSpendPayload>;
  /** Approves a record of work for invoicing. */
  approveRecordOfWork: Maybe<ApproveRecordOfWorkMutation>;
  approveWorkOrderClientInvoices: Maybe<ApproveWorkOrderClientInvoicesMutation>;
  archiveReportTemplate: Maybe<ArchiveReportTemplatePayload>;
  assignUsersToRole: Maybe<AssignUsersToRoleMutationPayload>;
  assignWorkOrderEscalation: Maybe<AssignWorkOrderEscalationPayload>;
  assignWorkOrderToTeamMember: Maybe<AssignWorkOrderToTeamMemberPayload>;
  associateUserTags: Maybe<AssociateUserTagsMutationPayload>;
  blockAp: Maybe<BlockApMutationPayload>;
  bulkCreateFavouriteVendorConfiguration: Maybe<BulkCreateFavouriteVendorConfigurationPayload>;
  bulkDeleteFavouriteVendorConfigurations: Maybe<BulkDeleteFavouriteVendorConfigurationsPayload>;
  cancelInvite: Maybe<CancelInviteMutation>;
  cancelMaintenancePlan: Maybe<CancelMaintenancePlanMutation>;
  cancelWorkOrder: Maybe<CancelWorkOrderMutation>;
  captureVisitNotes: Maybe<CaptureVisitNotesPayload>;
  changePassword: Maybe<ChangePasswordMutation>;
  chargePaymentMethod: Maybe<ChargePaymentMethodPayload>;
  checkUncheckWorkOrderTask: Maybe<CheckUncheckWorkOrderTaskPayload>;
  completeBillingEntityOnboardingStep: Maybe<CompleteBillingEntityOnboardingStepMutationPayload>;
  completeClientOnboarding: Maybe<CompleteClientOnboardingMutation>;
  completeFacilitiesOnboardingStep: Maybe<CompleteFacilitiesOnboardingStepMutationPayload>;
  completeGetStartedOnboardingStep: Maybe<CompleteGetStartedOnboardingStepMutationPayload>;
  completeInternalRequestTeamMemberAssignment: Maybe<CompleteInternalRequestTeamMemberAssignmentPayload>;
  completePaymentInfoOnboardingStep: Maybe<CompletePaymentInfoOnboardingStepMutationPayload>;
  completeRatesOnboardingStep: Maybe<CompleteRatesOnboardingStepMutationPayload>;
  completeStaffOnboardingStep: Maybe<CompleteStaffOnboardingStepMutationPayload>;
  completeTroubleshootingSession: Maybe<CompleteTroubleshootingSessionMutationPayload>;
  completeVendorOnboarding: Maybe<CompleteVendorOnboardingMutationPayload>;
  completeWorkOrderTeamMemberAssignment: Maybe<CompleteWorkOrderTeamMemberAssignmentPayload>;
  confirmVendorAgreement: Maybe<ConfirmVendorAgreementMutationPayload>;
  createBudget: Maybe<CreateBudgetMutationPayload>;
  createBusinessUnit: Maybe<CreateBusinessUnitMutation>;
  createClientAdjustmentInvoice: Maybe<CreateClientAdjustmentInvoicePayload>;
  createClientAutoAdjustmentInvoice: Maybe<CreateClientAutoAdjustmentInvoiceMutationPayload>;
  createComment: Maybe<CreateCommentMutation>;
  createControlCenterUser: Maybe<CreateControlCenterUserMutationPayload>;
  createCoordinator: Maybe<CreateCoordinatorMutationPayload>;
  createCyovDispatch: Maybe<CreateCyovDispatchPayload>;
  createDeviceConfigs: Maybe<CreateDeviceConfigsPayload>;
  createDeviceDataExport: Maybe<CreateDeviceDataExportPayload>;
  createExternalBankAccount: Maybe<CreateExternalBankAccountMutation>;
  createFacility: Maybe<CreateFacilityPayload>;
  createFacilityGroup: Maybe<CreateFacilityGroupPayload>;
  createFavouriteVendorConfiguration: Maybe<CreateFavouriteVendorConfigurationPayload>;
  createMaintenancePlan: Maybe<CreateMaintenancePlanMutation>;
  createMarket: Maybe<CreateMarketPayload>;
  createOffResqCustomer: Maybe<CreateOffResqCustomerMutationPayload>;
  createOrUpdateBusinessUnitOnboarding: Maybe<CreateOrUpdateBusinessUnitOnboardingMutationPayload>;
  createOriginalVendorInvoice: Maybe<CreateOriginalVendorInvoiceMutationPayload>;
  createPaymentMethod: Maybe<CreatePaymentMethodMutationPayload>;
  createPmOneTimeWorkOrder: Maybe<CreatePmOneTimeWorkOrderPayload>;
  createPreventativeMaintenance: Maybe<CreatePreventativeMaintenancePayload>;
  createQuote: Maybe<CreateQuoteMutationPayload>;
  createQuoteSetOptions: Maybe<CreateQuoteSetOptionsPayload>;
  createReportTemplate: Maybe<CreateReportTemplatePayload>;
  createRole: Maybe<CreateRolePayload>;
  createRuleViolations: Maybe<CreateRuleViolationsMutationPayload>;
  createRuleViolationsFeedback: Maybe<CreateRuleViolationsFeedbackPayload>;
  createTroubleshootingSession: Maybe<CreateTroubleshootingSessionMutationPayload>;
  createUpdateDispatchRelationship: Maybe<CreateUpdateDispatchRelationshipMutationPayload>;
  createUpdateExternalReference: Maybe<CreateUpdateExternalReferenceMutationPayload>;
  createUpdateWorkOrderExpenseType: Maybe<CreateUpdateWorkOrderExpenseTypeMutationPayload>;
  createVendor: Maybe<CreateVendorMutation>;
  createVendorAdjustmentInvoice: Maybe<CreateVendorAdjustmentInvoiceMutation>;
  createVendorAutoAdjustmentInvoice: Maybe<CreateVendorAutoAdjustmentInvoiceMutationPayload>;
  createVendorInternalNote: Maybe<CreateVendorInternalNoteMutation>;
  createVendorInvoiceBatch: Maybe<CreateVendorInvoiceBatchMutation>;
  createVisitReview: Maybe<CreateVisitReviewMutation>;
  createWorkOrderEscalation: Maybe<CreateWorkOrderEscalationPayload>;
  createWorkOrderInternalNote: Maybe<CreateWorkOrderInternalNotePayload>;
  createWorkOrderNote: Maybe<CreateWorkOrderNotePayload>;
  createWorkOrderReview: Maybe<CreateWorkOrderReviewMutation>;
  createWorkOrderV2: Maybe<CreateWorkOrderV2Payload>;
  deactivateEquipmentMutation: Maybe<DeactivateEquipmentPayload>;
  deactivateFacility: Maybe<DeactivateFacilityPayload>;
  declineVendorDispatchRequest: Maybe<DeclineVendorDispatchRequestMutationPayload>;
  deleteAttachment: Maybe<DeleteAttachmentMutation>;
  deleteBudget: Maybe<DeleteBudgetMutationPayload>;
  deleteBusinessUnit: Maybe<DeleteBusinessUnitMutationPayload>;
  deleteClientReportSchedule: Maybe<DeleteClientReportScheduleMutationPayload>;
  deleteComment: Maybe<DeleteCommentMutation>;
  deleteDispatchRelationship: Maybe<DeleteDispatchRelationshipMutationPayload>;
  deleteFacility: Maybe<DeleteFacilityPayload>;
  deleteFacilityGroup: Maybe<DeleteFacilityGroupPayload>;
  deleteFavouriteVendorConfiguration: Maybe<DeleteFavouriteVendorConfigurationPayload>;
  deleteImageFromWorkOrder: Maybe<DeleteImageFromWorkOrderMutation>;
  deleteInboundVendorInvoice: Maybe<DeleteInboundVendorInvoiceMutationPayload>;
  deletePreventativeMaintenance: Maybe<DeletePreventativeMaintenancePayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  deleteWorkOrderInternalNote: Maybe<DeleteWorkOrderInternalNotePayload>;
  dismiss: Maybe<DismissMutationPayload>;
  dismissWorkOrderNoteMetadata: Maybe<DismissWorkOrderNoteMetadataMutationPayload>;
  disputeWorkOrder: Maybe<DisputeWorkOrderMutation>;
  editBlockedGroups: Maybe<EditBlockedGroupsPayload>;
  editClientOrganization: Maybe<EditClientOrganizationMutation>;
  editClientOrganizationMember: Maybe<EditClientOrganizationMemberMutation>;
  editClientVendorRelationshipInvite: Maybe<EditClientVendorRelationshipInvitePayload>;
  editEquipment: Maybe<EditEquipmentMutation>;
  editFavouriteVendorConfiguration: Maybe<EditFavouriteVendorConfigurationPayload>;
  editOrgOwner: Maybe<EditOrgOwnerMutationPayload>;
  editOrganizationFeatures: Maybe<EditOrganizationFeaturesMutationPayload>;
  editPreventativeMaintenance: Maybe<EditPreventativeMaintenancePayload>;
  editQuote: Maybe<EditQuoteMutationPayload>;
  editUserDjangoGroups: Maybe<EditUserDjangoGroupsMutationPayload>;
  /** @deprecated Deprecated in favour of updateUserProfile. */
  editVendorUserDetails: Maybe<EditVendorUserDetailsMutation>;
  editWorkOrder: Maybe<EditWorkOrderPayload>;
  endActivity: Maybe<EndActivityPayload>;
  endVisit: Maybe<EndVisitPayload>;
  forceWorkOrderCompletion: Maybe<ForceWorkOrderCompletionMutationPayload>;
  generateKustomerLoginToken: Maybe<GenerateKustomerLoginTokenPayload>;
  generateVendorInvoicePdf: Maybe<GenerateVendorInvoicePdfPayload>;
  importPaidInvoices: Maybe<ImportPaidInvoicesPayload>;
  initiateMarketplaceOnboarding: Maybe<InitiateMarketplaceOnboardingMutationPayload>;
  inviteMemberToClientOrganization: Maybe<InviteMemberToClientOrganizationMutation>;
  inviteMemberToVendor: Maybe<InviteMemberToVendorMutation>;
  inviteOwnerToOnboarding: Maybe<InviteOwnerToOnboardingMutation>;
  markApBatchesAsPaid: Maybe<MarkApBatchesAsPaidMutationPayload>;
  markApBatchesAsUnpaid: Maybe<MarkApBatchesAsUnpaidMutationPayload>;
  markInboxItemRead: Maybe<MarkInboxItemReadMutation>;
  markWorkOrderTeamMemberAssignmentAsUnresolved: Maybe<MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload>;
  mergeApBatches: Maybe<MergeApBatchesMutationPayload>;
  moveEquipmentToAnotherFacility: Maybe<MoveEquipmentToAnotherFacilityPayload>;
  moveWorkOrderToAwaitingRecordOfWork: Maybe<MoveWorkOrderToAwaitingRecordOfWorkMutation>;
  overrideLocationAddress: Maybe<OverrideLocationAddressMutationPayload>;
  processInboundVendorInvoice: Maybe<ProcessInboundVendorInvoiceMutationPayload>;
  raiseApprovedSpendDuringWorkOrderSubmission: Maybe<RaiseApprovedSpendDuringWorkOrderSubmissionPayload>;
  reactivateEquipmentMutation: Maybe<ReactivateEquipmentPayload>;
  reactivateFacility: Maybe<ReactivateFacilityMutationPayload>;
  reassignWorkOrderToTeamMember: Maybe<ReassignWorkOrderToTeamMemberPayload>;
  reassignWorkOrderVendor: Maybe<ReassignWorkOrderVendorPayload>;
  recordPayment: Maybe<RecordPaymentPayload>;
  recordSuccessfulTroubleshooting: Maybe<RecordSuccessfulTroubleshootingMutationPayload>;
  /** Regenerates client and vendor invoices of a record of work for invoicing. */
  regenerateInvoices: Maybe<RegenerateInvoicesMutationPayload>;
  rejectClientWorkOrder: Maybe<RejectClientWorkOrderPayload>;
  rejectQuoteSet: Maybe<RejectQuoteSetPayload>;
  rejectQuoteSetOptionForSpend: Maybe<RejectQuoteSetOptionForSpendPayload>;
  removePaymentMethod: Maybe<RemovePaymentMethodMutationPayload>;
  removeQuote: Maybe<RemoveQuoteMutation>;
  removeQuoteSetOption: Maybe<RemoveQuoteSetOptionPayload>;
  removeUpcomingAllocation: Maybe<RemoveUpcomingAllocationMutationPayload>;
  removeUserFromClientOrganization: Maybe<RemoveUserFromClientOrganizationMutation>;
  removeUsersFromRole: Maybe<RemoveUsersFromRoleMutationPayload>;
  removeVendorMember: Maybe<RemoveVendorMemberMutation>;
  removeVendorPayoutInfo: Maybe<RemoveVendorPayoutInfoMutationPayload>;
  requestAutopayChanges: Maybe<RequestAutopayChangesMutationPayload>;
  requestDispatchChanges: Maybe<RequestDispatchChangesMutationPayload>;
  requestMaintenancePlan: Maybe<RequestMaintenancePlanMutationPayload>;
  requestNewCapexProject: Maybe<RequestNewCapexProjectMutationPayload>;
  requestPlannedMaintenanceQuote: Maybe<RequestPlannedMaintenanceQuoteMutationPayload>;
  requestQuote: Maybe<RequestMaintenancePlanQuoteMutation>;
  requestServiceGuarantee: Maybe<RequestServiceGuaranteePayload>;
  rescheduleAppointment: Maybe<RescheduleAppointmentPayload>;
  rescheduleInternalAppointment: Maybe<RescheduleInternalAppointmentPayload>;
  resendClientVendorRelationshipInvite: Maybe<ResendClientVendorRelationshipInvitePayload>;
  resetQuoteSet: Maybe<ResetQuoteSetPayload>;
  resolveFacilityExpansion: Maybe<ResolveFacilityExpansionMutationPayload>;
  resolveFlaggedInvoice: Maybe<ResolveFlaggedInvoicePayload>;
  resolveIncidents: Maybe<ResolveIncidentsPayload>;
  resolveWorkOrderDispute: Maybe<ResolveWorkOrderDisputeMutation>;
  resolveWorkOrderEscalation: Maybe<ResolveWorkOrderEscalationPayload>;
  reverseClientInvoicePayment: Maybe<ReverseClientInvoicePaymentMutationPayload>;
  revokeClientVendorRelationshipInvite: Maybe<RevokeClientVendorRelationshipInvitePayload>;
  /** Creates or updates a record of work by work order. */
  saveRecordOfWork: Maybe<SaveRecordOfWorkMutation>;
  scheduleInternalAppointment: Maybe<ScheduleInternalAppointmentPayload>;
  selectQuoteSetOption: Maybe<SelectQuoteSetOptionPayload>;
  sendInviteSms: Maybe<SendInviteSmsMutation>;
  sendReport: Maybe<SendReportPayload>;
  sendWelcomeEmail: Maybe<SendWelcomeEmailMutationPayload>;
  setEstimatedTimeOfArrivalSourcingParts: Maybe<SetEstimatedTimeOfArrivalSourcingPartsMutationPayload>;
  setNotificationPreference: Maybe<SetNotificationPreferencePayload>;
  setSubscriptionAddons: Maybe<SetSubscriptionAddonsPayload>;
  setUserNotificationPreference: Maybe<SetUserNoficationPreferenceMutationPayload>;
  setVendorAgreementPlans: Maybe<SetVendorAgreementPlansMutationPayload>;
  setupPreAuthorizedDebit: Maybe<SetupPreAuthorizedDebitMutationPayload>;
  skipWorkOrderReview: Maybe<SkipWorkOrderReviewMutation>;
  snooze: Maybe<SnoozeMutationPayload>;
  snoozeIncidents: Maybe<SnoozeIncidentsPayload>;
  snoozeReviews: Maybe<SnoozeReviewsPayload>;
  startAppointmentActivity: Maybe<StartAppointmentActivityPayload>;
  startChooseVendorActivity: Maybe<StartChooseVendorActivityPayload>;
  startDispatchActivity: Maybe<StartDispatchActivityPayload>;
  startFindingQuoteActivity: Maybe<StartFindingQuoteActivityPayload>;
  startOnHoldActivity: Maybe<StartOnHoldActivityPayload>;
  startOrganizationSubscription: Maybe<StartOrganizationSubscriptionMutationPayload>;
  startResqReviewActivity: Maybe<StartResqReviewActivityPayload>;
  startSchedulingActivity: Maybe<StartSchedulingActivityPayload>;
  startSchedulingCalldown: Maybe<StartSchedulingCalldownPayload>;
  startSiteVisitActivity: Maybe<StartSiteVisitActivityPayload>;
  startSourcingPartsActivity: Maybe<StartSourcingPartsActivityPayload>;
  startSubscription: Maybe<StartSubscriptionPayload>;
  startVisit: Maybe<StartVisitMutationPayload>;
  stopOrganizationSubscriptions: Maybe<DeactivateOrganizationSubscriptionsPayload>;
  submitOffResqVendorInvoice: Maybe<SubmitOffResqVendorInvoiceMutationPayload>;
  submitQuoteFeedback: Maybe<SubmitQuoteFeedbackMutation>;
  submitRecordOfWork: Maybe<SubmitRecordOfWorkPayload>;
  submitVendorInvoice: Maybe<SubmitVendorInvoiceMutation>;
  submitWorkOrder: Maybe<SubmitWorkOrderPayload>;
  submitWorkOrderForApproval: Maybe<SubmitWorkOrderForApproval>;
  submitWorkOrderToMarketplace: Maybe<SubmitWorkOrderToMarketplacePayload>;
  triggerSampleNotification: Maybe<TriggerSampleNotificationPayload>;
  /** Unapproves a record of work for invoicing. */
  unapproveRecordOfWork: Maybe<UnapproveRecordOfWorkMutationPayload>;
  unarchiveReportTemplate: Maybe<UnarchiveReportTemplatePayload>;
  unassignedWorkOrderFromVendorCompany: Maybe<UnassignWorkOrderFromVendorCompanyMutation>;
  unblockAp: Maybe<UnblockApMutationPayload>;
  unblockVendor: Maybe<UnblockVendorMutation>;
  uncancelWorkOrder: Maybe<UncancelWorkOrderMutation>;
  updateApBatch: Maybe<UpdateApBatchMutationPayload>;
  updateBudget: Maybe<UpdateBudgetMutationPayload>;
  updateBusinessUnit: Maybe<UpdateBusinessUnitMutation>;
  updateClientOrgSensitivity: Maybe<UpdateClientOrgSensitivityMutationPayload>;
  updateClientOrganizationStatus: Maybe<UpdateClientOrganizationStatusMutationPayload>;
  updateClientReportSchedule: Maybe<UpdateClientReportScheduleMutationPayload>;
  updateDevice: Maybe<UpdateDeviceMutation>;
  updateDeviceConfigs: Maybe<UpdateDeviceConfigsPayload>;
  updateExternalBankAccount: Maybe<UpdateExternalBankAccountMutation>;
  updateExternalExpense: Maybe<UpdateExternalExpenseMutationPayload>;
  updateFacility: Maybe<UpdateFacilityMutation>;
  updateFacilityGroup: Maybe<UpdateFacilityGroupPayload>;
  updateFacilityGroupOpsOwnerMutation: Maybe<UpdateFacilityGroupOpsOwnerPayload>;
  updateFavouriteVendorInviteSubscription: Maybe<UpdateFavouriteVendorInviteSubscriptionMutationPayload>;
  updateGlCodes: Maybe<UpdateGlCodesMutationPayload>;
  updateInternalRequestTeamMemberAssignments: Maybe<UpdateInternalRequestTeamMemberAssignmentsPayload>;
  updateInvoiceApprovalSettings: Maybe<UpdateInvoiceApprovalSettingsPayload>;
  updateMaintenancePlan: Maybe<UpdateMaintenancePlanMutation>;
  updateMarket: Maybe<UpdateMarketPayload>;
  updateOffResqCustomer: Maybe<UpdateOffResqCustomerMutationPayload>;
  updateOrganizationSubscription: Maybe<UpdateOrganizationSubscriptionMutationPayload>;
  updatePreventativeMaintenanceTaskListItems: Maybe<UpdatePreventativeMaintenanceTaskListItemsPayload>;
  updatePriceRateOverrides: Maybe<UpdatePriceRateOverridesMutationPayload>;
  updateQuoteAcceptanceSettings: Maybe<UpdateQuoteAcceptanceSettingsPayload>;
  updateQuoteApprovalThresholds: Maybe<UpdateQuoteApprovalThresholdsPayload>;
  updateReportTemplate: Maybe<UpdateReportTemplatePayload>;
  updateRevenueShareOverrides: Maybe<UpdateRevenueShareOverridesMutationPayload>;
  updateRole: Maybe<UpdateRolePayload>;
  updateServiceCategories: Maybe<UpdateServiceCategoriesPayload>;
  updateSpendApprovalPreferences: Maybe<UpdateSpendApprovalPreferencesPayload>;
  updateSubscription: Maybe<UpdateSubscriptionPayload>;
  updateTroubleshootingAction: Maybe<UpdateTroubleshootingActionMutationPayload>;
  updateUserProfile: Maybe<UpdateUserProfileMutationPayload>;
  updateVendor: Maybe<UpdateVendorMutation>;
  updateVendorGeneralInfo: Maybe<UpdateVendorGeneralInfoMutationPayload>;
  updateVendorInsuranceDocument: Maybe<UpdateVendorInsuranceDocumentMutationPayload>;
  updateVendorMarketplace: Maybe<UpdateVendorMarketplaceMutationPayload>;
  updateVendorMember: Maybe<UpdateVendorMemberMutation>;
  updateVendorOpenToMarketplace: Maybe<UpdateVendorOpenToMarketplaceMutationPayload>;
  updateVendorPayoutInfo: Maybe<UpdateVendorPayoutInfoMutationPayload>;
  updateVendorPriceRates: Maybe<UpdateVendorPriceRatesMutationPayload>;
  updateVendorProfileDispatch: Maybe<UpdateVendorProfileDispatchMutationPayload>;
  updateVendorRevenueShares: Maybe<UpdateVendorRevenueSharesMutationPayload>;
  updateVisit: Maybe<UpdateVisitPayload>;
  updateWorkOrderCompletionTime: Maybe<UpdateWorkOrderCompletionTimePayload>;
  updateWorkOrderNte: Maybe<UpdateWorkOrderNtePayload>;
  updateWorkOrderOpsOwner: Maybe<UpdateWorkOrderOpsOwnerMutation>;
  uploadAfterImages: Maybe<UploadAfterImagesMutation>;
  uploadQuote: Maybe<UploadQuoteMutationPayload>;
  uploadVendorInvoice: Maybe<UploadVendorInvoicePayload>;
  voidSubscriptionInvoiceMutation: Maybe<VoidSubscriptionInvoiceMutationPayload>;
};


export type MutationsAcceptRequestForQuoteArgs = {
  input: AcceptRequestForQuoteInput;
};


export type MutationsActivateMaintenancePlanArgs = {
  maintenancePlanId: Scalars['ID'];
};


export type MutationsActivatePreventativeMaintenanceArgs = {
  input: ActivatePreventitiveMaintenanceMutationInput;
};


export type MutationsAddAfterImagesToVisitArgs = {
  input: AddAfterImagesToVisitInput;
};


export type MutationsAddAttachmentArgs = {
  attachToId: Scalars['ID'];
  file: Scalars['String'];
  fileContentType: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
};


export type MutationsAddBarcodeArgs = {
  input: AddBarcodeMutationInput;
};


export type MutationsAddBeforeImagesToVisitArgs = {
  input: AddBeforeImagesToVisitInput;
};


export type MutationsAddClientOrganizationArgs = {
  contractSignedOn?: InputMaybe<Scalars['Date']>;
  currency: Currency;
  invoiceApprovalStrategy: InvoiceApprovalStrategy;
  isEnterprise?: InputMaybe<Scalars['Boolean']>;
  markup: Scalars['Decimal'];
  name: Scalars['String'];
  offlinePaymentMethod?: InputMaybe<OfflinePaymentMethods>;
  operatingCountryId: Scalars['ID'];
  paymentMethod: PaymentMethodType;
  quoteApprovalStrategy: QuoteApprovalStrategy;
  reportingManagerId?: InputMaybe<Scalars['ID']>;
  sensitivity?: InputMaybe<Sensitivity>;
  sfId?: InputMaybe<Scalars['String']>;
  successOwnerId?: InputMaybe<Scalars['ID']>;
  tierId?: InputMaybe<Scalars['ID']>;
};


export type MutationsAddEquipmentArgs = {
  barCode: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  description: Scalars['String'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
  historicalSpend?: InputMaybe<Scalars['Decimal']>;
  installedOn?: InputMaybe<Scalars['Date']>;
  location: Scalars['String'];
  mainImage?: InputMaybe<Image>;
  manufacturer: Scalars['String'];
  modelNo: Scalars['String'];
  modelTagImage?: InputMaybe<Image>;
  name: Scalars['String'];
  photos?: InputMaybe<Array<InputMaybe<Image>>>;
  serialNo: Scalars['String'];
  subcategory?: InputMaybe<Scalars['String']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']>;
  warrantyNotes?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type MutationsAddExistingUserToClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID'];
  facilityIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
  username: Scalars['String'];
};


export type MutationsAddExistingUserToVendorArgs = {
  input: AddExistingUserToVendorMutationInput;
};


export type MutationsAddExternalExpenseArgs = {
  input: AddExternalExpenseMutationInput;
};


export type MutationsAddImageToWorkOrderArgs = {
  imageKey: Scalars['String'];
  workOrderId: Scalars['ID'];
};


export type MutationsAddNewUserToClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID'];
  email: Scalars['String'];
  facilityIds: Array<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  roleIds: Array<Scalars['ID']>;
  username: Scalars['String'];
};


export type MutationsAddNewUserToVendorArgs = {
  arguments: AddNewUserToVendorArguments;
};


export type MutationsAddOwnerToClientOrganizationArgs = {
  input: AddOwnerToClientOrganizationMutationInput;
};


export type MutationsAgreeVendorTosArgs = {
  input: AgreeVendorTosInput;
};


export type MutationsApproveQuoteSetOptionForSpendArgs = {
  input: ApproveQuoteSetOptionForSpendInput;
};


export type MutationsApproveRecordOfWorkArgs = {
  allowMissingMareketplacePlan?: InputMaybe<Scalars['Boolean']>;
  ranFlaggingRules?: InputMaybe<Scalars['Boolean']>;
  recordOfWorkId: Scalars['ID'];
};


export type MutationsApproveWorkOrderClientInvoicesArgs = {
  arguments: ApproveWorkOrderClientInvoicesArguments;
};


export type MutationsArchiveReportTemplateArgs = {
  input: ArchiveReportTemplateInput;
};


export type MutationsAssignUsersToRoleArgs = {
  input: AssignUsersToRoleMutationInput;
};


export type MutationsAssignWorkOrderEscalationArgs = {
  input: AssignWorkOrderEscalationInput;
};


export type MutationsAssignWorkOrderToTeamMemberArgs = {
  input: AssignWorkOrderToTeamMemberInput;
};


export type MutationsAssociateUserTagsArgs = {
  input: AssociateUserTagsMutationInput;
};


export type MutationsBlockApArgs = {
  input: BlockApMutationInput;
};


export type MutationsBulkCreateFavouriteVendorConfigurationArgs = {
  input: BulkCreateFavouriteVendorConfigurationInput;
};


export type MutationsBulkDeleteFavouriteVendorConfigurationsArgs = {
  input: BulkDeleteFavouriteVendorConfigurationsInput;
};


export type MutationsCancelInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationsCancelMaintenancePlanArgs = {
  maintenancePlanId: Scalars['ID'];
};


export type MutationsCancelWorkOrderArgs = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<WorkOrderCancellationReason>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<WorkOrderCancellationSource>;
  workOrderId: Scalars['ID'];
};


export type MutationsCaptureVisitNotesArgs = {
  input: CaptureVisitNotesInput;
};


export type MutationsChangePasswordArgs = {
  arguments: ChangePasswordArguments;
};


export type MutationsChargePaymentMethodArgs = {
  input: ChargePaymentMethodInput;
};


export type MutationsCheckUncheckWorkOrderTaskArgs = {
  input: CheckUncheckWorkOrderTaskInput;
};


export type MutationsCompleteBillingEntityOnboardingStepArgs = {
  input: CompleteBillingEntityOnboardingStepMutationInput;
};


export type MutationsCompleteClientOnboardingArgs = {
  organizationId: Scalars['ID'];
};


export type MutationsCompleteFacilitiesOnboardingStepArgs = {
  input: CompleteFacilitiesOnboardingStepMutationInput;
};


export type MutationsCompleteGetStartedOnboardingStepArgs = {
  input: CompleteGetStartedOnboardingStepMutationInput;
};


export type MutationsCompleteInternalRequestTeamMemberAssignmentArgs = {
  input: CompleteInternalRequestTeamMemberAssignmentInput;
};


export type MutationsCompletePaymentInfoOnboardingStepArgs = {
  input: CompletePaymentInfoOnboardingStepMutationInput;
};


export type MutationsCompleteRatesOnboardingStepArgs = {
  input: CompleteRatesOnboardingStepMutationInput;
};


export type MutationsCompleteStaffOnboardingStepArgs = {
  input: CompleteStaffOnboardingStepMutationInput;
};


export type MutationsCompleteTroubleshootingSessionArgs = {
  input: CompleteTroubleshootingSessionMutationInput;
};


export type MutationsCompleteVendorOnboardingArgs = {
  input: CompleteVendorOnboardingMutationInput;
};


export type MutationsCompleteWorkOrderTeamMemberAssignmentArgs = {
  input: CompleteWorkOrderTeamMemberAssignmentInput;
};


export type MutationsConfirmVendorAgreementArgs = {
  input: ConfirmVendorAgreementMutationInput;
};


export type MutationsCreateBudgetArgs = {
  input: CreateBudgetMutationInput;
};


export type MutationsCreateBusinessUnitArgs = {
  arguments: CreateBusinessUnitArguments;
};


export type MutationsCreateClientAdjustmentInvoiceArgs = {
  input: CreateClientAdjustmentInvoiceInput;
};


export type MutationsCreateClientAutoAdjustmentInvoiceArgs = {
  input: CreateClientAutoAdjustmentInvoiceMutationInput;
};


export type MutationsCreateCommentArgs = {
  contactReason?: InputMaybe<ContactReason>;
  contactSource?: InputMaybe<ContactSource>;
  message: Scalars['String'];
  workOrderId: Scalars['ID'];
};


export type MutationsCreateControlCenterUserArgs = {
  input: CreateControlCenterUserMutationInput;
};


export type MutationsCreateCoordinatorArgs = {
  input: CreateCoordinatorMutationInput;
};


export type MutationsCreateCyovDispatchArgs = {
  input: CreateCyovDispatchInput;
};


export type MutationsCreateDeviceConfigsArgs = {
  input: CreateDeviceConfigsInput;
};


export type MutationsCreateDeviceDataExportArgs = {
  input: CreateDeviceDataExportInput;
};


export type MutationsCreateExternalBankAccountArgs = {
  accountNumber: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  institutionNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  routingNumber: Scalars['String'];
  type: ExternalBankAccountType;
};


export type MutationsCreateFacilityArgs = {
  input: CreateFacilityInput;
};


export type MutationsCreateFacilityGroupArgs = {
  input: CreateFacilityGroupInput;
};


export type MutationsCreateFavouriteVendorConfigurationArgs = {
  input: CreateFavouriteVendorConfigurationInput;
};


export type MutationsCreateMaintenancePlanArgs = {
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int'];
  facilityId: Scalars['ID'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String'];
  maintenancePlanTypeId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nextWorkOrderCreationDate: Scalars['Date'];
  opsOwnerId?: InputMaybe<Scalars['ID']>;
  priceAfterMarkup: Scalars['Decimal'];
  priceBeforeMarkup: Scalars['Decimal'];
  scopeOfWork: Scalars['String'];
  serviceFrequencyUnit?: InputMaybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']>;
  templateLineItems?: InputMaybe<Array<LineItemInput>>;
  templateNotes?: InputMaybe<Scalars['String']>;
  templateVendorNotes?: InputMaybe<Scalars['String']>;
  variablePricing: Scalars['Boolean'];
  vendorCompanyId: Scalars['ID'];
};


export type MutationsCreateMarketArgs = {
  input: CreateMarketInput;
};


export type MutationsCreateOffResqCustomerArgs = {
  input: CreateOffResqCustomerMutationInput;
};


export type MutationsCreateOrUpdateBusinessUnitOnboardingArgs = {
  input: CreateOrUpdateBusinessUnitOnboardingMutationInput;
};


export type MutationsCreateOriginalVendorInvoiceArgs = {
  input: CreateOriginalVendorInvoiceMutationInput;
};


export type MutationsCreatePaymentMethodArgs = {
  input: CreatePaymentMethodMutationInput;
};


export type MutationsCreatePmOneTimeWorkOrderArgs = {
  input: CreatePmOneTimeWorkOrderInput;
};


export type MutationsCreatePreventativeMaintenanceArgs = {
  input: CreatePreventativeMaintenanceInput;
};


export type MutationsCreateQuoteArgs = {
  input: CreateQuoteMutationInput;
};


export type MutationsCreateQuoteSetOptionsArgs = {
  input: CreateQuoteSetOptionsInput;
};


export type MutationsCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


export type MutationsCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationsCreateRuleViolationsArgs = {
  input: CreateRuleViolationsMutationInput;
};


export type MutationsCreateRuleViolationsFeedbackArgs = {
  input: CreateRuleViolationsFeedbackInput;
};


export type MutationsCreateTroubleshootingSessionArgs = {
  input: CreateTroubleshootingSessionMutationInput;
};


export type MutationsCreateUpdateDispatchRelationshipArgs = {
  input: CreateUpdateDispatchRelationshipMutationInput;
};


export type MutationsCreateUpdateExternalReferenceArgs = {
  input: CreateUpdateExternalReferenceMutationInput;
};


export type MutationsCreateUpdateWorkOrderExpenseTypeArgs = {
  input: CreateUpdateWorkOrderExpenseTypeMutationInput;
};


export type MutationsCreateVendorArgs = {
  arguments: CreateVendorArguments;
};


export type MutationsCreateVendorAdjustmentInvoiceArgs = {
  adjustmentAmount: Scalars['Decimal'];
  applyAsDiscount?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  taxRateIds: Array<Scalars['ID']>;
  workOrderId: Scalars['ID'];
};


export type MutationsCreateVendorAutoAdjustmentInvoiceArgs = {
  input: CreateVendorAutoAdjustmentInvoiceMutationInput;
};


export type MutationsCreateVendorInternalNoteArgs = {
  arguments: CreateVendorInternalNoteArguments;
};


export type MutationsCreateVendorInvoiceBatchArgs = {
  vendorInvoiceIds: Array<Scalars['ID']>;
};


export type MutationsCreateVisitReviewArgs = {
  outcome: VisitReviewOutcome;
  visitReviewRequestId: Scalars['ID'];
};


export type MutationsCreateWorkOrderEscalationArgs = {
  input: CreateWorkOrderEscalationInput;
};


export type MutationsCreateWorkOrderInternalNoteArgs = {
  input: CreateWorkOrderInternalNoteInput;
};


export type MutationsCreateWorkOrderNoteArgs = {
  input: CreateWorkOrderNoteInput;
};


export type MutationsCreateWorkOrderReviewArgs = {
  arguments: CreateWorkOrderReviewArguments;
};


export type MutationsCreateWorkOrderV2Args = {
  input: CreateWorkOrderV2Input;
};


export type MutationsDeactivateEquipmentMutationArgs = {
  input: DeactivateEquipmentInput;
};


export type MutationsDeactivateFacilityArgs = {
  input: DeactivateFacilityInput;
};


export type MutationsDeclineVendorDispatchRequestArgs = {
  input: DeclineVendorDispatchRequestMutationInput;
};


export type MutationsDeleteAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationsDeleteBudgetArgs = {
  input: DeleteBudgetMutationInput;
};


export type MutationsDeleteBusinessUnitArgs = {
  input: DeleteBusinessUnitMutationInput;
};


export type MutationsDeleteClientReportScheduleArgs = {
  input: DeleteClientReportScheduleMutationInput;
};


export type MutationsDeleteCommentArgs = {
  commentId: Scalars['ID'];
};


export type MutationsDeleteDispatchRelationshipArgs = {
  input: DeleteDispatchRelationshipMutationInput;
};


export type MutationsDeleteFacilityArgs = {
  input: DeleteFacilityInput;
};


export type MutationsDeleteFacilityGroupArgs = {
  input: DeleteFacilityGroupInput;
};


export type MutationsDeleteFavouriteVendorConfigurationArgs = {
  input: DeleteFavouriteVendorConfigurationInput;
};


export type MutationsDeleteImageFromWorkOrderArgs = {
  imageId: Scalars['String'];
};


export type MutationsDeleteInboundVendorInvoiceArgs = {
  input: DeleteInboundVendorInvoiceMutationInput;
};


export type MutationsDeletePreventativeMaintenanceArgs = {
  input: DeletePreventativeMaintenanceInput;
};


export type MutationsDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationsDeleteWorkOrderInternalNoteArgs = {
  input: DeleteWorkOrderInternalNoteInput;
};


export type MutationsDismissArgs = {
  input: DismissMutationInput;
};


export type MutationsDismissWorkOrderNoteMetadataArgs = {
  input: DismissWorkOrderNoteMetadataMutationInput;
};


export type MutationsDisputeWorkOrderArgs = {
  arguments: DisputeWorkOrderArguments;
};


export type MutationsEditBlockedGroupsArgs = {
  input: EditBlockedGroupsInput;
};


export type MutationsEditClientOrganizationArgs = {
  contractSignedOn?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  isAutopay?: InputMaybe<Scalars['Boolean']>;
  isEnterprise?: InputMaybe<Scalars['Boolean']>;
  markup: Scalars['Decimal'];
  name: Scalars['String'];
  offlinePaymentMethod?: InputMaybe<OfflinePaymentMethods>;
  paymentMethod: PaymentMethodType;
  reportingManagerId?: InputMaybe<Scalars['ID']>;
  sensitivity?: InputMaybe<Sensitivity>;
  strategy?: InputMaybe<QuoteApprovalStrategy>;
  successOwnerId?: InputMaybe<Scalars['ID']>;
  tierId?: InputMaybe<Scalars['ID']>;
};


export type MutationsEditClientOrganizationMemberArgs = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']>>;
  clientOrganizationId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  memberId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationsEditClientVendorRelationshipInviteArgs = {
  input: EditClientVendorRelationshipInviteInput;
};


export type MutationsEditEquipmentArgs = {
  barCode: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  description: Scalars['String'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  equipmentId: Scalars['ID'];
  historicalSpend?: InputMaybe<Scalars['Decimal']>;
  installedOn?: InputMaybe<Scalars['Date']>;
  location: Scalars['String'];
  mainImage?: InputMaybe<Image>;
  manufacturer: Scalars['String'];
  modelNo: Scalars['String'];
  modelTagImage?: InputMaybe<Image>;
  name: Scalars['String'];
  photos?: InputMaybe<Array<InputMaybe<Image>>>;
  serialNo: Scalars['String'];
  subcategory?: InputMaybe<Scalars['String']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']>;
  warrantyNotes?: InputMaybe<Scalars['String']>;
};


export type MutationsEditFavouriteVendorConfigurationArgs = {
  input: EditFavouriteVendorConfigurationInput;
};


export type MutationsEditOrgOwnerArgs = {
  input: EditOrgOwnerMutationInput;
};


export type MutationsEditOrganizationFeaturesArgs = {
  input: EditOrganizationFeaturesMutationInput;
};


export type MutationsEditPreventativeMaintenanceArgs = {
  input: EditPreventativeMaintenanceInput;
};


export type MutationsEditQuoteArgs = {
  input: EditQuoteMutationInput;
};


export type MutationsEditUserDjangoGroupsArgs = {
  input: EditUserDjangoGroupsMutationInput;
};


export type MutationsEditVendorUserDetailsArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationsEditWorkOrderArgs = {
  input: EditWorkOrderInput;
};


export type MutationsEndActivityArgs = {
  input: EndActivityInput;
};


export type MutationsEndVisitArgs = {
  input: EndVisitInput;
};


export type MutationsForceWorkOrderCompletionArgs = {
  input: ForceWorkOrderCompletionMutationInput;
};


export type MutationsGenerateKustomerLoginTokenArgs = {
  input: GenerateKustomerLoginTokenInput;
};


export type MutationsGenerateVendorInvoicePdfArgs = {
  input: GenerateVendorInvoicePdfInput;
};


export type MutationsImportPaidInvoicesArgs = {
  input: ImportPaidInvoicesInput;
};


export type MutationsInitiateMarketplaceOnboardingArgs = {
  input: InitiateMarketplaceOnboardingMutationInput;
};


export type MutationsInviteMemberToClientOrganizationArgs = {
  assignedFacilityGroupIds: Array<Scalars['ID']>;
  assignedRoleIds: Array<Scalars['ID']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  inviteType?: InputMaybe<InviteType>;
  lastName?: InputMaybe<Scalars['String']>;
  noExpiry?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  sendInvite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsInviteMemberToVendorArgs = {
  arguments: InviteMemberToVendorArguments;
};


export type MutationsInviteOwnerToOnboardingArgs = {
  email: Scalars['String'];
  isResqEssentials?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationsMarkApBatchesAsPaidArgs = {
  input: MarkApBatchesAsPaidMutationInput;
};


export type MutationsMarkApBatchesAsUnpaidArgs = {
  input: MarkApBatchesAsUnpaidMutationInput;
};


export type MutationsMarkInboxItemReadArgs = {
  inboxItemId: Scalars['ID'];
};


export type MutationsMarkWorkOrderTeamMemberAssignmentAsUnresolvedArgs = {
  input: MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput;
};


export type MutationsMergeApBatchesArgs = {
  input: MergeApBatchesMutationInput;
};


export type MutationsMoveEquipmentToAnotherFacilityArgs = {
  input: MoveEquipmentToAnotherFacilityInput;
};


export type MutationsMoveWorkOrderToAwaitingRecordOfWorkArgs = {
  workOrderId: Scalars['ID'];
};


export type MutationsOverrideLocationAddressArgs = {
  input: OverrideLocationAddressMutationInput;
};


export type MutationsProcessInboundVendorInvoiceArgs = {
  input: ProcessInboundVendorInvoiceMutationInput;
};


export type MutationsRaiseApprovedSpendDuringWorkOrderSubmissionArgs = {
  input: RaiseApprovedSpendDuringWorkOrderSubmissionInput;
};


export type MutationsReactivateEquipmentMutationArgs = {
  input: ReactivateEquipmentInput;
};


export type MutationsReactivateFacilityArgs = {
  input: ReactivateFacilityMutationInput;
};


export type MutationsReassignWorkOrderToTeamMemberArgs = {
  input: ReassignWorkOrderToTeamMemberInput;
};


export type MutationsReassignWorkOrderVendorArgs = {
  input: ReassignWorkOrderVendorInput;
};


export type MutationsRecordPaymentArgs = {
  input: RecordPaymentInput;
};


export type MutationsRecordSuccessfulTroubleshootingArgs = {
  input: RecordSuccessfulTroubleshootingMutationInput;
};


export type MutationsRegenerateInvoicesArgs = {
  input: RegenerateInvoicesMutationInput;
};


export type MutationsRejectClientWorkOrderArgs = {
  input: RejectClientWorkOrderInput;
};


export type MutationsRejectQuoteSetArgs = {
  input: RejectQuoteSetInput;
};


export type MutationsRejectQuoteSetOptionForSpendArgs = {
  input: RejectQuoteSetOptionForSpendInput;
};


export type MutationsRemovePaymentMethodArgs = {
  input: RemovePaymentMethodMutationInput;
};


export type MutationsRemoveQuoteArgs = {
  arguments: RemoveQuoteArguments;
};


export type MutationsRemoveQuoteSetOptionArgs = {
  input: RemoveQuoteSetOptionInput;
};


export type MutationsRemoveUpcomingAllocationArgs = {
  input: RemoveUpcomingAllocationMutationInput;
};


export type MutationsRemoveUserFromClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationsRemoveUsersFromRoleArgs = {
  input: RemoveUsersFromRoleMutationInput;
};


export type MutationsRemoveVendorMemberArgs = {
  arguments: RemoveVendorMemberArguments;
};


export type MutationsRemoveVendorPayoutInfoArgs = {
  input: RemoveVendorPayoutInfoMutationInput;
};


export type MutationsRequestAutopayChangesArgs = {
  input: RequestAutopayChangesMutationInput;
};


export type MutationsRequestDispatchChangesArgs = {
  input: RequestDispatchChangesMutationInput;
};


export type MutationsRequestMaintenancePlanArgs = {
  input: RequestMaintenancePlanMutationInput;
};


export type MutationsRequestNewCapexProjectArgs = {
  input: RequestNewCapexProjectMutationInput;
};


export type MutationsRequestPlannedMaintenanceQuoteArgs = {
  input: RequestPlannedMaintenanceQuoteMutationInput;
};


export type MutationsRequestQuoteArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  maintenancePlanTypeId: Scalars['ID'];
};


export type MutationsRequestServiceGuaranteeArgs = {
  input: RequestServiceGuaranteeInput;
};


export type MutationsRescheduleAppointmentArgs = {
  input: RescheduleAppointmentInput;
};


export type MutationsRescheduleInternalAppointmentArgs = {
  input: RescheduleInternalAppointmentInput;
};


export type MutationsResendClientVendorRelationshipInviteArgs = {
  input: ResendClientVendorRelationshipInviteInput;
};


export type MutationsResetQuoteSetArgs = {
  input: ResetQuoteSetInput;
};


export type MutationsResolveFacilityExpansionArgs = {
  input: ResolveFacilityExpansionMutationInput;
};


export type MutationsResolveFlaggedInvoiceArgs = {
  input: ResolveFlaggedInvoiceInput;
};


export type MutationsResolveIncidentsArgs = {
  input: ResolveIncidentsInput;
};


export type MutationsResolveWorkOrderDisputeArgs = {
  arguments: ResolveWorkOrderDisputeArguments;
};


export type MutationsResolveWorkOrderEscalationArgs = {
  input: ResolveWorkOrderEscalationInput;
};


export type MutationsReverseClientInvoicePaymentArgs = {
  input: ReverseClientInvoicePaymentMutationInput;
};


export type MutationsRevokeClientVendorRelationshipInviteArgs = {
  input: RevokeClientVendorRelationshipInviteInput;
};


export type MutationsSaveRecordOfWorkArgs = {
  arguments: SaveRecordOfWorkArguments;
};


export type MutationsScheduleInternalAppointmentArgs = {
  input: ScheduleInternalAppointmentInput;
};


export type MutationsSelectQuoteSetOptionArgs = {
  input: SelectQuoteSetOptionInput;
};


export type MutationsSendInviteSmsArgs = {
  inviteId: Scalars['ID'];
};


export type MutationsSendReportArgs = {
  input: SendReportInput;
};


export type MutationsSendWelcomeEmailArgs = {
  input: SendWelcomeEmailMutationInput;
};


export type MutationsSetEstimatedTimeOfArrivalSourcingPartsArgs = {
  input: SetEstimatedTimeOfArrivalSourcingPartsMutationInput;
};


export type MutationsSetNotificationPreferenceArgs = {
  input: SetNotificationPreferenceInput;
};


export type MutationsSetSubscriptionAddonsArgs = {
  input: SetSubscriptionAddonsInput;
};


export type MutationsSetUserNotificationPreferenceArgs = {
  input: SetUserNoficationPreferenceMutationInput;
};


export type MutationsSetVendorAgreementPlansArgs = {
  input: SetVendorAgreementPlansMutationInput;
};


export type MutationsSetupPreAuthorizedDebitArgs = {
  input: SetupPreAuthorizedDebitMutationInput;
};


export type MutationsSkipWorkOrderReviewArgs = {
  workOrderId: Scalars['ID'];
};


export type MutationsSnoozeArgs = {
  input: SnoozeMutationInput;
};


export type MutationsSnoozeIncidentsArgs = {
  input: SnoozeIncidentsInput;
};


export type MutationsSnoozeReviewsArgs = {
  input: SnoozeReviewsInput;
};


export type MutationsStartAppointmentActivityArgs = {
  input: StartAppointmentActivityInput;
};


export type MutationsStartChooseVendorActivityArgs = {
  input: StartChooseVendorActivityInput;
};


export type MutationsStartDispatchActivityArgs = {
  input: StartDispatchActivityInput;
};


export type MutationsStartFindingQuoteActivityArgs = {
  input: StartFindingQuoteActivityInput;
};


export type MutationsStartOnHoldActivityArgs = {
  input: StartOnHoldActivityInput;
};


export type MutationsStartOrganizationSubscriptionArgs = {
  input: StartOrganizationSubscriptionMutationInput;
};


export type MutationsStartResqReviewActivityArgs = {
  input: StartResqReviewActivityInput;
};


export type MutationsStartSchedulingActivityArgs = {
  input: StartSchedulingActivityInput;
};


export type MutationsStartSchedulingCalldownArgs = {
  input: StartSchedulingCalldownInput;
};


export type MutationsStartSiteVisitActivityArgs = {
  input: StartSiteVisitActivityInput;
};


export type MutationsStartSourcingPartsActivityArgs = {
  input: StartSourcingPartsActivityInput;
};


export type MutationsStartSubscriptionArgs = {
  input: StartSubscriptionInput;
};


export type MutationsStartVisitArgs = {
  input: StartVisitMutationInput;
};


export type MutationsStopOrganizationSubscriptionsArgs = {
  input: DeactivateOrganizationSubscriptionsInput;
};


export type MutationsSubmitOffResqVendorInvoiceArgs = {
  input: SubmitOffResqVendorInvoiceMutationInput;
};


export type MutationsSubmitQuoteFeedbackArgs = {
  arguments: SubmitQuoteFeedbackArguments;
};


export type MutationsSubmitRecordOfWorkArgs = {
  input: SubmitRecordOfWorkInput;
};


export type MutationsSubmitVendorInvoiceArgs = {
  arguments: SubmitVendorInvoiceMutationArguments;
};


export type MutationsSubmitWorkOrderArgs = {
  input: SubmitWorkOrderInput;
};


export type MutationsSubmitWorkOrderForApprovalArgs = {
  workOrderId: Scalars['ID'];
};


export type MutationsSubmitWorkOrderToMarketplaceArgs = {
  input: SubmitWorkOrderToMarketplaceInput;
};


export type MutationsTriggerSampleNotificationArgs = {
  input: TriggerSampleNotificationInput;
};


export type MutationsUnapproveRecordOfWorkArgs = {
  input: UnapproveRecordOfWorkMutationInput;
};


export type MutationsUnarchiveReportTemplateArgs = {
  input: UnarchiveReportTemplateInput;
};


export type MutationsUnassignedWorkOrderFromVendorCompanyArgs = {
  workOrderId: Scalars['ID'];
};


export type MutationsUnblockApArgs = {
  input: UnblockApMutationInput;
};


export type MutationsUnblockVendorArgs = {
  clientOrganizationId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


export type MutationsUncancelWorkOrderArgs = {
  arguments: UncancelWorkOrderArguments;
};


export type MutationsUpdateApBatchArgs = {
  input: UpdateApBatchMutationInput;
};


export type MutationsUpdateBudgetArgs = {
  input: UpdateBudgetMutationInput;
};


export type MutationsUpdateBusinessUnitArgs = {
  arguments: UpdateBusinessUnitArguments;
};


export type MutationsUpdateClientOrgSensitivityArgs = {
  input: UpdateClientOrgSensitivityMutationInput;
};


export type MutationsUpdateClientOrganizationStatusArgs = {
  input: UpdateClientOrganizationStatusMutationInput;
};


export type MutationsUpdateClientReportScheduleArgs = {
  input: UpdateClientReportScheduleMutationInput;
};


export type MutationsUpdateDeviceArgs = {
  buildType?: InputMaybe<Scalars['String']>;
  device: Scalars['String'];
  deviceToken: Scalars['String'];
  pushNotificationService?: InputMaybe<Scalars['String']>;
  pushUserType?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateDeviceConfigsArgs = {
  input: UpdateDeviceConfigsInput;
};


export type MutationsUpdateExternalBankAccountArgs = {
  accountNumber: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  externalBankAccountId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  institutionNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  routingNumber: Scalars['String'];
  type: ExternalBankAccountType;
};


export type MutationsUpdateExternalExpenseArgs = {
  input: UpdateExternalExpenseMutationInput;
};


export type MutationsUpdateFacilityArgs = {
  arguments?: InputMaybe<UpdateFacilityArguments>;
};


export type MutationsUpdateFacilityGroupArgs = {
  input: UpdateFacilityGroupInput;
};


export type MutationsUpdateFacilityGroupOpsOwnerMutationArgs = {
  input: UpdateFacilityGroupOpsOwnerInput;
};


export type MutationsUpdateFavouriteVendorInviteSubscriptionArgs = {
  input: UpdateFavouriteVendorInviteSubscriptionMutationInput;
};


export type MutationsUpdateGlCodesArgs = {
  input: UpdateGlCodesMutationInput;
};


export type MutationsUpdateInternalRequestTeamMemberAssignmentsArgs = {
  input: UpdateInternalRequestTeamMemberAssignmentsInput;
};


export type MutationsUpdateInvoiceApprovalSettingsArgs = {
  input: UpdateInvoiceApprovalSettingsInput;
};


export type MutationsUpdateMaintenancePlanArgs = {
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String'];
  maintenancePlanId: Scalars['ID'];
  maintenancePlanTypeId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nextWorkOrderCreationDate: Scalars['Date'];
  opsOwnerId?: InputMaybe<Scalars['ID']>;
  priceAfterMarkup: Scalars['Decimal'];
  priceBeforeMarkup: Scalars['Decimal'];
  scopeOfWork: Scalars['String'];
  serviceFrequencyUnit?: InputMaybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']>;
  templateLineItems?: InputMaybe<Array<LineItemInput>>;
  templateNotes?: InputMaybe<Scalars['String']>;
  templateVendorNotes?: InputMaybe<Scalars['String']>;
  variablePricing: Scalars['Boolean'];
  vendorCompanyId: Scalars['ID'];
};


export type MutationsUpdateMarketArgs = {
  input: UpdateMarketInput;
};


export type MutationsUpdateOffResqCustomerArgs = {
  input: UpdateOffResqCustomerMutationInput;
};


export type MutationsUpdateOrganizationSubscriptionArgs = {
  input: UpdateOrganizationSubscriptionMutationInput;
};


export type MutationsUpdatePreventativeMaintenanceTaskListItemsArgs = {
  input: UpdatePreventativeMaintenanceTaskListItemsInput;
};


export type MutationsUpdatePriceRateOverridesArgs = {
  input: UpdatePriceRateOverridesMutationInput;
};


export type MutationsUpdateQuoteAcceptanceSettingsArgs = {
  input: UpdateQuoteAcceptanceSettingsInput;
};


export type MutationsUpdateQuoteApprovalThresholdsArgs = {
  input: UpdateQuoteApprovalThresholdsInput;
};


export type MutationsUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationsUpdateRevenueShareOverridesArgs = {
  input: UpdateRevenueShareOverridesMutationInput;
};


export type MutationsUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationsUpdateServiceCategoriesArgs = {
  input: UpdateServiceCategoriesInput;
};


export type MutationsUpdateSpendApprovalPreferencesArgs = {
  input: UpdateSpendApprovalPreferencesInput;
};


export type MutationsUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationsUpdateTroubleshootingActionArgs = {
  input: UpdateTroubleshootingActionMutationInput;
};


export type MutationsUpdateUserProfileArgs = {
  input: UpdateUserProfileMutationInput;
};


export type MutationsUpdateVendorArgs = {
  arguments: UpdateVendorArguments;
};


export type MutationsUpdateVendorGeneralInfoArgs = {
  input: UpdateVendorGeneralInfoMutationInput;
};


export type MutationsUpdateVendorInsuranceDocumentArgs = {
  input: UpdateVendorInsuranceDocumentMutationInput;
};


export type MutationsUpdateVendorMarketplaceArgs = {
  input: UpdateVendorMarketplaceMutationInput;
};


export type MutationsUpdateVendorMemberArgs = {
  arguments: UpdateVendorMemberArguments;
};


export type MutationsUpdateVendorOpenToMarketplaceArgs = {
  input: UpdateVendorOpenToMarketplaceMutationInput;
};


export type MutationsUpdateVendorPayoutInfoArgs = {
  input: UpdateVendorPayoutInfoMutationInput;
};


export type MutationsUpdateVendorPriceRatesArgs = {
  input: UpdateVendorPriceRatesMutationInput;
};


export type MutationsUpdateVendorProfileDispatchArgs = {
  input: UpdateVendorProfileDispatchMutationInput;
};


export type MutationsUpdateVendorRevenueSharesArgs = {
  input: UpdateVendorRevenueSharesMutationInput;
};


export type MutationsUpdateVisitArgs = {
  input: UpdateVisitInput;
};


export type MutationsUpdateWorkOrderCompletionTimeArgs = {
  input: UpdateWorkOrderCompletionTimeInput;
};


export type MutationsUpdateWorkOrderNteArgs = {
  input: UpdateWorkOrderNteInput;
};


export type MutationsUpdateWorkOrderOpsOwnerArgs = {
  opsOwnerId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};


export type MutationsUploadAfterImagesArgs = {
  appointmentId: Scalars['ID'];
  images: Array<InputMaybe<Image>>;
};


export type MutationsUploadQuoteArgs = {
  input: UploadQuoteMutationInput;
};


export type MutationsUploadVendorInvoiceArgs = {
  input: UploadVendorInvoiceInput;
};


export type MutationsVoidSubscriptionInvoiceMutationArgs = {
  input: VoidSubscriptionInvoiceMutationInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type NonDeactivatedVendorOrganizationNode = Node & {
  __typename: 'NonDeactivatedVendorOrganizationNode';
  code: Scalars['String'];
  hasServicedClient: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  profile: VendorProfileNode;
};

export type NonDeactivatedVendorOrganizationNodeConnection = {
  __typename: 'NonDeactivatedVendorOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NonDeactivatedVendorOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `NonDeactivatedVendorOrganizationNode` and its cursor. */
export type NonDeactivatedVendorOrganizationNodeEdge = {
  __typename: 'NonDeactivatedVendorOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<NonDeactivatedVendorOrganizationNode>;
};

/** An enumeration. */
export enum NotReadyForOnboardingReasonChoice {
  ExpansionOpportunity = 'EXPANSION_OPPORTUNITY',
  Other = 'OTHER',
  RestaurantNotYetInOperation = 'RESTAURANT_NOT_YET_IN_OPERATION'
}

/** An enumeration. */
export enum NoteSource {
  Client = 'CLIENT',
  Resq = 'RESQ',
  Vendor = 'VENDOR'
}

/** An enumeration. */
export enum NotificationChannel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type NotificationInputItem = {
  __typename: 'NotificationInputItem';
  name: Scalars['String'];
};

export type NotificationPreferenceNode = Node & {
  __typename: 'NotificationPreferenceNode';
  email: Scalars['Boolean'];
  emailConfigurable: Scalars['Boolean'];
  emailImplemented: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  notificationType: NotificationType;
  push: Scalars['Boolean'];
  pushConfigurable: Scalars['Boolean'];
  pushImplemented: Scalars['Boolean'];
  sms: Scalars['Boolean'];
  smsConfigurable: Scalars['Boolean'];
  smsImplemented: Scalars['Boolean'];
  user: UserNode;
};

export type NotificationPreferenceNodeConnection = {
  __typename: 'NotificationPreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationPreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `NotificationPreferenceNode` and its cursor. */
export type NotificationPreferenceNodeEdge = {
  __typename: 'NotificationPreferenceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<NotificationPreferenceNode>;
};

export type NotificationSkeleton = {
  __typename: 'NotificationSkeleton';
  email: Scalars['Boolean'];
  inputs: Array<NotificationInputItem>;
  name: Scalars['String'];
  push: Scalars['Boolean'];
  sms: Scalars['Boolean'];
};

/** An enumeration. */
export enum NotificationType {
  AwaitingInvoiceProcessing = 'AWAITING_INVOICE_PROCESSING',
  ChecklistAssignment = 'CHECKLIST_ASSIGNMENT',
  ClientStatus = 'CLIENT_STATUS',
  ClientWorkOrderNotes = 'CLIENT_WORK_ORDER_NOTES',
  CoordinatorWorkOrderNotes = 'COORDINATOR_WORK_ORDER_NOTES',
  Invoices = 'INVOICES',
  InvoicesReadyForApproval = 'INVOICES_READY_FOR_APPROVAL',
  JobAwaitingScheduling = 'JOB_AWAITING_SCHEDULING',
  JobDispatch = 'JOB_DISPATCH',
  MagicLink = 'MAGIC_LINK',
  MonthlyStatement = 'MONTHLY_STATEMENT',
  PartnerWorkOrderCancellation = 'PARTNER_WORK_ORDER_CANCELLATION',
  PaymentConfirmation = 'PAYMENT_CONFIRMATION',
  QuoteAction = 'QUOTE_ACTION',
  QuoteOutcome = 'QUOTE_OUTCOME',
  QuoteReminder = 'QUOTE_REMINDER',
  SensorAlert = 'SENSOR_ALERT',
  VendorDailyMenu = 'VENDOR_DAILY_MENU',
  VendorPerformanceReport = 'VENDOR_PERFORMANCE_REPORT',
  VendorWorkOrderNotes = 'VENDOR_WORK_ORDER_NOTES',
  VendorWorkOrderPriorityUpdates = 'VENDOR_WORK_ORDER_PRIORITY_UPDATES',
  WorkOrderAssignment = 'WORK_ORDER_ASSIGNMENT',
  WorkOrderCancellation = 'WORK_ORDER_CANCELLATION',
  WorkOrderDispatch = 'WORK_ORDER_DISPATCH',
  WorkOrderRejection = 'WORK_ORDER_REJECTION',
  WorkOrderReviews = 'WORK_ORDER_REVIEWS',
  WorkOrderStatusUpdate = 'WORK_ORDER_STATUS_UPDATE',
  WorkOrderTriage = 'WORK_ORDER_TRIAGE',
  WorkOrderUpdate = 'WORK_ORDER_UPDATE'
}

export type OffResqCustomerNode = Node & {
  __typename: 'OffResqCustomerNode';
  billingAddress: BillingAddressNode;
  billingContactEmail: Scalars['String'];
  billingContactFirstName: Scalars['String'];
  billingContactLastName: Scalars['String'];
  billingContactPhone: Scalars['String'];
  businessDateOfIncorporation: Maybe<Scalars['DateTime']>;
  businessLegalStructure: Maybe<BusinessLegalStructure>;
  businessTaxNumber: Maybe<Scalars['String']>;
  currency: Maybe<Currency>;
  /** The ID of the object */
  id: Scalars['ID'];
  legalName: Maybe<Scalars['String']>;
  offResqFacility: Maybe<OffResqFacilityNode>;
  totalInvoiced: Scalars['Int'];
};

export type OffResqCustomerNodeConnection = {
  __typename: 'OffResqCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffResqCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `OffResqCustomerNode` and its cursor. */
export type OffResqCustomerNodeEdge = {
  __typename: 'OffResqCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<OffResqCustomerNode>;
};

/** An enumeration. */
export enum OffResqFacilityIndustry {
  /** Agriculture and Food Production */
  AgricultureAndFoodProduction = 'AGRICULTURE_AND_FOOD_PRODUCTION',
  /** Construction and Engineering */
  ConstructionAndEngineering = 'CONSTRUCTION_AND_ENGINEERING',
  /** Educational Institutions */
  EducationalInstitutions = 'EDUCATIONAL_INSTITUTIONS',
  /** Entertainment and Recreation */
  EntertainmentAndRecreation = 'ENTERTAINMENT_AND_RECREATION',
  /** Financial Services */
  FinancialServices = 'FINANCIAL_SERVICES',
  /** Healthcare Facilities */
  HealthcareFacilities = 'HEALTHCARE_FACILITIES',
  /** Hospitality and Lodging */
  HospitalityAndLodging = 'HOSPITALITY_AND_LODGING',
  /** Industrial and Manufacturing */
  IndustrialAndManufacturing = 'INDUSTRIAL_AND_MANUFACTURING',
  /** Media and Communication */
  MediaAndCommunication = 'MEDIA_AND_COMMUNICATION',
  /** Office Buildings and Corporate Facilities */
  OfficeBuildingsAndCorporateFacilities = 'OFFICE_BUILDINGS_AND_CORPORATE_FACILITIES',
  /** Public Services and Government */
  PublicServicesAndGovernment = 'PUBLIC_SERVICES_AND_GOVERNMENT',
  /** Real Estate and Property Management */
  RealEstateAndPropertyManagement = 'REAL_ESTATE_AND_PROPERTY_MANAGEMENT',
  /** Restaurants and Food Services */
  RestaurantsAndFoodServices = 'RESTAURANTS_AND_FOOD_SERVICES',
  /** Retail Stores */
  RetailStores = 'RETAIL_STORES',
  /** Technology and IT Services */
  TechnologyAndItServices = 'TECHNOLOGY_AND_IT_SERVICES',
  /** Transportation and Logistics */
  TransportationAndLogistics = 'TRANSPORTATION_AND_LOGISTICS',
  /** Utilities and Energy */
  UtilitiesAndEnergy = 'UTILITIES_AND_ENERGY'
}

export type OffResqFacilityNode = Node & {
  __typename: 'OffResqFacilityNode';
  /** The ID of the object */
  id: Scalars['ID'];
  industry: Maybe<OffResqFacilityIndustry>;
  name: Scalars['String'];
  preResqPaymentTermsDays: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum OfflinePaymentMethods {
  AchEft = 'ACH_EFT',
  Cheque = 'CHEQUE',
  WireTransfer = 'WIRE_TRANSFER'
}

export type OnDemandAndMaintenancePlanCounts = {
  __typename: 'OnDemandAndMaintenancePlanCounts';
  maintenancePlan: Scalars['Int'];
  onDemand: Scalars['Int'];
};

export type OnHoldActivity = Activity & Node & {
  __typename: 'OnHoldActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  miscellaneousHold: MiscellaneousHold;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type OnboardingActionNode = Node & {
  __typename: 'OnboardingActionNode';
  completedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  isFirstTime: Scalars['Boolean'];
  isResqEssentials: Maybe<Scalars['Boolean']>;
  onboardingType: Maybe<OnboardingType>;
  organization: VendorOrganizationNode;
  steps: Array<Maybe<OnboardingSteps>>;
};

export type OnboardingActionNodeConnection = {
  __typename: 'OnboardingActionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OnboardingActionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `OnboardingActionNode` and its cursor. */
export type OnboardingActionNodeEdge = {
  __typename: 'OnboardingActionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<OnboardingActionNode>;
};

/** An enumeration. */
export enum OnboardingStatus {
  AbleToSubmitMarketplaceWorkOrders = 'ABLE_TO_SUBMIT_MARKETPLACE_WORK_ORDERS',
  InOnboarding = 'IN_ONBOARDING',
  NotReadyForOnboarding = 'NOT_READY_FOR_ONBOARDING'
}

/** An enumeration. */
export enum OnboardingSteps {
  BillingInfo = 'BILLING_INFO',
  Facilities = 'FACILITIES',
  GeneralInfo = 'GENERAL_INFO',
  GetStarted = 'GET_STARTED',
  InvitedCaTos = 'INVITED_CA_TOS',
  InvitedUkTos = 'INVITED_UK_TOS',
  InvitedUsTos = 'INVITED_US_TOS',
  MarketplaceCaTos = 'MARKETPLACE_CA_TOS',
  MarketplaceUkTos = 'MARKETPLACE_UK_TOS',
  MarketplaceUsTos = 'MARKETPLACE_US_TOS',
  OperatingAreas = 'OPERATING_AREAS',
  PartnerAgreement = 'PARTNER_AGREEMENT',
  PaymentInfo = 'PAYMENT_INFO',
  PayoutInfo = 'PAYOUT_INFO',
  Rates = 'RATES',
  ReviewAndSubmit = 'REVIEW_AND_SUBMIT',
  Roles = 'ROLES',
  ServiceCategories = 'SERVICE_CATEGORIES',
  ServiceProviders = 'SERVICE_PROVIDERS',
  Skills = 'SKILLS',
  Staff = 'STAFF',
  Tos = 'TOS'
}

/** An enumeration. */
export enum OnboardingType {
  Client = 'CLIENT',
  Inherited = 'INHERITED',
  InheritedToMarketplace = 'INHERITED_TO_MARKETPLACE',
  SourcedVendor = 'SOURCED_VENDOR',
  Tos = 'TOS'
}

export type OperatingAreaNode = Node & {
  __typename: 'OperatingAreaNode';
  area: Maybe<Scalars['MultiPolygon']>;
  /** The ID of the object */
  id: Scalars['ID'];
  market: Maybe<MarketNode>;
  name: Scalars['String'];
};

export type OperatingAreaNodeConnection = {
  __typename: 'OperatingAreaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatingAreaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OperatingAreaNode` and its cursor. */
export type OperatingAreaNodeEdge = {
  __typename: 'OperatingAreaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<OperatingAreaNode>;
};

/** An enumeration. */
export enum OperatingAreaStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Transitioning = 'TRANSITIONING'
}

export enum OrganizationCanActions {
  AccessStatements = 'ACCESS_STATEMENTS',
  AccessSubscriptions = 'ACCESS_SUBSCRIPTIONS',
  ApproveInvoices = 'APPROVE_INVOICES',
  ApproveQuote = 'APPROVE_QUOTE',
  ChooseExpenseType = 'CHOOSE_EXPENSE_TYPE',
  ClientInternalAssignment = 'CLIENT_INTERNAL_ASSIGNMENT',
  CreateBudget = 'CREATE_BUDGET',
  ManageBusinessSettings = 'MANAGE_BUSINESS_SETTINGS',
  ManageChecklistAssignments = 'MANAGE_CHECKLIST_ASSIGNMENTS',
  ManageChecklistTemplates = 'MANAGE_CHECKLIST_TEMPLATES',
  ManageFavouriteVendors = 'MANAGE_FAVOURITE_VENDORS',
  ManagePreventativeMaintenance = 'MANAGE_PREVENTATIVE_MAINTENANCE',
  ManageStaff = 'MANAGE_STAFF',
  PayInvoice = 'PAY_INVOICE',
  SelectQuote = 'SELECT_QUOTE',
  SubmitWorkOrder = 'SUBMIT_WORK_ORDER',
  UpdateExpenseType = 'UPDATE_EXPENSE_TYPE'
}

export type OrganizationFeaturesNode = Node & {
  __typename: 'OrganizationFeaturesNode';
  additionalFeatures: Array<Features>;
  allFeatures: Array<Features>;
  /** The ID of the object */
  id: Scalars['ID'];
  organizationId: Scalars['Int'];
  removedFeatures: Array<Features>;
  tier: FeatureTierNode;
  unimplementedFeatures: Array<Features>;
};

/** An enumeration. */
export enum Outcome {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  Rescheduled = 'RESCHEDULED'
}

export type OverrideLocationAddressMutationInput = {
  addressResolutionId?: InputMaybe<Scalars['ID']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
};

export type OverrideLocationAddressMutationPayload = {
  __typename: 'OverrideLocationAddressMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  locationAddressResolution: LocationAddressResolutionNode;
};

export type OvertimeStatus = {
  __typename: 'OvertimeStatus';
  facilityId: Scalars['ID'];
  isOvertime: Scalars['Boolean'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PaymentMethodAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type PaymentMethodNode = Node & {
  __typename: 'PaymentMethodNode';
  achAccountPayment: Maybe<AchAccountNode>;
  creditCardPayment: Maybe<CreditCardPaymentNode>;
  facilityCount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  isVerified: Scalars['Boolean'];
  paymentType: PaymentMethodPaymentType;
  preAuthorizedDebitPayment: Maybe<PreAuthorizedDebitPaymentNode>;
};

export type PaymentMethodNodeConnection = {
  __typename: 'PaymentMethodNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentMethodNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PaymentMethodNode` and its cursor. */
export type PaymentMethodNodeEdge = {
  __typename: 'PaymentMethodNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<PaymentMethodNode>;
};

/** An enumeration. */
export enum PaymentMethodPaymentType {
  AchAccount = 'ACH_ACCOUNT',
  CreditCard = 'CREDIT_CARD',
  PreAuthorizedDebit = 'PRE_AUTHORIZED_DEBIT'
}

export enum PaymentMethodType {
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD'
}

export type PaymentNode = Node & {
  __typename: 'PaymentNode';
  amount: Scalars['Decimal'];
  batchPayment: BatchPaymentNode;
  clientInvoice: ClientInvoiceNode;
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID'];
};

export type PaymentNodeConnection = {
  __typename: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  __typename: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<PaymentNode>;
};

/** An enumeration. */
export enum PaymentStatus {
  DisputeClosed = 'DISPUTE_CLOSED',
  DisputeLost = 'DISPUTE_LOST',
  DisputeNeedsResponse = 'DISPUTE_NEEDS_RESPONSE',
  DisputeRefunded = 'DISPUTE_REFUNDED',
  DisputeUnderReview = 'DISPUTE_UNDER_REVIEW',
  DisputeWon = 'DISPUTE_WON',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export enum PaymentType {
  Ach = 'ACH',
  Cheque = 'CHEQUE',
  Credit = 'CREDIT',
  CreditCard = 'CREDIT_CARD',
  Eft = 'EFT',
  Other = 'OTHER',
  Refund = 'REFUND'
}

export type PeriodicSpendComparison = {
  __typename: 'PeriodicSpendComparison';
  difference: Scalars['Decimal'];
  differencePercent: Maybe<Scalars['Decimal']>;
  period: MetricsPeriod;
  spendAmount: Scalars['Decimal'];
};

/** An enumeration. */
export enum Permission {
  ClientAccessStatements = 'CLIENT_ACCESS_STATEMENTS',
  ClientAccessSubscriptions = 'CLIENT_ACCESS_SUBSCRIPTIONS',
  ClientCreateBudget = 'CLIENT_CREATE_BUDGET',
  ClientInternalAssignment = 'CLIENT_INTERNAL_ASSIGNMENT',
  ClientManageBusinessSettings = 'CLIENT_MANAGE_BUSINESS_SETTINGS',
  ClientManageEquipment = 'CLIENT_MANAGE_EQUIPMENT',
  ClientManageFacilitySettings = 'CLIENT_MANAGE_FACILITY_SETTINGS',
  ClientManageFavouriteVendors = 'CLIENT_MANAGE_FAVOURITE_VENDORS',
  ClientManageMembers = 'CLIENT_MANAGE_MEMBERS',
  ClientManageSensors = 'CLIENT_MANAGE_SENSORS',
  ClientPayInvoice = 'CLIENT_PAY_INVOICE',
  ClientReviewWorkOrder = 'CLIENT_REVIEW_WORK_ORDER',
  ClientSubmitWorkOrder = 'CLIENT_SUBMIT_WORK_ORDER',
  ClientUpdateExpenseType = 'CLIENT_UPDATE_EXPENSE_TYPE',
  VendorApproveInvoice = 'VENDOR_APPROVE_INVOICE',
  VendorCreateInvoice = 'VENDOR_CREATE_INVOICE',
  VendorManageMembers = 'VENDOR_MANAGE_MEMBERS',
  VendorManageProfile = 'VENDOR_MANAGE_PROFILE',
  VendorPerformDelegatedWork = 'VENDOR_PERFORM_DELEGATED_WORK',
  VendorPerformWork = 'VENDOR_PERFORM_WORK',
  VendorScheduleAppointment = 'VENDOR_SCHEDULE_APPOINTMENT'
}

export type PreAuthorizedDebitPaymentNode = Node & {
  __typename: 'PreAuthorizedDebitPaymentNode';
  accountNumber: Scalars['String'];
  bankName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type PreAuthorizedDebitPreview = {
  __typename: 'PreAuthorizedDebitPreview';
  accountNumberLastFour: Scalars['String'];
  facilityPreviews: Array<FacilityPaymentPreview>;
  total: Scalars['Decimal'];
  workOrders: Array<WorkOrderNode>;
};

/** An enumeration. */
export enum PreventativeMaintenanceFrequencyUnit {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PreventativeMaintenanceNode = Node & {
  __typename: 'PreventativeMaintenanceNode';
  additionalDetails: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expectedDuration: Maybe<Scalars['Int']>;
  facility: FacilityNode;
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  /** Number of units for the next work order creation */
  frequencyValue: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  nextWorkOrderCreationDate: Scalars['Date'];
  /** For Monthly frequencies, the day of the month for the next work order creationFor dates that are higher than the maximum day of the month,we will resolve to the last day of the month instead */
  recurrenceDayOfMonth: Maybe<Scalars['Int']>;
  serviceCategory: ServiceCategory;
  taskListAttachments: Array<AttachmentNode>;
  taskListUrls: Array<AttachedUrlNode>;
  tasks: Array<PreventativeMaintenanceTaskListItemNode>;
  teamMembers: Array<UserNode>;
  title: Scalars['String'];
};

export type PreventativeMaintenanceNodeConnection = {
  __typename: 'PreventativeMaintenanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PreventativeMaintenanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PreventativeMaintenanceNode` and its cursor. */
export type PreventativeMaintenanceNodeEdge = {
  __typename: 'PreventativeMaintenanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<PreventativeMaintenanceNode>;
};

export type PreventativeMaintenanceTaskListItemNode = Node & {
  __typename: 'PreventativeMaintenanceTaskListItemNode';
  /** The ID of the object */
  id: Scalars['ID'];
  order: Scalars['Int'];
  text: Scalars['String'];
};

export type PreviouslyHiredVendorsNode = Node & {
  __typename: 'PreviouslyHiredVendorsNode';
  /** The ID of the object */
  id: Scalars['ID'];
  vendors: Array<VendorOrganizationNode>;
};

export type PriceRateOverrideNode = Node & {
  __typename: 'PriceRateOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  labourRate: Maybe<Scalars['Decimal']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']>;
  serviceCallRate: Maybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelRate: Maybe<Scalars['Decimal']>;
  truckRate: Maybe<Scalars['Decimal']>;
  vendor: VendorOrganizationNode;
};

export type PriceRateOverrideNodeConnection = {
  __typename: 'PriceRateOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PriceRateOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `PriceRateOverrideNode` and its cursor. */
export type PriceRateOverrideNodeEdge = {
  __typename: 'PriceRateOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<PriceRateOverrideNode>;
};

export type ProcessInboundVendorInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inboundVendorInvoiceId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};

export type ProcessInboundVendorInvoiceMutationPayload = {
  __typename: 'ProcessInboundVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  inboundVendorInvoice: InboundVendorInvoiceNode;
};

export enum PromotionTypeEnum {
  PromotionTypeAll = 'PROMOTION_TYPE_ALL',
  PromotionTypeClient = 'PROMOTION_TYPE_CLIENT',
  PromotionTypeVendor = 'PROMOTION_TYPE_VENDOR'
}

export type ProvinceNode = Node & {
  __typename: 'ProvinceNode';
  code: Maybe<Scalars['String']>;
  country: CountryNode;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProvinceNodeConnection = {
  __typename: 'ProvinceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProvinceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProvinceNode` and its cursor. */
export type ProvinceNodeEdge = {
  __typename: 'ProvinceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ProvinceNode>;
};

export type Query = {
  __typename: 'Query';
  _debug: Maybe<DjangoDebug>;
  activities: Maybe<ActivityConnection>;
  activityFeed: Maybe<ActivityFeedEntryNodeConnection>;
  alerts: Array<Alert>;
  allocations: Maybe<AllocationNodeConnection>;
  apBatch: Maybe<ApBatchNode>;
  apBatches: Maybe<ApBatchNodeConnection>;
  apBlock: Maybe<ApBlockNode>;
  apBlocks: Maybe<ApBlockNodeConnection>;
  appointment: Maybe<AppointmentNode>;
  appointmentReschedulingReasons: Array<AppointmentReschedulingReasonType>;
  appointments: Maybe<AppointmentNodeConnection>;
  attachment: Maybe<AttachmentNode>;
  attachments: Maybe<AttachmentNodeConnection>;
  availableVendors: Maybe<AvailableVendorNodeConnection>;
  bankAccount: Maybe<BankAccountNode>;
  bankAccounts: Maybe<BankAccountNodeConnection>;
  barcode: Maybe<AttachmentNode>;
  barcodes: Maybe<BarcodeNodeConnection>;
  batchPayment: Maybe<BatchPaymentNode>;
  batchPayments: Maybe<BatchPaymentNodeConnection>;
  billingInformation: Maybe<BillingInformationNode>;
  billingInformations: Maybe<BillingInformationNodeConnection>;
  brands: Maybe<BrandNodeConnection>;
  budget: Maybe<BudgetNode>;
  budgets: Maybe<BudgetNodeConnection>;
  businessUnit: Maybe<BusinessUnitNode>;
  businessUnits: Maybe<BusinessUnitNodeConnection>;
  calculatedMarkupInvoiceFigures: Maybe<CalculatedInvoiceNode>;
  calculatedRevShareInvoiceFigures: Maybe<CalculatedInvoiceNode>;
  categories: Maybe<CategoryNodeConnection>;
  cities: Maybe<CityNodeConnection>;
  clientFeatures: Maybe<Array<Maybe<ClientFeature>>>;
  clientInvoice: Maybe<ClientInvoiceNode>;
  clientInvoices: Maybe<ClientInvoiceNodeConnection>;
  clientMetrics: Maybe<ClientMetricsNode>;
  clientOrganization: Maybe<ClientOrganizationNode>;
  clientOrganizationMembers: Maybe<ClientOrganizationMemberNodeConnection>;
  clientOrganizations: Maybe<ClientOrganizationNodeConnection>;
  clientPreferredSpendThreshold: Maybe<ClientPreferredSpendThresholdNode>;
  clientReport: Maybe<ClientReportNode>;
  clientReportSchedule: Maybe<ClientReportScheduleNode>;
  clientReportSchedules: Maybe<ClientReportScheduleNodeConnection>;
  clientReports: Maybe<ClientReportNodeConnection>;
  clientStatements: Maybe<ClientMonthlyStatementNodeConnection>;
  clientVendorRelationships: Maybe<ClientVendorRelationshipNodeConnection>;
  coordinator: Maybe<CoordinatorNode>;
  coordinatorUsers: Maybe<UserNodeConnection>;
  countries: Maybe<CountryNodeConnection>;
  dailyMenuIncidents: Maybe<IncidentConnection>;
  defaultMarkupLineItem: Maybe<RecordOfWorkDefaultLineItemNode>;
  defaultRevShareLineItem: Maybe<RecordOfWorkDefaultLineItemNode>;
  defaultVendorRevenueShare: Maybe<DefaultVendorRevenueShareNode>;
  defaultVendorRevenueShareOverride: Maybe<DefaultVendorRevenueShareOverrideNode>;
  defaultVendorRevenueShareOverrides: Maybe<DefaultVendorRevenueShareOverrideNodeConnection>;
  defaultVendorRevenueShares: Maybe<DefaultVendorRevenueShareNodeConnection>;
  determineTroubleshootingPlan: Maybe<DetermineTroubleshootingPlanNode>;
  deviceConfigs: Array<DeviceConfig>;
  deviceData: DeviceDataSet;
  devices: Array<Device>;
  dispatchRelationship: Maybe<DispatchRelationshipNode>;
  dispatchRelationshipSummaries: Maybe<DispatchRelationshipSummaryNodeConnection>;
  dispatchRelationships: Maybe<DispatchRelationshipNodeConnection>;
  djangoGroups: Maybe<DjangoGroupNodeConnection>;
  djangoPermissions: Maybe<DjangoPermissionNodeConnection>;
  equipment: Maybe<EquipmentNode>;
  equipmentCategories: Maybe<EquipmentCategoryNodeConnection>;
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  equipmentManufacturer: Maybe<EquipmentManufacturerNode>;
  equipmentManufacturers: Maybe<EquipmentManufacturerNodeConnection>;
  equipments: Maybe<EquipmentNodeConnection>;
  escalationChannels: Array<EscalationChannelType>;
  expectedServiceTimelines: Array<ExpectedServiceTimelineType>;
  experimentVariant: Maybe<VariantNode>;
  externalBankAccount: Maybe<ExternalBankAccountNode>;
  externalBankAccounts: Maybe<ExternalBankAccountNodeConnection>;
  facilities: Maybe<FacilityNodeConnection>;
  facilitiesOutsideVendorOperatingArea: Array<FacilityNode>;
  facility: Maybe<FacilityNode>;
  facilityGroup: Maybe<FacilityGroupNode>;
  facilityGroupSelection: Maybe<FacilityGroupSelectionNode>;
  facilityGroupSelections: Maybe<FacilityGroupSelectionNodeConnection>;
  facilityGroupSpend: Array<FacilityGroupSpendNode>;
  facilityGroups: Maybe<FacilityGroupNodeConnection>;
  facilityVendorRelationships: Maybe<FacilityVendorRelationshipNodeConnection>;
  favouriteVendorConfigurations: Maybe<FavouriteVendorConfigurationNodeConnection>;
  featureFlags: Array<Scalars['String']>;
  featureTier: Maybe<FeatureTierNode>;
  featureTiers: Maybe<FeatureTierNodeConnection>;
  glCode: Maybe<GlCodeNode>;
  glCodes: Maybe<GlCodeNodeConnection>;
  globalSearch: Maybe<Array<SearchResult>>;
  inboundVendorInvoiceValidation: Maybe<InboundVendorInvoiceValidationNode>;
  inboundVendorInvoices: Maybe<InboundVendorInvoiceNodeConnection>;
  inboxItem: Maybe<InboxItemNode>;
  inboxItems: Maybe<InboxItemNodeConnection>;
  incident: Incident;
  incidents: Maybe<IncidentConnection>;
  internalAppointment: Maybe<InternalAppointmentNode>;
  internalAppointments: Maybe<InternalAppointmentNodeConnection>;
  internalRequest: Maybe<InternalRequestNode>;
  internalRequests: Maybe<InternalRequestNodeConnection>;
  invite: Maybe<InviteNode>;
  invites: Maybe<InviteNodeConnection>;
  invoiceApprovalSettings: Maybe<InvoiceApprovalSettings>;
  invoicePaymentsPreview: Maybe<InvoicePaymentPreview>;
  invoiceSet: Maybe<InvoiceSetNode>;
  isExpectedServiceTimelineValid: Scalars['Boolean'];
  jobChangeSuggestions: Maybe<VendorJobChangeSuggestionNodeConnection>;
  jobCounts: Maybe<VendorJobCountNode>;
  kustomerWorkOrderEscalation: Maybe<KustomerWorkOrderEscalationNode>;
  locationAddressResolution: Maybe<LocationAddressResolutionNode>;
  locationAddressResolutions: Maybe<LocationAddressResolutionNodeConnection>;
  maintenancePlan: Maybe<MaintenancePlanNode>;
  maintenancePlanNotesTemplatePreview: Maybe<Scalars['String']>;
  maintenancePlanType: Maybe<MaintenancePlanTypeNode>;
  maintenancePlanTypes: Maybe<MaintenancePlanTypeNodeConnection>;
  maintenancePlans: Maybe<MaintenancePlanNodeConnection>;
  market: Maybe<MarketNode>;
  markets: Maybe<MarketNodeConnection>;
  markupInvoiceValidation: Maybe<InvoiceValidationNode>;
  markupQuoteValidation: Maybe<QuoteValidationNode>;
  me: Maybe<UserNode>;
  miscellaneousHolds: Maybe<MiscellaneousHoldConnection>;
  nondeactivatedVendors: Maybe<NonDeactivatedVendorOrganizationNodeConnection>;
  notificationPreferences: Maybe<NotificationPreferenceNodeConnection>;
  notifications: Array<NotificationSkeleton>;
  offResqCustomer: Maybe<OffResqCustomerNode>;
  offResqCustomers: Maybe<OffResqCustomerNodeConnection>;
  onboardingAction: Maybe<OnboardingActionNode>;
  onboardingActions: Maybe<OnboardingActionNodeConnection>;
  operatingArea: Maybe<OperatingAreaNode>;
  operatingAreas: Maybe<OperatingAreaNodeConnection>;
  organizationFeatures: Maybe<OrganizationFeaturesNode>;
  overtimeStatus: Maybe<OvertimeStatus>;
  payment: Maybe<PaymentNode>;
  paymentMethod: Maybe<PaymentMethodNode>;
  paymentMethods: Maybe<PaymentMethodNodeConnection>;
  payments: Maybe<PaymentNodeConnection>;
  preventativeMaintenance: Maybe<PreventativeMaintenanceNode>;
  preventativeMaintenances: Maybe<PreventativeMaintenanceNodeConnection>;
  previouslyHiredVendors: PreviouslyHiredVendorsNode;
  priceRateOverride: Maybe<PriceRateOverrideNode>;
  priceRateOverrides: Maybe<PriceRateOverrideNodeConnection>;
  provinces: Maybe<ProvinceNodeConnection>;
  quote: Maybe<QuoteNode>;
  quoteAcceptanceSettings: Maybe<QuoteAcceptanceSettings>;
  quoteApprovalThreshold: Maybe<QuoteApprovalThresholdNode>;
  quoteApprovalThresholds: Maybe<QuoteApprovalThresholdNodeConnection>;
  quoteSet: Maybe<QuoteSetNode>;
  quoteSets: Maybe<QuoteSetNodeConnection>;
  quoteSpendThreshold: Scalars['Decimal'];
  quotes: Maybe<QuoteNodeConnection>;
  realMe: Maybe<UserNode>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  recordOfWorkRevenueShareValues: Maybe<RecordOfWorkRevenueShareValuesNode>;
  recordsOfWork: Maybe<RecordOfWorkNodeConnection>;
  reportFilter: Maybe<ReportFilterNode>;
  reportFilters: Maybe<ReportFilterNodeConnection>;
  reportInstance: Maybe<ReportInstanceNode>;
  reportInstances: Maybe<ReportInstanceNodeConnection>;
  reportPreview: Maybe<ReportPreviewNode>;
  reportTemplate: Maybe<ReportTemplateNode>;
  reportTemplates: Maybe<ReportTemplateNodeConnection>;
  resqActiveHoursStatus: Maybe<ResqActiveHoursStatus>;
  revShareInvoiceValidation: Maybe<InvoiceValidationNode>;
  revShareQuoteValidation: Maybe<QuoteValidationNode>;
  revenueShareOverride: Maybe<RevenueShareOverrideNode>;
  revenueShareOverrides: Maybe<RevenueShareOverrideNodeConnection>;
  reviewRequests: Maybe<ReviewRequestNodeConnection>;
  role: Maybe<RoleNode>;
  roles: Maybe<RoleNodeConnection>;
  ruleViolations: Maybe<RuleViolationsNodeConnection>;
  salesforceClientAccountResult: Maybe<SalesforceClientAccountResult>;
  salesforceClientExpansionPosibilities: Maybe<SalesforceClientExpansionPossibilities>;
  salesforceVendorAccountResult: Maybe<SalesforceVendorAccountResult>;
  schedulingRequests: Maybe<SchedulingRequestConnection>;
  schemaHash: Scalars['String'];
  serviceCategories: Array<ServiceCategoryNode>;
  skill: Maybe<SkillNode>;
  skills: Maybe<SkillNodeConnection>;
  sourcingPartsHolds: Maybe<SourcingPartsHoldConnection>;
  spendApproval: Maybe<SpendApprovalNode>;
  spendApprovalOnWorkOrder: Maybe<SpendApprovalNode>;
  spendApprovalPreferences: Maybe<SpendApprovalPreferenceNodeConnection>;
  spendApprovals: Maybe<SpendApprovalNodeConnection>;
  spendItemAllocation: SpendItemAllocationNode;
  stripeCustomer: Maybe<StripeCustomerNode>;
  stripeCustomers: Maybe<StripeCustomerNodeConnection>;
  subscription: Maybe<SubscriptionNode>;
  subscriptions: Maybe<SubscriptionNodeConnection>;
  taxRates: Maybe<TaxRateNodeConnection>;
  taxonomyNodes: Array<TaxonomyNodeNode>;
  technicians: Maybe<UserNodeConnection>;
  trades: Maybe<TradeNodeConnection>;
  troubleshootingPlan: Maybe<TroubleshootingPlanNode>;
  user: Maybe<UserNode>;
  userNotificationPreferences: Maybe<UserNotificationPreferenceConnection>;
  userTags: Maybe<UserTagNodeConnection>;
  users: Maybe<UserNodeConnection>;
  validateAddress: Maybe<AddressValidation>;
  vendorAssignments: Maybe<VendorAssignmentNodeConnection>;
  vendorDispatchRequest: Maybe<VendorDispatchRequestNode>;
  vendorDispatchRequests: Maybe<VendorDispatchRequestNodeConnection>;
  vendorInvoice: Maybe<VendorInvoiceNode>;
  vendorInvoices: Maybe<VendorInvoiceNodeConnection>;
  vendorMatches: VendorMatchSet;
  vendorMembers: Maybe<VendorMemberNodeConnection>;
  vendorMetrics: Maybe<VendorMetricsNode>;
  vendorOrganization: Maybe<VendorOrganizationNode>;
  vendorPayout: Maybe<VendorPayoutNode>;
  vendorPerformanceProfile: Maybe<VendorPerformanceProfile>;
  vendorPlans: Maybe<VendorPlanNodeConnection>;
  vendorPriceRate: Maybe<VendorPriceRateNode>;
  vendorPriceRates: Maybe<VendorPriceRateNodeConnection>;
  vendorRevenueShare: Maybe<VendorRevenueShareNode>;
  vendorRevenueShares: Maybe<VendorRevenueShareNodeConnection>;
  vendors: Maybe<VendorOrganizationNodeConnection>;
  verifyFacilityAddress: Maybe<VerifyFacilityAddressNode>;
  verifyLocationAddress: Maybe<VerifyLocationAddressNode>;
  verifyOrganizationAddresses: Maybe<VerifyOrganizationAddressesNode>;
  visitReviewRequests: Maybe<VisitReviewRequestNodeConnection>;
  visits: Maybe<VisitNodeConnection>;
  workOrder: Maybe<WorkOrderNode>;
  workOrderCancellationDetail: Maybe<WorkOrderCancellationDetailNodeConnection>;
  workOrderComments: Maybe<CommentNodeConnection>;
  workOrderCountsForCoordinatorStatuses: WorkOrderCountsByCoordinatorStatus;
  workOrderCountsForCyovDispatches: WorkOrderCountsByCyovDispatches;
  workOrderEscalation: Maybe<WorkOrderEscalationNode>;
  workOrderEscalationReasons: Array<WorkOrderEscalationReasonType>;
  workOrderEscalations: Maybe<WorkOrderEscalationNodeConnection>;
  workOrderExpenseType: Maybe<WorkOrderExpenseTypeNode>;
  workOrderInternalNotes: Maybe<WorkOrderInternalNoteNodeConnection>;
  workOrderNotes: Maybe<WorkOrderNoteNodeConnection>;
  workOrderPendingReview: Maybe<WorkOrderNode>;
  workOrderPriorities: Maybe<WorkOrderPriorityNodeConnection>;
  workOrderReviewFeedback: Maybe<WorkOrderReviewFeedbackNodeConnection>;
  workOrderReviews: Maybe<WorkOrderReviewNodeConnection>;
  workOrderSchedulingSla: Maybe<Scalars['DateTime']>;
  workOrderSchedulingViolations: Maybe<Array<SchedulingViolation>>;
  workOrderStatusSuggestion: Maybe<WorkOrderStatusSuggestion>;
  workOrderTeamMemberAssignment: Maybe<WorkOrderTeamMemberAssignmentNode>;
  workOrderVendorEligibilityProfiles: Maybe<WorkOrderVendorEligibilityProfileNodeConnection>;
  workOrders: Maybe<WorkOrderNodeConnection>;
};


export type QueryActivitiesArgs = {
  activityType_In?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  facilityGroupId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facilityId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isEssentials?: InputMaybe<Scalars['Boolean']>;
  isInProgress?: InputMaybe<Scalars['Boolean']>;
  isOvertimeApproved?: InputMaybe<Scalars['Boolean']>;
  isSnoozed?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  opsOwnerId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  reviewType_In?: InputMaybe<Array<InputMaybe<ResqReviewActivityReviewType>>>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceGuaranteeStatusIn?: InputMaybe<Array<InputMaybe<ServiceGuaranteeStatus>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryActivityFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<ActivityFeedEntryEntryType>;
  first?: InputMaybe<Scalars['Int']>;
  isVendor?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryAlertsArgs = {
  params: GetAllAlertsInput;
};


export type QueryAllocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  budgetId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryApBatchArgs = {
  id: Scalars['ID'];
};


export type QueryApBatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dueAtEndDate?: InputMaybe<Scalars['Date']>;
  dueAtStartDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<ApBatchStatus>>>;
  vendorOrganizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryApBlockArgs = {
  id: Scalars['ID'];
};


export type QueryApBlocksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  blockedAtEndDate?: InputMaybe<Scalars['Date']>;
  blockedAtStartDate?: InputMaybe<Scalars['Date']>;
  entityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryAppointmentArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  hasOutcome?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Array<InputMaybe<Outcome>>>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']>;
  startsAtGte?: InputMaybe<Scalars['DateTime']>;
  startsAtLte?: InputMaybe<Scalars['DateTime']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryAttachmentArgs = {
  id: Scalars['ID'];
};


export type QueryAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachedTo: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryAvailableVendorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};


export type QueryBankAccountArgs = {
  id: Scalars['ID'];
};


export type QueryBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBarcodeArgs = {
  id: Scalars['ID'];
};


export type QueryBarcodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachedTo?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBatchPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryBatchPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryBillingInformationArgs = {
  id: Scalars['ID'];
};


export type QueryBillingInformationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBudgetArgs = {
  id: Scalars['ID'];
};


export type QueryBudgetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryBusinessUnitArgs = {
  id: Scalars['ID'];
};


export type QueryBusinessUnitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryCalculatedMarkupInvoiceFiguresArgs = {
  facilityId: Scalars['ID'];
  lineItems: Array<MarkupInputLineItemType>;
  serviceCategory?: InputMaybe<ServiceCategory>;
};


export type QueryCalculatedRevShareInvoiceFiguresArgs = {
  facilityId: Scalars['ID'];
  lineItems: Array<RevShareInputLineItemType>;
  serviceCategory?: InputMaybe<ServiceCategory>;
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryClientFeaturesArgs = {
  businessUnitId?: InputMaybe<Scalars['ID']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryClientInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryClientInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']>;
  dueAtDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  expenseTypes?: InputMaybe<Array<InputMaybe<ExpenseType>>>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isDisputed?: InputMaybe<Scalars['Boolean']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionInvoice?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  query?: InputMaybe<Scalars['String']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<ClientInvoiceStatus>>>;
  workOrder?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryClientMetricsArgs = {
  clientId: Scalars['ID'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  lastPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  lastPeriodStart?: InputMaybe<Scalars['DateTime']>;
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  userTz?: InputMaybe<Scalars['String']>;
};


export type QueryClientOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryClientOrganizationMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeClientUsersWithResqEmails?: InputMaybe<Scalars['Boolean']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  hideAdmins?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyColleaguesOfUser?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  permissions?: InputMaybe<Array<InputMaybe<Permission>>>;
  query?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showAnonymous?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryClientOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryClientPreferredSpendThresholdArgs = {
  organizationId: Scalars['ID'];
  serviceCategory: ServiceCategory;
};


export type QueryClientReportArgs = {
  id: Scalars['ID'];
};


export type QueryClientReportScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryClientReportSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryClientReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  reportType?: InputMaybe<Array<InputMaybe<ClientReportType>>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryClientStatementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['ID']>;
  businessUnit_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Date']>;
};


export type QueryClientVendorRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  hasFavourites?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  inviteStatus?: InputMaybe<InviteStatus>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendorName?: InputMaybe<Scalars['String']>;
};


export type QueryCoordinatorArgs = {
  id: Scalars['ID'];
};


export type QueryCoordinatorUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDailyMenuIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  configIds?: InputMaybe<Array<Scalars['ID']>>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  readingType?: InputMaybe<DeviceConfigReadingType>;
  skip?: InputMaybe<Scalars['Int']>;
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
};


export type QueryDefaultMarkupLineItemArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  newLineItem: MarkupInputLineItemType;
  notes?: InputMaybe<Scalars['String']>;
  quoteId?: InputMaybe<Scalars['ID']>;
  vendorNotes?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};


export type QueryDefaultRevShareLineItemArgs = {
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  newLineItem: RevShareInputLineItemType;
  notes?: InputMaybe<Scalars['String']>;
  quoteId?: InputMaybe<Scalars['ID']>;
  vendorNotes?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};


export type QueryDefaultVendorRevenueShareArgs = {
  id: Scalars['ID'];
};


export type QueryDefaultVendorRevenueShareOverrideArgs = {
  id: Scalars['ID'];
};


export type QueryDefaultVendorRevenueShareOverridesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryDefaultVendorRevenueSharesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryDetermineTroubleshootingPlanArgs = {
  clientId: Scalars['ID'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  taxonomyId?: InputMaybe<Scalars['ID']>;
};


export type QueryDeviceConfigsArgs = {
  deviceId?: InputMaybe<Scalars['ID']>;
};


export type QueryDeviceDataArgs = {
  params: GetDeviceDataInput;
};


export type QueryDevicesArgs = {
  params: GetAllDevicesInput;
};


export type QueryDispatchRelationshipArgs = {
  id: Scalars['ID'];
};


export type QueryDispatchRelationshipSummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dispatchRelationships_Vendor?: InputMaybe<Scalars['ID']>;
  facilityGroup_Facility?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDispatchRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  computedForFacilityGroupId?: InputMaybe<Scalars['ID']>;
  facilityGroupId?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<DispatchRelationshipStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryDjangoGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasGlobalPermission?: InputMaybe<Scalars['Boolean']>;
  includeInternalCoordinator?: InputMaybe<Scalars['Boolean']>;
  includeOnlyOutsourceGroups?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDjangoPermissionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryEquipmentArgs = {
  id: Scalars['ID'];
};


export type QueryEquipmentCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  depth?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  serviceCategory?: InputMaybe<Scalars['String']>;
  showNotCategorized?: InputMaybe<Scalars['Boolean']>;
  showOther?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryEquipmentCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryEquipmentManufacturerArgs = {
  id: Scalars['ID'];
};


export type QueryEquipmentManufacturersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  showGeneric?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryEquipmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  barCode?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  code_Istartswith?: InputMaybe<Scalars['String']>;
  equippedFacilities_Id?: InputMaybe<Scalars['ID']>;
  equippedFacilities_Organization?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facility_Id?: InputMaybe<Scalars['ID']>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facility_Organization?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  hasOngoingIncident?: InputMaybe<Scalars['Boolean']>;
  hasSensor?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  modelNo?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceEndDate?: InputMaybe<Scalars['Date']>;
  serviceStartDate?: InputMaybe<Scalars['Date']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<EquipmentStatus>>>;
};


export type QueryExpectedServiceTimelinesArgs = {
  facilityId: Scalars['ID'];
};


export type QueryExperimentVariantArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  experimentName: Scalars['String'];
  facilityId?: InputMaybe<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryExternalBankAccountArgs = {
  id: Scalars['ID'];
};


export type QueryExternalBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  entityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  hasWorkedWithVendorId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFacilitiesOutsideVendorOperatingAreaArgs = {
  clientId: Scalars['ID'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  vendorId: Scalars['ID'];
};


export type QueryFacilityArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityGroupArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityGroupSelectionArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityGroupSelectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryFacilityGroupSpendArgs = {
  budgetId: Scalars['ID'];
  parentId?: InputMaybe<Scalars['ID']>;
};


export type QueryFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dispatchRelationshipCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  dispatchRelationships_VendorId?: InputMaybe<Scalars['ID']>;
  entityId?: InputMaybe<Scalars['ID']>;
  excludeLeaf?: InputMaybe<Scalars['Boolean']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  groupFacilityId?: InputMaybe<Scalars['ID']>;
  groupUserId?: InputMaybe<Scalars['ID']>;
  hasDispatchRelationships?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nameOrFacilityName?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryFacilityVendorRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryFavouriteVendorConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryFeatureFlagsArgs = {
  appVersion?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryFeatureTierArgs = {
  id: Scalars['ID'];
};


export type QueryFeatureTiersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryGlCodeArgs = {
  id: Scalars['ID'];
};


export type QueryGlCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryGlobalSearchArgs = {
  q: Scalars['String'];
};


export type QueryInboundVendorInvoiceValidationArgs = {
  invoiceFile: Scalars['String'];
  workOrderId: Scalars['ID'];
};


export type QueryInboundVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryInboxItemArgs = {
  id: Scalars['ID'];
};


export type QueryInboxItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  itemTypes?: InputMaybe<Array<InputMaybe<InboxItemType>>>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryIncidentArgs = {
  incidentId: Scalars['ID'];
};


export type QueryIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  configIds?: InputMaybe<Array<Scalars['ID']>>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']>>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  readingType?: InputMaybe<DeviceConfigReadingType>;
  skip?: InputMaybe<Scalars['Int']>;
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
  useUserFacilities?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInternalAppointmentArgs = {
  id: Scalars['ID'];
};


export type QueryInternalAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Array<InputMaybe<InternalAppointmentOutcome>>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryInternalRequestArgs = {
  id: Scalars['ID'];
};


export type QueryInternalRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeDismissed?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hasIncompleteTasks?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Array<InputMaybe<InternalRequestOutcome>>>;
  preventativeMaintenanceId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isOwnerInvite?: InputMaybe<Scalars['Boolean']>;
  isVendorInvite?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryInvoiceApprovalSettingsArgs = {
  clientId: Scalars['ID'];
};


export type QueryInvoicePaymentsPreviewArgs = {
  workOrderIds: Array<Scalars['ID']>;
};


export type QueryInvoiceSetArgs = {
  id: Scalars['ID'];
};


export type QueryIsExpectedServiceTimelineValidArgs = {
  expectedServiceTimeline: ExpectedServiceTimeline;
  facilityId: Scalars['ID'];
  firstVisitExpectedArrivalTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryJobChangeSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryJobCountsArgs = {
  today: Scalars['Date'];
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryKustomerWorkOrderEscalationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationAddressResolutionArgs = {
  id: Scalars['ID'];
};


export type QueryLocationAddressResolutionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryMaintenancePlanArgs = {
  id: Scalars['ID'];
};


export type QueryMaintenancePlanNotesTemplatePreviewArgs = {
  frequencyUnit: MaintenancePlanFrequencyUnit;
  frequencyValue: Scalars['Int'];
  maintenancePlanTypeId: Scalars['ID'];
  periodEndDate: Scalars['Date'];
  template: Scalars['String'];
};


export type QueryMaintenancePlanTypeArgs = {
  id: Scalars['ID'];
};


export type QueryMaintenancePlanTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryMaintenancePlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  maintenancePlanType_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<MaintenancePlanStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryMarketArgs = {
  id: Scalars['ID'];
};


export type QueryMarketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryMarkupInvoiceValidationArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']>;
  vendorNotes?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};


export type QueryMarkupQuoteValidationArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']>;
  quoteId?: InputMaybe<Scalars['ID']>;
  workOrderId: Scalars['ID'];
};


export type QueryMiscellaneousHoldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QueryNondeactivatedVendorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  servicedClientId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryOffResqCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryOffResqCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type QueryOnboardingActionArgs = {
  id: Scalars['ID'];
};


export type QueryOnboardingActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryOperatingAreaArgs = {
  id: Scalars['ID'];
};


export type QueryOperatingAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  bbox?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  before?: InputMaybe<Scalars['String']>;
  center?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['ID']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<OperatingAreaStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrganizationFeaturesArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryOvertimeStatusArgs = {
  facilityId: Scalars['ID'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentMethodArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paymentType?: InputMaybe<Array<InputMaybe<PaymentMethodPaymentType>>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  batchPaymentId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  clientInvoiceId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryPreventativeMaintenanceArgs = {
  id: Scalars['ID'];
};


export type QueryPreventativeMaintenancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  teamMemberIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryPreviouslyHiredVendorsArgs = {
  clientId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryPriceRateOverrideArgs = {
  id: Scalars['ID'];
};


export type QueryPriceRateOverridesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryProvincesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteAcceptanceSettingsArgs = {
  clientId: Scalars['ID'];
};


export type QueryQuoteApprovalThresholdArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteApprovalThresholdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  threshold?: InputMaybe<Scalars['Decimal']>;
};


export type QueryQuoteSetArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteSetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<QuoteSetStatus>>>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryRecordOfWorkArgs = {
  id?: InputMaybe<Scalars['ID']>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QueryRecordOfWorkRevenueShareValuesArgs = {
  facilityId: Scalars['ID'];
  serviceCategory: ServiceCategory;
  vendorId: Scalars['ID'];
};


export type QueryRecordsOfWorkArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  invoiceSetId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<RecordOfWorkStatus>;
  vendorId?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportFilterArgs = {
  id: Scalars['ID'];
};


export type QueryReportFiltersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  datatype?: InputMaybe<Array<InputMaybe<ReportFilterDatatype>>>;
  field?: InputMaybe<Scalars['String']>;
  field_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<Array<InputMaybe<ReportFilterOperator>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportInstanceArgs = {
  id: Scalars['ID'];
};


export type QueryReportInstancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportPreviewArgs = {
  organizationId: Scalars['ID'];
  reportFields: Array<InputMaybe<Scalars['String']>>;
  reportFilters: Array<InputMaybe<FilterInput>>;
  reportOrderBy: Scalars['String'];
  reportType: ReportType;
};


export type QueryReportTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  description_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  reportType?: InputMaybe<Array<InputMaybe<ReportType>>>;
  skip?: InputMaybe<Scalars['Int']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
};


export type QueryRevShareInvoiceValidationArgs = {
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']>;
  vendorNotes?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};


export type QueryRevShareQuoteValidationArgs = {
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']>;
  quoteId?: InputMaybe<Scalars['ID']>;
  workOrderId: Scalars['ID'];
};


export type QueryRevenueShareOverrideArgs = {
  id: Scalars['ID'];
};


export type QueryRevenueShareOverridesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isDueForReminder?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<ReviewRequestStatus>>>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlySubsetOfUser?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  showAnonymous?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRuleViolationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entity: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySalesforceClientAccountResultArgs = {
  sfId: Scalars['String'];
};


export type QuerySalesforceClientExpansionPosibilitiesArgs = {
  clientId: Scalars['ID'];
};


export type QuerySalesforceVendorAccountResultArgs = {
  sfId: Scalars['String'];
};


export type QuerySchedulingRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  skip?: InputMaybe<Scalars['Int']>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QueryServiceCategoriesArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  equipmentRelated?: InputMaybe<Scalars['Boolean']>;
  submittable?: InputMaybe<Scalars['Boolean']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QuerySkillArgs = {
  id: Scalars['ID'];
};


export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySourcingPartsHoldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QuerySpendApprovalArgs = {
  id: Scalars['ID'];
};


export type QuerySpendApprovalOnWorkOrderArgs = {
  workOrderId: Scalars['ID'];
};


export type QuerySpendApprovalPreferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySpendApprovalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QuerySpendItemAllocationArgs = {
  spendItemId: Scalars['ID'];
};


export type QueryStripeCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryStripeCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryTaxRatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  facility: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validTo?: InputMaybe<Scalars['DateTime']>;
  validTo_Isnull?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTaxonomyNodesArgs = {
  serviceCategory: ServiceCategory;
};


export type QueryTechniciansArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignableToWorkorder?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryTradesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryTroubleshootingPlanArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryValidateAddressArgs = {
  address: Scalars['String'];
  cityName?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  provinceCode?: InputMaybe<Scalars['String']>;
};


export type QueryVendorAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Array<InputMaybe<VendorAssignmentOutcome>>>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorDispatchRequestArgs = {
  id: Scalars['ID'];
};


export type QueryVendorDispatchRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<VendorDispatchRequestStatus>>>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']>;
  dueAtEndDate?: InputMaybe<Scalars['Date']>;
  dueAtStartDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isOffResqCustomer?: InputMaybe<Scalars['Boolean']>;
  isPaid?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']>;
  query?: InputMaybe<Scalars['String']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorPayoutStatus?: InputMaybe<Array<InputMaybe<WorkOrderVendorPayoutStatus>>>;
  workOrder?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorMatchesArgs = {
  input: VendorMatchesInput;
};


export type QueryVendorMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  permissions?: InputMaybe<Array<InputMaybe<Permission>>>;
  query?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorMetricsArgs = {
  categories?: InputMaybe<Array<ServiceCategory>>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  technicianIds?: InputMaybe<Array<Scalars['ID']>>;
  vendorId: Scalars['ID'];
  verifiedDataOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryVendorOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryVendorPayoutArgs = {
  id: Scalars['ID'];
};


export type QueryVendorPerformanceProfileArgs = {
  vendorId: Scalars['ID'];
};


export type QueryVendorPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  legacyGroup?: InputMaybe<Scalars['Int']>;
  legacyGroup_Isnull?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryVendorPriceRateArgs = {
  id: Scalars['ID'];
};


export type QueryVendorPriceRatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorRevenueShareArgs = {
  id: Scalars['ID'];
};


export type QueryVendorRevenueSharesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryVendorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  servicedClientId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryVerifyFacilityAddressArgs = {
  facilityId: Scalars['ID'];
};


export type QueryVerifyLocationAddressArgs = {
  address?: InputMaybe<Scalars['String']>;
  cityId: Scalars['ID'];
  countryId: Scalars['ID'];
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId: Scalars['ID'];
};


export type QueryVerifyOrganizationAddressesArgs = {
  organizationId: Scalars['ID'];
};


export type QueryVisitReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  appointment?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statusIn?: InputMaybe<Array<InputMaybe<VisitReviewRequestStatus>>>;
};


export type QueryVisitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrder?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderArgs = {
  id: Scalars['ID'];
};


export type QueryWorkOrderCancellationDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrder?: InputMaybe<Scalars['ID']>;
  workOrderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryWorkOrderCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderCountsForCoordinatorStatusesArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  isDisputed?: InputMaybe<Scalars['Boolean']>;
  isEscalated?: InputMaybe<Scalars['Boolean']>;
  isEssentials?: InputMaybe<Scalars['Boolean']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isOnHold?: InputMaybe<Scalars['Boolean']>;
  noOpsOwner?: InputMaybe<Scalars['Boolean']>;
  opsOwnerId?: InputMaybe<Scalars['ID']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  serviceGuaranteeStatusIn?: InputMaybe<Array<ServiceGuaranteeStatus>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderCountsForCyovDispatchesArgs = {
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<WorkOrderStatus>>;
};


export type QueryWorkOrderEscalationArgs = {
  id: Scalars['ID'];
};


export type QueryWorkOrderEscalationReasonsArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  sourceOrgType?: InputMaybe<WorkOrderEscalationSourceOrgType>;
};


export type QueryWorkOrderEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  isDismissed?: InputMaybe<Scalars['Boolean']>;
  isOvertimeApproved?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<InputMaybe<WorkOrderEscalationReason>>>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']>;
  sourceOrgId?: InputMaybe<Scalars['ID']>;
  sourceOrgType?: InputMaybe<Array<InputMaybe<WorkOrderEscalationSourceOrgType>>>;
  unresolved?: InputMaybe<Scalars['Boolean']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderExpenseTypeArgs = {
  workOrderId: Scalars['ID'];
};


export type QueryWorkOrderInternalNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderPrioritiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkOrderReviewFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkOrderReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  satisfied?: InputMaybe<Scalars['Boolean']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrderSchedulingSlaArgs = {
  workOrderId: Scalars['ID'];
};


export type QueryWorkOrderSchedulingViolationsArgs = {
  selectedDate?: InputMaybe<Scalars['Date']>;
  selectedEndsAt?: InputMaybe<Scalars['DateTime']>;
  selectedStartsAt?: InputMaybe<Scalars['DateTime']>;
  workOrderId: Scalars['ID'];
};


export type QueryWorkOrderStatusSuggestionArgs = {
  workOrderId: Scalars['ID'];
};


export type QueryWorkOrderTeamMemberAssignmentArgs = {
  id: Scalars['ID'];
};


export type QueryWorkOrderVendorEligibilityProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  newClientIncentive?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedTechnician?: InputMaybe<Scalars['ID']>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  clientStatus_In?: InputMaybe<Array<InputMaybe<ClientWorkOrderStatus>>>;
  code?: InputMaybe<Scalars['String']>;
  code_Icontains?: InputMaybe<Scalars['String']>;
  code_Istartswith?: InputMaybe<Scalars['String']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']>;
  coordinatorStatus_In?: InputMaybe<Array<InputMaybe<CoordinatorStatusEnum>>>;
  cyovDispatchesCountGte?: InputMaybe<Scalars['Float']>;
  cyovDispatchesCountLte?: InputMaybe<Scalars['Float']>;
  equipment?: InputMaybe<Scalars['ID']>;
  equipmentId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  expectedServiceTimeline_In?: InputMaybe<Array<InputMaybe<ExpectedServiceTimeline>>>;
  facility?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  facility_Organization?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  hasActionableQuoteForClient?: InputMaybe<Scalars['ID']>;
  hasUnresolvedRuleViolations?: InputMaybe<Scalars['Boolean']>;
  holdReason_In?: InputMaybe<Array<InputMaybe<WorkOrderHoldReason>>>;
  id?: InputMaybe<Scalars['ID']>;
  invoicesApproved?: InputMaybe<Scalars['Boolean']>;
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  isCyov?: InputMaybe<Scalars['Boolean']>;
  isDisputed?: InputMaybe<Scalars['Boolean']>;
  isEscalated?: InputMaybe<Scalars['Boolean']>;
  isEssentials?: InputMaybe<Scalars['Boolean']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isOnHold?: InputMaybe<Scalars['Boolean']>;
  isOverdueForCompletion?: InputMaybe<Scalars['Boolean']>;
  isSatisfied?: InputMaybe<Scalars['Boolean']>;
  isSnoozed?: InputMaybe<Scalars['Boolean']>;
  isWithinAppointmentWindow?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  needsPayment?: InputMaybe<Scalars['Boolean']>;
  needsResponseNotes?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  onHold?: InputMaybe<Scalars['Boolean']>;
  opsOwner?: InputMaybe<Scalars['ID']>;
  opsOwner_Isnull?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  preventativeMaintenanceId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']>;
  scheduledForEnd?: InputMaybe<Scalars['Date']>;
  scheduledForStart?: InputMaybe<Scalars['Date']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceGuaranteeStatusIn?: InputMaybe<Array<InputMaybe<ServiceGuaranteeStatus>>>;
  skip?: InputMaybe<Scalars['Int']>;
  status_In?: InputMaybe<Array<InputMaybe<WorkOrderStatus>>>;
  submittedBy?: InputMaybe<Scalars['ID']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  undergoingCyov?: InputMaybe<Scalars['Boolean']>;
  vendor?: InputMaybe<Scalars['ID']>;
  vendorPayoutStatus_In?: InputMaybe<Array<InputMaybe<WorkOrderVendorPayoutStatus>>>;
  vendorStatus_In?: InputMaybe<Array<InputMaybe<WorkOrderVendorStatus>>>;
};

export type QuoteAcceptanceSettings = {
  __typename: 'QuoteAcceptanceSettings';
  approvalThresholds: Array<QuoteApprovalThresholdNode>;
  selectionRoles: Array<RoleNode>;
};

/** An enumeration. */
export enum QuoteApprovalStrategy {
  Cascading = 'CASCADING',
  Simple = 'SIMPLE'
}

export type QuoteApprovalThresholdInput = {
  roleIds: Array<Scalars['ID']>;
  thresholdAmount?: InputMaybe<Scalars['Decimal']>;
  thresholdId?: InputMaybe<Scalars['ID']>;
};

export type QuoteApprovalThresholdNode = Node & {
  __typename: 'QuoteApprovalThresholdNode';
  /** The ID of the object */
  id: Scalars['ID'];
  roles: Array<RoleNode>;
  threshold: Maybe<Scalars['Decimal']>;
};

export type QuoteApprovalThresholdNodeConnection = {
  __typename: 'QuoteApprovalThresholdNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteApprovalThresholdNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `QuoteApprovalThresholdNode` and its cursor. */
export type QuoteApprovalThresholdNodeEdge = {
  __typename: 'QuoteApprovalThresholdNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<QuoteApprovalThresholdNode>;
};

export enum QuoteFeedbackType {
  ChangeScope = 'CHANGE_SCOPE',
  ClarifyPrice = 'CLARIFY_PRICE',
  ClarifyScope = 'CLARIFY_SCOPE'
}

export enum QuoteLineItemEnum {
  ItemTypeEnvironmentalFees = 'ITEM_TYPE_ENVIRONMENTAL_FEES',
  ItemTypeFreightShippingHandling = 'ITEM_TYPE_FREIGHT_SHIPPING_HANDLING',
  ItemTypeLabour = 'ITEM_TYPE_LABOUR',
  ItemTypeOther = 'ITEM_TYPE_OTHER',
  ItemTypeParking = 'ITEM_TYPE_PARKING',
  ItemTypePart = 'ITEM_TYPE_PART',
  ItemTypePromotion = 'ITEM_TYPE_PROMOTION',
  ItemTypeServiceCharge = 'ITEM_TYPE_SERVICE_CHARGE',
  ItemTypeTravel = 'ITEM_TYPE_TRAVEL',
  ItemTypeTruck = 'ITEM_TYPE_TRUCK'
}

export type QuoteLineItemNode = Node & {
  __typename: 'QuoteLineItemNode';
  description: Maybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  itemType: QuoteLineItemEnum;
  markup: Scalars['Decimal'];
  /** A boolean of whether the line item is flagged as an overtime value. Overtime values for service calls, labour, and travel are more expensive than their non-overtime counterparts. */
  overtime: Scalars['Boolean'];
  /** This is applicable for line items with a type of Part (1). */
  partManufacturer: Maybe<Scalars['String']>;
  /** This is applicable for line items with a type of Part (1). */
  partName: Maybe<Scalars['String']>;
  /** This is applicable for line items with a type of Part (1). */
  partNumber: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  revShare: Scalars['Decimal'];
  taxRates: Array<TaxRateNode>;
  /** A boolean of whether the line item is covered by warranty of not. */
  warranty: Scalars['Boolean'];
};

export type QuoteNode = Node & {
  __typename: 'QuoteNode';
  actionedBy: Maybe<UserNode>;
  approvedAt: Maybe<Scalars['DateTime']>;
  can: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  declinedAt: Maybe<Scalars['DateTime']>;
  feedbackCount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoicingVersion: InvoicingVersion;
  lineItems: Array<QuoteLineItemNode>;
  notes: Scalars['String'];
  overrideNotes: Maybe<Scalars['String']>;
  pdfFile: Maybe<FileType>;
  price: Scalars['Decimal'];
  publishedAt: Maybe<Scalars['DateTime']>;
  quoteUploadSource: QuoteUploadSource;
  validUntil: Maybe<Scalars['DateTime']>;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};


export type QuoteNodeCanArgs = {
  perform: QuotePermission;
};

export type QuoteNodeConnection = {
  __typename: 'QuoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuoteNode` and its cursor. */
export type QuoteNodeEdge = {
  __typename: 'QuoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<QuoteNode>;
};

export enum QuotePermission {
  Approve = 'APPROVE'
}

export type QuoteSetNode = Node & {
  __typename: 'QuoteSetNode';
  cancelReason: Scalars['String'];
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime'];
  expectedPrice: Maybe<Scalars['Decimal']>;
  /** The ID of the object */
  id: Scalars['ID'];
  options: Array<QuoteSetOptionNode>;
  permissions: QuoteSetPermissions;
  rejectedAt: Maybe<Scalars['DateTime']>;
  rejectedBy: Maybe<UserNode>;
  rejectionReason: Scalars['String'];
  remainingApprovalSteps: Scalars['Int'];
  status: QuoteSetStatus;
  workOrder: WorkOrderNode;
};

export type QuoteSetNodeConnection = {
  __typename: 'QuoteSetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteSetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuoteSetNode` and its cursor. */
export type QuoteSetNodeEdge = {
  __typename: 'QuoteSetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<QuoteSetNode>;
};

export type QuoteSetOptionApprovalNode = Node & {
  __typename: 'QuoteSetOptionApprovalNode';
  approvedAt: Scalars['DateTime'];
  approvedBy: UserNode;
  approvedByMember: Maybe<ClientOrganizationMemberNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  quoteSetOption: QuoteSetOptionNode;
};

export type QuoteSetOptionNode = Node & {
  __typename: 'QuoteSetOptionNode';
  approvalNeededRoles: Array<Array<RoleNode>>;
  approvals: Array<QuoteSetOptionApprovalNode>;
  createdAt: Scalars['DateTime'];
  expiredAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<QuoteSetOptionOutcome>;
  permissions: QuoteSetOptionPermissions;
  quote: QuoteNode;
  quoteSet: QuoteSetNode;
  rejectReasons: Array<Scalars['String']>;
  rejectedAt: Maybe<Scalars['DateTime']>;
  rejectedBy: Maybe<UserNode>;
  rejectedByMember: Maybe<ClientOrganizationMemberNode>;
  removeReason: Scalars['String'];
  removedAt: Maybe<Scalars['DateTime']>;
  removedBy: Maybe<UserNode>;
  selectedAt: Maybe<Scalars['DateTime']>;
  selectedBy: Maybe<UserNode>;
  selectedByMember: Maybe<ClientOrganizationMemberNode>;
};

/** An enumeration. */
export enum QuoteSetOptionOutcome {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Selected = 'SELECTED'
}

export type QuoteSetOptionPermissions = {
  __typename: 'QuoteSetOptionPermissions';
  actionOnSpend: Scalars['Boolean'];
  provideFeedback: Scalars['Boolean'];
  remove: Scalars['Boolean'];
  select: Scalars['Boolean'];
  selectAndApproveSpend: Scalars['Boolean'];
};

export type QuoteSetPermissions = {
  __typename: 'QuoteSetPermissions';
  reject: Scalars['Boolean'];
};

/** An enumeration. */
export enum QuoteSetStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Presented = 'PRESENTED',
  Rejected = 'REJECTED',
  Selected = 'SELECTED'
}

/** An enumeration. */
export enum QuoteUploadSource {
  PartnerApp = 'PARTNER_APP',
  Pmc = 'PMC',
  Rcc = 'RCC'
}

export type QuoteValidationNode = Node & {
  __typename: 'QuoteValidationNode';
  /** The ID of the object */
  id: Scalars['ID'];
  validationMessages: Array<Scalars['String']>;
  validationResults: Array<InvoiceValidationResult>;
};

export type RaiseApprovedSpendDuringWorkOrderSubmissionInput = {
  amount: Scalars['Decimal'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type RaiseApprovedSpendDuringWorkOrderSubmissionPayload = {
  __typename: 'RaiseApprovedSpendDuringWorkOrderSubmissionPayload';
  clientMutationId: Maybe<Scalars['String']>;
  spendApproval: SpendApprovalNode;
};

export type ReactivateEquipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  equipmentId: Scalars['ID'];
};

export type ReactivateEquipmentPayload = {
  __typename: 'ReactivateEquipmentPayload';
  clientMutationId: Maybe<Scalars['String']>;
  equipment: EquipmentNode;
};

export type ReactivateFacilityMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['ID'];
};

export type ReactivateFacilityMutationPayload = {
  __typename: 'ReactivateFacilityMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ReassignWorkOrderToTeamMemberInput = {
  assignedUserId: Scalars['ID'];
  assignmentId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReassignWorkOrderToTeamMemberPayload = {
  __typename: 'ReassignWorkOrderToTeamMemberPayload';
  clientMutationId: Maybe<Scalars['String']>;
  newAssignment: WorkOrderTeamMemberAssignmentNode;
};

export type ReassignWorkOrderVendorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  correlationId: Scalars['String'];
  vendor: Scalars['ID'];
  workOrder: Scalars['ID'];
};

export type ReassignWorkOrderVendorPayload = {
  __typename: 'ReassignWorkOrderVendorPayload';
  clientMutationId: Maybe<Scalars['String']>;
  newWorkOrder: WorkOrderNode;
};

export type RecordOfWorkDefaultLineItemNode = Node & {
  __typename: 'RecordOfWorkDefaultLineItemNode';
  defaultLineItem: RecordOfWorkLineItemNode;
  /** The ID of the object */
  id: Scalars['ID'];
};

export enum RecordOfWorkLineItemEnum {
  ItemTypeEnvironmentalFees = 'ITEM_TYPE_ENVIRONMENTAL_FEES',
  ItemTypeFee = 'ITEM_TYPE_FEE',
  ItemTypeFreightShippingHandling = 'ITEM_TYPE_FREIGHT_SHIPPING_HANDLING',
  ItemTypeLabour = 'ITEM_TYPE_LABOUR',
  ItemTypeOther = 'ITEM_TYPE_OTHER',
  ItemTypeParking = 'ITEM_TYPE_PARKING',
  ItemTypePart = 'ITEM_TYPE_PART',
  ItemTypePromotion = 'ITEM_TYPE_PROMOTION',
  ItemTypeServiceCharge = 'ITEM_TYPE_SERVICE_CHARGE',
  ItemTypeTravel = 'ITEM_TYPE_TRAVEL',
  ItemTypeTruck = 'ITEM_TYPE_TRUCK'
}

export type RecordOfWorkLineItemNode = Node & {
  __typename: 'RecordOfWorkLineItemNode';
  description: Maybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal'];
  /** A boolean of whether the line item is flagged as an overtime value. Overtime values for service calls, labour, and travel are more expensive than their non-overtime counterparts. */
  overtime: Scalars['Boolean'];
  /** This is applicable for line items with a type of Part (1). */
  partManufacturer: Maybe<Scalars['String']>;
  /** This is applicable for line items with a type of Part (1). */
  partName: Maybe<Scalars['String']>;
  /** This is applicable for line items with a type of Part (1). */
  partNumber: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  revShare: Scalars['Decimal'];
  taxRates: Array<TaxRateNode>;
  vendorTaxRates: Array<TaxRateNode>;
  /** A boolean of whether the line item is covered by warranty of not. */
  warranty: Scalars['Boolean'];
};

export type RecordOfWorkNode = Node & {
  __typename: 'RecordOfWorkNode';
  createdAt: Scalars['DateTime'];
  /** Denotes whether the associated partner invoice is eligible for fast payments. */
  fastPaymentsEligible: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  invoicingVersion: InvoicingVersion;
  lineItems: Array<RecordOfWorkLineItemNode>;
  /** Notes about the work order and invoice provided by the vendor. This appears on the generated invoice. */
  notes: Scalars['String'];
  /** When a record of work is created by internal ResQ employees, a number of validation rules are performed on save and submission for approval to ensure the integrity of the invoice. If an Customer Experience Manager chooses to override a validation rule, then they are asked to provide a justification and the reasons are stored in this field. A Customer Experience Manager can choose to not provide a reason. */
  overrideNotes: Scalars['String'];
  pdfUrl: Scalars['String'];
  status: RecordOfWorkStatus;
  total: Scalars['Float'];
  /** The time at which the record of work was unapproved internally by the customer experience team. */
  unapprovedAt: Maybe<Scalars['DateTime']>;
  /** Notes about the work order and invoice provided by the vendor that are for internal consumption only. */
  vendorNotes: Scalars['String'];
  /** The date that overrides the vendor invoice payout due date. */
  vendorPayoutOverrideDate: Maybe<Scalars['Date']>;
  /** The reason why the vendor payout date was overridden. */
  vendorPayoutOverrideReason: Scalars['String'];
  /** An identifier for the inbound invoice (i.e. the original invoice sent to ResQ) used by the vendor. */
  vendorReferenceNumber: Maybe<Scalars['String']>;
  /** The ID of the work order that record of work is associated with. */
  workOrder: Maybe<WorkOrderNode>;
};

export type RecordOfWorkNodeConnection = {
  __typename: 'RecordOfWorkNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecordOfWorkNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RecordOfWorkNode` and its cursor. */
export type RecordOfWorkNodeEdge = {
  __typename: 'RecordOfWorkNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<RecordOfWorkNode>;
};

export type RecordOfWorkRevenueShareValuesNode = Node & {
  __typename: 'RecordOfWorkRevenueShareValuesNode';
  /** The ID of the object */
  id: Scalars['ID'];
  labourPercentage: Maybe<Scalars['Decimal']>;
  labourRate: Maybe<Scalars['Decimal']>;
  otherPercentage: Maybe<Scalars['Decimal']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']>;
  partsPercentage: Maybe<Scalars['Decimal']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']>;
  serviceCallRate: Maybe<Scalars['Decimal']>;
  travelPercentage: Maybe<Scalars['Decimal']>;
  travelRate: Maybe<Scalars['Decimal']>;
  truckPercentage: Maybe<Scalars['Decimal']>;
  truckRate: Maybe<Scalars['Decimal']>;
};

export enum RecordOfWorkStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT'
}

export type RecordOfWorkTemplateLineItemNode = Node & {
  __typename: 'RecordOfWorkTemplateLineItemNode';
  description: Maybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  /** The ID of the object */
  id: Scalars['ID'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal'];
  partManufacturer: Maybe<Scalars['String']>;
  partName: Maybe<Scalars['String']>;
  partNumber: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  revShare: Scalars['Decimal'];
  taxRates: Array<TaxRateNode>;
  warranty: Scalars['Boolean'];
};

export type RecordOfWorkTemplateNode = Node & {
  __typename: 'RecordOfWorkTemplateNode';
  /** The ID of the object */
  id: Scalars['ID'];
  lineItems: Array<RecordOfWorkTemplateLineItemNode>;
  notes: Scalars['String'];
  vendorNotes: Scalars['String'];
};

export type RecordPaymentInput = {
  amount: Scalars['Decimal'];
  clientInvoiceIds: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  referenceDate: Scalars['Date'];
  referenceNumber: Scalars['String'];
};

export type RecordPaymentPayload = {
  __typename: 'RecordPaymentPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RecordSuccessfulTroubleshootingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  selectedSteps: Scalars['Int'];
  totalSteps: Scalars['Int'];
};

export type RecordSuccessfulTroubleshootingMutationPayload = {
  __typename: 'RecordSuccessfulTroubleshootingMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RegenerateInvoicesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  recordOfWorkId: Scalars['ID'];
};

/** Regenerates client and vendor invoices of a record of work for invoicing. */
export type RegenerateInvoicesMutationPayload = {
  __typename: 'RegenerateInvoicesMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']>;
  vendorInvoice: Maybe<VendorInvoiceNode>;
};

export type RejectClientWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type RejectClientWorkOrderPayload = {
  __typename: 'RejectClientWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type RejectQuoteSetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  expectedPrice?: InputMaybe<Scalars['Decimal']>;
  quoteSet: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type RejectQuoteSetOptionForSpendInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteSetOptionId: Scalars['ID'];
  reasons: Array<Scalars['String']>;
};

export type RejectQuoteSetOptionForSpendPayload = {
  __typename: 'RejectQuoteSetOptionForSpendPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type RejectQuoteSetPayload = {
  __typename: 'RejectQuoteSetPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

/** An enumeration. */
export enum RelationshipSource {
  Inherited = 'INHERITED',
  Marketplace = 'MARKETPLACE'
}

export type RemovePaymentMethodMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentMethodId: Scalars['ID'];
};

export type RemovePaymentMethodMutationPayload = {
  __typename: 'RemovePaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RemoveQuoteArguments = {
  id: Scalars['ID'];
};

export type RemoveQuoteMutation = {
  __typename: 'RemoveQuoteMutation';
  ok: Scalars['Boolean'];
};

export type RemoveQuoteSetOptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteSetOptionId: Scalars['ID'];
  removeReason: Scalars['String'];
};

export type RemoveQuoteSetOptionPayload = {
  __typename: 'RemoveQuoteSetOptionPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type RemoveUpcomingAllocationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  workOrder: Scalars['ID'];
};

export type RemoveUpcomingAllocationMutationPayload = {
  __typename: 'RemoveUpcomingAllocationMutationPayload';
  allocation: Maybe<AllocationNode>;
  clientMutationId: Maybe<Scalars['String']>;
};

export type RemoveUserFromClientOrganizationMutation = {
  __typename: 'RemoveUserFromClientOrganizationMutation';
  ok: Scalars['Boolean'];
};

export type RemoveUsersFromRoleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  roleId: Scalars['ID'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RemoveUsersFromRoleMutationPayload = {
  __typename: 'RemoveUsersFromRoleMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RemoveVendorMemberArguments = {
  memberId: Scalars['ID'];
};

export type RemoveVendorMemberMutation = {
  __typename: 'RemoveVendorMemberMutation';
  ok: Scalars['Boolean'];
};

export type RemoveVendorPayoutInfoMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type RemoveVendorPayoutInfoMutationPayload = {
  __typename: 'RemoveVendorPayoutInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum ReportDay {
  Daily = 'DAILY',
  FirstCalendarDay = 'FIRST_CALENDAR_DAY',
  FirstDayOfMonth = 'FIRST_DAY_OF_MONTH',
  Friday = 'FRIDAY',
  LastCalendarDay = 'LAST_CALENDAR_DAY',
  LastDayOfMonth = 'LAST_DAY_OF_MONTH',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** An enumeration. */
export enum ReportFilterDatatype {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING'
}

export type ReportFilterNode = Node & {
  __typename: 'ReportFilterNode';
  datatype: ReportFilterDatatype;
  /** The field being filtered. */
  field: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  operator: ReportFilterOperator;
  template: ReportTemplateNode;
  /** The value to compare against. */
  value: Maybe<Scalars['String']>;
};

export type ReportFilterNodeConnection = {
  __typename: 'ReportFilterNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportFilterNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ReportFilterNode` and its cursor. */
export type ReportFilterNodeEdge = {
  __typename: 'ReportFilterNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ReportFilterNode>;
};

/** An enumeration. */
export enum ReportFilterOperator {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Empty = 'EMPTY',
  Equals = 'EQUALS',
  Greater = 'GREATER',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  Less = 'LESS',
  LessOrEqual = 'LESS_OR_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEmpty = 'NOT_EMPTY',
  NotEquals = 'NOT_EQUALS',
  PreviousMonths = 'PREVIOUS_MONTHS'
}

/** An enumeration. */
export enum ReportFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ReportInstanceNode = Node & {
  __typename: 'ReportInstanceNode';
  createdAt: Scalars['DateTime'];
  csvUrl: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** A list of emails that this report was delivered to when generated. */
  recipients: Array<Scalars['String']>;
  template: ReportTemplateNode;
};

export type ReportInstanceNodeConnection = {
  __typename: 'ReportInstanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportInstanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ReportInstanceNode` and its cursor. */
export type ReportInstanceNodeEdge = {
  __typename: 'ReportInstanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ReportInstanceNode>;
};

export type ReportPreviewNode = {
  __typename: 'ReportPreviewNode';
  count: Maybe<Scalars['Int']>;
  data: Maybe<Scalars['JSONString']>;
};

export type ReportTemplateNode = Node & {
  __typename: 'ReportTemplateNode';
  /** The datetime of when this report was archived, which means it will no longer be generated and delivered. A null value means it is not archived. */
  archivedAt: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  day: ReportDay;
  description: Maybe<Scalars['String']>;
  /** The datetime of when this report was last edited by a person (ie ignoring next_report_on being updated). */
  editedAt: Scalars['DateTime'];
  /** The list and order of fields contained in the report. */
  fields: Array<Scalars['String']>;
  filters: Array<ReportFilterNode>;
  frequency: Maybe<ReportFrequency>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** How many cadences apart is the report generated. */
  interval: Scalars['Int'];
  /** The datetime when the report should next go out. */
  nextReportOn: Maybe<Scalars['Date']>;
  /** The field to order the data by, prefixed with - for descending order. */
  orderBy: Scalars['String'];
  /** A list of emails the report will be delivered to when generated. */
  recipients: Array<Scalars['String']>;
  reportType: ReportType;
  /** A short title to describe the report. */
  title: Scalars['String'];
};

export type ReportTemplateNodeConnection = {
  __typename: 'ReportTemplateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ReportTemplateNode` and its cursor. */
export type ReportTemplateNodeEdge = {
  __typename: 'ReportTemplateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ReportTemplateNode>;
};

/** An enumeration. */
export enum ReportType {
  Invoices = 'INVOICES',
  Quotes = 'QUOTES',
  WorkOrders = 'WORK_ORDERS'
}

export type RequestAutopayChangesMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  requestAutopay: Scalars['Boolean'];
};

export type RequestAutopayChangesMutationPayload = {
  __typename: 'RequestAutopayChangesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RequestDispatchChangesMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  requestDetails: Scalars['String'];
};

export type RequestDispatchChangesMutationPayload = {
  __typename: 'RequestDispatchChangesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RequestMaintenancePlanMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  approvedById?: InputMaybe<Scalars['ID']>;
  attachmentFileType?: InputMaybe<Scalars['String']>;
  attachmentLabel?: InputMaybe<Scalars['String']>;
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactName: Scalars['String'];
  email: Scalars['String'];
  fileUri?: InputMaybe<Scalars['String']>;
  maintenancePlanTypeId: Scalars['ID'];
};

export type RequestMaintenancePlanMutationPayload = {
  __typename: 'RequestMaintenancePlanMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RequestMaintenancePlanQuoteMutation = {
  __typename: 'RequestMaintenancePlanQuoteMutation';
  ok: Scalars['Boolean'];
};

export type RequestNewCapexProjectMutationInput = {
  approvedById?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  email: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type RequestNewCapexProjectMutationPayload = {
  __typename: 'RequestNewCapexProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RequestPlannedMaintenanceQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};

export type RequestPlannedMaintenanceQuoteMutationPayload = {
  __typename: 'RequestPlannedMaintenanceQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RequestServiceGuaranteeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendor: Scalars['ID'];
};

export type RequestServiceGuaranteePayload = {
  __typename: 'RequestServiceGuaranteePayload';
  clientMutationId: Maybe<Scalars['String']>;
  matchingProfile: VendorMatchingProfileNode;
};

export type RescheduleAppointmentInput = {
  appointmentId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  otherReschedulingReason?: InputMaybe<Scalars['String']>;
  reschedulingReason?: InputMaybe<AppointmentReschedulingReason>;
  startsAt: Scalars['DateTime'];
  technicianId?: InputMaybe<Scalars['ID']>;
};

export type RescheduleAppointmentPayload = {
  __typename: 'RescheduleAppointmentPayload';
  appointment: AppointmentNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type RescheduleInternalAppointmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  internalRequestId: Scalars['ID'];
};

export type RescheduleInternalAppointmentPayload = {
  __typename: 'RescheduleInternalAppointmentPayload';
  appointment: InternalAppointmentNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type ResendClientVendorRelationshipInviteInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['ID'];
  inviterName?: InputMaybe<Scalars['String']>;
  inviterNote?: InputMaybe<Scalars['String']>;
  subscribeToInvite?: InputMaybe<Scalars['Boolean']>;
};

export type ResendClientVendorRelationshipInvitePayload = {
  __typename: 'ResendClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']>;
  invite: InviteNode;
};

export type ResetQuoteSetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteSetId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};

export type ResetQuoteSetPayload = {
  __typename: 'ResetQuoteSetPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type ResolveFacilityExpansionMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  expansionRequestType: ExpansionRequestType;
};

export type ResolveFacilityExpansionMutationPayload = {
  __typename: 'ResolveFacilityExpansionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ResolveFlaggedInvoiceInput = {
  action: RuleResolutionAction;
  clientMutationId?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  ruleViolationsId: Scalars['ID'];
};

export type ResolveFlaggedInvoicePayload = {
  __typename: 'ResolveFlaggedInvoicePayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ResolveIncidentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  equipmentIds: Array<Scalars['ID']>;
  incidentIds: Array<Scalars['String']>;
};

export type ResolveIncidentsPayload = {
  __typename: 'ResolveIncidentsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ResolveWorkOrderDisputeArguments = {
  comment: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type ResolveWorkOrderDisputeMutation = {
  __typename: 'ResolveWorkOrderDisputeMutation';
  ok: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export type ResolveWorkOrderEscalationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  escalationId: Scalars['ID'];
  resolutionComment?: InputMaybe<Scalars['String']>;
};

export type ResolveWorkOrderEscalationPayload = {
  __typename: 'ResolveWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type ResqActiveHoursStatus = {
  __typename: 'ResqActiveHoursStatus';
  isActiveHours: Scalars['Boolean'];
};

export type ResqReviewActivity = Activity & Node & {
  __typename: 'ResqReviewActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  reviewType: ResqReviewActivityReviewType;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ResqReviewActivityReviewType {
  FindingQuote = 'FINDING_QUOTE',
  FindingVendor = 'FINDING_VENDOR',
  Unknown = 'UNKNOWN'
}

export type RevShareInputLineItemType = {
  description?: InputMaybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  itemType: RecordOfWorkLineItemEnum;
  order: Scalars['Int'];
  overtime?: InputMaybe<Scalars['Boolean']>;
  partManufacturer?: InputMaybe<Scalars['String']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal'];
  rate: Scalars['Decimal'];
  revShare: Scalars['Decimal'];
  taxRateIds: Array<Scalars['ID']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']>>;
  warranty: Scalars['Boolean'];
};

export type RevenueShareOverrideNode = Node & {
  __typename: 'RevenueShareOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID'];
  labourPercentage: Maybe<Scalars['Decimal']>;
  otherPercentage: Maybe<Scalars['Decimal']>;
  partsPercentage: Maybe<Scalars['Decimal']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelPercentage: Maybe<Scalars['Decimal']>;
  truckPercentage: Maybe<Scalars['Decimal']>;
  vendor: VendorOrganizationNode;
};

export type RevenueShareOverrideNodeConnection = {
  __typename: 'RevenueShareOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RevenueShareOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `RevenueShareOverrideNode` and its cursor. */
export type RevenueShareOverrideNodeEdge = {
  __typename: 'RevenueShareOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<RevenueShareOverrideNode>;
};

export type RevenueShareOverridePercentageInput = {
  labourPercentage?: InputMaybe<Scalars['Decimal']>;
  otherPercentage?: InputMaybe<Scalars['Decimal']>;
  partsPercentage?: InputMaybe<Scalars['Decimal']>;
  serviceCallPercentage?: InputMaybe<Scalars['Decimal']>;
  travelPercentage?: InputMaybe<Scalars['Decimal']>;
  truckPercentage?: InputMaybe<Scalars['Decimal']>;
};

export type RevenueSharePercentageInput = {
  labourPercentage: Scalars['Decimal'];
  otherPercentage: Scalars['Decimal'];
  partsPercentage: Scalars['Decimal'];
  serviceCallPercentage: Scalars['Decimal'];
  travelPercentage: Scalars['Decimal'];
  truckPercentage: Scalars['Decimal'];
};

export type ReverseClientInvoicePaymentMutationInput = {
  clientInvoiceId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type ReverseClientInvoicePaymentMutationPayload = {
  __typename: 'ReverseClientInvoicePaymentMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type ReviewMetrics = {
  __typename: 'ReviewMetrics';
  negativeReviewCount: Scalars['Int'];
  positiveReviewCount: Scalars['Int'];
  topNegativeFeedback: Array<TopReviewFeedback>;
  topPositiveFeedback: Array<TopReviewFeedback>;
};

export type ReviewRequestNode = Node & {
  __typename: 'ReviewRequestNode';
  /** The ID of the object */
  id: Scalars['ID'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type ReviewRequestNodeConnection = {
  __typename: 'ReviewRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `ReviewRequestNode` and its cursor. */
export type ReviewRequestNodeEdge = {
  __typename: 'ReviewRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ReviewRequestNode>;
};

/** An enumeration. */
export enum ReviewRequestStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type ReviewSummary = {
  __typename: 'ReviewSummary';
  badReviewCount: Scalars['Int'];
  badReviewTags: Array<Scalars['String']>;
  goodReviewCount: Scalars['Int'];
  goodReviewTags: Array<Scalars['String']>;
};

export type RevokeClientVendorRelationshipInviteInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['ID'];
};

export type RevokeClientVendorRelationshipInvitePayload = {
  __typename: 'RevokeClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type RoleNode = Node & {
  __typename: 'RoleNode';
  /** @deprecated Moving forward, name should be suitable for display directly. */
  displayName: Scalars['String'];
  editable: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  memberships: Array<ClientOrganizationMemberNode>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  userCount: Scalars['Int'];
};

export type RoleNodeConnection = {
  __typename: 'RoleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RoleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `RoleNode` and its cursor. */
export type RoleNodeEdge = {
  __typename: 'RoleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<RoleNode>;
};

/** An enumeration. */
export enum RuleBroken {
  OverQuotedAmount = 'OVER_QUOTED_AMOUNT',
  OverSpendApproval = 'OVER_SPEND_APPROVAL',
  PriceTooHigh = 'PRICE_TOO_HIGH',
  TooManyHours = 'TOO_MANY_HOURS'
}

/** An enumeration. */
export enum RuleResolutionAction {
  ConfirmInvoice = 'CONFIRM_INVOICE',
  CreateNewInvoice = 'CREATE_NEW_INVOICE',
  SentNote = 'SENT_NOTE',
  UploadNewInvoice = 'UPLOAD_NEW_INVOICE'
}

export type RuleViolationsFeedbackNode = Node & {
  __typename: 'RuleViolationsFeedbackNode';
  comment: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isPositive: Scalars['Boolean'];
  ruleViolations: RuleViolationsNode;
};

export type RuleViolationsNode = Node & {
  __typename: 'RuleViolationsNode';
  expiredAt: Maybe<Scalars['DateTime']>;
  feedback: Maybe<RuleViolationsFeedbackNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  reason: Maybe<Scalars['String']>;
  violations: Array<RuleBroken>;
};

export type RuleViolationsNodeConnection = {
  __typename: 'RuleViolationsNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RuleViolationsNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RuleViolationsNode` and its cursor. */
export type RuleViolationsNodeEdge = {
  __typename: 'RuleViolationsNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<RuleViolationsNode>;
};

export type SalesforceClientAccount = {
  __typename: 'SalesforceClientAccount';
  city: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type SalesforceClientAccountResult = {
  __typename: 'SalesforceClientAccountResult';
  client: Maybe<ClientOrganizationNode>;
  salesforceClientAccount: Maybe<SalesforceClientAccount>;
};

export type SalesforceClientExpansionPossibilities = {
  __typename: 'SalesforceClientExpansionPossibilities';
  numberOfFacilities: Scalars['Int'];
};

export type SalesforceVendorAccount = {
  __typename: 'SalesforceVendorAccount';
  city: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  openToMarketplace: Scalars['Boolean'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type SalesforceVendorAccountResult = {
  __typename: 'SalesforceVendorAccountResult';
  salesforceVendorAccount: Maybe<SalesforceVendorAccount>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type SatisfactionRate = {
  __typename: 'SatisfactionRate';
  negativeCount: Scalars['Int'];
  positiveCount: Scalars['Int'];
};

export type SaveRecordOfWorkArguments = {
  lineItems: Array<LineItemInput>;
  notes: Scalars['String'];
  overrideNotes: Scalars['String'];
  recordOfWorkId?: InputMaybe<Scalars['ID']>;
  vendorNotes: Scalars['String'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

/** Creates or updates a record of work by work order. */
export type SaveRecordOfWorkMutation = {
  __typename: 'SaveRecordOfWorkMutation';
  created: Maybe<Scalars['Boolean']>;
  recordOfWork: RecordOfWorkNode;
};

export type ScheduleInternalAppointmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  internalRequestId: Scalars['ID'];
};

export type ScheduleInternalAppointmentPayload = {
  __typename: 'ScheduleInternalAppointmentPayload';
  appointment: InternalAppointmentNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type SchedulingActivity = Activity & Node & {
  __typename: 'SchedulingActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  request: SchedulingRequest;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type SchedulingRequest = Node & {
  __typename: 'SchedulingRequest';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this request was cancelled. Operations that can cancel a scheduling request: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The time at which this request was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  permissions: SchedulingRequestPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type SchedulingRequestConnection = {
  __typename: 'SchedulingRequestConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SchedulingRequestEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SchedulingRequest` and its cursor. */
export type SchedulingRequestEdge = {
  __typename: 'SchedulingRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SchedulingRequest>;
};

export type SchedulingRequestPermissions = {
  __typename: 'SchedulingRequestPermissions';
  fulfill: Scalars['Boolean'];
};

export type SchedulingViolation = {
  __typename: 'SchedulingViolation';
  description: Scalars['String'];
  type: SchedulingViolationType;
};

/** An enumeration. */
export enum SchedulingViolationType {
  MaintenancePlanScheduling = 'MAINTENANCE_PLAN_SCHEDULING',
  OnDemandScheduling = 'ON_DEMAND_SCHEDULING',
  Overtime = 'OVERTIME'
}

/** An enumeration. */
export enum ScoreMetric {
  ActionRate = 'ACTION_RATE',
  DisputeRate = 'DISPUTE_RATE',
  FirstTimeFixRate = 'FIRST_TIME_FIX_RATE',
  PlatformUsage = 'PLATFORM_USAGE',
  SatisfactionRate = 'SATISFACTION_RATE',
  TimeToInvoice = 'TIME_TO_INVOICE',
  TimeToOnsite = 'TIME_TO_ONSITE',
  TimeToQuote = 'TIME_TO_QUOTE'
}

/** An enumeration. */
export enum ScorePillar {
  Process = 'PROCESS',
  Quality = 'QUALITY',
  Speed = 'SPEED'
}

export type SearchResult = ClientOrganizationNode | FacilityNode | UserNode | VendorOrganizationNode | WorkOrderNode;

export type SelectQuoteSetOptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  quoteSetOptionId: Scalars['ID'];
};

export type SelectQuoteSetOptionPayload = {
  __typename: 'SelectQuoteSetOptionPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type SendInviteSmsMutation = {
  __typename: 'SendInviteSMSMutation';
  ok: Scalars['Boolean'];
};

export type SendReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportTemplateId: Scalars['ID'];
};

export type SendReportPayload = {
  __typename: 'SendReportPayload';
  clientMutationId: Maybe<Scalars['String']>;
  reportTemplate: ReportTemplateNode;
};

export type SendWelcomeEmailMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type SendWelcomeEmailMutationPayload = {
  __typename: 'SendWelcomeEmailMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum Sensitivity {
  PriceSensitive = 'PRICE_SENSITIVE',
  QualitySensitive = 'QUALITY_SENSITIVE'
}

/** An enumeration. */
export enum ServiceCategory {
  AirCompressors = 'AIR_COMPRESSORS',
  Asbestos = 'ASBESTOS',
  Audits = 'AUDITS',
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  Backflow = 'BACKFLOW',
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  Chowbotics = 'CHOWBOTICS',
  Cleaning = 'CLEANING',
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  DriveThuItems = 'DRIVE_THU_ITEMS',
  Electrical = 'ELECTRICAL',
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  EmergencyLights = 'EMERGENCY_LIGHTS',
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  FireAlarms = 'FIRE_ALARMS',
  FireSuppression = 'FIRE_SUPPRESSION',
  Fixtures = 'FIXTURES',
  Flooring = 'FLOORING',
  FoodEquipment = 'FOOD_EQUIPMENT',
  FuelOil = 'FUEL_OIL',
  Furniture = 'FURNITURE',
  GasBoilers = 'GAS_BOILERS',
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  Generators = 'GENERATORS',
  GreaseTrap = 'GREASE_TRAP',
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  Hoods = 'HOODS',
  HotWaterTank = 'HOT_WATER_TANK',
  IceMachine = 'ICE_MACHINE',
  Landscaping = 'LANDSCAPING',
  LocksDoors = 'LOCKS_DOORS',
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  MenuScreens = 'MENU_SCREENS',
  MessengerServices = 'MESSENGER_SERVICES',
  Miscellaneous = 'MISCELLANEOUS',
  MovingServices = 'MOVING_SERVICES',
  PackScreens = 'PACK_SCREENS',
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  Pavement = 'PAVEMENT',
  PestControl = 'PEST_CONTROL',
  Plumbing = 'PLUMBING',
  Refrigeration = 'REFRIGERATION',
  Roofing = 'ROOFING',
  Security = 'SECURITY',
  Shredding = 'SHREDDING',
  Signage = 'SIGNAGE',
  SnowRemoval = 'SNOW_REMOVAL',
  Technology = 'TECHNOLOGY',
  TempServices = 'TEMP_SERVICES',
  Tiling = 'TILING',
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  Upholstery = 'UPHOLSTERY',
  VendingMachines = 'VENDING_MACHINES',
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  WasteRemoval = 'WASTE_REMOVAL',
  WaterFiltration = 'WATER_FILTRATION',
  Welding = 'WELDING',
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  WindowsGlass = 'WINDOWS_GLASS'
}

export type ServiceCategoryCount = {
  __typename: 'ServiceCategoryCount';
  count: Scalars['Int'];
  serviceCategory: ServiceCategory;
};

export type ServiceCategoryNode = {
  __typename: 'ServiceCategoryNode';
  isNew: Scalars['Boolean'];
  key: ServiceCategory;
};

export enum ServiceGuaranteeStatus {
  Eligible = 'ELIGIBLE',
  Guaranteed = 'GUARANTEED',
  NotEligible = 'NOT_ELIGIBLE'
}

/** An enumeration. */
export enum ServiceType {
  PreventiveMaintenance = 'PREVENTIVE_MAINTENANCE',
  Repair = 'REPAIR'
}

export type SetEstimatedTimeOfArrivalSourcingPartsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  partsEstimatedDateEnd: Scalars['Date'];
  partsEstimatedDateStart: Scalars['Date'];
  sourcingPartsHoldId: Scalars['ID'];
};

export type SetEstimatedTimeOfArrivalSourcingPartsMutationPayload = {
  __typename: 'SetEstimatedTimeOfArrivalSourcingPartsMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  sourcingPartsHold: SourcingPartsHold;
};

export type SetNotificationPreferenceInput = {
  channel: NotificationChannel;
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  notificationType: NotificationType;
  userId: Scalars['ID'];
};

export type SetNotificationPreferencePayload = {
  __typename: 'SetNotificationPreferencePayload';
  clientMutationId: Maybe<Scalars['String']>;
  notificationPreference: NotificationPreferenceNode;
};

export type SetSubscriptionAddonsInput = {
  addons: Array<SubscriptionAddon>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  commit?: InputMaybe<Scalars['Boolean']>;
  dataHashKey: Scalars['String'];
  facilityId: Scalars['ID'];
  prorate?: InputMaybe<Scalars['Boolean']>;
};

export type SetSubscriptionAddonsPayload = {
  __typename: 'SetSubscriptionAddonsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  dataHashKey: Scalars['String'];
  newAddons: Array<SubscriptionAddonNode>;
  oldAddons: Array<SubscriptionAddonNode>;
};

export type SetUserNoficationPreferenceMutationInput = {
  channel: NotificationChannel;
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  notificationName: Scalars['String'];
};

export type SetUserNoficationPreferenceMutationPayload = {
  __typename: 'SetUserNoficationPreferenceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  userNotificationPreference: UserNotificationPreferenceNode;
};

export type SetVendorAgreementPlansMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  overrideCurrentPlanIds?: InputMaybe<Array<Scalars['ID']>>;
  selectedPlanIds: Array<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type SetVendorAgreementPlansMutationPayload = {
  __typename: 'SetVendorAgreementPlansMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorAgreement: VendorAgreementNode;
};

export type SetupPreAuthorizedDebitMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  creditCardSetup?: InputMaybe<Scalars['Boolean']>;
};

export type SetupPreAuthorizedDebitMutationPayload = {
  __typename: 'SetupPreAuthorizedDebitMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  clientSecret: Scalars['String'];
};

export type SiteVisitActivity = Activity & Node & {
  __typename: 'SiteVisitActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  outcome: Maybe<SiteVisitActivityOutcome>;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  visit: VisitNode;
  workOrder: WorkOrderNode;
};

export enum SiteVisitActivityOutcome {
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type SkillNode = Node & {
  __typename: 'SkillNode';
  description: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type SkillNodeConnection = {
  __typename: 'SkillNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SkillNode` and its cursor. */
export type SkillNodeEdge = {
  __typename: 'SkillNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SkillNode>;
};

export type SkipWorkOrderReviewMutation = {
  __typename: 'SkipWorkOrderReviewMutation';
  workOrder: WorkOrderNode;
};

export type SnoozeIncidentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  durationInMinutes: Scalars['Int'];
  equipmentIds: Array<Scalars['ID']>;
  incidentIds: Array<Scalars['String']>;
};

export type SnoozeIncidentsPayload = {
  __typename: 'SnoozeIncidentsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SnoozeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  visibleAt: Scalars['DateTime'];
};

export type SnoozeMutationPayload = {
  __typename: 'SnoozeMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SnoozeReviewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SnoozeReviewsPayload = {
  __typename: 'SnoozeReviewsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Maybe<Scalars['Boolean']>;
};

export enum SourceUserType {
  Client = 'CLIENT',
  Coordinator = 'COORDINATOR',
  Unknown = 'UNKNOWN',
  Vendor = 'VENDOR'
}

export type SourcingPartsActivity = Activity & Node & {
  __typename: 'SourcingPartsActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime'];
  endedAt: Maybe<Scalars['DateTime']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  sourcingPartsHold: SourcingPartsHold;
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type SourcingPartsHold = Node & {
  __typename: 'SourcingPartsHold';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this hold was cancelled. Operations that can cancel a hold: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The time at which this hold was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  partsEstimatedDateEnd: Maybe<Scalars['Date']>;
  partsEstimatedDateSetBy: Maybe<UserNode>;
  partsEstimatedDateStart: Maybe<Scalars['Date']>;
  permissions: SourcingPartsHoldPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type SourcingPartsHoldConnection = {
  __typename: 'SourcingPartsHoldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SourcingPartsHoldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SourcingPartsHold` and its cursor. */
export type SourcingPartsHoldEdge = {
  __typename: 'SourcingPartsHoldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SourcingPartsHold>;
};

export type SourcingPartsHoldPermissions = {
  __typename: 'SourcingPartsHoldPermissions';
  fulfill: Scalars['Boolean'];
};

export type SpellCheckedAddressComponent = {
  __typename: 'SpellCheckedAddressComponent';
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type SpendApprovalNode = Node & {
  __typename: 'SpendApprovalNode';
  approvalRequiredOvertimeThreshold: Maybe<Scalars['Int']>;
  approvalRequiredThreshold: Maybe<Scalars['Int']>;
  approvedAmount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  nteRaiseRequestApprovedBy: Maybe<UserNode>;
  nteRaiseRequestedApprovalThreshold: Maybe<Scalars['Int']>;
  overtimeApprovedBy: Maybe<UserNode>;
  permissions: SpendApprovalPermissions;
  quoteBypassApprovedBy: Maybe<UserNode>;
  quotePrice: Maybe<Scalars['Int']>;
  workOrderId: Scalars['ID'];
};

export type SpendApprovalNodeConnection = {
  __typename: 'SpendApprovalNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpendApprovalNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpendApprovalNode` and its cursor. */
export type SpendApprovalNodeEdge = {
  __typename: 'SpendApprovalNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SpendApprovalNode>;
};

export type SpendApprovalPermissions = {
  __typename: 'SpendApprovalPermissions';
  /** Permissions to raise the approved spend */
  raiseApprovedSpend: Scalars['Boolean'];
};

export type SpendApprovalPreferenceNode = Node & {
  __typename: 'SpendApprovalPreferenceNode';
  approvalRequiredOvertimeThreshold: Scalars['Int'];
  approvalRequiredThreshold: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type SpendApprovalPreferenceNodeConnection = {
  __typename: 'SpendApprovalPreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpendApprovalPreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpendApprovalPreferenceNode` and its cursor. */
export type SpendApprovalPreferenceNodeEdge = {
  __typename: 'SpendApprovalPreferenceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SpendApprovalPreferenceNode>;
};

export type SpendByPeriod = {
  __typename: 'SpendByPeriod';
  period: MetricsPeriod;
  spendAmount: Scalars['Decimal'];
};

export type SpendByServiceCategory = {
  __typename: 'SpendByServiceCategory';
  serviceCategory: ServiceCategory;
  spendAmount: Scalars['Decimal'];
};

export type SpendItemAllocationNode = Node & {
  __typename: 'SpendItemAllocationNode';
  allocatedAmount: Scalars['Decimal'];
  attachment: Maybe<AttachmentNode>;
  description: Scalars['String'];
  expenseDate: Scalars['Date'];
  expenseType: ExpenseType;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type StartAppointmentActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  force?: InputMaybe<Scalars['Boolean']>;
  notifyVendor: Scalars['Boolean'];
  startsAt: Scalars['DateTime'];
  technician?: InputMaybe<Scalars['ID']>;
  vendor?: InputMaybe<Scalars['ID']>;
  workOrder: Scalars['ID'];
};

export type StartAppointmentActivityPayload = {
  __typename: 'StartAppointmentActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartChooseVendorActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  previousActivity: Scalars['ID'];
  workOrder: Scalars['ID'];
};

export type StartChooseVendorActivityPayload = {
  __typename: 'StartChooseVendorActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartDispatchActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  previousActivity?: InputMaybe<Scalars['ID']>;
  vendor?: InputMaybe<Scalars['ID']>;
  vendors?: InputMaybe<Array<Scalars['ID']>>;
  workOrder: Scalars['ID'];
};

export type StartDispatchActivityPayload = {
  __typename: 'StartDispatchActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartFindingQuoteActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  workOrder: Scalars['ID'];
};

export type StartFindingQuoteActivityPayload = {
  __typename: 'StartFindingQuoteActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteSet: QuoteSetNode;
};

export type StartOnHoldActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  notes: Scalars['String'];
  workOrder: Scalars['ID'];
};

export type StartOnHoldActivityPayload = {
  __typename: 'StartOnHoldActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartOrganizationSubscriptionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  subscriptionStartDate?: InputMaybe<Scalars['Date']>;
  subscriptions: Array<SubscriptionInput>;
};

export type StartOrganizationSubscriptionMutationPayload = {
  __typename: 'StartOrganizationSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartResqReviewActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  reviewType: ResqReviewActivityReviewType;
  workOrder: Scalars['ID'];
};

export type StartResqReviewActivityPayload = {
  __typename: 'StartResqReviewActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartSchedulingActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  workOrder: Scalars['ID'];
};

export type StartSchedulingActivityPayload = {
  __typename: 'StartSchedulingActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartSchedulingCalldownInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userToCallId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
  workOrderId: Scalars['ID'];
};

export type StartSchedulingCalldownPayload = {
  __typename: 'StartSchedulingCalldownPayload';
  clientMutationId: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type StartSiteVisitActivityInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityManagerName: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
  images: Array<Image>;
  visitedBy?: InputMaybe<Scalars['ID']>;
  workOrder: Scalars['ID'];
};

export type StartSiteVisitActivityPayload = {
  __typename: 'StartSiteVisitActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  visit: VisitNode;
};

export type StartSourcingPartsActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  sourcingPartsHoldEtaEnd?: InputMaybe<Scalars['Date']>;
  sourcingPartsHoldEtaStart?: InputMaybe<Scalars['Date']>;
  workOrder: Scalars['ID'];
};

export type StartSourcingPartsActivityPayload = {
  __typename: 'StartSourcingPartsActivityPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type StartSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  commit?: InputMaybe<Scalars['Boolean']>;
  dataHashKey: Scalars['String'];
  effectiveStartDate: Scalars['Date'];
  facilityId: Scalars['ID'];
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  prorate?: InputMaybe<Scalars['Boolean']>;
  unitAmount: Scalars['Decimal'];
};

export type StartSubscriptionPayload = {
  __typename: 'StartSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']>;
  dataHashKey: Scalars['String'];
  newSubscription: SubscriptionNode;
  oldSubscription: SubscriptionNode;
};

export type StartVisitMutationInput = {
  appointmentId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityManagerName: Scalars['String'];
  images: Array<Image>;
};

export type StartVisitMutationPayload = {
  __typename: 'StartVisitMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  visit: VisitNode;
};

/** An enumeration. */
export enum StripeAccount {
  Ca = 'CA',
  Uk = 'UK',
  Us = 'US'
}

export type StripeCustomerNode = Node & {
  __typename: 'StripeCustomerNode';
  account: StripeAccount;
  /** The ID of the object */
  id: Scalars['ID'];
};

export type StripeCustomerNodeConnection = {
  __typename: 'StripeCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StripeCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `StripeCustomerNode` and its cursor. */
export type StripeCustomerNodeEdge = {
  __typename: 'StripeCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<StripeCustomerNode>;
};

export type SubmitOffResqVendorInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  invoiceFile: Scalars['String'];
  offResqCustomerId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type SubmitOffResqVendorInvoiceMutationPayload = {
  __typename: 'SubmitOffResqVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SubmitQuoteFeedbackArguments = {
  comment: Scalars['String'];
  feedbackType: QuoteFeedbackType;
  quoteId: Scalars['ID'];
};

export type SubmitQuoteFeedbackMutation = {
  __typename: 'SubmitQuoteFeedbackMutation';
  ok: Scalars['Boolean'];
  quote: QuoteNode;
};

export type SubmitRecordOfWorkInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  recordOfWorkId: Scalars['ID'];
};

export type SubmitRecordOfWorkPayload = {
  __typename: 'SubmitRecordOfWorkPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SubmitVendorInvoiceMutation = {
  __typename: 'SubmitVendorInvoiceMutation';
  workOrder: WorkOrderNode;
};

export type SubmitVendorInvoiceMutationArguments = {
  dispute: Scalars['Boolean'];
  vendorNotes: Scalars['String'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']>;
  vendorReferenceNumber: Scalars['String'];
  workOrderId: Scalars['ID'];
};

export type SubmitWorkOrderForApproval = {
  __typename: 'SubmitWorkOrderForApproval';
  ok: Scalars['Boolean'];
};

export type SubmitWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  cyovData?: InputMaybe<CyovDataInput>;
  internalAppointmentDate?: InputMaybe<Scalars['Date']>;
  taskListAttachedFiles?: InputMaybe<Array<AttachmentInput>>;
  taskListAttachedUrls?: InputMaybe<Array<AttachedUrlInput>>;
  taskListItems?: InputMaybe<Array<Scalars['String']>>;
  teamMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  workOrderId: Scalars['ID'];
};

export type SubmitWorkOrderPayload = {
  __typename: 'SubmitWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type SubmitWorkOrderToMarketplaceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityAccessInstruction?: InputMaybe<Scalars['String']>;
  overtimeApproved: Scalars['Boolean'];
  pointOfContact?: InputMaybe<WorkOrderPointOfContactInput>;
  selectedVendorId?: InputMaybe<Scalars['ID']>;
  selectedVendors?: InputMaybe<Array<Scalars['ID']>>;
  wasDuplicateWoModalShown?: InputMaybe<Scalars['Boolean']>;
  workOrderId: Scalars['ID'];
};

export type SubmitWorkOrderToMarketplacePayload = {
  __typename: 'SubmitWorkOrderToMarketplacePayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type SubscriptionAddon = {
  description: Scalars['String'];
  effectiveEndDate?: InputMaybe<Scalars['Date']>;
  effectiveStartDate: Scalars['Date'];
  endDate?: InputMaybe<Scalars['Date']>;
  percentage?: InputMaybe<Scalars['Decimal']>;
  startDate: Scalars['Date'];
  unitAmount?: InputMaybe<Scalars['Decimal']>;
};

export type SubscriptionAddonNode = Node & {
  __typename: 'SubscriptionAddonNode';
  description: Scalars['String'];
  effectiveEndDate: Maybe<Scalars['Date']>;
  effectiveStartDate: Scalars['Date'];
  endDate: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  percentage: Maybe<Scalars['Decimal']>;
  startDate: Scalars['Date'];
  subscription: SubscriptionNode;
  unitAmount: Scalars['Decimal'];
};

export type SubscriptionInput = {
  businessUnitId?: InputMaybe<Scalars['ID']>;
  facilities: Array<FacilitySubscriptionInput>;
  memberUserIds: Array<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  taggingFee?: InputMaybe<Scalars['Decimal']>;
  unitPrice: Scalars['Decimal'];
};

export type SubscriptionNode = Node & {
  __typename: 'SubscriptionNode';
  addons: Array<SubscriptionAddonNode>;
  billingFrequency: Maybe<BillingFrequency>;
  dataHashKey: Scalars['String'];
  effectiveStartDate: Maybe<Scalars['Date']>;
  facility: FacilityNode;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The last time we billed the customer. The existence of this field means the customer has paid for the time between the last_billing_date to (next_billing_date - 1 day) */
  lastBillingDate: Maybe<Scalars['Date']>;
  /** The next time we expect to bill the customer */
  nextBillingDate: Maybe<Scalars['Date']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  startedOn: Maybe<Scalars['Date']>;
  state: SubscriptionState;
  unitAmount: Maybe<Scalars['Decimal']>;
  updateOperation: SubscriptionOperation;
  updatedBy: UserNode;
};

export type SubscriptionNodeConnection = {
  __typename: 'SubscriptionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubscriptionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `SubscriptionNode` and its cursor. */
export type SubscriptionNodeEdge = {
  __typename: 'SubscriptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<SubscriptionNode>;
};

/** An enumeration. */
export enum SubscriptionOperation {
  Bill = 'BILL',
  Cancel = 'CANCEL',
  Creation = 'CREATION',
  GenerateProratedInvoice = 'GENERATE_PRORATED_INVOICE',
  Migration = 'MIGRATION',
  Pause = 'PAUSE',
  Start = 'START',
  Update = 'UPDATE',
  UpdateAddons = 'UPDATE_ADDONS'
}

/** An enumeration. */
export enum SubscriptionState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Initial = 'INITIAL',
  Paused = 'PAUSED'
}

export type SuggestedMarkup = {
  __typename: 'SuggestedMarkup';
  markup: Scalars['Decimal'];
  source: Scalars['String'];
};

/** An enumeration. */
export enum TaggingMethod {
  ResqTagging = 'RESQ_TAGGING',
  TagAsYouGo = 'TAG_AS_YOU_GO',
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum TaxRateName {
  /** Gst */
  Gst = 'GST',
  /** Hst */
  Hst = 'HST',
  /** Pst */
  Pst = 'PST',
  /** Qst */
  Qst = 'QST',
  /** Sales Tax */
  SalesTax = 'SALES_TAX'
}

export type TaxRateNode = Node & {
  __typename: 'TaxRateNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: TaxRateName;
  rate: Scalars['Decimal'];
  validFrom: Maybe<Scalars['DateTime']>;
  validTo: Maybe<Scalars['DateTime']>;
};

export type TaxRateNodeConnection = {
  __typename: 'TaxRateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaxRateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TaxRateNode` and its cursor. */
export type TaxRateNodeEdge = {
  __typename: 'TaxRateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<TaxRateNode>;
};

export type TaxonomyNodeNode = Node & {
  __typename: 'TaxonomyNodeNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  parent: Maybe<TaxonomyNodeNode>;
  path: Array<TaxonomyNodeNode>;
  symptoms: Array<TaxonomySymptomNode>;
};

export type TaxonomySymptomNode = Node & {
  __typename: 'TaxonomySymptomNode';
  description: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type TechnicianPerformance = {
  __typename: 'TechnicianPerformance';
  completedMaintenanceJobCount: Scalars['Int'];
  completedOnDemandJobCount: Scalars['Int'];
  disputeCount: Scalars['Int'];
  revenue: Scalars['Decimal'];
  technician: UserNode;
};

/** An enumeration. */
export enum TimeSlotType {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING',
  Night = 'NIGHT'
}

export type TopReviewFeedback = {
  __typename: 'TopReviewFeedback';
  count: Scalars['Int'];
  feedback: WorkOrderReviewFeedbackNode;
};

export type TopSpendFacilities = {
  __typename: 'TopSpendFacilities';
  facilityName: Scalars['String'];
  percentDifference: Scalars['Decimal'];
  spendAmount: Scalars['Decimal'];
};

export type TopSpendWorkOrders = {
  __typename: 'TopSpendWorkOrders';
  spendAmount: Scalars['Decimal'];
  workOrder: WorkOrderNode;
};

export type TradeNode = Node & {
  __typename: 'TradeNode';
  category: CategoryNode;
  code: Scalars['String'];
  description: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TradeNodeConnection = {
  __typename: 'TradeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TradeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TradeNode` and its cursor. */
export type TradeNodeEdge = {
  __typename: 'TradeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<TradeNode>;
};

export type TriggerSampleNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationInputs: Scalars['JSONString'];
  notificationName: Scalars['String'];
  targetEmail: Scalars['String'];
};

export type TriggerSampleNotificationPayload = {
  __typename: 'TriggerSampleNotificationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type TroubleshootingActionNode = Node & {
  __typename: 'TroubleshootingActionNode';
  /** The ID of the object */
  id: Scalars['ID'];
  troubleshootingStep: TroubleshootingStepNode;
};

export type TroubleshootingPlanNode = Node & {
  __typename: 'TroubleshootingPlanNode';
  /** The ID of the object */
  id: Scalars['ID'];
  troubleshootingSteps: Array<Maybe<TroubleshootingStepNode>>;
};

export type TroubleshootingSessionNode = Node & {
  __typename: 'TroubleshootingSessionNode';
  actions: Array<TroubleshootingActionNode>;
  /** The ID of the object */
  id: Scalars['ID'];
};

/** An enumeration. */
export enum TroubleshootingSessionOutcome {
  Incomplete = 'INCOMPLETE',
  ResolvedIssue = 'RESOLVED_ISSUE',
  WorkOrderCreated = 'WORK_ORDER_CREATED'
}

export type TroubleshootingStepNode = Node & {
  __typename: 'TroubleshootingStepNode';
  /** The ID of the object */
  id: Scalars['ID'];
  order: Scalars['Int'];
  /** A description of a single troubleshooting step. */
  stepDescription: Scalars['String'];
  /** A support link relating to the troubleshooting step. */
  supportLink: Scalars['String'];
};

export type UnapproveRecordOfWorkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  recordOfWorkId: Scalars['ID'];
};

/** Unapproves a record of work for invoicing. */
export type UnapproveRecordOfWorkMutationPayload = {
  __typename: 'UnapproveRecordOfWorkMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  recordOfWork: RecordOfWorkNode;
};

export type UnarchiveReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportTemplateId: Scalars['ID'];
};

export type UnarchiveReportTemplatePayload = {
  __typename: 'UnarchiveReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']>;
  reportTemplate: ReportTemplateNode;
};

export type UnassignWorkOrderFromVendorCompanyMutation = {
  __typename: 'UnassignWorkOrderFromVendorCompanyMutation';
  ok: Scalars['Boolean'];
};

export type UnblockApMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
};

export type UnblockApMutationPayload = {
  __typename: 'UnblockAPMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UnblockVendorMutation = {
  __typename: 'UnblockVendorMutation';
  ok: Scalars['Boolean'];
};

export type UncancelWorkOrderArguments = {
  workOrderId: Scalars['ID'];
};

export type UncancelWorkOrderMutation = {
  __typename: 'UncancelWorkOrderMutation';
  workOrder: WorkOrderNode;
};

export type UninvoicedByPeriod = {
  __typename: 'UninvoicedByPeriod';
  count: Scalars['Int'];
  period: MetricsPeriod;
};

export type UpdateApBatchMutationInput = {
  batchId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorInvoiceIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateApBatchMutationPayload = {
  __typename: 'UpdateApBatchMutationPayload';
  batch: ApBatchNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type UpdateBudgetMutationInput = {
  budgetId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  facilityGroupAllotments?: InputMaybe<Array<InputMaybe<FacilityGroupAllotmentInput>>>;
  isCapex?: InputMaybe<Scalars['Boolean']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isOnDemand?: InputMaybe<Scalars['Boolean']>;
  isOpex?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startDate: Scalars['Date'];
  total: Scalars['Decimal'];
};

export type UpdateBudgetMutationPayload = {
  __typename: 'UpdateBudgetMutationPayload';
  budget: Maybe<BudgetNode>;
  clientMutationId: Maybe<Scalars['String']>;
};

export type UpdateBusinessUnitArguments = {
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['ID'];
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  taggingFee?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateBusinessUnitMutation = {
  __typename: 'UpdateBusinessUnitMutation';
  businessUnit: BusinessUnitNode;
  ok: Scalars['Boolean'];
};

export type UpdateClientOrgSensitivityMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  sensitivity?: InputMaybe<Sensitivity>;
};

export type UpdateClientOrgSensitivityMutationPayload = {
  __typename: 'UpdateClientOrgSensitivityMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateClientOrganizationStatusMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientStatus?: InputMaybe<ClientOrganizationStatus>;
  organizationId: Scalars['ID'];
};

export type UpdateClientOrganizationStatusMutationPayload = {
  __typename: 'UpdateClientOrganizationStatusMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateClientReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  frequency: ClientReportFrequency;
  organizationId: Scalars['ID'];
  recipientEmailAddresses: Array<Scalars['String']>;
  reportType: ClientReportType;
};

export type UpdateClientReportScheduleMutationPayload = {
  __typename: 'UpdateClientReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  schedule: ClientReportScheduleNode;
};

export type UpdateDeviceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  configs: Array<DeviceConfigRequestInput>;
  equipmentId: Scalars['ID'];
};

export type UpdateDeviceConfigsPayload = {
  __typename: 'UpdateDeviceConfigsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateDeviceMutation = {
  __typename: 'UpdateDeviceMutation';
  ok: Scalars['Boolean'];
};

export type UpdateExternalBankAccountMutation = {
  __typename: 'UpdateExternalBankAccountMutation';
  externalBankAccount: ExternalBankAccountNode;
};

export type UpdateExternalExpenseMutationInput = {
  allocatedAmount: Scalars['Decimal'];
  attachmentFileType?: InputMaybe<Scalars['String']>;
  attachmentLabel?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  facilityId?: InputMaybe<Scalars['ID']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  spendItemId: Scalars['ID'];
  uploadedFileUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateExternalExpenseMutationPayload = {
  __typename: 'UpdateExternalExpenseMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  externalExpense: SpendItemAllocationNode;
};

export type UpdateFacilityArguments = {
  accessInfo?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  busyHours?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  countryId?: InputMaybe<Scalars['ID']>;
  daysOpened?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['ID'];
  goliveOn?: InputMaybe<Scalars['Date']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  isEssentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notReadyForOnboardingReason?: InputMaybe<NotReadyForOnboardingReasonChoice>;
  notes?: InputMaybe<Scalars['String']>;
  onboardingStatus?: InputMaybe<OnboardingStatus>;
  onsiteHours?: InputMaybe<Scalars['String']>;
  openedOn?: InputMaybe<Scalars['Date']>;
  parentGroupId?: InputMaybe<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Image>;
  plannedGoLiveOn?: InputMaybe<Scalars['Date']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  storeNumber?: InputMaybe<Scalars['String']>;
  taggingMethod?: InputMaybe<TaggingMethod>;
  transactionFee?: InputMaybe<Scalars['Float']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateFacilityGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupId: Scalars['ID'];
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateFacilityGroupOpsOwnerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupId: Scalars['ID'];
  opsOwnerId?: InputMaybe<Scalars['ID']>;
};

export type UpdateFacilityGroupOpsOwnerPayload = {
  __typename: 'UpdateFacilityGroupOpsOwnerPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facilityGroup: FacilityGroupNode;
};

export type UpdateFacilityGroupPayload = {
  __typename: 'UpdateFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']>;
  facilityGroup: FacilityGroupNode;
};

export type UpdateFacilityMutation = {
  __typename: 'UpdateFacilityMutation';
  facility: FacilityNode;
  ok: Scalars['Boolean'];
};

export type UpdateFacilitySubscriptionInput = {
  facilityId?: InputMaybe<Scalars['ID']>;
  goliveOn?: InputMaybe<Scalars['Date']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFavouriteVendorInviteSubscriptionMutationInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['ID'];
  subscribe: Scalars['Boolean'];
};

export type UpdateFavouriteVendorInviteSubscriptionMutationPayload = {
  __typename: 'UpdateFavouriteVendorInviteSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateGlCodesInput = {
  code: Scalars['String'];
  serviceCategory: ServiceCategory;
};

export type UpdateGlCodesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  glCodes: Array<UpdateGlCodesInput>;
};

export type UpdateGlCodesMutationPayload = {
  __typename: 'UpdateGLCodesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  glCodes: Array<GlCodeNode>;
};

export type UpdateInternalRequestTeamMemberAssignmentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  teamMemberIds: Array<Scalars['ID']>;
  workOrderId: Scalars['ID'];
};

export type UpdateInternalRequestTeamMemberAssignmentsPayload = {
  __typename: 'UpdateInternalRequestTeamMemberAssignmentsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  internalRequest: InternalRequestNode;
};

export type UpdateInvoiceApprovalSettingsInput = {
  approvalRoleIds?: InputMaybe<Array<Scalars['ID']>>;
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  strategy: InvoiceApprovalStrategy;
};

export type UpdateInvoiceApprovalSettingsPayload = {
  __typename: 'UpdateInvoiceApprovalSettingsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  invoiceApprovalSettings: InvoiceApprovalSettings;
};

export type UpdateMaintenancePlanMutation = {
  __typename: 'UpdateMaintenancePlanMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean'];
};

export type UpdateMarketInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  disabledCategories?: InputMaybe<Array<ServiceCategory>>;
  marketId: Scalars['ID'];
  name: Scalars['String'];
  operatingAreaIds: Array<Scalars['ID']>;
  pricing: MarketPricingInput;
};

export type UpdateMarketPayload = {
  __typename: 'UpdateMarketPayload';
  clientMutationId: Maybe<Scalars['String']>;
  market: MarketNode;
};

export type UpdateOffResqCustomerMutationInput = {
  address?: InputMaybe<Scalars['String']>;
  billingContactEmail?: InputMaybe<Scalars['String']>;
  billingContactFirstName?: InputMaybe<Scalars['String']>;
  billingContactLastName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  businessDateOfIncorporation?: InputMaybe<Scalars['Date']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']>;
  cityName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  facilityName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  offResqCustomerId: Scalars['ID'];
  postalCode?: InputMaybe<Scalars['String']>;
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type UpdateOffResqCustomerMutationPayload = {
  __typename: 'UpdateOffResqCustomerMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  offResqCustomer: OffResqCustomerNode;
};

export type UpdateOrgSubscriptionInput = {
  businessUnitId?: InputMaybe<Scalars['ID']>;
  facilities: Array<UpdateFacilitySubscriptionInput>;
  memberUserIds: Array<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  skipProrations: Scalars['Boolean'];
  taggingFee?: InputMaybe<Scalars['Decimal']>;
  unitPrice: Scalars['Decimal'];
};

export type UpdateOrganizationSubscriptionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  subscriptions: Array<UpdateOrgSubscriptionInput>;
};

export type UpdateOrganizationSubscriptionMutationPayload = {
  __typename: 'UpdateOrganizationSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdatePreventativeMaintenanceTaskListItemsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deletedTaskListAdditionalUrls?: InputMaybe<Array<Scalars['ID']>>;
  deletedTaskListAttachments?: InputMaybe<Array<Scalars['ID']>>;
  newTaskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  newTaskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  preventativeMaintenanceId: Scalars['ID'];
  taskListItems: Array<Scalars['String']>;
};

export type UpdatePreventativeMaintenanceTaskListItemsPayload = {
  __typename: 'UpdatePreventativeMaintenanceTaskListItemsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type UpdatePriceRateOverrideInput = {
  labourRate?: InputMaybe<Scalars['Decimal']>;
  overtimeMultiplier?: InputMaybe<Scalars['Decimal']>;
  serviceCallRate?: InputMaybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelRate?: InputMaybe<Scalars['Decimal']>;
  truckRate?: InputMaybe<Scalars['Decimal']>;
};

export type UpdatePriceRateOverridesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  facilityGroupId: Scalars['ID'];
  priceRateOverrides: Array<UpdatePriceRateOverrideInput>;
  vendorId: Scalars['ID'];
};

export type UpdatePriceRateOverridesMutationPayload = {
  __typename: 'UpdatePriceRateOverridesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  priceRateOverrides: Array<PriceRateOverrideNode>;
};

export type UpdateQuoteAcceptanceSettingsInput = {
  approvalThresholds: Array<QuoteApprovalThresholdInput>;
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  selectionRoleIds: Array<Scalars['ID']>;
};

export type UpdateQuoteAcceptanceSettingsPayload = {
  __typename: 'UpdateQuoteAcceptanceSettingsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quoteAcceptanceSettings: QuoteAcceptanceSettings;
};

export type UpdateQuoteApprovalThresholdsInput = {
  clientId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  thresholdData: Array<InputMaybe<QuoteApprovalThresholdInput>>;
};

export type UpdateQuoteApprovalThresholdsPayload = {
  __typename: 'UpdateQuoteApprovalThresholdsPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  day: ReportDay;
  description?: InputMaybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  filters?: InputMaybe<Array<FilterInput>>;
  frequency?: InputMaybe<ReportFrequency>;
  interval: Scalars['Int'];
  orderBy: Scalars['String'];
  recipients?: InputMaybe<Array<Scalars['String']>>;
  reportTemplateId: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateReportTemplatePayload = {
  __typename: 'UpdateReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']>;
  reportTemplate: ReportTemplateNode;
};

export type UpdateRevenueShareOverrideInput = {
  labourPercentage?: InputMaybe<Scalars['Decimal']>;
  otherPercentage?: InputMaybe<Scalars['Decimal']>;
  partsPercentage?: InputMaybe<Scalars['Decimal']>;
  serviceCallPercentage?: InputMaybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelPercentage?: InputMaybe<Scalars['Decimal']>;
  truckPercentage?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateRevenueShareOverridesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  defaultVendorRevenueShareOverrides?: InputMaybe<RevenueShareOverridePercentageInput>;
  facilityGroupId: Scalars['ID'];
  revenueShareOverrides: Array<UpdateRevenueShareOverrideInput>;
  vendorId: Scalars['ID'];
};

export type UpdateRevenueShareOverridesMutationPayload = {
  __typename: 'UpdateRevenueShareOverridesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  defaultRevenueShareOverrides: Maybe<DefaultVendorRevenueShareOverrideNode>;
  revenueShareOverrides: Array<RevenueShareOverrideNode>;
};

export type UpdateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  roleId: Scalars['ID'];
};

export type UpdateRolePayload = {
  __typename: 'UpdateRolePayload';
  clientMutationId: Maybe<Scalars['String']>;
  role: RoleNode;
};

export type UpdateServiceCategoriesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  vendorId: Scalars['ID'];
};

export type UpdateServiceCategoriesPayload = {
  __typename: 'UpdateServiceCategoriesPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: VendorOrganizationNode;
};

export type UpdateSpendApprovalPreferenceInput = {
  approvalRequiredOvertimeThreshold?: InputMaybe<Scalars['Int']>;
  approvalRequiredThreshold: Scalars['Decimal'];
  serviceCategory?: InputMaybe<ServiceCategory>;
};

export type UpdateSpendApprovalPreferencesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  spendApprovalPreferences: Array<UpdateSpendApprovalPreferenceInput>;
};

export type UpdateSpendApprovalPreferencesPayload = {
  __typename: 'UpdateSpendApprovalPreferencesPayload';
  clientMutationId: Maybe<Scalars['String']>;
  spendApprovalPreferences: Array<SpendApprovalPreferenceNode>;
};

export type UpdateSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  commit?: InputMaybe<Scalars['Boolean']>;
  dataHashKey: Scalars['String'];
  facilityId: Scalars['ID'];
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  prorate?: InputMaybe<Scalars['Boolean']>;
  unitAmount: Scalars['Decimal'];
};

export type UpdateSubscriptionPayload = {
  __typename: 'UpdateSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']>;
  dataHashKey: Scalars['String'];
  newSubscription: SubscriptionNode;
  oldSubscription: SubscriptionNode;
};

export type UpdateTroubleshootingActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  previousTroubleshootingActionId?: InputMaybe<Scalars['ID']>;
  troubleshootingActionId: Scalars['ID'];
  troubleshootingSessionId: Scalars['ID'];
};

export type UpdateTroubleshootingActionMutationPayload = {
  __typename: 'UpdateTroubleshootingActionMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateUserProfileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UpdateUserProfileMutationPayload = {
  __typename: 'UpdateUserProfileMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  user: UserNode;
};

export type UpdateVendorArguments = {
  address?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  documents: Array<VendorDocumentInput>;
  email: Scalars['String'];
  inheritedPaymentTerms?: InputMaybe<Scalars['Int']>;
  isAutoApproveEligible?: InputMaybe<Scalars['Boolean']>;
  lastResort?: InputMaybe<Scalars['Boolean']>;
  marketplacePaymentTerms?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  openToMarketplace?: InputMaybe<Scalars['Boolean']>;
  paymentTerms: Scalars['Int'];
  phone: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  remittanceEmailAddresses?: InputMaybe<Array<Scalars['String']>>;
  schedulesInApp?: InputMaybe<Scalars['Boolean']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  servicedOperatingAreaIds: Array<Scalars['ID']>;
  skillIds: Array<Scalars['ID']>;
  status: VendorStatus;
  successOwnerId?: InputMaybe<Scalars['ID']>;
  taxRegistrationNumber: Scalars['String'];
  tier?: InputMaybe<VendorTier>;
  vendorId: Scalars['ID'];
};

export type UpdateVendorGeneralInfoMutationInput = {
  address: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  afterHoursDispatchSetting?: InputMaybe<Scalars['Boolean']>;
  afterHoursPhone?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  legalFirstName?: InputMaybe<Scalars['String']>;
  legalLastName?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  onboardingActionId?: InputMaybe<Scalars['ID']>;
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  provinceId: Scalars['ID'];
  taxIdType?: InputMaybe<VendorTaxIdType>;
  taxRegistrationNumber?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};

export type UpdateVendorGeneralInfoMutationPayload = {
  __typename: 'UpdateVendorGeneralInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorInsuranceDocumentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  insuranceCertificate?: InputMaybe<VendorInsuranceDocumentInput>;
  vendorId: Scalars['ID'];
};

export type UpdateVendorInsuranceDocumentMutationPayload = {
  __typename: 'UpdateVendorInsuranceDocumentMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateVendorMarketplaceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  invoicingVersion: InvoicingVersion;
  vendorId: Scalars['ID'];
};

export type UpdateVendorMarketplaceMutationPayload = {
  __typename: 'UpdateVendorMarketplaceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: VendorOrganizationNode;
};

export type UpdateVendorMemberArguments = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  memberId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorMemberMutation = {
  __typename: 'UpdateVendorMemberMutation';
  member: Maybe<VendorMemberNode>;
  ok: Scalars['Boolean'];
};

export type UpdateVendorMutation = {
  __typename: 'UpdateVendorMutation';
  ok: Scalars['Boolean'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorOpenToMarketplaceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  openToMarketplace: Scalars['Boolean'];
  vendorId: Scalars['ID'];
};

export type UpdateVendorOpenToMarketplaceMutationPayload = {
  __typename: 'UpdateVendorOpenToMarketplaceMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorPayoutInfoMutationInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<ExternalBankAccountType>;
  addressLine2?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  institutionNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  provinceId?: InputMaybe<Scalars['ID']>;
  transitNumber?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
  voidCheck?: InputMaybe<VendorDocumentInput>;
};

export type UpdateVendorPayoutInfoMutationPayload = {
  __typename: 'UpdateVendorPayoutInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateVendorPriceRateInput = {
  labourRate?: InputMaybe<Scalars['Decimal']>;
  overtimeMultiplier?: InputMaybe<Scalars['Decimal']>;
  serviceCallRate?: InputMaybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelRate?: InputMaybe<Scalars['Decimal']>;
  truckRate?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateVendorPriceRatesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorPriceRates: Array<UpdateVendorPriceRateInput>;
};

export type UpdateVendorPriceRatesMutationPayload = {
  __typename: 'UpdateVendorPriceRatesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendorPriceRates: Array<VendorPriceRateNode>;
};

export type UpdateVendorProfileDispatchMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  onboardingActionId?: InputMaybe<Scalars['ID']>;
  servicedOperatingAreaIds?: InputMaybe<Array<Scalars['ID']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  vendorId: Scalars['ID'];
};

export type UpdateVendorProfileDispatchMutationPayload = {
  __typename: 'UpdateVendorProfileDispatchMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorRevenueShareInput = {
  labourPercentage: Scalars['Decimal'];
  otherPercentage: Scalars['Decimal'];
  partsPercentage: Scalars['Decimal'];
  serviceCallPercentage: Scalars['Decimal'];
  serviceCategory: ServiceCategory;
  travelPercentage: Scalars['Decimal'];
  truckPercentage: Scalars['Decimal'];
};

export type UpdateVendorRevenueSharesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  defaultVendorRevenueShares: RevenueSharePercentageInput;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorRevenueShares: Array<UpdateVendorRevenueShareInput>;
};

export type UpdateVendorRevenueSharesMutationPayload = {
  __typename: 'UpdateVendorRevenueSharesMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  defaultVendorRevenueShares: DefaultVendorRevenueShareNode;
  vendorRevenueShares: Array<VendorRevenueShareNode>;
};

export type UpdateVisitInput = {
  afterImages: Array<Image>;
  beforeImages: Array<Image>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  recommendations: Scalars['String'];
  visit: Scalars['ID'];
};

export type UpdateVisitPayload = {
  __typename: 'UpdateVisitPayload';
  clientMutationId: Maybe<Scalars['String']>;
  visit: VisitNode;
};

export type UpdateWorkOrderCompletionTimeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  completionTime: Scalars['DateTime'];
  workOrder: Scalars['ID'];
};

export type UpdateWorkOrderCompletionTimePayload = {
  __typename: 'UpdateWorkOrderCompletionTimePayload';
  clientMutationId: Maybe<Scalars['String']>;
  workOrder: WorkOrderNode;
};

export type UpdateWorkOrderNteInput = {
  amount: Scalars['Decimal'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type UpdateWorkOrderNtePayload = {
  __typename: 'UpdateWorkOrderNTEPayload';
  clientMutationId: Maybe<Scalars['String']>;
  spendApproval: SpendApprovalNode;
};

export type UpdateWorkOrderOpsOwnerMutation = {
  __typename: 'UpdateWorkOrderOpsOwnerMutation';
  ok: Scalars['Boolean'];
  workOrder: Maybe<WorkOrderNode>;
};

export type UploadAfterImagesMutation = {
  __typename: 'UploadAfterImagesMutation';
  ok: Scalars['Boolean'];
};

export type UploadQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quoteFile: Scalars['String'];
  quoteUploadSource: QuoteUploadSource;
  subtotal: Scalars['Decimal'];
  validUntil: Scalars['DateTime'];
  vendorId: Scalars['ID'];
  vendorReferenceNumber?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['ID'];
};

export type UploadQuoteMutationPayload = {
  __typename: 'UploadQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']>;
  quote: QuoteNode;
};

export type UploadVendorInvoiceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryMethod?: InputMaybe<InboundVendorInvoiceSource>;
  invoiceFile: Scalars['String'];
  replaceInvoice?: InputMaybe<Scalars['Boolean']>;
  workOrderId: Scalars['ID'];
};

export type UploadVendorInvoicePayload = {
  __typename: 'UploadVendorInvoicePayload';
  clientMutationId: Maybe<Scalars['String']>;
  inboundVendorInvoice: InboundVendorInvoiceNode;
};

export type UserNode = Node & {
  __typename: 'UserNode';
  accountType: AccountType;
  canAccessFinanceTab: Scalars['Boolean'];
  clientMemberships: Array<ClientOrganizationMemberNode>;
  djangoGroups: Array<DjangoGroupNode>;
  email: Scalars['String'];
  facilityGroupMemberships: Array<FacilityGroupMembershipNode>;
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  isFinance: Scalars['Boolean'];
  isFinanceSuperuser: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  profile: UserProfileNode;
  sourceId: Scalars['Int'];
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  vendorMemberships: Array<VendorMemberNode>;
};

export type UserNodeConnection = {
  __typename: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<UserNode>;
};

export type UserNotificationPreferenceConnection = {
  __typename: 'UserNotificationPreferenceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNotificationPreferenceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserNotificationPreference` and its cursor. */
export type UserNotificationPreferenceEdge = {
  __typename: 'UserNotificationPreferenceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<UserNotificationPreferenceNode>;
};

export type UserNotificationPreferenceNode = Node & {
  __typename: 'UserNotificationPreferenceNode';
  email: Maybe<Scalars['Boolean']>;
  emailConfigurable: Maybe<Scalars['Boolean']>;
  emailImplemented: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  notificationName: Scalars['String'];
  push: Maybe<Scalars['Boolean']>;
  pushConfigurable: Maybe<Scalars['Boolean']>;
  pushImplemented: Maybe<Scalars['Boolean']>;
  sms: Maybe<Scalars['Boolean']>;
  smsConfigurable: Maybe<Scalars['Boolean']>;
  smsImplemented: Maybe<Scalars['Boolean']>;
};

export type UserProfileNode = Node & {
  __typename: 'UserProfileNode';
  avatarBackgroundColor: Scalars['String'];
  avatarTextColor: Scalars['String'];
  confirmationRequired: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Anonymous users are used to submit work orders without an account */
  isAnonymous: Scalars['Boolean'];
  lastConfirmedAt: Maybe<Scalars['DateTime']>;
  locale: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  picture: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  user: Maybe<UserNode>;
  userTags: Array<UserTagNode>;
};

export type UserTagNode = Node & {
  __typename: 'UserTagNode';
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UserTagNodeConnection = {
  __typename: 'UserTagNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTagNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `UserTagNode` and its cursor. */
export type UserTagNodeEdge = {
  __typename: 'UserTagNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<UserTagNode>;
};

/** An enumeration. */
export enum ValidationRuleResultAction {
  NoAction = 'NO_ACTION',
  ProcessVendorInvoice = 'PROCESS_VENDOR_INVOICE'
}

export type VariantNode = {
  __typename: 'VariantNode';
  enabled: Scalars['Boolean'];
  experimentId: Scalars['ID'];
  experimentName: Scalars['String'];
  id: Scalars['ID'];
  payload: Scalars['GenericScalar'];
  variantId: Scalars['ID'];
  variantName: Scalars['String'];
};

export type VendorAgreementNode = Node & {
  __typename: 'VendorAgreementNode';
  confirmedAt: Maybe<Scalars['DateTime']>;
  confirmedBy: Maybe<UserNode>;
  effectiveDate: Maybe<Scalars['Date']>;
  futurePlans: Array<VendorPlanNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  isConfirmed: Scalars['Boolean'];
  plans: Array<VendorPlanNode>;
};

export type VendorAssignmentNode = Node & {
  __typename: 'VendorAssignmentNode';
  clientId: Scalars['Int'];
  closedAt: Maybe<Scalars['DateTime']>;
  facilityId: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  vendorId: Scalars['Int'];
  workOrder: WorkOrderNode;
  workOrderId: Scalars['Int'];
};

export type VendorAssignmentNodeConnection = {
  __typename: 'VendorAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorAssignmentNode` and its cursor. */
export type VendorAssignmentNodeEdge = {
  __typename: 'VendorAssignmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorAssignmentNode>;
};

/** An enumeration. */
export enum VendorAssignmentOutcome {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED'
}

export type VendorCurrentRevenueShareBreakdownNode = Node & {
  __typename: 'VendorCurrentRevenueShareBreakdownNode';
  /** The ID of the object */
  id: Scalars['ID'];
  marketplaceRevenueShare: Scalars['Decimal'];
  payoutRevenueShare: Scalars['Decimal'];
  payoutTerms: Scalars['Int'];
  vendorId: Scalars['Int'];
};

export type VendorDispatchNode = Node & {
  __typename: 'VendorDispatchNode';
  endedAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  requests: Array<VendorDispatchRequestNode>;
  startedAt: Maybe<Scalars['DateTime']>;
  startedAutomatically: Maybe<Scalars['Boolean']>;
  startedThroughCyov: Scalars['Boolean'];
  status: VendorDispatchStatus;
  workOrder: Maybe<WorkOrderNode>;
};

/** An enumeration. */
export enum VendorDispatchRequestDeclineReasonChoices {
  DoNotHaveTheRightEquipment = 'DO_NOT_HAVE_THE_RIGHT_EQUIPMENT',
  NotInMyFieldOfExpertise = 'NOT_IN_MY_FIELD_OF_EXPERTISE',
  Other = 'OTHER',
  TooBusy = 'TOO_BUSY',
  TooFar = 'TOO_FAR',
  WeDoNotServiceThisRestaurant = 'WE_DO_NOT_SERVICE_THIS_RESTAURANT'
}

export type VendorDispatchRequestDeclineReasonNode = Node & {
  __typename: 'VendorDispatchRequestDeclineReasonNode';
  /** The ID of the object */
  id: Scalars['ID'];
  otherReason: Maybe<Scalars['String']>;
  reasonChoice: VendorDispatchRequestDeclineReasonChoices;
  vendorDispatchRequest: VendorDispatchRequestNode;
};

export type VendorDispatchRequestNode = Node & {
  __typename: 'VendorDispatchRequestNode';
  actionedAt: Maybe<Scalars['DateTime']>;
  can: Scalars['Boolean'];
  declineReason: Maybe<VendorDispatchRequestDeclineReasonNode>;
  exclusivityWindow: Scalars['Int'];
  expectedAcceptanceAt: Maybe<Scalars['DateTime']>;
  expiresAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  order: Scalars['Int'];
  serviceGuaranteed: Scalars['Boolean'];
  startedAt: Maybe<Scalars['DateTime']>;
  status: VendorDispatchRequestStatus;
  vendor: VendorOrganizationNode;
  vendorDispatch: VendorDispatchNode;
};


export type VendorDispatchRequestNodeCanArgs = {
  perform: VendorDispatchRequestPermission;
};

export type VendorDispatchRequestNodeConnection = {
  __typename: 'VendorDispatchRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorDispatchRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorDispatchRequestNode` and its cursor. */
export type VendorDispatchRequestNodeEdge = {
  __typename: 'VendorDispatchRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorDispatchRequestNode>;
};

export enum VendorDispatchRequestPermission {
  Respond = 'RESPOND'
}

/** An enumeration. */
export enum VendorDispatchRequestStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum VendorDispatchStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export enum VendorDocumentEnum {
  Insurance = 'INSURANCE',
  Licence = 'LICENCE',
  Other = 'OTHER',
  TaxW9 = 'TAX_W9',
  VoidCheque = 'VOID_CHEQUE',
  Wsib = 'WSIB'
}

export type VendorDocumentInput = {
  documentFile: Scalars['String'];
  documentName: Scalars['String'];
  documentType: VendorDocumentEnum;
  expiresOn?: InputMaybe<Scalars['Date']>;
};

export type VendorDocumentNode = {
  __typename: 'VendorDocumentNode';
  createdAt: Scalars['DateTime'];
  documentFile: FileType;
  documentName: Scalars['String'];
  documentType: VendorDocumentEnum;
  expiresOn: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
};

export type VendorImprovementMetric = {
  __typename: 'VendorImprovementMetric';
  metric: ScoreMetric;
  percentileRank: Scalars['Decimal'];
  pillar: ScorePillar;
};

export type VendorInsuranceDocumentInput = {
  documentFile: Scalars['String'];
  documentName: Scalars['String'];
  expiresOn: Scalars['Date'];
};

export type VendorInternalNoteNode = Node & {
  __typename: 'VendorInternalNoteNode';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID'];
};

export type VendorInviteValues = {
  email?: InputMaybe<Scalars['String']>;
  facilityGroupIds: Array<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  previousMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  serviceCategories: Array<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum VendorInvoiceCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

export type VendorInvoiceNode = Node & {
  __typename: 'VendorInvoiceNode';
  batch: Maybe<ApBatchNode>;
  code: Maybe<Scalars['String']>;
  /** The currency of the invoice amounts. */
  currency: VendorInvoiceCurrency;
  dueAtDate: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoiceSet: Maybe<InvoiceSetNode>;
  invoicingVersion: InvoicingVersion;
  issuedAt: Scalars['DateTime'];
  issuedAtDate: Scalars['Date'];
  paidAt: Maybe<Scalars['DateTime']>;
  pdfUrl: Maybe<Scalars['String']>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  referenceNumber: Maybe<Scalars['String']>;
  status: VendorInvoiceStatus;
  total: Scalars['Float'];
  /** The ID of the vendor that the invoice is associated with. This is also called organization_id in other models. */
  vendor: VendorOrganizationNode;
  /** The ID of the work order that the invoice is associated with.  */
  workOrder: WorkOrderNode;
};

export type VendorInvoiceNodeConnection = {
  __typename: 'VendorInvoiceNodeConnection';
  cadTotal: Scalars['Decimal'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorInvoiceNodeEdge>>;
  gbpTotal: Scalars['Decimal'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  usdTotal: Scalars['Decimal'];
};

/** A Relay edge containing a `VendorInvoiceNode` and its cursor. */
export type VendorInvoiceNodeEdge = {
  __typename: 'VendorInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorInvoiceNode>;
};

export enum VendorInvoiceStatus {
  AwaitingPayout = 'AWAITING_PAYOUT',
  Disputed = 'DISPUTED',
  Paid = 'PAID'
}

export type VendorInvoiceTaxNode = Node & {
  __typename: 'VendorInvoiceTaxNode';
  /** The ID of the object */
  id: Scalars['ID'];
  taxRate: TaxRateNode;
  total: Scalars['Decimal'];
};

export type VendorJobChangeSuggestionNode = Node & {
  __typename: 'VendorJobChangeSuggestionNode';
  endAt: Maybe<Scalars['DateTime']>;
  endDate: Maybe<Scalars['Date']>;
  endTime: Maybe<Scalars['Time']>;
  /** The ID of the object */
  id: Scalars['ID'];
  startAt: Maybe<Scalars['DateTime']>;
  startDate: Maybe<Scalars['Date']>;
  startTime: Maybe<Scalars['Time']>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type VendorJobChangeSuggestionNodeConnection = {
  __typename: 'VendorJobChangeSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorJobChangeSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorJobChangeSuggestionNode` and its cursor. */
export type VendorJobChangeSuggestionNodeEdge = {
  __typename: 'VendorJobChangeSuggestionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorJobChangeSuggestionNode>;
};

export type VendorJobCountNode = {
  __typename: 'VendorJobCountNode';
  awaitingPartsCount: Scalars['Int'];
  awaitingPayoutCount: Scalars['Int'];
  disputedCount: Scalars['Int'];
  invoicesNeededCount: Scalars['Int'];
  quotesInReviewCount: Scalars['Int'];
  quotesNeededCount: Scalars['Int'];
  todayCount: Scalars['Int'];
};

export type VendorMatch = {
  __typename: 'VendorMatch';
  badExperiences: Array<MatchBadExperience>;
  completedWorkOrderCount: Scalars['Int'];
  dispatchEnabled: Scalars['Boolean'];
  firstTimeFixRate: Maybe<Scalars['Decimal']>;
  isInherited: Scalars['Boolean'];
  isMpProvider: Scalars['Boolean'];
  isNewToFacility: Scalars['Boolean'];
  isNewToPlatform: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  negativeReviewCount: Scalars['Int'];
  positiveReviewCount: Scalars['Int'];
  priceLevel: Maybe<Scalars['Int']>;
  qualityScore: Maybe<Scalars['Decimal']>;
  satisfactionRate: Maybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  serviceGuaranteed: Scalars['Boolean'];
  timeToOnsite: Maybe<Scalars['Int']>;
  vendor: VendorOrganizationNode;
  vendorPriceRate: Maybe<VendorPriceRateNode>;
  vendorSkills: Array<SkillNode>;
  willBypassExpiry: Scalars['Boolean'];
};

export type VendorMatchSet = {
  __typename: 'VendorMatchSet';
  favouriteVendors: Array<VendorMatch>;
  inheritedVendors: Array<VendorMatch>;
  marketplaceVendors: Array<VendorMatch>;
  suggestedVendors: Array<VendorMatch>;
  suspectedCallbackVendors: Array<VendorMatch>;
  verifiedVendors: Array<VendorMatch>;
};

export type VendorMatchesInput = {
  callbackOriginalWorkOrderId?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['String']>;
  correlationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['ID']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facility?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<Scalars['String']>>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']>;
  isUrgent?: InputMaybe<Scalars['Boolean']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  symptom?: InputMaybe<Scalars['ID']>;
  taxonomyNode?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['ID']>;
};

export type VendorMatchingProfileNode = Node & {
  __typename: 'VendorMatchingProfileNode';
  /** The ID of the object */
  id: Scalars['ID'];
  openToMarketplace: Scalars['Boolean'];
  serviceGuaranteeRequestedAt: Maybe<Scalars['DateTime']>;
  skills: Array<SkillNode>;
};

export type VendorMemberNode = Node & {
  __typename: 'VendorMemberNode';
  can: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  roles: Array<RoleNode>;
  user: UserNode;
  vendor: VendorOrganizationNode;
};


export type VendorMemberNodeCanArgs = {
  perform: MemberPermission;
};

export type VendorMemberNodeConnection = {
  __typename: 'VendorMemberNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorMemberNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorMemberNode` and its cursor. */
export type VendorMemberNodeEdge = {
  __typename: 'VendorMemberNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorMemberNode>;
};

export type VendorMetricsNode = {
  __typename: 'VendorMetricsNode';
  completedWorkOrdersComparison: CompletedWorkOrdersComparison;
  facilitiesServiced: Scalars['Int'];
  jobsPerCategory: Array<JobsPerServiceCategory>;
  jobsPerType: JobsPerType;
  lifetimeCompletedJobCount: Scalars['Int'];
  lifetimeCustomers: Maybe<FacilityNodeConnection>;
  lifetimeCustomersCount: Scalars['Int'];
  lifetimeFacilitiesServiced: Scalars['Int'];
  lifetimeJobCount: Scalars['Int'];
  lifetimeRevenue: Scalars['Decimal'];
  outstandingInvoiceCount: Scalars['Int'];
  performanceByTechnician: Array<TechnicianPerformance>;
  revenue: Scalars['Decimal'];
  satisfactionRate: SatisfactionRate;
};


export type VendorMetricsNodeLifetimeCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum VendorOption {
  Callback = 'CALLBACK',
  Directory = 'DIRECTORY',
  Favourite = 'FAVOURITE',
  VerifiedVendor = 'VERIFIED_VENDOR'
}

export type VendorOrganizationNode = Node & {
  __typename: 'VendorOrganizationNode';
  agreement: Maybe<VendorAgreementNode>;
  allBlockedBy: Array<FacilityGroupNode>;
  allDispatchRelationships: Array<DispatchRelationshipNode>;
  bankAccount: Maybe<BankAccountNode>;
  billingAddress: Maybe<BillingAddressNode>;
  billingInformation: BillingInformationNode;
  code: Scalars['String'];
  /** @deprecated Renamed to `name`. */
  companyName: Scalars['String'];
  currentRevenueShareBreakdown: Maybe<VendorCurrentRevenueShareBreakdownNode>;
  documents: Array<VendorDocumentNode>;
  experienceAreas: ExperienceAreas;
  /** The ID of the object */
  id: Scalars['ID'];
  internalNotes: Array<VendorInternalNoteNode>;
  invites: Array<InviteNode>;
  matchingProfile: Maybe<VendorMatchingProfileNode>;
  members: Array<VendorMemberNode>;
  name: Scalars['String'];
  owner: Maybe<UserNode>;
  permissions: VendorPermissions;
  profile: VendorProfileNode;
  successOwner: Maybe<UserNode>;
  tier: Maybe<VendorTier>;
  timezone: Scalars['String'];
  trackingId: Scalars['Int'];
  tradeQualifications: Array<VendorTradeQualificationNode>;
  /** @deprecated Use `members` instead. */
  users: Array<UserNode>;
  vendorIcsLink: Maybe<Scalars['String']>;
  verifiedVendorCreatedAt: Maybe<Scalars['DateTime']>;
};


export type VendorOrganizationNodeExperienceAreasArgs = {
  facilityId: Scalars['ID'];
};

export type VendorOrganizationNodeConnection = {
  __typename: 'VendorOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorOrganizationNode` and its cursor. */
export type VendorOrganizationNodeEdge = {
  __typename: 'VendorOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorOrganizationNode>;
};

export type VendorPayoutNode = Node & {
  __typename: 'VendorPayoutNode';
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID'];
  operatingCountry: CountryNode;
};

export type VendorPerformancePillarPercentiles = {
  __typename: 'VendorPerformancePillarPercentiles';
  process: Maybe<Scalars['Decimal']>;
  quality: Maybe<Scalars['Decimal']>;
  speed: Maybe<Scalars['Decimal']>;
};

export type VendorPerformanceProfile = {
  __typename: 'VendorPerformanceProfile';
  completedJobsCount: Maybe<Scalars['Int']>;
  eligibleForServiceGuarantee: Scalars['Boolean'];
  firstTimeFixRates: Array<FirstTimeFixRate>;
  improvementMetrics: Array<VendorImprovementMetric>;
  pillarPercentiles: VendorPerformancePillarPercentiles;
  reviewSummary: ReviewMetrics;
  scoreSummary: VendorScoreSummary;
  serviceGuaranteed: Scalars['Boolean'];
  timeToOnsite: Maybe<Scalars['Int']>;
  vendor: VendorOrganizationNode;
};

export type VendorPermissions = {
  __typename: 'VendorPermissions';
  /** Permission to view and accept dispatch requests. */
  acceptDispatchRequests: Scalars['Boolean'];
  blockAp: Scalars['Boolean'];
  createInvoice: Scalars['Boolean'];
  /** Permission to view and fulfill scheduling requests. */
  fulfillSchedulingRequests: Scalars['Boolean'];
  manageProfile: Scalars['Boolean'];
  manageUsers: Scalars['Boolean'];
  modifyDetails: Scalars['Boolean'];
  unblockAp: Scalars['Boolean'];
  uploadInvoice: Scalars['Boolean'];
  viewCustomers: Scalars['Boolean'];
  /** Permission to view performance page */
  viewPerformance: Scalars['Boolean'];
};

export type VendorPlanNode = Node & {
  __typename: 'VendorPlanNode';
  /** The ID of the object */
  id: Scalars['ID'];
  impactsInherited: Scalars['Boolean'];
  isPopular: Scalars['Boolean'];
  legacyGroup: Maybe<Scalars['Int']>;
  paymentTerms: Maybe<Scalars['Int']>;
  perks: Array<VendorPlanPerk>;
  revenueShareImpact: Scalars['Decimal'];
  type: VendorPlanType;
};

export type VendorPlanNodeConnection = {
  __typename: 'VendorPlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorPlanNode` and its cursor. */
export type VendorPlanNodeEdge = {
  __typename: 'VendorPlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorPlanNode>;
};

/** An enumeration. */
export enum VendorPlanPerk {
  BusinessReview = 'BUSINESS_REVIEW',
  CompetitiveQuoteAccess = 'COMPETITIVE_QUOTE_ACCESS',
  FastPayout = 'FAST_PAYOUT',
  MaintenacePlanAccess = 'MAINTENACE_PLAN_ACCESS',
  Marketplace = 'MARKETPLACE',
  QuickPayout = 'QUICK_PAYOUT',
  StandardPayout = 'STANDARD_PAYOUT'
}

/** An enumeration. */
export enum VendorPlanType {
  MarketplacePremium = 'MARKETPLACE_PREMIUM',
  MarketplaceStandard = 'MARKETPLACE_STANDARD',
  PayoutFast = 'PAYOUT_FAST',
  PayoutQuick = 'PAYOUT_QUICK',
  PayoutStandard = 'PAYOUT_STANDARD'
}

export type VendorPriceRateNode = Node & {
  __typename: 'VendorPriceRateNode';
  hourlyLabourRate: Maybe<Scalars['Decimal']>;
  hourlyLabourRateLowerBound: Maybe<Scalars['Decimal']>;
  hourlyLabourRateUpperBound: Maybe<Scalars['Decimal']>;
  /** The ID of the object */
  id: Scalars['ID'];
  labourRate: Maybe<Scalars['Decimal']>;
  minServiceCallHours: Maybe<Scalars['Decimal']>;
  minServiceCallRate: Maybe<Scalars['Decimal']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']>;
  serviceCallRate: Maybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelRate: Maybe<Scalars['Decimal']>;
  truckRate: Maybe<Scalars['Decimal']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  vendor: VendorOrganizationNode;
};

export type VendorPriceRateNodeConnection = {
  __typename: 'VendorPriceRateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPriceRateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VendorPriceRateNode` and its cursor. */
export type VendorPriceRateNodeEdge = {
  __typename: 'VendorPriceRateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorPriceRateNode>;
};

export type VendorProfileNode = Node & {
  __typename: 'VendorProfileNode';
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  dateOfBirth: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  favoritedBrands: Maybe<Array<BrandNode>>;
  /** The ID of the object */
  id: Scalars['ID'];
  inheritedPaymentTerms: Maybe<Scalars['Int']>;
  invoicingVersion: InvoicingVersion;
  isAutoApproveEligible: Maybe<Scalars['Boolean']>;
  isChowboticsPartner: Scalars['Boolean'];
  lastResort: Scalars['Boolean'];
  legalFirstName: Maybe<Scalars['String']>;
  legalLastName: Maybe<Scalars['String']>;
  legalName: Maybe<Scalars['String']>;
  marketplacePaymentTerms: Maybe<Scalars['Int']>;
  onboarded: Scalars['Boolean'];
  openToMarketplace: Scalars['Boolean'];
  paymentTerms: Scalars['Int'];
  phone: Scalars['String'];
  remittanceEmailAddresses: Array<Scalars['String']>;
  schedulesInApp: Scalars['Boolean'];
  servicedOperatingAreas: Array<OperatingAreaNode>;
  servicedOperatingAreasCount: Scalars['Int'];
  skills: Array<SkillNode>;
  status: VendorStatus;
  taxIdType: Maybe<VendorTaxIdType>;
  taxRegistrationNumber: Scalars['String'];
};

export type VendorRevenueShareNode = Node & {
  __typename: 'VendorRevenueShareNode';
  /** The ID of the object */
  id: Scalars['ID'];
  labourPercentage: Maybe<Scalars['Decimal']>;
  otherPercentage: Maybe<Scalars['Decimal']>;
  partsPercentage: Maybe<Scalars['Decimal']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']>;
  serviceCategory: ServiceCategory;
  travelPercentage: Maybe<Scalars['Decimal']>;
  truckPercentage: Maybe<Scalars['Decimal']>;
  vendor: VendorOrganizationNode;
};

export type VendorRevenueShareNodeConnection = {
  __typename: 'VendorRevenueShareNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorRevenueShareNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VendorRevenueShareNode` and its cursor. */
export type VendorRevenueShareNodeEdge = {
  __typename: 'VendorRevenueShareNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VendorRevenueShareNode>;
};

export type VendorScoreSummary = {
  __typename: 'VendorScoreSummary';
  score: Maybe<Scalars['Decimal']>;
  scoreChange: Maybe<Scalars['Decimal']>;
};

/** An enumeration. */
export enum VendorStatus {
  Active = 'ACTIVE',
  AgreementPending = 'AGREEMENT_PENDING',
  Deactivated = 'DEACTIVATED',
  New = 'NEW',
  Paused = 'PAUSED',
  PendingInviteAccepted = 'PENDING_INVITE_ACCEPTED',
  Waitlisted = 'WAITLISTED'
}

export type VendorTosAgreementNode = Node & {
  __typename: 'VendorTOSAgreementNode';
  /** The ID of the object */
  id: Scalars['ID'];
  vendor: VendorOrganizationNode;
};

/** An enumeration. */
export enum VendorTaxIdType {
  Ein = 'EIN',
  Tin = 'TIN'
}

/** An enumeration. */
export enum VendorTier {
  VendorTier_1 = 'VENDOR_TIER_1',
  VendorTier_2 = 'VENDOR_TIER_2',
  VendorTier_3 = 'VENDOR_TIER_3'
}

export type VendorTradeQualificationNode = Node & {
  __typename: 'VendorTradeQualificationNode';
  /** The ID of the object */
  id: Scalars['ID'];
  serviceCategory: ServiceCategory;
};

export type VerifyBusinessUnitAddressNode = Node & {
  __typename: 'VerifyBusinessUnitAddressNode';
  addressesMatch: Scalars['Boolean'];
  businessUnit: BusinessUnitNode;
  id: Scalars['ID'];
  isOverridden: Scalars['Boolean'];
  isResolved: Scalars['Boolean'];
  validationMessages: Array<Maybe<Scalars['String']>>;
};

export type VerifyFacilityAddressNode = Node & {
  __typename: 'VerifyFacilityAddressNode';
  addressesMatch: Scalars['Boolean'];
  facility: FacilityNode;
  id: Scalars['ID'];
  isOverridden: Scalars['Boolean'];
  isResolved: Scalars['Boolean'];
  validationMessages: Array<Maybe<Scalars['String']>>;
};

export type VerifyLocationAddressNode = Node & {
  __typename: 'VerifyLocationAddressNode';
  addressesMatch: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  isResolved: Scalars['Boolean'];
  recommendedAddress: Maybe<AddressNode>;
  validationMessages: Array<Maybe<Scalars['String']>>;
};

export type VerifyOrganizationAddressesNode = Node & {
  __typename: 'VerifyOrganizationAddressesNode';
  businessUnitAddressResolutions: Array<VerifyBusinessUnitAddressNode>;
  facilityAddressResolutions: Array<VerifyFacilityAddressNode>;
  /** The ID of the object */
  id: Scalars['ID'];
};

export type VisitNode = Node & {
  __typename: 'VisitNode';
  afterImages: Array<ImageNode>;
  appointment: Maybe<AppointmentNode>;
  beforeImages: Array<ImageNode>;
  endedAt: Maybe<Scalars['DateTime']>;
  facilityManagerName: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  notes: Scalars['String'];
  outcome: Maybe<VisitOutcome>;
  permissions: VisitPermissions;
  recommendations: Scalars['String'];
  startedAt: Scalars['DateTime'];
  vendor: Maybe<VendorOrganizationNode>;
  visitedBy: Maybe<UserNode>;
};

export type VisitNodeConnection = {
  __typename: 'VisitNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VisitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VisitNode` and its cursor. */
export type VisitNodeEdge = {
  __typename: 'VisitNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VisitNode>;
};

export enum VisitOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type VisitPermissions = {
  __typename: 'VisitPermissions';
  /** Permission to end the visit. */
  end: Scalars['Boolean'];
  /** Permission to schedule the next appointment when ending the visit. */
  scheduleNextAppointment: Scalars['Boolean'];
};

/** An enumeration. */
export enum VisitReviewOutcome {
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  NoVendor = 'NO_VENDOR',
  PartsNeeded = 'PARTS_NEEDED',
  QuoteNeeded = 'QUOTE_NEEDED'
}

export type VisitReviewRequestNode = Node & {
  __typename: 'VisitReviewRequestNode';
  appointment: Maybe<AppointmentNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type VisitReviewRequestNodeConnection = {
  __typename: 'VisitReviewRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VisitReviewRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `VisitReviewRequestNode` and its cursor. */
export type VisitReviewRequestNodeEdge = {
  __typename: 'VisitReviewRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<VisitReviewRequestNode>;
};

/** An enumeration. */
export enum VisitReviewRequestStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type VoidSubscriptionInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']>;
  clientInvoiceId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type VoidSubscriptionInvoiceMutationPayload = {
  __typename: 'VoidSubscriptionInvoiceMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']>;
};

export type WorkOrderCancellationDetailNode = Node & {
  __typename: 'WorkOrderCancellationDetailNode';
  additionalDetails: Maybe<Scalars['String']>;
  cancelReason: Maybe<WorkOrderCancellationReason>;
  cancelReasonDisplay: Maybe<Scalars['String']>;
  cancelledOn: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  source: Maybe<WorkOrderCancellationSource>;
  workOrder: WorkOrderNode;
};

export type WorkOrderCancellationDetailNodeConnection = {
  __typename: 'WorkOrderCancellationDetailNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderCancellationDetailNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderCancellationDetailNode` and its cursor. */
export type WorkOrderCancellationDetailNodeEdge = {
  __typename: 'WorkOrderCancellationDetailNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderCancellationDetailNode>;
};

/** An enumeration. */
export enum WorkOrderCancellationReason {
  Duplicate = 'DUPLICATE',
  HandledByMaintenancePlan = 'HANDLED_BY_MAINTENANCE_PLAN',
  IssueNotHandledByResq = 'ISSUE_NOT_HANDLED_BY_RESQ',
  IssueResolved = 'ISSUE_RESOLVED',
  IssueWithQuote = 'ISSUE_WITH_QUOTE',
  NoAvailableVendors = 'NO_AVAILABLE_VENDORS',
  Other = 'OTHER',
  SubmittedByMistake = 'SUBMITTED_BY_MISTAKE',
  VendorReassigned = 'VENDOR_REASSIGNED'
}

/** An enumeration. */
export enum WorkOrderCancellationSource {
  FacilityApp = 'FACILITY_APP',
  Rcc = 'RCC',
  Rmc = 'RMC',
  System = 'SYSTEM'
}

export type WorkOrderClientInvoicesApprovalNode = Node & {
  __typename: 'WorkOrderClientInvoicesApprovalNode';
  /** The ID of the object */
  id: Scalars['ID'];
  user: UserNode;
};

export type WorkOrderCountsByCyovDispatches = {
  __typename: 'WorkOrderCountsByCYOVDispatches';
  additionalDispatches: Scalars['Int'];
  firstDispatch: Scalars['Int'];
  secondDispatch: Scalars['Int'];
};

export type WorkOrderCountsByCoordinatorStatus = {
  __typename: 'WorkOrderCountsByCoordinatorStatus';
  allStatus: Scalars['Int'];
  awaitingAcceptance: Scalars['Int'];
  awaitingAssignment: Scalars['Int'];
  awaitingCompletion: Scalars['Int'];
  awaitingFacilityApproval: Scalars['Int'];
  awaitingPayment: Scalars['Int'];
  awaitingRecordOfWork: Scalars['Int'];
  awaitingResqApproval: Scalars['Int'];
  awaitingScheduling: Scalars['Int'];
  awaitingVendorPayout: Scalars['Int'];
  awaitingVmApproval: Scalars['Int'];
  cancelled: Scalars['Int'];
  closed: Scalars['Int'];
  disputed: Scalars['Int'];
  missingVendorInvoice: Scalars['Int'];
  vendorClosed: Scalars['Int'];
};

export type WorkOrderEscalationNode = Node & {
  __typename: 'WorkOrderEscalationNode';
  assignedAt: Maybe<Scalars['DateTime']>;
  assignedTo: Maybe<UserNode>;
  channel: Maybe<EscalationChannelType>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  escalatedBy: UserNode;
  escalationReason: Maybe<WorkOrderEscalationReasonType>;
  /** The ID of the object */
  id: Scalars['ID'];
  kustomerWorkOrderEscalation: Maybe<KustomerWorkOrderEscalationNode>;
  otherReason: Maybe<Scalars['String']>;
  permissions: WorkOrderEscalationPermissions;
  reason: WorkOrderEscalationReason;
  resolutionComment: Maybe<Scalars['String']>;
  resolvedAt: Maybe<Scalars['DateTime']>;
  resolvedBy: Maybe<UserNode>;
  sourceOrgType: Maybe<WorkOrderEscalationSourceOrgType>;
  workOrder: WorkOrderNode;
};

export type WorkOrderEscalationNodeConnection = {
  __typename: 'WorkOrderEscalationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderEscalationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderEscalationNode` and its cursor. */
export type WorkOrderEscalationNodeEdge = {
  __typename: 'WorkOrderEscalationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderEscalationNode>;
};

export type WorkOrderEscalationPermissions = {
  __typename: 'WorkOrderEscalationPermissions';
  /** Permission to resolve escalations. */
  resolveEscalations: Scalars['Boolean'];
};

/** An enumeration. */
export enum WorkOrderEscalationReason {
  BadQuote = 'BAD_QUOTE',
  CallbackRequired = 'CALLBACK_REQUIRED',
  CancelWorkOrder = 'CANCEL_WORK_ORDER',
  CantUpdateWorkOrderStatus = 'CANT_UPDATE_WORK_ORDER_STATUS',
  CantUploadInvoice = 'CANT_UPLOAD_INVOICE',
  ChangeSchedulingTimeline = 'CHANGE_SCHEDULING_TIMELINE',
  ChangeToEmergency = 'CHANGE_TO_EMERGENCY',
  ChangeVendor = 'CHANGE_VENDOR',
  DifficultyContactingCustomer = 'DIFFICULTY_CONTACTING_CUSTOMER',
  EmergencyApprovalForWorkOrder = 'EMERGENCY_APPROVAL_FOR_WORK_ORDER',
  InvoiceIssue = 'INVOICE_ISSUE',
  NobodyOnSite = 'NOBODY_ON_SITE',
  NoDispatchResponse = 'NO_DISPATCH_RESPONSE',
  Other = 'OTHER',
  PartsUpdate = 'PARTS_UPDATE',
  PaymentQuestion = 'PAYMENT_QUESTION',
  PoorQuality = 'POOR_QUALITY',
  ScheduleConflict = 'SCHEDULE_CONFLICT',
  VendorNotFound = 'VENDOR_NOT_FOUND',
  VendorNotResponsive = 'VENDOR_NOT_RESPONSIVE',
  VendorNoShow = 'VENDOR_NO_SHOW'
}

export type WorkOrderEscalationReasonType = {
  __typename: 'WorkOrderEscalationReasonType';
  key: WorkOrderEscalationReason;
  label: Scalars['String'];
};

/** An enumeration. */
export enum WorkOrderEscalationSourceOrgType {
  Client = 'CLIENT',
  Vendor = 'VENDOR'
}

export type WorkOrderExpenseTypeNode = Node & {
  __typename: 'WorkOrderExpenseTypeNode';
  expenseType: ExpenseType;
  expenseTypeSetThrough: ExpenseTypeSetThrough;
  /** The ID of the object */
  id: Scalars['ID'];
  setBy: Maybe<UserNode>;
  workOrderId: Scalars['Int'];
};

export enum WorkOrderHoldReason {
  AdditionalVisitRequired = 'ADDITIONAL_VISIT_REQUIRED',
  AwaitingParts = 'AWAITING_PARTS',
  AwaitingQuoteApprovalFromClient = 'AWAITING_QUOTE_APPROVAL_FROM_CLIENT',
  AwaitingQuoteFromVendor = 'AWAITING_QUOTE_FROM_VENDOR',
  Other = 'OTHER'
}

export type WorkOrderInternalNoteNode = Node & {
  __typename: 'WorkOrderInternalNoteNode';
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  deletedAt: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  message: Scalars['String'];
  permissions: WorkOrderInternalNotePermissions;
  workOrderId: Scalars['Int'];
};

export type WorkOrderInternalNoteNodeConnection = {
  __typename: 'WorkOrderInternalNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderInternalNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderInternalNoteNode` and its cursor. */
export type WorkOrderInternalNoteNodeEdge = {
  __typename: 'WorkOrderInternalNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderInternalNoteNode>;
};

export type WorkOrderInternalNotePermissions = {
  __typename: 'WorkOrderInternalNotePermissions';
  /** Permission to delete an internal note */
  deleteNote: Scalars['Boolean'];
};

export type WorkOrderNode = Node & {
  __typename: 'WorkOrderNode';
  activityFeedEntries: Array<ActivityFeedEntryNode>;
  appointment: Maybe<AppointmentNode>;
  assignedToTechnician: Maybe<UserNode>;
  availableTimeSlots: Array<AvailableTimeSlotNode>;
  callbackOriginalWorkOrder: Maybe<WorkOrderNode>;
  callbackWorkOrder: Maybe<WorkOrderNode>;
  can: Scalars['Boolean'];
  canAcceptNewQuotes: Scalars['Boolean'];
  cancelledOn: Maybe<Scalars['DateTime']>;
  /** @deprecated Replaced with service category */
  category: TradeNode;
  clientInvoices: Maybe<Array<ClientInvoiceNode>>;
  clientInvoicesApprovals: Array<WorkOrderClientInvoicesApprovalNode>;
  clientRejectReason: Maybe<Scalars['String']>;
  clientRuleViolations: Maybe<RuleViolationsNode>;
  clientStatus: ClientWorkOrderStatus;
  code: Scalars['String'];
  comments: Array<CommentNode>;
  completedOn: Maybe<Scalars['DateTime']>;
  coordinator: Maybe<CoordinatorNode>;
  correlationId: Maybe<Scalars['String']>;
  currency: Currency;
  currentEscalations: Array<WorkOrderEscalationNode>;
  cyovDispatchCount: Scalars['Int'];
  description: Scalars['String'];
  disputeReason: Maybe<Scalars['String']>;
  disputedOn: Maybe<Scalars['DateTime']>;
  eligibleForServiceGuarantee: Scalars['Boolean'];
  equipment: Maybe<EquipmentNode>;
  expectedPrice: Maybe<Scalars['Decimal']>;
  expectedServiceTimeline: Maybe<ExpectedServiceTimelineType>;
  expenseType: Maybe<ExpenseType>;
  externalReferenceNumber: Maybe<Scalars['String']>;
  facility: FacilityNode;
  facilityAccessInfo: Maybe<Scalars['String']>;
  firstVisitExpectedArrivalTime: Maybe<Scalars['DateTime']>;
  firstVisitSchedulingNotes: Scalars['String'];
  hasMaintenancePlan: Scalars['Boolean'];
  hasVendorInvoiceEmail: Scalars['Boolean'];
  heldOn: Maybe<Scalars['DateTime']>;
  holdComments: Scalars['String'];
  holdReason: Maybe<WorkOrderHoldReason>;
  /** The ID of the object */
  id: Scalars['ID'];
  images: Array<ImageNode>;
  inProgressVisit: Maybe<VisitNode>;
  inboundVendorInvoices: Array<InboundVendorInvoiceNode>;
  internalPriority: Maybe<Scalars['String']>;
  internalRequest: Maybe<InternalRequestNode>;
  isCallback: Scalars['Boolean'];
  isCyov: Scalars['Boolean'];
  isEssentials: Scalars['Boolean'];
  isSuspectedCallback: Scalars['Boolean'];
  isUnderWarranty: Scalars['Boolean'];
  /** Client says this WO is urgent. */
  isUrgent: Scalars['Boolean'];
  lastModified: Maybe<Scalars['DateTime']>;
  latestVisit: Maybe<VisitNode>;
  legacyId: Scalars['Int'];
  maintenancePlan: Maybe<MaintenancePlanNode>;
  needsApproval: Scalars['Boolean'];
  needsResponseNote: Maybe<WorkOrderNoteNode>;
  noteCount: Maybe<Scalars['Int']>;
  notes: Maybe<Array<WorkOrderNoteNode>>;
  onHold: Scalars['Boolean'];
  opsOwner: Maybe<UserNode>;
  opsOwnerAssignedAt: Maybe<Scalars['DateTime']>;
  overtimeApprovedBy: Maybe<UserNode>;
  pointOfContact: Maybe<WorkOrderPointOfContactNode>;
  priority: Maybe<WorkOrderPriorityNode>;
  quoteRequiredThreshold: Scalars['Int'];
  quoteSets: Array<QuoteSetNode>;
  quoteThresholdOverrideApprovedBy: Maybe<UserNode>;
  /** @deprecated Replaced by quote approvals system. */
  quotes: Array<QuoteNode>;
  raisedOn: Scalars['DateTime'];
  recordOfWork: Maybe<RecordOfWorkNode>;
  /** @deprecated Recurring has been replaced by Preventative Maintenance */
  recurring: Scalars['Boolean'];
  requestType: Maybe<WorkOrderRequestType>;
  requestedTeamMember: Maybe<UserNode>;
  requestedVendor: Maybe<VendorOrganizationNode>;
  /** Name of the anonymous user submitting WO */
  requestorName: Maybe<Scalars['String']>;
  reviews: Array<WorkOrderReviewNode>;
  scheduledForEnd: Maybe<Scalars['DateTime']>;
  scheduledForStart: Maybe<Scalars['DateTime']>;
  scheduledOn: Maybe<Scalars['DateTime']>;
  scopeOfWork: Maybe<Scalars['String']>;
  serviceCategory: ServiceCategory;
  serviceGuaranteed: Scalars['Boolean'];
  sourcingPartsHold: Maybe<SourcingPartsHold>;
  spend: Maybe<Scalars['Decimal']>;
  spendApproval: Maybe<SpendApprovalNode>;
  status: WorkOrderStatus;
  statusDescription: Scalars['String'];
  /** @deprecated Replaced with service category */
  subcategory: CategoryNode;
  submittedBy: Maybe<UserNode>;
  submittedToMarketplaceAt: Maybe<Scalars['DateTime']>;
  submittedToMarketplaceBy: Maybe<UserNode>;
  suggestedMarkup: SuggestedMarkup;
  symptom: Maybe<TaxonomySymptomNode>;
  symptomDiscoveryPath: Maybe<Array<Scalars['String']>>;
  taxonomyNode: Maybe<TaxonomyNodeNode>;
  teamMemberAssignments: Array<WorkOrderTeamMemberAssignmentNode>;
  title: Scalars['String'];
  troubleshootingSession: Maybe<TroubleshootingSessionNode>;
  unresolvedRuleViolations: Maybe<RuleViolationsNode>;
  upcomingAppointment: Maybe<AppointmentNode>;
  vendor: Maybe<VendorOrganizationNode>;
  vendorComments: Maybe<Scalars['String']>;
  vendorDispatch: Maybe<VendorDispatchNode>;
  vendorDueAtDate: Maybe<Scalars['DateTime']>;
  vendorImages: Array<ImageNode>;
  vendorPaidAt: Maybe<Scalars['DateTime']>;
  vendorPayoutStatus: Maybe<WorkOrderVendorPayoutStatus>;
  vendorRecommendations: Scalars['String'];
  vendorStatus: WorkOrderVendorStatus;
};


export type WorkOrderNodeCanArgs = {
  perform: WorkOrderPermission;
};

export type WorkOrderNodeConnection = {
  __typename: 'WorkOrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderNode` and its cursor. */
export type WorkOrderNodeEdge = {
  __typename: 'WorkOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderNode>;
};

export type WorkOrderNoteNode = Node & {
  __typename: 'WorkOrderNoteNode';
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID'];
  message: Scalars['String'];
  sourceUserType: NoteSource;
  workOrderId: Scalars['Int'];
};

export type WorkOrderNoteNodeConnection = {
  __typename: 'WorkOrderNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderNoteNode` and its cursor. */
export type WorkOrderNoteNodeEdge = {
  __typename: 'WorkOrderNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderNoteNode>;
};

export enum WorkOrderPermission {
  ApproveInvoices = 'APPROVE_INVOICES',
  AssignToTeamMember = 'ASSIGN_TO_TEAM_MEMBER',
  BlockAp = 'BLOCK_AP',
  CancelJob = 'CANCEL_JOB',
  ChooseVendor = 'CHOOSE_VENDOR',
  CompleteJob = 'COMPLETE_JOB',
  CreateCallback = 'CREATE_CALLBACK',
  DisputeInvoices = 'DISPUTE_INVOICES',
  EditJob = 'EDIT_JOB',
  EditMatchingDetails = 'EDIT_MATCHING_DETAILS',
  Escalate = 'ESCALATE',
  ForceCompleteJob = 'FORCE_COMPLETE_JOB',
  HoldJob = 'HOLD_JOB',
  PayInvoices = 'PAY_INVOICES',
  ReassignVendor = 'REASSIGN_VENDOR',
  RegenerateInvoices = 'REGENERATE_INVOICES',
  RemoveHold = 'REMOVE_HOLD',
  ReviewJob = 'REVIEW_JOB',
  ScheduleAppointment = 'SCHEDULE_APPOINTMENT',
  StartJob = 'START_JOB',
  SubmitToMarketplace = 'SUBMIT_TO_MARKETPLACE',
  UnapproveInvoices = 'UNAPPROVE_INVOICES',
  UnblockAp = 'UNBLOCK_AP',
  VendorAddAttachments = 'VENDOR_ADD_ATTACHMENTS'
}

export type WorkOrderPointOfContactInput = {
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type WorkOrderPointOfContactNode = Node & {
  __typename: 'WorkOrderPointOfContactNode';
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  orgType: Scalars['String'];
  phoneNumber: Scalars['String'];
  user: Maybe<UserNode>;
};

export type WorkOrderPriorityNode = Node & {
  __typename: 'WorkOrderPriorityNode';
  expectedResolutionDuration: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  isEmergency: Scalars['Boolean'];
  name: Scalars['String'];
  shouldWarnForOvertime: Scalars['Boolean'];
};


export type WorkOrderPriorityNodeShouldWarnForOvertimeArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  referenceTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type WorkOrderPriorityNodeConnection = {
  __typename: 'WorkOrderPriorityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderPriorityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderPriorityNode` and its cursor. */
export type WorkOrderPriorityNodeEdge = {
  __typename: 'WorkOrderPriorityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderPriorityNode>;
};

/** An enumeration. */
export enum WorkOrderRequestType {
  AssignToStaffMember = 'ASSIGN_TO_STAFF_MEMBER',
  Emergency = 'EMERGENCY',
  Quote = 'QUOTE',
  Repair = 'REPAIR'
}

export type WorkOrderReviewFeedbackNode = Node & {
  __typename: 'WorkOrderReviewFeedbackNode';
  comment: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  isPositive: Scalars['Boolean'];
};

export type WorkOrderReviewFeedbackNodeConnection = {
  __typename: 'WorkOrderReviewFeedbackNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderReviewFeedbackNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WorkOrderReviewFeedbackNode` and its cursor. */
export type WorkOrderReviewFeedbackNodeEdge = {
  __typename: 'WorkOrderReviewFeedbackNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderReviewFeedbackNode>;
};

export type WorkOrderReviewNode = Node & {
  __typename: 'WorkOrderReviewNode';
  comment: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserNode;
  feedback: Array<WorkOrderReviewFeedbackNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  satisfied: Maybe<Scalars['Boolean']>;
  skipped: Scalars['Boolean'];
  workOrder: WorkOrderNode;
};

export type WorkOrderReviewNodeConnection = {
  __typename: 'WorkOrderReviewNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderReviewNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderReviewNode` and its cursor. */
export type WorkOrderReviewNodeEdge = {
  __typename: 'WorkOrderReviewNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderReviewNode>;
};

export enum WorkOrderStatus {
  Assigned = 'ASSIGNED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** @deprecated Deprecated in favour of cancelled_on timestamp. */
  Cancelled = 'CANCELLED',
  ClientAssigned = 'CLIENT_ASSIGNED',
  ClientRejected = 'CLIENT_REJECTED',
  ClientResolved = 'CLIENT_RESOLVED',
  ClientTriage = 'CLIENT_TRIAGE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  NotYetCompleted = 'NOT_YET_COMPLETED',
  NotYetScanned = 'NOT_YET_SCANNED',
  NotYetScheduled = 'NOT_YET_SCHEDULED',
  Open = 'OPEN',
  WaitingForCoordinatorApproval = 'WAITING_FOR_COORDINATOR_APPROVAL',
  WaitingForFmApproval = 'WAITING_FOR_FM_APPROVAL',
  WaitingForVmApproval = 'WAITING_FOR_VM_APPROVAL'
}

export type WorkOrderStatusSuggestion = {
  __typename: 'WorkOrderStatusSuggestion';
  completedAt: Maybe<Scalars['DateTime']>;
  isCompleted: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  scheduledAtEnd: Maybe<Scalars['DateTime']>;
  scheduledAtStart: Maybe<Scalars['DateTime']>;
};

export type WorkOrderTaskListItemNode = Node & {
  __typename: 'WorkOrderTaskListItemNode';
  checked: Scalars['Boolean'];
  content: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export type WorkOrderTeamMemberAssignmentNode = Node & {
  __typename: 'WorkOrderTeamMemberAssignmentNode';
  assignedUser: UserNode;
  can: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  notes: Scalars['String'];
  outcome: Maybe<WorkOrderTeamMemberAssignmentOutcome>;
  photos: Array<WorkOrderTeamMemberAssignmentPhotoNode>;
  resolvedAt: Maybe<Scalars['DateTime']>;
  workOrder: WorkOrderNode;
};


export type WorkOrderTeamMemberAssignmentNodeCanArgs = {
  perform: WorkOrderTeamMemberAssignmentPermission;
};

/** An enumeration. */
export enum WorkOrderTeamMemberAssignmentOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Reassigned = 'REASSIGNED',
  SentToVendor = 'SENT_TO_VENDOR',
  Unresolved = 'UNRESOLVED'
}

export enum WorkOrderTeamMemberAssignmentPermission {
  Complete = 'COMPLETE',
  Reassign = 'REASSIGN'
}

export type WorkOrderTeamMemberAssignmentPhotoNode = Node & {
  __typename: 'WorkOrderTeamMemberAssignmentPhotoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  photo: ImageType;
};

export type WorkOrderVendorEligibilityProfileNode = Node & {
  __typename: 'WorkOrderVendorEligibilityProfileNode';
  createdAt: Scalars['DateTime'];
  deletedAt: Maybe<Scalars['DateTime']>;
  facility: FacilityNode;
  facilityId: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  newClientIncentive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  vendor: VendorOrganizationNode;
  vendorId: Scalars['Int'];
  workOrder: WorkOrderNode;
  workOrderId: Scalars['Int'];
};

export type WorkOrderVendorEligibilityProfileNodeConnection = {
  __typename: 'WorkOrderVendorEligibilityProfileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderVendorEligibilityProfileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A Relay edge containing a `WorkOrderVendorEligibilityProfileNode` and its cursor. */
export type WorkOrderVendorEligibilityProfileNodeEdge = {
  __typename: 'WorkOrderVendorEligibilityProfileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderVendorEligibilityProfileNode>;
};

/** Pseudo-status for vendor payout. */
export enum WorkOrderVendorPayoutStatus {
  AwaitingInvoice = 'AWAITING_INVOICE',
  AwaitingPayout = 'AWAITING_PAYOUT',
  Closed = 'CLOSED',
  Disputed = 'DISPUTED'
}

export enum WorkOrderVendorStatus {
  AwaitingScheduling = 'AWAITING_SCHEDULING',
  Disputed = 'DISPUTED',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  NeedsApproval = 'NEEDS_APPROVAL',
  NeedsInvoice = 'NEEDS_INVOICE',
  Paid = 'PAID',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export type WorkOrdersAwaitingPayment = {
  __typename: 'WorkOrdersAwaitingPayment';
  awaitingPayment: Scalars['Int'];
  overdueCount: Scalars['Int'];
};

export type WorkOrdersByStatus = {
  __typename: 'WorkOrdersByStatus';
  completed: OnDemandAndMaintenancePlanCounts;
  invoiced: OnDemandAndMaintenancePlanCounts;
  onHold: OnDemandAndMaintenancePlanCounts;
  scheduled: OnDemandAndMaintenancePlanCounts;
  submitted: OnDemandAndMaintenancePlanCounts;
};

export type WorkOrdersSubmitted = {
  __typename: 'WorkOrdersSubmitted';
  nonUrgentCount: Scalars['Int'];
  urgentCount: Scalars['Int'];
};

export type SpendApprovalFragment = { __typename: 'SpendApprovalNode', approvedAmount: number, nteRaiseRequestApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'SpendApprovalPermissions', raiseApprovedSpend: boolean } };

export type ActivityFeedEntrySummaryFragment = { __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } };

export type AppointmentSummaryFragment = { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } };

export type BusinessUnitDetailsFragment = { __typename: 'BusinessUnitNode', id: string, name: string, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> };

export type BusinessUnitMembershipSummaryFragment = { __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> };

export type BusinessUnitSummaryFragment = { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> };

export type ClientDetailsFragment = { __typename: 'ClientOrganizationNode', id: string, name: string, trackingId: number, clientStatus: ClientOrganizationStatus | null, hasEssentialsFacilities: boolean | null, canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean, owner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency, paymentTerms: number | null, isAutopay: boolean, operatingCountry: { __typename: 'CountryNode', id: string, code: string | null } }, matchingProfile: { __typename: 'ClientMatchingProfileNode', id: string, favouriteVendorsImported: boolean | null, optedIntoMarketplace: boolean } | null, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, canManage: boolean }>, successOwner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, paymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, invoiceApprovalStrategy: InvoiceApprovalStrategy, paymentMethod: PaymentMethodType } };

export type ClientInvoiceSummaryFragment = { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null };

export type ClientMembershipForQuoteActionFragment = { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> };

export type ClientMembershipPermissionsFragment = { __typename: 'ClientOrganizationMemberNode', canManage: boolean };

export type ClientMembershipSummaryFragment = { __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> };

export type ClientMonthlyStatementSummaryFragment = { __typename: 'ClientMonthlyStatementNode', id: string, createdAt: string, year: number, month: number, agingReportPdfUrl: string | null, transactionSummaryCsvUrl: string | null, businessUnit: { __typename: 'BusinessUnitNode', id: string } };

export type ClientOrganizationPermissionsFragment = { __typename: 'ClientOrganizationNode', canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean };

export type ClientReportDetailsFragment = { __typename: 'ClientReportNode', id: string, reportType: ClientReportType, generatedOn: string, startDate: string, endDate: string, csvUrl: string | null };

export type ClientReportScheduleDetailsFragment = { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null };

export type EquipmentDetailsFragment = { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, isEssentialsEnabled: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } }, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null };

export type EquipmentServiceCountFragment = { __typename: 'EquipmentServiceCount', count: number, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } } };

export type EquipmentSummaryFragment = { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null };

export type EquipmentSummaryShortVersionFragment = { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, shouldUpdateWarranty: boolean, totalSpend: string | null, cost: string | null, historicalSpend: string | null, facility: { __typename: 'FacilityNode', name: string, id: string }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, devices: Array<{ __typename: 'Device', id: string, name: string }>, incidents: Array<{ __typename: 'Incident', id: string }> };

export type FacilityDetailsFragment = { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, status: FacilityStatus, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isEssentialsEnabled: boolean, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isVerified: boolean, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } };

export type Facility_FacilityGroupsField_FacilityGroupFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } };

export type FacilityGroupDetailsFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null };

export type FacilityGroupForSelectionFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } };

export type FacilityGroupMembershipDetailsFragment = { __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> };

export type FacilityGroupSummaryFragment = { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null };

export type FacilityPermissionsFragment = { __typename: 'FacilityNode', canManage: boolean };

export type FacilitySummaryFragment = { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null };

export type ImageSummaryFragment = { __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string };

export type InboundVendorInvoiceSummaryFragment = { __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } };

export type InvitePermissionsFragment = { __typename: 'InviteNode', canCancel: boolean };

export type InviteSummaryFragment = { __typename: 'InviteNode', id: string, firstName: string, lastName: string, phoneNumber: string, emailAddress: string, expiresAt: string | null, hasOnboardingAction: boolean, canCancel: boolean, assignedFacilityGroups: Array<{ __typename: 'FacilityGroupNode', id: string, name: string }>, assignedRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> };

export type InvoiceApprovalSettingsFragment = { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> };

export type MaintenancePlanDetailsFragment = { __typename: 'MaintenancePlanNode', nextWorkOrderCreationDate: string, scopeOfWork: string, serviceFrequencyUnit: MaintenancePlanFrequencyUnit | null, serviceFrequencyValue: number | null, id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null }>, currentWorkOrder: { __typename: 'WorkOrderNode', id: string, completedOn: string | null } | null, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } };

export type MaintenancePlanSummaryFragment = { __typename: 'MaintenancePlanNode', id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, nextWorkOrderCreationDate: string, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } };

export type MaintenancePlanTypeSummaryFragment = { __typename: 'MaintenancePlanTypeNode', id: string, name: string, description: string, defaultServiceFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultServiceFrequencyValue: number | null, defaultBillingFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultBillingFrequencyValue: number | null, defaultVariablePricing: boolean, defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus, serviceCategory: ServiceCategory, image: { __typename: 'ImageType', url: string } };

export type NotificationPreferenceSummaryFragment = { __typename: 'NotificationPreferenceNode', id: string, notificationType: NotificationType, email: boolean, push: boolean, sms: boolean, emailConfigurable: boolean, pushConfigurable: boolean, smsConfigurable: boolean, emailImplemented: boolean, pushImplemented: boolean, smsImplemented: boolean };

export type PaymentMethodSummaryFragment = { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isVerified: boolean, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null };

export type PeriodicSpendComparisonFragment = { __typename: 'PeriodicSpendComparison', spendAmount: string, differencePercent: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type QuoteAcceptanceSettingsFragment = { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> };

export type QuoteApprovalThresholdSummaryFragment = { __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> };

export type QuoteSetDetailsFragment = { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } };

export type QuoteSetOptionDetailsFragment = { __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } };

export type QuoteSummaryFragment = { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null };

export type ReviewFeedbackFragment = { __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string, isPositive: boolean };

export type ReviewRequestFragment = { __typename: 'ReviewRequestNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, correlationId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, timezone: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } };

export type RoleDetailsFragment = { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number };

export type RoleSummaryFragment = { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number };

export type SkillDetailsFragment = { __typename: 'SkillNode', id: string, description: string };

export type SpendByPeriodFragment = { __typename: 'SpendByPeriod', spendAmount: string, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type SpendByServiceCategoryFragment = { __typename: 'SpendByServiceCategory', serviceCategory: ServiceCategory, spendAmount: string };

export type TopSpendFacilitiesFragment = { __typename: 'TopSpendFacilities', facilityName: string, spendAmount: string, percentDifference: string };

export type TopSpendWorkOrdersFragment = { __typename: 'TopSpendWorkOrders', spendAmount: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, completedOn: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } };

export type UninvoicedByPeriodFragment = { __typename: 'UninvoicedByPeriod', count: number, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type UserDetailsFragment = { __typename: 'UserNode', id: string, accountType: AccountType, firstName: string, lastName: string, username: string, email: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, title: string | null }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> }>, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } }> };

export type UserSummaryFragment = { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } };

export type VendorDispatchFragment = { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> };

export type VendorDispatchRequestFragment = { __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } };

export type VendorSummaryFragment = { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> };

export type VisitReviewRequestFragment = { __typename: 'VisitReviewRequestNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, serviceCategory: ServiceCategory, isEssentials: boolean, facility: { __typename: 'FacilityNode', id: string, timezone: string, name: string } }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null };

export type WorkOrderClientInvoicesApprovalSummaryFragment = { __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } };

export type WorkOrderDetailsFragment = { __typename: 'WorkOrderNode', id: string, correlationId: string | null, status: WorkOrderStatus, clientStatus: ClientWorkOrderStatus, isCyov: boolean, isEssentials: boolean, onHold: boolean, holdReason: WorkOrderHoldReason | null, raisedOn: string, submittedToMarketplaceAt: string | null, code: string, title: string, requestorName: string | null, description: string, completedOn: string | null, isUnderWarranty: boolean, isSuspectedCallback: boolean, disputedOn: string | null, currency: Currency, serviceCategory: ServiceCategory, symptomDiscoveryPath: Array<string> | null, cancelledOn: string | null, expenseType: ExpenseType | null, externalReferenceNumber: string | null, facilityAccessInfo: string | null, requestType: WorkOrderRequestType | null, firstVisitExpectedArrivalTime: string | null, firstVisitSchedulingNotes: string, canPay: boolean, canApproveInvoices: boolean, canDispute: boolean, canSubmitToMarketplace: boolean, canAssignToTeamMember: boolean, canCancelWorkOrder: boolean, canChooseVendor: boolean, canReassignVendor: boolean, canScheduleAppointment: boolean, canEditGeneralDetails: boolean, canEditMatchingDetails: boolean, canEscalate: boolean, canCreateCallback: boolean, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, submittedToMarketplaceBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null, images: Array<{ __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, overtimeApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null, vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } | null, quotes: Array<{ __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }>, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string, code: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null, clientInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, status: ClientInvoiceStatus, dueAtDate: string, pdfUrl: string | null, total: number, currency: Currency, outstandingAmount: string }> | null, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, inboundVendorInvoices: Array<{ __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } }>, activityFeedEntries: Array<{ __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }>, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, symptom: { __typename: 'TaxonomySymptomNode', id: string, description: string } | null, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string } | null, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, pointOfContact: { __typename: 'WorkOrderPointOfContactNode', id: string, fullName: string, phoneNumber: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null } | null, requestedVendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, requestedTeamMember: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, callbackOriginalWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, callbackWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline, label: string, isValid: boolean | null, expectedArrivalTimestamp: string | null, validatedAt: string | null } | null, clientRuleViolations: { __typename: 'RuleViolationsNode', id: string, violations: Array<RuleBroken>, reason: string | null, feedback: { __typename: 'RuleViolationsFeedbackNode', id: string, isPositive: boolean, comment: string | null } | null } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, outcome: InternalRequestOutcome | null, closedAt: string | null, deletedPreventativeMaintenanceTitle: string | null, closedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, currentAppointment: { __typename: 'InternalAppointmentNode', id: string, date: string } | null, preventativeMaintenance: { __typename: 'PreventativeMaintenanceNode', id: string, title: string } | null, taskListAttachments: Array<{ __typename: 'AttachmentNode', id: string, url: string, createdAt: string, label: string, fileContentType: string, file: { __typename: 'FileType', key: string } | null }>, taskListUrls: Array<{ __typename: 'AttachedUrlNode', id: string, url: string, label: string }>, tasks: Array<{ __typename: 'WorkOrderTaskListItemNode', id: string, checked: boolean, content: string, order: number }>, completion: { __typename: 'InternalRequestCompletionNode', id: string, duration: number, cost: string | null, additionalNotes: string | null, completionDate: string | null, incompleteTaskNotes: string | null, photos: Array<{ __typename: 'InternalRequestCompletionPhotoNode', id: string, photo: string }> } | null } | null };

export type WorkOrderForSpendReportingFragment = { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null };

export type WorkOrderReviewFragment = { __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> };

export type WorkOrderSummaryFragment = { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, vendor: { __typename: 'VendorOrganizationNode', name: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null };

export type WorkOrderTeamMemberAssignmentDetailsFragment = { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> };

export type WorkOrderTeamMemberAssignmentPhotoDetailsFragment = { __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } };

export type AddEquipmentMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  mainImage?: InputMaybe<Image>;
  modelTagImage?: InputMaybe<Image>;
  location: Scalars['String'];
  serialNo: Scalars['String'];
  modelNo: Scalars['String'];
  manufacturer: Scalars['String'];
  barCode: Scalars['String'];
  installedOn?: InputMaybe<Scalars['Date']>;
  warrantyNotes?: InputMaybe<Scalars['String']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  historicalSpend?: InputMaybe<Scalars['Decimal']>;
}>;


export type AddEquipmentMutationNode = { __typename: 'Mutations', addEquipment: { __typename: 'AddEquipmentMutation', ok: boolean, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } } | null };

export type AddExternalExpenseMutationVariables = Exact<{
  input: AddExternalExpenseMutationInput;
}>;


export type AddExternalExpenseMutationNode = { __typename: 'Mutations', addExternalExpense: { __typename: 'AddExternalExpenseMutationPayload', externalExpense: { __typename: 'SpendItemAllocationNode', id: string } } | null };

export type ApproveQuoteSetOptionForSpendMutationVariables = Exact<{
  input: ApproveQuoteSetOptionForSpendInput;
}>;


export type ApproveQuoteSetOptionForSpendMutationNode = { __typename: 'Mutations', approveQuoteSetOptionForSpend: { __typename: 'ApproveQuoteSetOptionForSpendPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, workOrder: { __typename: 'WorkOrderNode', id: string }, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type ApproveWorkOrderInvoicesMutationVariables = Exact<{
  arguments: ApproveWorkOrderClientInvoicesArguments;
}>;


export type ApproveWorkOrderInvoicesMutationNode = { __typename: 'Mutations', approveWorkOrderInvoices: { __typename: 'ApproveWorkOrderClientInvoicesMutation', ok: boolean } | null };

export type AssignUsersToRoleMutationVariables = Exact<{
  input: AssignUsersToRoleMutationInput;
}>;


export type AssignUsersToRoleMutationNode = { __typename: 'Mutations', assignUsersToRole: { __typename: 'AssignUsersToRoleMutationPayload', ok: boolean } | null };

export type AssignWorkOrderToTeamMemberMutationVariables = Exact<{
  input: AssignWorkOrderToTeamMemberInput;
}>;


export type AssignWorkOrderToTeamMemberMutationNode = { __typename: 'Mutations', assignWorkOrderToTeamMember: { __typename: 'AssignWorkOrderToTeamMemberPayload', workOrder: { __typename: 'WorkOrderNode', id: string, correlationId: string | null, status: WorkOrderStatus, clientStatus: ClientWorkOrderStatus, isCyov: boolean, isEssentials: boolean, onHold: boolean, holdReason: WorkOrderHoldReason | null, raisedOn: string, submittedToMarketplaceAt: string | null, code: string, title: string, requestorName: string | null, description: string, completedOn: string | null, isUnderWarranty: boolean, isSuspectedCallback: boolean, disputedOn: string | null, currency: Currency, serviceCategory: ServiceCategory, symptomDiscoveryPath: Array<string> | null, cancelledOn: string | null, expenseType: ExpenseType | null, externalReferenceNumber: string | null, facilityAccessInfo: string | null, requestType: WorkOrderRequestType | null, firstVisitExpectedArrivalTime: string | null, firstVisitSchedulingNotes: string, canPay: boolean, canApproveInvoices: boolean, canDispute: boolean, canSubmitToMarketplace: boolean, canAssignToTeamMember: boolean, canCancelWorkOrder: boolean, canChooseVendor: boolean, canReassignVendor: boolean, canScheduleAppointment: boolean, canEditGeneralDetails: boolean, canEditMatchingDetails: boolean, canEscalate: boolean, canCreateCallback: boolean, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, submittedToMarketplaceBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null, images: Array<{ __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, overtimeApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null, vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } | null, quotes: Array<{ __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }>, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string, code: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null, clientInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, status: ClientInvoiceStatus, dueAtDate: string, pdfUrl: string | null, total: number, currency: Currency, outstandingAmount: string }> | null, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, inboundVendorInvoices: Array<{ __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } }>, activityFeedEntries: Array<{ __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }>, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, symptom: { __typename: 'TaxonomySymptomNode', id: string, description: string } | null, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string } | null, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, pointOfContact: { __typename: 'WorkOrderPointOfContactNode', id: string, fullName: string, phoneNumber: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null } | null, requestedVendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, requestedTeamMember: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, callbackOriginalWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, callbackWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline, label: string, isValid: boolean | null, expectedArrivalTimestamp: string | null, validatedAt: string | null } | null, clientRuleViolations: { __typename: 'RuleViolationsNode', id: string, violations: Array<RuleBroken>, reason: string | null, feedback: { __typename: 'RuleViolationsFeedbackNode', id: string, isPositive: boolean, comment: string | null } | null } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, outcome: InternalRequestOutcome | null, closedAt: string | null, deletedPreventativeMaintenanceTitle: string | null, closedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, currentAppointment: { __typename: 'InternalAppointmentNode', id: string, date: string } | null, preventativeMaintenance: { __typename: 'PreventativeMaintenanceNode', id: string, title: string } | null, taskListAttachments: Array<{ __typename: 'AttachmentNode', id: string, url: string, createdAt: string, label: string, fileContentType: string, file: { __typename: 'FileType', key: string } | null }>, taskListUrls: Array<{ __typename: 'AttachedUrlNode', id: string, url: string, label: string }>, tasks: Array<{ __typename: 'WorkOrderTaskListItemNode', id: string, checked: boolean, content: string, order: number }>, completion: { __typename: 'InternalRequestCompletionNode', id: string, duration: number, cost: string | null, additionalNotes: string | null, completionDate: string | null, incompleteTaskNotes: string | null, photos: Array<{ __typename: 'InternalRequestCompletionPhotoNode', id: string, photo: string }> } | null } | null } } | null };

export type CancelInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type CancelInviteMutationNode = { __typename: 'Mutations', cancelInvite: { __typename: 'CancelInviteMutation', ok: boolean } | null };

export type CancelWorkOrderMutationVariables = Exact<{
  workOrderId: Scalars['ID'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<WorkOrderCancellationSource>;
  cancelReason?: InputMaybe<WorkOrderCancellationReason>;
  additionalDetails?: InputMaybe<Scalars['String']>;
}>;


export type CancelWorkOrderMutationNode = { __typename: 'Mutations', cancelWorkOrder: { __typename: 'CancelWorkOrderMutation', ok: boolean } | null };

export type ChangePasswordMutationVariables = Exact<{
  arguments: ChangePasswordArguments;
}>;


export type ChangePasswordMutationNode = { __typename: 'Mutations', changePassword: { __typename: 'ChangePasswordMutation', ok: boolean } | null };

export type ChargePaymentMethodMutationVariables = Exact<{
  input: ChargePaymentMethodInput;
}>;


export type ChargePaymentMethodMutationNode = { __typename: 'Mutations', chargePaymentMethod: { __typename: 'ChargePaymentMethodPayload', paymentSubmittedInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null }> | null } | null };

export type CompleteBillingEntityOnboardingStepMutationVariables = Exact<{
  input: CompleteBillingEntityOnboardingStepMutationInput;
}>;


export type CompleteBillingEntityOnboardingStepMutationNode = { __typename: 'Mutations', completeBillingEntityOnboardingStep: { __typename: 'CompleteBillingEntityOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteClientOnboardingMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompleteClientOnboardingMutationNode = { __typename: 'Mutations', completeClientOnboarding: { __typename: 'CompleteClientOnboardingMutation', ok: boolean } | null };

export type CompleteFacilitiesOnboardingStepMutationVariables = Exact<{
  input: CompleteFacilitiesOnboardingStepMutationInput;
}>;


export type CompleteFacilitiesOnboardingStepMutationNode = { __typename: 'Mutations', completeFacilitiesOnboardingStep: { __typename: 'CompleteFacilitiesOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteGetStartedOnboardingStepMutationVariables = Exact<{
  input: CompleteGetStartedOnboardingStepMutationInput;
}>;


export type CompleteGetStartedOnboardingStepMutationNode = { __typename: 'Mutations', completeGetStartedOnboardingStep: { __typename: 'CompleteGetStartedOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteStaffOnboardingStepMutationVariables = Exact<{
  input: CompleteStaffOnboardingStepMutationInput;
}>;


export type CompleteStaffOnboardingStepMutationNode = { __typename: 'Mutations', completeStaffOnboardingStep: { __typename: 'CompleteStaffOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteTroubleshootingSessionMutationVariables = Exact<{
  input: CompleteTroubleshootingSessionMutationInput;
}>;


export type CompleteTroubleshootingSessionMutationNode = { __typename: 'Mutations', completeTroubleshootingSession: { __typename: 'CompleteTroubleshootingSessionMutationPayload', ok: boolean } | null };

export type CompleteWorkOrderMutationVariables = Exact<{
  input: ForceWorkOrderCompletionMutationInput;
}>;


export type CompleteWorkOrderMutationNode = { __typename: 'Mutations', forceWorkOrderCompletion: { __typename: 'ForceWorkOrderCompletionMutationPayload', ok: boolean } | null };

export type CompleteWorkOrderTeamMemberAssignmentMutationVariables = Exact<{
  input: CompleteWorkOrderTeamMemberAssignmentInput;
}>;


export type CompleteWorkOrderTeamMemberAssignmentMutationNode = { __typename: 'Mutations', completeWorkOrderTeamMemberAssignment: { __typename: 'CompleteWorkOrderTeamMemberAssignmentPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type CreateBudgetMutationVariables = Exact<{
  input: CreateBudgetMutationInput;
}>;


export type CreateBudgetMutationNode = { __typename: 'Mutations', createBudget: { __typename: 'CreateBudgetMutationPayload', budget: { __typename: 'BudgetNode', id: string, name: string, endDate: string, startDate: string, description: string } | null } | null };

export type CreateBusinessUnitMutationVariables = Exact<{
  arguments: CreateBusinessUnitArguments;
}>;


export type CreateBusinessUnitMutationNode = { __typename: 'Mutations', createBusinessUnit: { __typename: 'CreateBusinessUnitMutation', businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null };

export type CreateCyovDispatchMutationVariables = Exact<{
  input: CreateCyovDispatchInput;
}>;


export type CreateCyovDispatchMutationNode = { __typename: 'Mutations', createCyovDispatch: { __typename: 'CreateCYOVDispatchPayload', vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } } | null };

export type CreateFacilityMutationVariables = Exact<{
  input: CreateFacilityInput;
}>;


export type CreateFacilityMutationNode = { __typename: 'Mutations', createFacility: { __typename: 'CreateFacilityPayload', facility: { __typename: 'FacilityNode', id: string } } | null };

export type CreateFacilityGroupMutationVariables = Exact<{
  input: CreateFacilityGroupInput;
}>;


export type CreateFacilityGroupMutationNode = { __typename: 'Mutations', createFacilityGroup: { __typename: 'CreateFacilityGroupPayload', facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } } | null };

export type CreateOrUpdateBusinessUnitOnboardingMutationVariables = Exact<{
  input: CreateOrUpdateBusinessUnitOnboardingMutationInput;
}>;


export type CreateOrUpdateBusinessUnitOnboardingMutationNode = { __typename: 'Mutations', createOrUpdateBusinessUnitOnboarding: { __typename: 'CreateOrUpdateBusinessUnitOnboardingMutationPayload', businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutationNode = { __typename: 'Mutations', createRole: { __typename: 'CreateRolePayload', role: { __typename: 'RoleNode', id: string } } | null };

export type CreateTroubleshootingSessionMutationVariables = Exact<{
  input: CreateTroubleshootingSessionMutationInput;
}>;


export type CreateTroubleshootingSessionMutationNode = { __typename: 'Mutations', createTroubleshootingSession: { __typename: 'CreateTroubleshootingSessionMutationPayload', troubleshootingSession: { __typename: 'TroubleshootingSessionNode', id: string, actions: Array<{ __typename: 'TroubleshootingActionNode', id: string, troubleshootingStep: { __typename: 'TroubleshootingStepNode', id: string, order: number, stepDescription: string, supportLink: string } }> } | null } | null };

export type CreateUpdateWorkOrderExpenseTypeMutationVariables = Exact<{
  input: CreateUpdateWorkOrderExpenseTypeMutationInput;
}>;


export type CreateUpdateWorkOrderExpenseTypeMutationNode = { __typename: 'Mutations', createUpdateWorkOrderExpenseType: { __typename: 'CreateUpdateWorkOrderExpenseTypeMutationPayload', workOrderExpenseType: { __typename: 'WorkOrderExpenseTypeNode', id: string, workOrderId: number, expenseType: ExpenseType, expenseTypeSetThrough: ExpenseTypeSetThrough, setBy: { __typename: 'UserNode', id: string } | null } | null } | null };

export type CreateVisitReviewMutationVariables = Exact<{
  visitReviewRequestId: Scalars['ID'];
  outcome: VisitReviewOutcome;
}>;


export type CreateVisitReviewMutationNode = { __typename: 'Mutations', createVisitReview: { __typename: 'CreateVisitReviewMutation', ok: boolean } | null };

export type CreateWorkOrderEscalationMutationVariables = Exact<{
  input: CreateWorkOrderEscalationInput;
}>;


export type CreateWorkOrderEscalationMutationNode = { __typename: 'Mutations', createWorkOrderEscalation: { __typename: 'CreateWorkOrderEscalationPayload', workOrderEscalation: { __typename: 'WorkOrderEscalationNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, canEscalate: boolean }, kustomerWorkOrderEscalation: { __typename: 'KustomerWorkOrderEscalationNode', ticketNumber: string | null, kustomerUrl: string | null } | null } } | null };

export type CreateWorkOrderReviewMutationVariables = Exact<{
  input: CreateWorkOrderReviewArguments;
}>;


export type CreateWorkOrderReviewMutationNode = { __typename: 'Mutations', createWorkOrderReview: { __typename: 'CreateWorkOrderReviewMutation', workOrder: { __typename: 'WorkOrderNode', reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }> } | null } | null };

export type DeactivateFacilityMutationVariables = Exact<{
  input: DeactivateFacilityInput;
}>;


export type DeactivateFacilityMutationNode = { __typename: 'Mutations', deactivateFacility: { __typename: 'DeactivateFacilityPayload', facility: { __typename: 'FacilityNode', id: string, status: FacilityStatus } } | null };

export type DeleteBusinessUnitMutationVariables = Exact<{
  input: DeleteBusinessUnitMutationInput;
}>;


export type DeleteBusinessUnitMutationNode = { __typename: 'Mutations', deleteBusinessUnit: { __typename: 'DeleteBusinessUnitMutationPayload', ok: boolean } | null };

export type DeleteClientReportScheduleMutationVariables = Exact<{
  input: DeleteClientReportScheduleMutationInput;
}>;


export type DeleteClientReportScheduleMutationNode = { __typename: 'Mutations', deleteClientReportSchedule: { __typename: 'DeleteClientReportScheduleMutationPayload', ok: boolean } | null };

export type DeleteFacilityMutationVariables = Exact<{
  input: DeleteFacilityInput;
}>;


export type DeleteFacilityMutationNode = { __typename: 'Mutations', deleteFacility: { __typename: 'DeleteFacilityPayload', facility: { __typename: 'FacilityNode', id: string, status: FacilityStatus } } | null };

export type DeleteFacilityGroupMutationVariables = Exact<{
  input: DeleteFacilityGroupInput;
}>;


export type DeleteFacilityGroupMutationNode = { __typename: 'Mutations', deleteFacilityGroup: { __typename: 'DeleteFacilityGroupPayload', ok: boolean | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutationNode = { __typename: 'Mutations', deleteRole: { __typename: 'DeleteRolePayload', ok: boolean } | null };

export type DisputeWorkOrderMutationVariables = Exact<{
  arguments: DisputeWorkOrderArguments;
}>;


export type DisputeWorkOrderMutationNode = { __typename: 'Mutations', disputeWorkOrder: { __typename: 'DisputeWorkOrderMutation', workOrder: { __typename: 'WorkOrderNode', id: string, correlationId: string | null, status: WorkOrderStatus, clientStatus: ClientWorkOrderStatus, isCyov: boolean, isEssentials: boolean, onHold: boolean, holdReason: WorkOrderHoldReason | null, raisedOn: string, submittedToMarketplaceAt: string | null, code: string, title: string, requestorName: string | null, description: string, completedOn: string | null, isUnderWarranty: boolean, isSuspectedCallback: boolean, disputedOn: string | null, currency: Currency, serviceCategory: ServiceCategory, symptomDiscoveryPath: Array<string> | null, cancelledOn: string | null, expenseType: ExpenseType | null, externalReferenceNumber: string | null, facilityAccessInfo: string | null, requestType: WorkOrderRequestType | null, firstVisitExpectedArrivalTime: string | null, firstVisitSchedulingNotes: string, canPay: boolean, canApproveInvoices: boolean, canDispute: boolean, canSubmitToMarketplace: boolean, canAssignToTeamMember: boolean, canCancelWorkOrder: boolean, canChooseVendor: boolean, canReassignVendor: boolean, canScheduleAppointment: boolean, canEditGeneralDetails: boolean, canEditMatchingDetails: boolean, canEscalate: boolean, canCreateCallback: boolean, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, submittedToMarketplaceBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null, images: Array<{ __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, overtimeApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null, vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } | null, quotes: Array<{ __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }>, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string, code: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null, clientInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, status: ClientInvoiceStatus, dueAtDate: string, pdfUrl: string | null, total: number, currency: Currency, outstandingAmount: string }> | null, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, inboundVendorInvoices: Array<{ __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } }>, activityFeedEntries: Array<{ __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }>, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, symptom: { __typename: 'TaxonomySymptomNode', id: string, description: string } | null, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string } | null, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, pointOfContact: { __typename: 'WorkOrderPointOfContactNode', id: string, fullName: string, phoneNumber: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null } | null, requestedVendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, requestedTeamMember: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, callbackOriginalWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, callbackWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline, label: string, isValid: boolean | null, expectedArrivalTimestamp: string | null, validatedAt: string | null } | null, clientRuleViolations: { __typename: 'RuleViolationsNode', id: string, violations: Array<RuleBroken>, reason: string | null, feedback: { __typename: 'RuleViolationsFeedbackNode', id: string, isPositive: boolean, comment: string | null } | null } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, outcome: InternalRequestOutcome | null, closedAt: string | null, deletedPreventativeMaintenanceTitle: string | null, closedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, currentAppointment: { __typename: 'InternalAppointmentNode', id: string, date: string } | null, preventativeMaintenance: { __typename: 'PreventativeMaintenanceNode', id: string, title: string } | null, taskListAttachments: Array<{ __typename: 'AttachmentNode', id: string, url: string, createdAt: string, label: string, fileContentType: string, file: { __typename: 'FileType', key: string } | null }>, taskListUrls: Array<{ __typename: 'AttachedUrlNode', id: string, url: string, label: string }>, tasks: Array<{ __typename: 'WorkOrderTaskListItemNode', id: string, checked: boolean, content: string, order: number }>, completion: { __typename: 'InternalRequestCompletionNode', id: string, duration: number, cost: string | null, additionalNotes: string | null, completionDate: string | null, incompleteTaskNotes: string | null, photos: Array<{ __typename: 'InternalRequestCompletionPhotoNode', id: string, photo: string }> } | null } | null } } | null };

export type EditClientMembershipDetailsMutationVariables = Exact<{
  clientId: Scalars['ID'];
  membershipId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  businessUnitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type EditClientMembershipDetailsMutationNode = { __typename: 'Mutations', EditClientMembershipDetails: { __typename: 'EditClientOrganizationMemberMutation', member: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> } } | null };

export type EditClientOrganizationMemberMutationVariables = Exact<{
  clientOrganizationId: Scalars['ID'];
  memberId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  businessUnitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type EditClientOrganizationMemberMutationNode = { __typename: 'Mutations', editClientOrganizationMember: { __typename: 'EditClientOrganizationMemberMutation', member: { __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> } } | null };

export type EditClientVendorRelationshipInviteMutationVariables = Exact<{
  input: EditClientVendorRelationshipInviteInput;
}>;


export type EditClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', editClientVendorRelationshipInvite: { __typename: 'EditClientVendorRelationshipInvitePayload', invite: { __typename: 'InviteNode', id: string } } | null };

export type EditEquipmentMutationVariables = Exact<{
  equipmentId: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  mainImage?: InputMaybe<Image>;
  modelTagImage?: InputMaybe<Image>;
  location: Scalars['String'];
  serialNo: Scalars['String'];
  modelNo: Scalars['String'];
  manufacturer: Scalars['String'];
  barCode: Scalars['String'];
  installedOn?: InputMaybe<Scalars['Date']>;
  warrantyNotes?: InputMaybe<Scalars['String']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  cost?: InputMaybe<Scalars['Decimal']>;
  historicalSpend?: InputMaybe<Scalars['Decimal']>;
}>;


export type EditEquipmentMutationNode = { __typename: 'Mutations', editEquipment: { __typename: 'EditEquipmentMutation', ok: boolean, equipment: { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, isEssentialsEnabled: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } }, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null } } | null };

export type GetInboundVendorInvoiceValidationQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
  invoiceFile: Scalars['String'];
}>;


export type GetInboundVendorInvoiceValidationQueryNode = { __typename: 'Query', inboundVendorInvoiceValidation: { __typename: 'InboundVendorInvoiceValidationNode', validationResult: { __typename: 'InboundVendorInvoiceValidationResult', validationMessage: string, canOverride: boolean } | null } | null };

export type InviteMemberToClientOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  emailAddress: Scalars['String'];
  assignedFacilityGroupIds: Array<Scalars['ID']> | Scalars['ID'];
  assignedRoleIds: Array<Scalars['ID']> | Scalars['ID'];
  sendInvite?: InputMaybe<Scalars['Boolean']>;
  noExpiry?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  inviteType?: InputMaybe<InviteType>;
}>;


export type InviteMemberToClientOrganizationMutationNode = { __typename: 'Mutations', inviteMemberToClientOrganization: { __typename: 'InviteMemberToClientOrganizationMutation', invite: { __typename: 'InviteNode', id: string } } | null };

export type InviteOwnerToOnboardingMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  isResqEssentials?: InputMaybe<Scalars['Boolean']>;
}>;


export type InviteOwnerToOnboardingMutationNode = { __typename: 'Mutations', inviteOwnerToOnboarding: { __typename: 'InviteOwnerToOnboardingMutation', ok: boolean } | null };

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables = Exact<{
  input: MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput;
}>;


export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode = { __typename: 'Mutations', markWorkOrderTeamMemberAssignmentAsUnresolved: { __typename: 'MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables = Exact<{
  input: CompleteInternalRequestTeamMemberAssignmentInput;
}>;


export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode = { __typename: 'Mutations', completeInternalRequestTeamMemberAssignment: { __typename: 'CompleteInternalRequestTeamMemberAssignmentPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type ReassignWorkOrderToTeamMemberMutationVariables = Exact<{
  input: ReassignWorkOrderToTeamMemberInput;
}>;


export type ReassignWorkOrderToTeamMemberMutationNode = { __typename: 'Mutations', reassignWorkOrderToTeamMember: { __typename: 'ReassignWorkOrderToTeamMemberPayload', newAssignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type ReassignWorkOrderVendorMutationVariables = Exact<{
  input: ReassignWorkOrderVendorInput;
}>;


export type ReassignWorkOrderVendorMutationNode = { __typename: 'Mutations', reassignWorkOrderVendor: { __typename: 'ReassignWorkOrderVendorPayload', newWorkOrder: { __typename: 'WorkOrderNode', id: string } } | null };

export type RejectQuoteSetMutationVariables = Exact<{
  input: RejectQuoteSetInput;
}>;


export type RejectQuoteSetMutationNode = { __typename: 'Mutations', rejectQuoteSet: { __typename: 'RejectQuoteSetPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type RejectQuoteSetOptionForSpendMutationVariables = Exact<{
  input: RejectQuoteSetOptionForSpendInput;
}>;


export type RejectQuoteSetOptionForSpendMutationNode = { __typename: 'Mutations', rejectQuoteSetOptionForSpend: { __typename: 'RejectQuoteSetOptionForSpendPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type RemoveUserFromClientOrganizationMutationVariables = Exact<{
  clientOrganizationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveUserFromClientOrganizationMutationNode = { __typename: 'Mutations', removeUserFromClientOrganization: { __typename: 'RemoveUserFromClientOrganizationMutation', ok: boolean } | null };

export type RemoveUsersFromRoleMutationVariables = Exact<{
  input: RemoveUsersFromRoleMutationInput;
}>;


export type RemoveUsersFromRoleMutationNode = { __typename: 'Mutations', removeUsersFromRole: { __typename: 'RemoveUsersFromRoleMutationPayload', ok: boolean } | null };

export type RequestDispatchChangesMutationVariables = Exact<{
  input: RequestDispatchChangesMutationInput;
}>;


export type RequestDispatchChangesMutationNode = { __typename: 'Mutations', requestDispatchChanges: { __typename: 'RequestDispatchChangesMutationPayload', ok: boolean } | null };

export type RequestPlannedMaintenanceQuoteMutationVariables = Exact<{
  input: RequestPlannedMaintenanceQuoteMutationInput;
}>;


export type RequestPlannedMaintenanceQuoteMutationNode = { __typename: 'Mutations', requestPlannedMaintenanceQuote: { __typename: 'RequestPlannedMaintenanceQuoteMutationPayload', ok: boolean } | null };

export type RescheduleAppointmentMutationVariables = Exact<{
  input: RescheduleAppointmentInput;
}>;


export type RescheduleAppointmentMutationNode = { __typename: 'Mutations', rescheduleAppointment: { __typename: 'RescheduleAppointmentPayload', appointment: { __typename: 'AppointmentNode', id: string } } | null };

export type ResendClientVendorRelationshipInviteMutationVariables = Exact<{
  input: ResendClientVendorRelationshipInviteInput;
}>;


export type ResendClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', resendClientVendorRelationshipInvite: { __typename: 'ResendClientVendorRelationshipInvitePayload', invite: { __typename: 'InviteNode', id: string } } | null };

export type RevokeClientVendorRelationshipInviteMutationVariables = Exact<{
  input: RevokeClientVendorRelationshipInviteInput;
}>;


export type RevokeClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', revokeClientVendorRelationshipInvite: { __typename: 'RevokeClientVendorRelationshipInvitePayload', ok: boolean } | null };

export type SelectQuoteSetOptionMutationVariables = Exact<{
  input: SelectQuoteSetOptionInput;
}>;


export type SelectQuoteSetOptionMutationNode = { __typename: 'Mutations', selectQuoteSetOption: { __typename: 'SelectQuoteSetOptionPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, workOrder: { __typename: 'WorkOrderNode', id: string }, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type SendInviteSmsMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type SendInviteSmsMutationNode = { __typename: 'Mutations', sendInviteSms: { __typename: 'SendInviteSMSMutation', ok: boolean } | null };

export type SetNotificationPreferenceMutationVariables = Exact<{
  input: SetNotificationPreferenceInput;
}>;


export type SetNotificationPreferenceMutationNode = { __typename: 'Mutations', setNotificationPreference: { __typename: 'SetNotificationPreferencePayload', notificationPreference: { __typename: 'NotificationPreferenceNode', id: string, notificationType: NotificationType, email: boolean, push: boolean, sms: boolean, emailConfigurable: boolean, pushConfigurable: boolean, smsConfigurable: boolean, emailImplemented: boolean, pushImplemented: boolean, smsImplemented: boolean } } | null };

export type SetUserNotificationPreferenceMutationVariables = Exact<{
  input: SetUserNoficationPreferenceMutationInput;
}>;


export type SetUserNotificationPreferenceMutationNode = { __typename: 'Mutations', setUserNotificationPreference: { __typename: 'SetUserNoficationPreferenceMutationPayload', userNotificationPreference: { __typename: 'UserNotificationPreferenceNode', id: string, email: boolean | null, push: boolean | null, sms: boolean | null } } | null };

export type SetupPreAuthorizedDebitMutationVariables = Exact<{
  input: SetupPreAuthorizedDebitMutationInput;
}>;


export type SetupPreAuthorizedDebitMutationNode = { __typename: 'Mutations', setupPreAuthorizedDebit: { __typename: 'SetupPreAuthorizedDebitMutationPayload', clientSecret: string } | null };

export type SnoozeReviewsMutationVariables = Exact<{
  input: SnoozeReviewsInput;
}>;


export type SnoozeReviewsMutationNode = { __typename: 'Mutations', snoozeReviews: { __typename: 'SnoozeReviewsPayload', ok: boolean | null } | null };

export type SubmitQuoteFeedbackMutationVariables = Exact<{
  arguments: SubmitQuoteFeedbackArguments;
}>;


export type SubmitQuoteFeedbackMutationNode = { __typename: 'Mutations', submitQuoteFeedback: { __typename: 'SubmitQuoteFeedbackMutation', quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null } } | null };

export type UpdateBusinessUnitMutationVariables = Exact<{
  arguments: UpdateBusinessUnitArguments;
}>;


export type UpdateBusinessUnitMutationNode = { __typename: 'Mutations', updateBusinessUnit: { __typename: 'UpdateBusinessUnitMutation', businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } } | null };

export type UpdateClientReportScheduleMutationVariables = Exact<{
  input: UpdateClientReportScheduleMutationInput;
}>;


export type UpdateClientReportScheduleMutationNode = { __typename: 'Mutations', updateClientReportSchedule: { __typename: 'UpdateClientReportScheduleMutationPayload', schedule: { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null } } | null };

export type UpdateFacilityMutationVariables = Exact<{
  arguments: UpdateFacilityArguments;
}>;


export type UpdateFacilityMutationNode = { __typename: 'Mutations', updateFacility: { __typename: 'UpdateFacilityMutation', facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, status: FacilityStatus, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isEssentialsEnabled: boolean, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isVerified: boolean, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } } } | null };

export type UpdateFacilityGroupMutationVariables = Exact<{
  input: UpdateFacilityGroupInput;
}>;


export type UpdateFacilityGroupMutationNode = { __typename: 'Mutations', updateFacilityGroup: { __typename: 'UpdateFacilityGroupPayload', facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } } | null };

export type UpdateInternalRequestTeamMemberAssignmentsMutationVariables = Exact<{
  input: UpdateInternalRequestTeamMemberAssignmentsInput;
}>;


export type UpdateInternalRequestTeamMemberAssignmentsMutationNode = { __typename: 'Mutations', updateInternalRequestTeamMemberAssignments: { __typename: 'UpdateInternalRequestTeamMemberAssignmentsPayload', internalRequest: { __typename: 'InternalRequestNode', id: string } } | null };

export type UpdateInvoiceApprovalSettingsMutationVariables = Exact<{
  input: UpdateInvoiceApprovalSettingsInput;
}>;


export type UpdateInvoiceApprovalSettingsMutationNode = { __typename: 'Mutations', updateInvoiceApprovalSettings: { __typename: 'UpdateInvoiceApprovalSettingsPayload', invoiceApprovalSettings: { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> } } | null };

export type UpdateQuoteAcceptanceSettingsMutationVariables = Exact<{
  input: UpdateQuoteAcceptanceSettingsInput;
}>;


export type UpdateQuoteAcceptanceSettingsMutationNode = { __typename: 'Mutations', updateQuoteAcceptanceSettings: { __typename: 'UpdateQuoteAcceptanceSettingsPayload', quoteAcceptanceSettings: { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } } | null };

export type UpdateQuoteApprovalThresholdsMutationVariables = Exact<{
  input: UpdateQuoteApprovalThresholdsInput;
}>;


export type UpdateQuoteApprovalThresholdsMutationNode = { __typename: 'Mutations', updateQuoteApprovalThresholds: { __typename: 'UpdateQuoteApprovalThresholdsPayload', ok: boolean } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutationNode = { __typename: 'Mutations', updateRole: { __typename: 'UpdateRolePayload', role: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number } } | null };

export type UpdateTroubleshootingActionMutationVariables = Exact<{
  input: UpdateTroubleshootingActionMutationInput;
}>;


export type UpdateTroubleshootingActionMutationNode = { __typename: 'Mutations', updateTroubleshootingAction: { __typename: 'UpdateTroubleshootingActionMutationPayload', ok: boolean } | null };

export type UpdateWorkOrderNteMutationVariables = Exact<{
  input: UpdateWorkOrderNteInput;
}>;


export type UpdateWorkOrderNteMutationNode = { __typename: 'Mutations', updateWorkOrderNte: { __typename: 'UpdateWorkOrderNTEPayload', spendApproval: { __typename: 'SpendApprovalNode', id: string, approvedAmount: number } } | null };

export type UploadAfterImagesMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  images: Array<InputMaybe<Image>> | InputMaybe<Image>;
}>;


export type UploadAfterImagesMutationNode = { __typename: 'Mutations', uploadAfterImages: { __typename: 'UploadAfterImagesMutation', ok: boolean } | null };

export type UploadVendorInvoiceMutationVariables = Exact<{
  input: UploadVendorInvoiceInput;
}>;


export type UploadVendorInvoiceMutationNode = { __typename: 'Mutations', uploadVendorInvoice: { __typename: 'UploadVendorInvoicePayload', inboundVendorInvoice: { __typename: 'InboundVendorInvoiceNode', workOrder: { __typename: 'WorkOrderNode', id: string }, invoiceFile: { __typename: 'FileType', key: string } } } | null };

export type CreateUpdateExternalReferenceMutationVariables = Exact<{
  input: CreateUpdateExternalReferenceMutationInput;
}>;


export type CreateUpdateExternalReferenceMutationNode = { __typename: 'Mutations', createUpdateExternalReference: { __typename: 'CreateUpdateExternalReferenceMutationPayload', ok: boolean | null } | null };

export type DetermineTroubleshootingPlanQueryVariables = Exact<{
  clientId: Scalars['ID'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']>;
  taxonomyId?: InputMaybe<Scalars['ID']>;
}>;


export type DetermineTroubleshootingPlanQueryNode = { __typename: 'Query', determineTroubleshootingPlan: { __typename: 'DetermineTroubleshootingPlanNode', id: string, troubleshootingPlan: { __typename: 'TroubleshootingPlanNode', id: string, troubleshootingSteps: Array<{ __typename: 'TroubleshootingStepNode', id: string, order: number, stepDescription: string, supportLink: string } | null> } | null } | null };

export type GetActivityFeedEntriesQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetActivityFeedEntriesQueryNode = { __typename: 'Query', activityFeed: { __typename: 'ActivityFeedEntryNodeConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'ActivityFeedEntryNodeEdge', node: { __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null } | null> } | null };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAppointmentQueryNode = { __typename: 'Query', appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null }, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null };

export type GetBusinessUnitDetailsQueryVariables = Exact<{
  businessUnitId: Scalars['ID'];
}>;


export type GetBusinessUnitDetailsQueryNode = { __typename: 'Query', businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } | null };

export type GetBusinessUnitsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBusinessUnitsQueryNode = { __typename: 'Query', businessUnits: { __typename: 'BusinessUnitNodeConnection', totalCount: number, edges: Array<{ __typename: 'BusinessUnitNodeEdge', node: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null> } | null };

export type GetCanWorkOrderBeForceCompletedQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetCanWorkOrderBeForceCompletedQueryNode = { __typename: 'Query', workOrder: { __typename: 'WorkOrderNode', canBeForceCompleted: boolean } | null };

export type GetCitiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  provinceId: Scalars['ID'];
  first: Scalars['Int'];
}>;


export type GetCitiesQueryNode = { __typename: 'Query', cities: { __typename: 'CityNodeConnection', edges: Array<{ __typename: 'CityNodeEdge', node: { __typename: 'CityNode', id: string, name: string } | null } | null> } | null };

export type GetClientDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClientDetailsQueryNode = { __typename: 'Query', clientOrganization: { __typename: 'ClientOrganizationNode', id: string, name: string, trackingId: number, clientStatus: ClientOrganizationStatus | null, hasEssentialsFacilities: boolean | null, canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean, owner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency, paymentTerms: number | null, isAutopay: boolean, operatingCountry: { __typename: 'CountryNode', id: string, code: string | null } }, matchingProfile: { __typename: 'ClientMatchingProfileNode', id: string, favouriteVendorsImported: boolean | null, optedIntoMarketplace: boolean } | null, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, canManage: boolean }>, successOwner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, paymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, invoiceApprovalStrategy: InvoiceApprovalStrategy, paymentMethod: PaymentMethodType } } | null };

export type GetClientFeaturesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
  businessUnitId?: InputMaybe<Scalars['ID']>;
  facilityId?: InputMaybe<Scalars['ID']>;
}>;


export type GetClientFeaturesQueryNode = { __typename: 'Query', clientFeatures: Array<ClientFeature | null> | null };

export type GetClientInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  clientOrganizationId: Scalars['ID'];
  businessUnitId?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status?: InputMaybe<Array<ClientInvoiceStatus> | ClientInvoiceStatus>;
  serviceCategory?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionInvoice?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']>;
  expenseTypes?: InputMaybe<Array<InputMaybe<ExpenseType>> | InputMaybe<ExpenseType>>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isDisputed?: InputMaybe<Scalars['Boolean']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  dueAtDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetClientInvoicesQueryNode = { __typename: 'Query', clientInvoices: { __typename: 'ClientInvoiceNodeConnection', totalCount: number, total: string, edges: Array<{ __typename: 'ClientInvoiceNodeEdge', node: { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetClientMembershipsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  onlyColleaguesOfUser?: InputMaybe<Scalars['Boolean']>;
  excludeClientUsersWithResqEmails?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<Array<Permission> | Permission>;
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetClientMembershipsQueryNode = { __typename: 'Query', clientMemberships: { __typename: 'ClientOrganizationMemberNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientOrganizationMemberNodeEdge', node: { __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> } | null } | null> } | null };

export type GetClientMetricsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  lastPeriodStart?: InputMaybe<Scalars['DateTime']>;
  lastPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  serviceTypes?: InputMaybe<Array<ServiceType> | ServiceType>;
  serviceCategories?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  userTz?: InputMaybe<Scalars['String']>;
}>;


export type GetClientMetricsQueryNode = { __typename: 'Query', clientMetrics: { __typename: 'ClientMetricsNode', clientId: string, spendThisPeriod: string, combinedSpend: Array<{ __typename: 'SpendByPeriod', spendAmount: string, period: { __typename: 'MetricsPeriod', start: string, end: string } }>, combinedUninvoiced: Array<{ __typename: 'UninvoicedByPeriod', count: number, period: { __typename: 'MetricsPeriod', start: string, end: string } }>, serviceCategorySpend: Array<{ __typename: 'SpendByServiceCategory', serviceCategory: ServiceCategory, spendAmount: string }>, mostServicedEquipment: Array<{ __typename: 'EquipmentServiceCount', count: number, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } } }>, lastMonthSpendComparison: { __typename: 'PeriodicSpendComparison', spendAmount: string, differencePercent: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } }, topSpendWorkOrders: Array<{ __typename: 'TopSpendWorkOrders', spendAmount: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, completedOn: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } }>, topSpendFacilities: Array<{ __typename: 'TopSpendFacilities', facilityName: string, spendAmount: string, percentDifference: string }>, averageMonthlyFacilitySpend: Array<{ __typename: 'AverageMonthlyFacilitySpend', date: string, avgRepairSpend: string, avgMpSpend: string }>, workOrdersAwaitingPayment: { __typename: 'WorkOrdersAwaitingPayment', overdueCount: number, awaitingPayment: number } } | null };

export type GetClientOrganizationMembersQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  onlyColleaguesOfUser?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetClientOrganizationMembersQueryNode = { __typename: 'Query', clientOrganizationMembers: { __typename: 'ClientOrganizationMemberNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientOrganizationMemberNodeEdge', node: { __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> } | null } | null> } | null };

export type GetClientPerformanceMetricsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  serviceTypes?: InputMaybe<Array<ServiceType> | ServiceType>;
  serviceCategories?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
}>;


export type GetClientPerformanceMetricsQueryNode = { __typename: 'Query', clientMetrics: { __typename: 'ClientMetricsNode', clientId: string, quotesAwaitingClientApproval: number, invoicesAwaitingClientApproval: number, workOrdersAwaitingTriage: number, workOrdersCompleted: number, transactingFacilities: number, workOrdersSubmitted: { __typename: 'WorkOrdersSubmitted', urgentCount: number, nonUrgentCount: number }, averageSchedulingSpeed: { __typename: 'AverageSchedulingSpeed', hasData: boolean, months: number, days: number, hours: number, minutes: number }, reviewSummary: { __typename: 'ReviewSummary', goodReviewCount: number, badReviewCount: number, goodReviewTags: Array<string>, badReviewTags: Array<string> }, workOrdersByStatus: { __typename: 'WorkOrdersByStatus', submitted: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, scheduled: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, onHold: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, completed: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, invoiced: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number } }, workOrdersByCategory: Array<{ __typename: 'ServiceCategoryCount', serviceCategory: ServiceCategory, count: number }> } | null };

export type GetClientReportSchedulesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetClientReportSchedulesQueryNode = { __typename: 'Query', clientReportSchedules: { __typename: 'ClientReportScheduleNodeConnection', edges: Array<{ __typename: 'ClientReportScheduleNodeEdge', node: { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null } | null } | null> } | null };

export type GetClientReportsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  reportType?: InputMaybe<Array<InputMaybe<ClientReportType>> | InputMaybe<ClientReportType>>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetClientReportsQueryNode = { __typename: 'Query', clientReports: { __typename: 'ClientReportNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientReportNodeEdge', node: { __typename: 'ClientReportNode', id: string, reportType: ClientReportType, generatedOn: string, startDate: string, endDate: string, csvUrl: string | null } | null } | null> } | null };

export type GetClientStatementsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  businessUnitId: Scalars['ID'];
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetClientStatementsQueryNode = { __typename: 'Query', clientStatements: { __typename: 'ClientMonthlyStatementNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientMonthlyStatementNodeEdge', node: { __typename: 'ClientMonthlyStatementNode', id: string, createdAt: string, year: number, month: number, agingReportPdfUrl: string | null, transactionSummaryCsvUrl: string | null, businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null } | null> } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQueryNode = { __typename: 'Query', countries: { __typename: 'CountryNodeConnection', edges: Array<{ __typename: 'CountryNodeEdge', node: { __typename: 'CountryNode', id: string, name: string, code: string | null } | null } | null> } | null };

export type GetClientPreferredSpendThresholdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  serviceCategory: ServiceCategory;
}>;


export type GetClientPreferredSpendThresholdQueryNode = { __typename: 'Query', clientPreferredSpendThreshold: { __typename: 'ClientPreferredSpendThresholdNode', approvalRequiredThreshold: number, approvalRequiredOvertimeThreshold: number } | null };

export type GetDisabledFacilityCategoriesQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type GetDisabledFacilityCategoriesQueryNode = { __typename: 'Query', facility: { __typename: 'FacilityNode', id: string, disabledCategories: Array<ServiceCategory> } | null };

export type GetEquipmentQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  serviceStartDate?: InputMaybe<Scalars['Date']>;
  serviceEndDate?: InputMaybe<Scalars['Date']>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
}>;


export type GetEquipmentQueryNode = { __typename: 'Query', equipments: { __typename: 'EquipmentNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentNodeEdge', node: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetEquipmentDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEquipmentDetailsQueryNode = { __typename: 'Query', equipment: { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, isEssentialsEnabled: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } }, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null } | null };

export type GetEquipmentShortVersionQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  serviceStartDate?: InputMaybe<Scalars['Date']>;
  serviceEndDate?: InputMaybe<Scalars['Date']>;
  hasOngoingIncident?: InputMaybe<Scalars['Boolean']>;
  hasSensor?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
  incidentStatus?: InputMaybe<Array<IncidentStatus> | IncidentStatus>;
}>;


export type GetEquipmentShortVersionQueryNode = { __typename: 'Query', equipments: { __typename: 'EquipmentNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentNodeEdge', node: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, shouldUpdateWarranty: boolean, totalSpend: string | null, cost: string | null, historicalSpend: string | null, facility: { __typename: 'FacilityNode', name: string, id: string }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, devices: Array<{ __typename: 'Device', id: string, name: string }>, incidents: Array<{ __typename: 'Incident', id: string }> } | null } | null> } | null };

export type GetEquipmentSymptomsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEquipmentSymptomsQueryNode = { __typename: 'Query', equipment: { __typename: 'EquipmentNode', id: string, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }> } | null };

export type GetEquipmentWorkOrdersQueryVariables = Exact<{
  equipmentId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetEquipmentWorkOrdersQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null> } | null };

export type GetExpenseTypePermissionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetExpenseTypePermissionsQueryNode = { __typename: 'Query', clientOrganization: { __typename: 'ClientOrganizationNode', id: string, canUpdateExpenseType: boolean } | null };

export type GetFacilitiesQueryVariables = Exact<{
  clientId: Scalars['ID'];
  businessUnitId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['ID']>;
}>;


export type GetFacilitiesQueryNode = { __typename: 'Query', facilities: { __typename: 'FacilityNodeConnection', totalCount: number, edges: Array<{ __typename: 'FacilityNodeEdge', node: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } | null> } | null };

export type GetFacilityDetailsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type GetFacilityDetailsQueryNode = { __typename: 'Query', facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, status: FacilityStatus, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isEssentialsEnabled: boolean, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isVerified: boolean, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } } | null };

export type GetFacilityGroupAllMembershipsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFacilityGroupAllMembershipsQueryNode = { __typename: 'Query', facilityGroup: { __typename: 'FacilityGroupNode', id: string, allMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } | null };

export type GetFacilityGroupsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
  excludeLeaf?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFacilityGroupsQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } | null } | null> } | null };

export type GetFacilityGroupsForBudgetCreationQueryVariables = Exact<{
  clientId: Scalars['ID'];
  isRoot?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
}>;


export type GetFacilityGroupsForBudgetCreationQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> } | null } | null> } | null };

export type FacilityGroupForBudgetCreationFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> };

export type GetFacilityGroupsForSelectionQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetFacilityGroupsForSelectionQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', pageInfo: { __typename: 'PageInfo', endCursor: string | null }, edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } | null } | null> } | null };

export type GetInvitesQueryVariables = Exact<{
  clientId: Scalars['ID'];
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetInvitesQueryNode = { __typename: 'Query', invites: { __typename: 'InviteNodeConnection', totalCount: number, edges: Array<{ __typename: 'InviteNodeEdge', node: { __typename: 'InviteNode', id: string, firstName: string, lastName: string, phoneNumber: string, emailAddress: string, expiresAt: string | null, hasOnboardingAction: boolean, canCancel: boolean, assignedFacilityGroups: Array<{ __typename: 'FacilityGroupNode', id: string, name: string }>, assignedRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> } | null } | null> } | null };

export type GetInvoiceApprovalSettingsQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type GetInvoiceApprovalSettingsQueryNode = { __typename: 'Query', invoiceApprovalSettings: { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> } | null };

export type InvoicePaymentsPreviewQueryVariables = Exact<{
  workOrderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InvoicePaymentsPreviewQueryNode = { __typename: 'Query', invoicePaymentsPreview: { __typename: 'InvoicePaymentPreview', total: string, invoiceCount: string, workOrderCount: number, creditCardPreviews: Array<{ __typename: 'CreditCardPaymentPreview', total: string, creditCardLastFour: string, brand: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null, eftPreviews: Array<{ __typename: 'PreAuthorizedDebitPreview', total: string, accountNumberLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null, achPreviews: Array<{ __typename: 'PreAuthorizedDebitPreview', total: string, accountNumberLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null } | null };

export type InvoicePaymentsPreviewPreEftQueryVariables = Exact<{
  workOrderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InvoicePaymentsPreviewPreEftQueryNode = { __typename: 'Query', invoicePaymentsPreview: { __typename: 'InvoicePaymentPreview', total: string, invoiceCount: string, creditCardPreviews: Array<{ __typename: 'CreditCardPaymentPreview', total: string, creditCardLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null } | null };

export type GetMaintenancePlanDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMaintenancePlanDetailsQueryNode = { __typename: 'Query', maintenancePlan: { __typename: 'MaintenancePlanNode', nextWorkOrderCreationDate: string, scopeOfWork: string, serviceFrequencyUnit: MaintenancePlanFrequencyUnit | null, serviceFrequencyValue: number | null, id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null }>, currentWorkOrder: { __typename: 'WorkOrderNode', id: string, completedOn: string | null } | null, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } } | null };

export type GetMaintenancePlanTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenancePlanTypesQueryNode = { __typename: 'Query', maintenancePlanTypes: { __typename: 'MaintenancePlanTypeNodeConnection', edges: Array<{ __typename: 'MaintenancePlanTypeNodeEdge', node: { __typename: 'MaintenancePlanTypeNode', id: string, name: string, description: string, defaultServiceFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultServiceFrequencyValue: number | null, defaultBillingFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultBillingFrequencyValue: number | null, defaultVariablePricing: boolean, defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus, serviceCategory: ServiceCategory, image: { __typename: 'ImageType', url: string } } | null } | null> } | null };

export type GetMaintenancePlansQueryVariables = Exact<{
  clientId: Scalars['ID'];
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  maintenancePlanTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetMaintenancePlansQueryNode = { __typename: 'Query', maintenancePlans: { __typename: 'MaintenancePlanNodeConnection', totalCount: number, edges: Array<{ __typename: 'MaintenancePlanNodeEdge', node: { __typename: 'MaintenancePlanNode', id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, nextWorkOrderCreationDate: string, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } } | null } | null> } | null };

export type GetManufacturersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetManufacturersQueryNode = { __typename: 'Query', equipmentManufacturers: { __typename: 'EquipmentManufacturerNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentManufacturerNodeEdge', node: { __typename: 'EquipmentManufacturerNode', id: string, name: string } | null } | null> } | null };

export type GetNotificationPreferencesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetNotificationPreferencesQueryNode = { __typename: 'Query', notificationPreferences: { __typename: 'NotificationPreferenceNodeConnection', totalCount: number, edges: Array<{ __typename: 'NotificationPreferenceNodeEdge', node: { __typename: 'NotificationPreferenceNode', id: string, notificationType: NotificationType, email: boolean, push: boolean, sms: boolean, emailConfigurable: boolean, pushConfigurable: boolean, smsConfigurable: boolean, emailImplemented: boolean, pushImplemented: boolean, smsImplemented: boolean } | null } | null> } | null };

export type GetOvertimeStatusQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type GetOvertimeStatusQueryNode = { __typename: 'Query', overtimeStatus: { __typename: 'OvertimeStatus', isOvertime: boolean } | null };

export type GetPaymentMethodsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetPaymentMethodsQueryNode = { __typename: 'Query', paymentMethods: { __typename: 'PaymentMethodNodeConnection', totalCount: number, edges: Array<{ __typename: 'PaymentMethodNodeEdge', node: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isVerified: boolean, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null } | null> } | null };

export type GetProvincesQueryVariables = Exact<{
  countryId: Scalars['ID'];
}>;


export type GetProvincesQueryNode = { __typename: 'Query', provinces: { __typename: 'ProvinceNodeConnection', edges: Array<{ __typename: 'ProvinceNodeEdge', node: { __typename: 'ProvinceNode', id: string, code: string | null, name: string } | null } | null> } | null };

export type GetQuoteAcceptanceSettingsQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type GetQuoteAcceptanceSettingsQueryNode = { __typename: 'Query', quoteAcceptanceSettings: { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> }> } | null };

export type GetQuoteApprovalThresholdsQueryVariables = Exact<{
  clientId: Scalars['ID'];
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  threshold?: InputMaybe<Scalars['Decimal']>;
}>;


export type GetQuoteApprovalThresholdsQueryNode = { __typename: 'Query', quoteApprovalThresholds: { __typename: 'QuoteApprovalThresholdNodeConnection', edges: Array<{ __typename: 'QuoteApprovalThresholdNodeEdge', node: { __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }> } | null } | null> } | null };

export type GetQuoteSetsQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
  statuses: Array<QuoteSetStatus> | QuoteSetStatus;
}>;


export type GetQuoteSetsQueryNode = { __typename: 'Query', quoteSets: { __typename: 'QuoteSetNodeConnection', edges: Array<{ __typename: 'QuoteSetNodeEdge', node: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } | null } | null> } | null };

export type GetReviewRequestsQueryVariables = Exact<{
  workOrder?: InputMaybe<Scalars['ID']>;
  statusIn?: InputMaybe<Array<ReviewRequestStatus> | ReviewRequestStatus>;
  orderBy?: InputMaybe<Scalars['String']>;
  isDueForReminder?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReviewRequestsQueryNode = { __typename: 'Query', reviewRequests: { __typename: 'ReviewRequestNodeConnection', edges: Array<{ __typename: 'ReviewRequestNodeEdge', node: { __typename: 'ReviewRequestNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, correlationId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, timezone: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } } | null } | null> } | null };

export type GetRoleDetailsQueryVariables = Exact<{
  roleId: Scalars['ID'];
}>;


export type GetRoleDetailsQueryNode = { __typename: 'Query', role: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number } | null };

export type GetRolesQueryVariables = Exact<{
  clientId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  onlySubsetOfUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRolesQueryNode = { __typename: 'Query', roles: { __typename: 'RoleNodeConnection', totalCount: number, edges: Array<{ __typename: 'RoleNodeEdge', node: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number } | null } | null> } | null };

export type GetSourcingPartsHoldsQueryVariables = Exact<{
  workOrder: Scalars['ID'];
}>;


export type GetSourcingPartsHoldsQueryNode = { __typename: 'Query', sourcingPartsHolds: { __typename: 'SourcingPartsHoldConnection', edges: Array<{ __typename: 'SourcingPartsHoldEdge', node: { __typename: 'SourcingPartsHold', id: string, partsEstimatedDateStart: string | null, partsEstimatedDateEnd: string | null, permissions: { __typename: 'SourcingPartsHoldPermissions', fulfill: boolean }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } } | null } | null> } | null };

export type GetStripeCustomersQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetStripeCustomersQueryNode = { __typename: 'Query', stripeCustomers: { __typename: 'StripeCustomerNodeConnection', edges: Array<{ __typename: 'StripeCustomerNodeEdge', node: { __typename: 'StripeCustomerNode', id: string, account: StripeAccount } | null } | null> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserQueryNode = { __typename: 'Query', user: { __typename: 'UserNode', id: string, accountType: AccountType, firstName: string, lastName: string, username: string, email: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, title: string | null }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> }>, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } }> } | null };

export type GetUserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationPreferencesQueryNode = { __typename: 'Query', userNotificationPreferences: { __typename: 'UserNotificationPreferenceConnection', totalCount: number, edges: Array<{ __typename: 'UserNotificationPreferenceEdge', node: { __typename: 'UserNotificationPreferenceNode', id: string, notificationName: string, email: boolean | null, push: boolean | null, sms: boolean | null, emailConfigurable: boolean | null, pushConfigurable: boolean | null, smsConfigurable: boolean | null, emailImplemented: boolean | null, pushImplemented: boolean | null, smsImplemented: boolean | null } | null } | null> } | null };

export type GetUserSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserSummaryQueryNode = { __typename: 'Query', user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null };

export type GetVisitReviewRequestsQueryVariables = Exact<{
  appointment?: InputMaybe<Scalars['ID']>;
  statusIn?: InputMaybe<Array<VisitReviewRequestStatus> | VisitReviewRequestStatus>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetVisitReviewRequestsQueryNode = { __typename: 'Query', visitReviewRequests: { __typename: 'VisitReviewRequestNodeConnection', edges: Array<{ __typename: 'VisitReviewRequestNodeEdge', node: { __typename: 'VisitReviewRequestNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, serviceCategory: ServiceCategory, isEssentials: boolean, facility: { __typename: 'FacilityNode', id: string, timezone: string, name: string } }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } | null } | null> } | null };

export type GetVisitsQueryVariables = Exact<{
  workOrder: Scalars['ID'];
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetVisitsQueryNode = { __typename: 'Query', visits: { __typename: 'VisitNodeConnection', edges: Array<{ __typename: 'VisitNodeEdge', node: { __typename: 'VisitNode', id: string, startedAt: string, endedAt: string | null, facilityManagerName: string | null, notes: string, recommendations: string, outcome: VisitOutcome | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null, visitedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, beforeImages: Array<{ __typename: 'ImageNode', id: string, url: string }>, afterImages: Array<{ __typename: 'ImageNode', id: string, url: string }> } | null } | null> } | null };

export type GetWorkOrderActivitiesQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetWorkOrderActivitiesQueryNode = { __typename: 'Query', activities: { __typename: 'ActivityConnection', edges: Array<{ __typename: 'ActivityEdge', node: { __typename: 'AppointmentActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } } | { __typename: 'ApproveQuoteActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'ChooseVendorActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'CreateQuoteActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'DispatchActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'OnHoldActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'ResqReviewActivity', reviewType: ResqReviewActivityReviewType, id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'SchedulingActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'SiteVisitActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | { __typename: 'SourcingPartsActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string } | null } | null> } | null };

export type GetWorkOrderCancellationDetailQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetWorkOrderCancellationDetailQueryNode = { __typename: 'Query', workOrderCancellationDetail: { __typename: 'WorkOrderCancellationDetailNodeConnection', edges: Array<{ __typename: 'WorkOrderCancellationDetailNodeEdge', node: { __typename: 'WorkOrderCancellationDetailNode', id: string, cancelReason: WorkOrderCancellationReason | null } | null } | null> } | null };

export type GetWorkOrderClientInvoicesQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetWorkOrderClientInvoicesQueryNode = { __typename: 'Query', clientInvoices: { __typename: 'ClientInvoiceNodeConnection', edges: Array<{ __typename: 'ClientInvoiceNodeEdge', node: { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetWorkOrderDetailsQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetWorkOrderDetailsQueryNode = { __typename: 'Query', workOrder: { __typename: 'WorkOrderNode', id: string, correlationId: string | null, status: WorkOrderStatus, clientStatus: ClientWorkOrderStatus, isCyov: boolean, isEssentials: boolean, onHold: boolean, holdReason: WorkOrderHoldReason | null, raisedOn: string, submittedToMarketplaceAt: string | null, code: string, title: string, requestorName: string | null, description: string, completedOn: string | null, isUnderWarranty: boolean, isSuspectedCallback: boolean, disputedOn: string | null, currency: Currency, serviceCategory: ServiceCategory, symptomDiscoveryPath: Array<string> | null, cancelledOn: string | null, expenseType: ExpenseType | null, externalReferenceNumber: string | null, facilityAccessInfo: string | null, requestType: WorkOrderRequestType | null, firstVisitExpectedArrivalTime: string | null, firstVisitSchedulingNotes: string, canPay: boolean, canApproveInvoices: boolean, canDispute: boolean, canSubmitToMarketplace: boolean, canAssignToTeamMember: boolean, canCancelWorkOrder: boolean, canChooseVendor: boolean, canReassignVendor: boolean, canScheduleAppointment: boolean, canEditGeneralDetails: boolean, canEditMatchingDetails: boolean, canEscalate: boolean, canCreateCallback: boolean, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, submittedToMarketplaceBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null, images: Array<{ __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, overtimeApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null, vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } | null, quotes: Array<{ __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }>, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string, code: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null, clientInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, status: ClientInvoiceStatus, dueAtDate: string, pdfUrl: string | null, total: number, currency: Currency, outstandingAmount: string }> | null, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, inboundVendorInvoices: Array<{ __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } }>, activityFeedEntries: Array<{ __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }>, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, symptom: { __typename: 'TaxonomySymptomNode', id: string, description: string } | null, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string } | null, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, pointOfContact: { __typename: 'WorkOrderPointOfContactNode', id: string, fullName: string, phoneNumber: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null } | null, requestedVendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, requestedTeamMember: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, callbackOriginalWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, callbackWorkOrder: { __typename: 'WorkOrderNode', id: string, code: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline, label: string, isValid: boolean | null, expectedArrivalTimestamp: string | null, validatedAt: string | null } | null, clientRuleViolations: { __typename: 'RuleViolationsNode', id: string, violations: Array<RuleBroken>, reason: string | null, feedback: { __typename: 'RuleViolationsFeedbackNode', id: string, isPositive: boolean, comment: string | null } | null } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, outcome: InternalRequestOutcome | null, closedAt: string | null, deletedPreventativeMaintenanceTitle: string | null, closedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, currentAppointment: { __typename: 'InternalAppointmentNode', id: string, date: string } | null, preventativeMaintenance: { __typename: 'PreventativeMaintenanceNode', id: string, title: string } | null, taskListAttachments: Array<{ __typename: 'AttachmentNode', id: string, url: string, createdAt: string, label: string, fileContentType: string, file: { __typename: 'FileType', key: string } | null }>, taskListUrls: Array<{ __typename: 'AttachedUrlNode', id: string, url: string, label: string }>, tasks: Array<{ __typename: 'WorkOrderTaskListItemNode', id: string, checked: boolean, content: string, order: number }>, completion: { __typename: 'InternalRequestCompletionNode', id: string, duration: number, cost: string | null, additionalNotes: string | null, completionDate: string | null, incompleteTaskNotes: string | null, photos: Array<{ __typename: 'InternalRequestCompletionPhotoNode', id: string, photo: string }> } | null } | null } | null, clientInvoices: { __typename: 'ClientInvoiceNodeConnection', edges: Array<{ __typename: 'ClientInvoiceNodeEdge', node: { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, isEssentialsEnabled: boolean, accessInfo: string, canManage: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, isEssentialsEnabled: boolean, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null } | null> } | null, spendApprovalOnWorkOrder: { __typename: 'SpendApprovalNode', approvedAmount: number, nteRaiseRequestApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'SpendApprovalPermissions', raiseApprovedSpend: boolean } } | null };

export type GetWorkOrderReviewFeedbackItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkOrderReviewFeedbackItemsQueryNode = { __typename: 'Query', workOrderReviewFeedback: { __typename: 'WorkOrderReviewFeedbackNodeConnection', edges: Array<{ __typename: 'WorkOrderReviewFeedbackNodeEdge', node: { __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string, isPositive: boolean } | null } | null> } | null };

export type GetWorkOrderSummaryQueryVariables = Exact<{
  workOrderId: Scalars['ID'];
}>;


export type GetWorkOrderSummaryQueryNode = { __typename: 'Query', workOrder: { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null } | null };

export type GetWorkOrderVendorsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  clientId: Scalars['ID'];
}>;


export type GetWorkOrderVendorsQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null> } | null };

export type GetWorkOrdersQueryVariables = Exact<{
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  clientId: Scalars['ID'];
  status?: InputMaybe<Array<ClientWorkOrderStatus> | ClientWorkOrderStatus>;
  onHold?: InputMaybe<Scalars['Boolean']>;
  holdReason?: InputMaybe<Array<WorkOrderHoldReason> | WorkOrderHoldReason>;
  orderBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  equipment?: InputMaybe<Scalars['ID']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  facility?: InputMaybe<Scalars['ID']>;
  serviceCategory?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']>;
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  isSatisfied?: InputMaybe<Scalars['Boolean']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']>;
  hasActionableQuoteForClient?: InputMaybe<Scalars['ID']>;
  expectedServiceTimeline?: InputMaybe<Array<ExpectedServiceTimeline> | ExpectedServiceTimeline>;
}>;


export type GetWorkOrdersQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, priority: { __typename: 'WorkOrderPriorityNode', id: string, name: string, expectedResolutionDuration: number } | null, vendor: { __typename: 'VendorOrganizationNode', name: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null } | null } | null> } | null };

export type CitySummaryFragment = { __typename: 'CityNode', id: string, name: string };

export type CountrySummaryFragment = { __typename: 'CountryNode', id: string, name: string, code: string | null };

export type ProvinceSummaryFragment = { __typename: 'ProvinceNode', id: string, code: string | null, name: string };

export type RealSessionDetailsFragment = { __typename: 'UserNode', id: string, sourceId: number, accountType: AccountType, username: string, email: string, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string } }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> };

export type SessionClientDetailsFragment = { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } };

export type SessionDetailsFragment = { __typename: 'UserNode', id: string, isActive: boolean, accountType: AccountType, isFinance: boolean, isFinanceSuperuser: boolean, canAccessFinanceTab: boolean, username: string, email: string, phone: string | null, firstName: string, lastName: string, sourceId: number, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, title: string | null, isAnonymous: boolean, confirmationRequired: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> };

export type SessionVendorDetailsFragment = { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string };

export type GetFeatureFlagsQueryVariables = Exact<{
  facilityId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetFeatureFlagsQueryNode = { __typename: 'Query', featureFlags: Array<string> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQueryNode = { __typename: 'Query', me: { __typename: 'UserNode', id: string, isActive: boolean, accountType: AccountType, isFinance: boolean, isFinanceSuperuser: boolean, canAccessFinanceTab: boolean, username: string, email: string, phone: string | null, firstName: string, lastName: string, sourceId: number, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, title: string | null, isAnonymous: boolean, confirmationRequired: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> } | null, realMe: { __typename: 'UserNode', id: string, sourceId: number, accountType: AccountType, username: string, email: string, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string } }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> } | null };

export type GetSchemaHashQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchemaHashQueryNode = { __typename: 'Query', schemaHash: string };

export const UserSummaryFragmentDoc = gql`
    fragment UserSummary on UserNode {
  id
  username
  email
  phone
  firstName
  lastName
  profile {
    id
    avatarBackgroundColor
    avatarTextColor
    phone
    locale
    isAnonymous
  }
}
    `;
export const SpendApprovalFragmentDoc = gql`
    fragment SpendApproval on SpendApprovalNode {
  approvedAmount
  nteRaiseRequestApprovedBy {
    ...UserSummary
  }
  permissions {
    raiseApprovedSpend
  }
}
    ${UserSummaryFragmentDoc}`;
export const CitySummaryFragmentDoc = gql`
    fragment CitySummary on CityNode {
  id
  name
}
    `;
export const ProvinceSummaryFragmentDoc = gql`
    fragment ProvinceSummary on ProvinceNode {
  id
  code
  name
}
    `;
export const CountrySummaryFragmentDoc = gql`
    fragment CountrySummary on CountryNode {
  id
  name
  code
}
    `;
export const FacilityPermissionsFragmentDoc = gql`
    fragment FacilityPermissions on FacilityNode {
  canManage: can(perform: MANAGE)
}
    `;
export const BusinessUnitSummaryFragmentDoc = gql`
    fragment BusinessUnitSummary on BusinessUnitNode {
  id
  name
  billingAddress {
    id
    address
    addressLine2
    cityName
    city {
      ...CitySummary
    }
    province {
      ...ProvinceSummary
    }
    country {
      ...CountrySummary
    }
    postalCode
  }
  memberCount
  facilityCount
  contactName
  contactEmail
  facilities {
    id
    name
  }
  isEssentialsEnabled
}
    ${CitySummaryFragmentDoc}
${ProvinceSummaryFragmentDoc}
${CountrySummaryFragmentDoc}`;
export const FacilitySummaryFragmentDoc = gql`
    fragment FacilitySummary on FacilityNode {
  id
  name
  address
  addressLine2
  phone
  email
  cityName
  city {
    ...CitySummary
  }
  province {
    ...ProvinceSummary
  }
  country {
    ...CountrySummary
  }
  zipCode
  postalCode
  currency
  maintenancePlans {
    id
  }
  timezone
  ...FacilityPermissions
  onsiteHoursJson
  busyHoursJson
  isEssentialsEnabled
  accessInfo
  businessUnit {
    ...BusinessUnitSummary
  }
}
    ${CitySummaryFragmentDoc}
${ProvinceSummaryFragmentDoc}
${CountrySummaryFragmentDoc}
${FacilityPermissionsFragmentDoc}
${BusinessUnitSummaryFragmentDoc}`;
export const RoleSummaryFragmentDoc = gql`
    fragment RoleSummary on RoleNode {
  id
  editable
  name
  permissions
  userCount
}
    `;
export const BusinessUnitMembershipSummaryFragmentDoc = gql`
    fragment BusinessUnitMembershipSummary on BusinessUnitMemberNode {
  id
  user {
    ...UserSummary
  }
  roles {
    ...RoleSummary
  }
}
    ${UserSummaryFragmentDoc}
${RoleSummaryFragmentDoc}`;
export const BusinessUnitDetailsFragmentDoc = gql`
    fragment BusinessUnitDetails on BusinessUnitNode {
  id
  name
  billingAddress {
    id
    address
    addressLine2
    cityName
    city {
      ...CitySummary
    }
    province {
      ...ProvinceSummary
    }
    country {
      ...CountrySummary
    }
    postalCode
  }
  facilities {
    ...FacilitySummary
  }
  members {
    ...BusinessUnitMembershipSummary
  }
  isEssentialsEnabled
}
    ${CitySummaryFragmentDoc}
${ProvinceSummaryFragmentDoc}
${CountrySummaryFragmentDoc}
${FacilitySummaryFragmentDoc}
${BusinessUnitMembershipSummaryFragmentDoc}`;
export const ClientOrganizationPermissionsFragmentDoc = gql`
    fragment ClientOrganizationPermissions on ClientOrganizationNode {
  canManageStaff: can(perform: MANAGE_STAFF)
  canManageBusinessSettings: can(perform: MANAGE_BUSINESS_SETTINGS)
  canAccessStatements: can(perform: ACCESS_STATEMENTS)
  canAccessSubscriptions: can(perform: ACCESS_SUBSCRIPTIONS)
  canSubmitWorkOrder: can(perform: SUBMIT_WORK_ORDER)
  canPay: can(perform: PAY_INVOICE)
  canApprove: can(perform: APPROVE_INVOICES)
  canManageFavouriteVendors: can(perform: MANAGE_FAVOURITE_VENDORS)
  canManagePreventativeMaintenance: can(perform: MANAGE_PREVENTATIVE_MAINTENANCE)
}
    `;
export const ClientDetailsFragmentDoc = gql`
    fragment ClientDetails on ClientOrganizationNode {
  id
  name
  trackingId
  owner {
    ...UserSummary
  }
  billingInformation {
    id
    currency
    operatingCountry {
      id
      code
    }
    paymentTerms
    isAutopay
  }
  matchingProfile {
    id
    favouriteVendorsImported
    optedIntoMarketplace
  }
  facilities {
    id
    name
    ...FacilityPermissions
  }
  clientStatus
  ...ClientOrganizationPermissions
  successOwner {
    ...UserSummary
  }
  hasEssentialsFacilities
  paymentPreference {
    id
    invoiceApprovalStrategy
    paymentMethod
  }
}
    ${UserSummaryFragmentDoc}
${FacilityPermissionsFragmentDoc}
${ClientOrganizationPermissionsFragmentDoc}`;
export const WorkOrderClientInvoicesApprovalSummaryFragmentDoc = gql`
    fragment WorkOrderClientInvoicesApprovalSummary on WorkOrderClientInvoicesApprovalNode {
  id
  user {
    ...UserSummary
  }
}
    ${UserSummaryFragmentDoc}`;
export const ClientInvoiceSummaryFragmentDoc = gql`
    fragment ClientInvoiceSummary on ClientInvoiceNode {
  id
  code
  dueAtDate
  issuedAtDate
  outstandingAmount
  paidAmount
  paidAt
  pdfUrl
  status
  subtotal
  tax
  total
  currency
  expenseType
  externalReferenceNumber
  latestFailureReason
  paymentInitiatedAt
  paymentInitiatedBy {
    ...UserSummary
  }
  businessUnit {
    name
  }
  workOrder {
    id
    code
    facility {
      ...FacilitySummary
    }
    clientInvoicesApprovals {
      ...WorkOrderClientInvoicesApprovalSummary
    }
    vendor {
      id
      name
    }
    serviceCategory
    canApproveInvoices: can(perform: APPROVE_INVOICES)
    canPay: can(perform: PAY_INVOICES)
    needsApproval
    disputedOn
  }
}
    ${UserSummaryFragmentDoc}
${FacilitySummaryFragmentDoc}
${WorkOrderClientInvoicesApprovalSummaryFragmentDoc}`;
export const Facility_FacilityGroupsField_FacilityGroupFragmentDoc = gql`
    fragment Facility_FacilityGroupsField_FacilityGroup on FacilityGroupNode {
  id
  name
  facility {
    ...FacilitySummary
  }
  permissions {
    manage
  }
  parentId
}
    ${FacilitySummaryFragmentDoc}`;
export const ClientMembershipPermissionsFragmentDoc = gql`
    fragment ClientMembershipPermissions on ClientOrganizationMemberNode {
  canManage: can(perform: MANAGE)
}
    `;
export const ClientMembershipSummaryFragmentDoc = gql`
    fragment ClientMembershipSummary on ClientOrganizationMemberNode {
  id
  user {
    ...UserSummary
    facilityGroupMemberships {
      id
      facilityGroup {
        ...Facility_FacilityGroupsField_FacilityGroup
      }
    }
  }
  roles {
    ...RoleSummary
  }
  businessUnits {
    ...BusinessUnitSummary
  }
  ...ClientMembershipPermissions
}
    ${UserSummaryFragmentDoc}
${Facility_FacilityGroupsField_FacilityGroupFragmentDoc}
${RoleSummaryFragmentDoc}
${BusinessUnitSummaryFragmentDoc}
${ClientMembershipPermissionsFragmentDoc}`;
export const ClientMonthlyStatementSummaryFragmentDoc = gql`
    fragment ClientMonthlyStatementSummary on ClientMonthlyStatementNode {
  id
  createdAt
  year
  month
  agingReportPdfUrl
  transactionSummaryCsvUrl
  businessUnit {
    id
  }
}
    `;
export const ClientReportDetailsFragmentDoc = gql`
    fragment ClientReportDetails on ClientReportNode {
  id
  reportType
  generatedOn
  startDate
  endDate
  csvUrl
}
    `;
export const ClientReportScheduleDetailsFragmentDoc = gql`
    fragment ClientReportScheduleDetails on ClientReportScheduleNode {
  id
  frequency
  reportType
  recipientEmailAddresses
  nextReportOn
  lastReportOn
}
    `;
export const EquipmentDetailsFragmentDoc = gql`
    fragment EquipmentDetails on EquipmentNode {
  id
  name
  description
  barCode
  status
  installedOn
  warrantyNotes
  warrantyExpiresOn
  manufacturer
  modelNo
  location
  totalSpend
  historicalSpend
  cost
  facility {
    id
    name
    phone
    timezone
    address
    addressLine2
    cityName
    postalCode
    city {
      id
      name
    }
    province {
      id
      name
    }
    zipCode
    isEssentialsEnabled
  }
  mainImage {
    url
  }
  modelTagImage {
    url
  }
  serialNo
  serviceCategory
  symptoms {
    id
    description
  }
  equipmentCategory {
    id
    name
  }
}
    `;
export const EquipmentServiceCountFragmentDoc = gql`
    fragment EquipmentServiceCount on EquipmentServiceCount {
  equipment {
    id
    name
    barCode
    facility {
      id
      name
    }
  }
  count
}
    `;
export const EquipmentSummaryShortVersionFragmentDoc = gql`
    fragment EquipmentSummaryShortVersion on EquipmentNode {
  id
  name
  barCode
  status
  workOrderCount
  serviceCategory
  facility {
    name
    id
  }
  shouldUpdateWarranty
  equipmentCategory {
    id
    name
  }
  totalSpend
  cost
  historicalSpend
  devices {
    id
    name
  }
  incidents(statusFilter: $incidentStatus) {
    id
  }
}
    `;
export const PaymentMethodSummaryFragmentDoc = gql`
    fragment PaymentMethodSummary on PaymentMethodNode {
  id
  paymentType
  isVerified
  facilityCount
  creditCardPayment {
    id
    brand
    number
    cardholderName
    expiryMonth
    expiryYear
  }
  preAuthorizedDebitPayment {
    id
    bankName
    accountNumber
  }
  achAccountPayment {
    id
    bankName
    accountNumber
    status
  }
}
    `;
export const FacilityDetailsFragmentDoc = gql`
    fragment FacilityDetails on FacilityNode {
  id
  name
  address
  addressLine2
  city {
    ...CitySummary
  }
  cityName
  province {
    ...ProvinceSummary
  }
  country {
    ...CountrySummary
  }
  zipCode
  postalCode
  phone
  email
  businessUnit {
    ...BusinessUnitSummary
  }
  paymentMethod {
    ...PaymentMethodSummary
  }
  ...FacilityPermissions
  status
  group {
    id
    memberships {
      id
      user {
        ...UserSummary
      }
      roles {
        ...RoleSummary
      }
    }
  }
  onsiteHoursJson
  busyHoursJson
  accessInfo
  isEssentialsEnabled
}
    ${CitySummaryFragmentDoc}
${ProvinceSummaryFragmentDoc}
${CountrySummaryFragmentDoc}
${BusinessUnitSummaryFragmentDoc}
${PaymentMethodSummaryFragmentDoc}
${FacilityPermissionsFragmentDoc}
${UserSummaryFragmentDoc}
${RoleSummaryFragmentDoc}`;
export const FacilityGroupMembershipDetailsFragmentDoc = gql`
    fragment FacilityGroupMembershipDetails on FacilityGroupMembershipNode {
  id
  user {
    ...UserSummary
  }
  roles {
    ...RoleSummary
  }
}
    ${UserSummaryFragmentDoc}
${RoleSummaryFragmentDoc}`;
export const FacilityGroupDetailsFragmentDoc = gql`
    fragment FacilityGroupDetails on FacilityGroupNode {
  id
  name
  memberships {
    ...FacilityGroupMembershipDetails
  }
  facility {
    ...FacilitySummary
  }
  parentId
}
    ${FacilityGroupMembershipDetailsFragmentDoc}
${FacilitySummaryFragmentDoc}`;
export const FacilityGroupForSelectionFragmentDoc = gql`
    fragment FacilityGroupForSelection on FacilityGroupNode {
  id
  name
  parentId
  permissions {
    manage
  }
}
    `;
export const InvitePermissionsFragmentDoc = gql`
    fragment InvitePermissions on InviteNode {
  canCancel: can(perform: CANCEL)
}
    `;
export const InviteSummaryFragmentDoc = gql`
    fragment InviteSummary on InviteNode {
  id
  firstName
  lastName
  phoneNumber
  emailAddress
  expiresAt
  assignedFacilityGroups {
    id
    name
  }
  assignedRoles {
    ...RoleSummary
  }
  ...InvitePermissions
  hasOnboardingAction
}
    ${RoleSummaryFragmentDoc}
${InvitePermissionsFragmentDoc}`;
export const InvoiceApprovalSettingsFragmentDoc = gql`
    fragment InvoiceApprovalSettings on InvoiceApprovalSettings {
  approvalRoles {
    ...RoleSummary
  }
  strategy
}
    ${RoleSummaryFragmentDoc}`;
export const MaintenancePlanSummaryFragmentDoc = gql`
    fragment MaintenancePlanSummary on MaintenancePlanNode {
  id
  code
  facility {
    id
    name
  }
  maintenancePlanType {
    id
    name
  }
  name
  billingFrequencyUnit
  billingFrequencyValue
  currency
  price
  variablePricing
  nextWorkOrderCreationDate
}
    `;
export const VendorSummaryFragmentDoc = gql`
    fragment VendorSummary on VendorOrganizationNode {
  id
  name
  profile {
    id
    phone
    email
  }
  invites {
    id
    emailAddress
  }
  tradeQualifications {
    id
    serviceCategory
  }
}
    `;
export const WorkOrderForSpendReportingFragmentDoc = gql`
    fragment WorkOrderForSpendReporting on WorkOrderNode {
  id
  code
  raisedOn
  title
  clientStatus
  completedOn
  spend
  vendor {
    id
    name
  }
}
    `;
export const MaintenancePlanDetailsFragmentDoc = gql`
    fragment MaintenancePlanDetails on MaintenancePlanNode {
  ...MaintenancePlanSummary
  facility {
    ...FacilitySummary
  }
  vendor {
    ...VendorSummary
  }
  workOrders {
    ...WorkOrderForSpendReporting
  }
  currentWorkOrder {
    id
    completedOn
  }
  nextWorkOrderCreationDate
  scopeOfWork
  serviceFrequencyUnit
  serviceFrequencyValue
}
    ${MaintenancePlanSummaryFragmentDoc}
${FacilitySummaryFragmentDoc}
${VendorSummaryFragmentDoc}
${WorkOrderForSpendReportingFragmentDoc}`;
export const MaintenancePlanTypeSummaryFragmentDoc = gql`
    fragment MaintenancePlanTypeSummary on MaintenancePlanTypeNode {
  id
  name
  image {
    url
  }
  description
  defaultServiceFrequencyUnit
  defaultServiceFrequencyValue
  defaultBillingFrequencyUnit
  defaultBillingFrequencyValue
  defaultVariablePricing
  defaultInitialWorkOrderStatus
  serviceCategory
}
    `;
export const NotificationPreferenceSummaryFragmentDoc = gql`
    fragment NotificationPreferenceSummary on NotificationPreferenceNode {
  id
  notificationType
  email
  push
  sms
  emailConfigurable
  pushConfigurable
  smsConfigurable
  emailImplemented
  pushImplemented
  smsImplemented
}
    `;
export const PeriodicSpendComparisonFragmentDoc = gql`
    fragment PeriodicSpendComparison on PeriodicSpendComparison {
  period {
    start
    end
  }
  spendAmount
  differencePercent
}
    `;
export const QuoteApprovalThresholdSummaryFragmentDoc = gql`
    fragment QuoteApprovalThresholdSummary on QuoteApprovalThresholdNode {
  id
  threshold
  roles {
    ...RoleSummary
  }
}
    ${RoleSummaryFragmentDoc}`;
export const QuoteAcceptanceSettingsFragmentDoc = gql`
    fragment QuoteAcceptanceSettings on QuoteAcceptanceSettings {
  selectionRoles {
    ...RoleSummary
  }
  approvalThresholds {
    ...QuoteApprovalThresholdSummary
  }
}
    ${RoleSummaryFragmentDoc}
${QuoteApprovalThresholdSummaryFragmentDoc}`;
export const QuoteSummaryFragmentDoc = gql`
    fragment QuoteSummary on QuoteNode {
  id
  code
  price
  currency
  vendor {
    ...VendorSummary
  }
  pdfFile {
    url
  }
  feedbackCount
  validUntil
  notes
}
    ${VendorSummaryFragmentDoc}`;
export const ClientMembershipForQuoteActionFragmentDoc = gql`
    fragment ClientMembershipForQuoteAction on ClientOrganizationMemberNode {
  id
  user {
    ...UserSummary
  }
  roles {
    id
    name
  }
}
    ${UserSummaryFragmentDoc}`;
export const QuoteSetOptionDetailsFragmentDoc = gql`
    fragment QuoteSetOptionDetails on QuoteSetOptionNode {
  id
  quote {
    ...QuoteSummary
  }
  outcome
  rejectReasons
  approvals {
    id
    approvedAt
    approvedBy {
      ...UserSummary
    }
    approvedByMember {
      ...ClientMembershipForQuoteAction
    }
  }
  approvalNeededRoles {
    id
    name
  }
  createdAt
  selectedAt
  selectedBy {
    ...UserSummary
  }
  selectedByMember {
    ...ClientMembershipForQuoteAction
  }
  rejectedAt
  rejectedBy {
    ...UserSummary
  }
  rejectedByMember {
    ...ClientMembershipForQuoteAction
  }
  permissions {
    select
    actionOnSpend
    selectAndApproveSpend
    provideFeedback
  }
}
    ${QuoteSummaryFragmentDoc}
${UserSummaryFragmentDoc}
${ClientMembershipForQuoteActionFragmentDoc}`;
export const QuoteSetDetailsFragmentDoc = gql`
    fragment QuoteSetDetails on QuoteSetNode {
  id
  status
  options {
    ...QuoteSetOptionDetails
  }
  createdAt
  rejectedAt
  rejectedBy {
    ...UserSummary
  }
  rejectionReason
  expectedPrice
  cancelledAt
  cancelReason
  cancelledBy {
    ...UserSummary
  }
  remainingApprovalSteps
  permissions {
    reject
  }
}
    ${QuoteSetOptionDetailsFragmentDoc}
${UserSummaryFragmentDoc}`;
export const ReviewFeedbackFragmentDoc = gql`
    fragment ReviewFeedback on WorkOrderReviewFeedbackNode {
  id
  comment
  isPositive
}
    `;
export const ReviewRequestFragmentDoc = gql`
    fragment ReviewRequest on ReviewRequestNode {
  id
  vendor {
    id
    name
  }
  workOrder {
    id
    code
    title
    correlationId
    facility {
      id
      name
      timezone
    }
    appointment {
      id
      startsAt
      endsAt
    }
  }
}
    `;
export const RoleDetailsFragmentDoc = gql`
    fragment RoleDetails on RoleNode {
  id
  editable
  name
  permissions
  userCount
}
    `;
export const SkillDetailsFragmentDoc = gql`
    fragment SkillDetails on SkillNode {
  id
  description
}
    `;
export const SpendByPeriodFragmentDoc = gql`
    fragment SpendByPeriod on SpendByPeriod {
  period {
    start
    end
  }
  spendAmount
}
    `;
export const SpendByServiceCategoryFragmentDoc = gql`
    fragment SpendByServiceCategory on SpendByServiceCategory {
  serviceCategory
  spendAmount
}
    `;
export const TopSpendFacilitiesFragmentDoc = gql`
    fragment TopSpendFacilities on TopSpendFacilities {
  facilityName
  spendAmount
  percentDifference
}
    `;
export const TopSpendWorkOrdersFragmentDoc = gql`
    fragment TopSpendWorkOrders on TopSpendWorkOrders {
  workOrder {
    id
    title
    code
    completedOn
    vendor {
      id
      name
    }
  }
  spendAmount
}
    `;
export const UninvoicedByPeriodFragmentDoc = gql`
    fragment UninvoicedByPeriod on UninvoicedByPeriod {
  period {
    start
    end
  }
  count
}
    `;
export const FacilityGroupSummaryFragmentDoc = gql`
    fragment FacilityGroupSummary on FacilityGroupNode {
  id
  name
  facility {
    ...FacilitySummary
  }
}
    ${FacilitySummaryFragmentDoc}`;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on UserNode {
  id
  accountType
  firstName
  lastName
  username
  email
  profile {
    id
    avatarBackgroundColor
    avatarTextColor
    phone
    title
  }
  clientMemberships {
    id
    client {
      id
    }
    roles {
      ...RoleSummary
    }
    businessUnits {
      ...BusinessUnitSummary
    }
    ...ClientMembershipPermissions
  }
  facilityGroupMemberships {
    id
    facilityGroup {
      ...FacilityGroupSummary
    }
  }
}
    ${RoleSummaryFragmentDoc}
${BusinessUnitSummaryFragmentDoc}
${ClientMembershipPermissionsFragmentDoc}
${FacilityGroupSummaryFragmentDoc}`;
export const VisitReviewRequestFragmentDoc = gql`
    fragment VisitReviewRequest on VisitReviewRequestNode {
  id
  workOrder {
    id
    title
    code
    serviceCategory
    isEssentials
    facility {
      id
      timezone
      name
    }
  }
  vendor {
    id
    name
  }
  appointment {
    id
    startsAt
    endsAt
  }
}
    `;
export const EquipmentSummaryFragmentDoc = gql`
    fragment EquipmentSummary on EquipmentNode {
  id
  name
  barCode
  status
  workOrderCount
  status
  serviceCategory
  totalSpend
  historicalSpend
  cost
  facility {
    ...FacilitySummary
  }
  shouldUpdateWarranty
  equipmentCategory {
    id
    name
    taxonomyNode {
      id
      name
    }
  }
}
    ${FacilitySummaryFragmentDoc}`;
export const ImageSummaryFragmentDoc = gql`
    fragment ImageSummary on ImageNode {
  id
  description
  url
  thumbnailUrl: url(width: 120, height: 120)
}
    `;
export const VendorDispatchRequestFragmentDoc = gql`
    fragment VendorDispatchRequest on VendorDispatchRequestNode {
  id
  status
  startedAt
  expectedAcceptanceAt
  declineReason {
    id
    reasonChoice
    otherReason
  }
  vendor {
    ...VendorSummary
    profile {
      id
      phone
    }
  }
}
    ${VendorSummaryFragmentDoc}`;
export const VendorDispatchFragmentDoc = gql`
    fragment VendorDispatch on VendorDispatchNode {
  id
  status
  startedThroughCyov
  startedAt
  requests {
    ...VendorDispatchRequest
  }
}
    ${VendorDispatchRequestFragmentDoc}`;
export const AppointmentSummaryFragmentDoc = gql`
    fragment AppointmentSummary on AppointmentNode {
  id
  startsAt
  endsAt
  fulfilledAt
  cancelledAt
  permissions {
    reschedule
  }
}
    `;
export const InboundVendorInvoiceSummaryFragmentDoc = gql`
    fragment InboundVendorInvoiceSummary on InboundVendorInvoiceNode {
  id
  name
  createdAt
  invoiceFile {
    url
  }
}
    `;
export const ActivityFeedEntrySummaryFragmentDoc = gql`
    fragment ActivityFeedEntrySummary on ActivityFeedEntryNode {
  id
  entryType
  createdAt
  activityDate
  defaultMessage
  parameters
  triggeredBy {
    ...UserSummary
  }
}
    ${UserSummaryFragmentDoc}`;
export const WorkOrderReviewFragmentDoc = gql`
    fragment WorkOrderReview on WorkOrderReviewNode {
  id
  createdAt
  satisfied
  skipped
  comment
  createdBy {
    ...UserSummary
  }
  feedback {
    id
    comment
  }
}
    ${UserSummaryFragmentDoc}`;
export const WorkOrderTeamMemberAssignmentPhotoDetailsFragmentDoc = gql`
    fragment WorkOrderTeamMemberAssignmentPhotoDetails on WorkOrderTeamMemberAssignmentPhotoNode {
  id
  photo {
    url
  }
}
    `;
export const WorkOrderTeamMemberAssignmentDetailsFragmentDoc = gql`
    fragment WorkOrderTeamMemberAssignmentDetails on WorkOrderTeamMemberAssignmentNode {
  id
  assignedUser {
    id
    firstName
    lastName
    username
    email
    phone
    profile {
      id
      avatarBackgroundColor
      avatarTextColor
      locale
      phone
      isAnonymous
    }
    clientMemberships {
      id
      client {
        id
      }
      roles {
        id
        name
      }
    }
  }
  resolvedAt
  outcome
  notes
  photos {
    ...WorkOrderTeamMemberAssignmentPhotoDetails
  }
  canCompleteAssignment: can(perform: COMPLETE)
  canReassignAssignment: can(perform: REASSIGN)
}
    ${WorkOrderTeamMemberAssignmentPhotoDetailsFragmentDoc}`;
export const WorkOrderDetailsFragmentDoc = gql`
    fragment WorkOrderDetails on WorkOrderNode {
  id
  correlationId
  status
  clientStatus
  isCyov
  isEssentials
  onHold
  holdReason
  raisedOn
  submittedBy {
    ...UserSummary
  }
  submittedToMarketplaceAt
  submittedToMarketplaceBy {
    ...UserSummary
  }
  code
  title
  requestorName
  description
  completedOn
  equipment {
    ...EquipmentSummary
  }
  images {
    ...ImageSummary
  }
  facility {
    ...FacilitySummary
  }
  overtimeApprovedBy {
    ...UserSummary
  }
  isUnderWarranty
  isSuspectedCallback
  vendor {
    ...VendorSummary
  }
  vendorDispatch {
    ...VendorDispatch
  }
  quotes {
    ...QuoteSummary
  }
  maintenancePlan {
    id
    code
  }
  disputedOn
  appointment {
    ...AppointmentSummary
  }
  clientInvoices {
    id
    code
    status
    dueAtDate
    pdfUrl
    total
    currency
    outstandingAmount
  }
  clientInvoicesApprovals {
    ...WorkOrderClientInvoicesApprovalSummary
  }
  inboundVendorInvoices {
    ...InboundVendorInvoiceSummary
  }
  activityFeedEntries {
    ...ActivityFeedEntrySummary
  }
  reviews {
    ...WorkOrderReview
  }
  teamMemberAssignments {
    ...WorkOrderTeamMemberAssignmentDetails
  }
  symptom {
    id
    description
  }
  taxonomyNode {
    id
  }
  currency
  serviceCategory
  symptomDiscoveryPath
  cancelledOn
  expenseType
  externalReferenceNumber
  facilityAccessInfo
  priority {
    id
    name
    expectedResolutionDuration
  }
  pointOfContact {
    id
    fullName
    phoneNumber
    user {
      ...UserSummary
    }
  }
  requestType
  requestedVendor {
    id
    name
  }
  requestedTeamMember {
    ...UserSummary
  }
  callbackOriginalWorkOrder {
    id
    code
  }
  callbackWorkOrder {
    id
    code
  }
  expectedServiceTimeline {
    key
    label
    isValid
    expectedArrivalTimestamp
    validatedAt
  }
  firstVisitExpectedArrivalTime
  firstVisitSchedulingNotes
  clientRuleViolations {
    id
    violations
    reason
    feedback {
      id
      isPositive
      comment
    }
  }
  internalRequest {
    id
    outcome
    closedBy {
      ...UserSummary
    }
    closedAt
    currentAppointment {
      id
      date
    }
    preventativeMaintenance {
      id
      title
    }
    deletedPreventativeMaintenanceTitle
    taskListAttachments {
      id
      url
      file {
        key
      }
      createdAt
      label
      fileContentType
    }
    taskListUrls {
      id
      url
      label
    }
    tasks {
      id
      checked
      content
      order
    }
    completion {
      id
      duration
      cost
      additionalNotes
      completionDate
      incompleteTaskNotes
      photos {
        id
        photo
      }
    }
  }
  canPay: can(perform: PAY_INVOICES)
  canApproveInvoices: can(perform: APPROVE_INVOICES)
  canDispute: can(perform: DISPUTE_INVOICES)
  canSubmitToMarketplace: can(perform: SUBMIT_TO_MARKETPLACE)
  canAssignToTeamMember: can(perform: ASSIGN_TO_TEAM_MEMBER)
  canCancelWorkOrder: can(perform: CANCEL_JOB)
  canChooseVendor: can(perform: CHOOSE_VENDOR)
  canReassignVendor: can(perform: REASSIGN_VENDOR)
  canScheduleAppointment: can(perform: SCHEDULE_APPOINTMENT)
  canEditGeneralDetails: can(perform: EDIT_JOB)
  canEditMatchingDetails: can(perform: EDIT_MATCHING_DETAILS)
  canEscalate: can(perform: ESCALATE)
  canCreateCallback: can(perform: CREATE_CALLBACK)
}
    ${UserSummaryFragmentDoc}
${EquipmentSummaryFragmentDoc}
${ImageSummaryFragmentDoc}
${FacilitySummaryFragmentDoc}
${VendorSummaryFragmentDoc}
${VendorDispatchFragmentDoc}
${QuoteSummaryFragmentDoc}
${AppointmentSummaryFragmentDoc}
${WorkOrderClientInvoicesApprovalSummaryFragmentDoc}
${InboundVendorInvoiceSummaryFragmentDoc}
${ActivityFeedEntrySummaryFragmentDoc}
${WorkOrderReviewFragmentDoc}
${WorkOrderTeamMemberAssignmentDetailsFragmentDoc}`;
export const WorkOrderSummaryFragmentDoc = gql`
    fragment WorkOrderSummary on WorkOrderNode {
  id
  code
  raisedOn
  title
  equipment {
    id
    name
  }
  clientStatus
  onHold
  holdReason
  completedOn
  cancelledOn
  coordinator {
    id
    user {
      ...UserSummary
    }
  }
  disputedOn
  submittedToMarketplaceAt
  submittedBy {
    ...UserSummary
  }
  appointment {
    id
    startsAt
    endsAt
    cancelledAt
  }
  facility {
    id
    name
  }
  serviceCategory
  maintenancePlan {
    id
  }
  overtimeApprovedBy {
    id
  }
  teamMemberAssignments {
    ...WorkOrderTeamMemberAssignmentDetails
  }
  priority {
    id
    name
    expectedResolutionDuration
  }
  vendor {
    name
  }
  noteCount
  expectedServiceTimeline {
    key
  }
}
    ${UserSummaryFragmentDoc}
${WorkOrderTeamMemberAssignmentDetailsFragmentDoc}`;
export const FacilityGroupForBudgetCreationFragmentDoc = gql`
    fragment FacilityGroupForBudgetCreation on FacilityGroupNode {
  id
  name
  facility {
    id
    name
    address
  }
  parentId
  children {
    id
  }
}
    `;
export const RealSessionDetailsFragmentDoc = gql`
    fragment RealSessionDetails on UserNode {
  id
  sourceId
  accountType
  username
  email
  firstName
  lastName
  profile {
    id
    avatarBackgroundColor
    avatarTextColor
    phone
    isAnonymous
  }
  clientMemberships {
    id
    client {
      id
      trackingId
      name
    }
  }
  vendorMemberships {
    id
    vendor {
      id
      trackingId
      name
    }
  }
}
    `;
export const SessionClientDetailsFragmentDoc = gql`
    fragment SessionClientDetails on ClientOrganizationNode {
  id
  trackingId
  name
  billingInformation {
    id
    currency
  }
}
    `;
export const SessionVendorDetailsFragmentDoc = gql`
    fragment SessionVendorDetails on VendorOrganizationNode {
  id
  trackingId
  name
}
    `;
export const SessionDetailsFragmentDoc = gql`
    fragment SessionDetails on UserNode {
  id
  isActive
  accountType
  isFinance
  isFinanceSuperuser
  canAccessFinanceTab
  username
  email
  phone
  firstName
  lastName
  sourceId
  profile {
    id
    avatarBackgroundColor
    avatarTextColor
    locale
    phone
    title
    isAnonymous
    confirmationRequired
  }
  clientMemberships {
    id
    client {
      ...SessionClientDetails
    }
    roles {
      id
      name
    }
  }
  vendorMemberships {
    id
    vendor {
      ...SessionVendorDetails
    }
  }
}
    ${SessionClientDetailsFragmentDoc}
${SessionVendorDetailsFragmentDoc}`;
export const AddEquipmentDocument = gql`
    mutation AddEquipment($facilityId: ID!, $name: String!, $description: String!, $mainImage: Image, $modelTagImage: Image, $location: String!, $serialNo: String!, $modelNo: String!, $manufacturer: String!, $barCode: String!, $installedOn: Date, $warrantyNotes: String, $warrantyExpiresOn: Date, $equipmentCategoryId: ID, $historicalSpend: Decimal) {
  addEquipment(
    facilityId: $facilityId
    name: $name
    description: $description
    mainImage: $mainImage
    modelTagImage: $modelTagImage
    location: $location
    serialNo: $serialNo
    modelNo: $modelNo
    manufacturer: $manufacturer
    barCode: $barCode
    installedOn: $installedOn
    warrantyNotes: $warrantyNotes
    warrantyExpiresOn: $warrantyExpiresOn
    equipmentCategoryId: $equipmentCategoryId
    historicalSpend: $historicalSpend
  ) {
    ok
    equipment {
      ...EquipmentSummary
    }
  }
}
    ${EquipmentSummaryFragmentDoc}`;
export type AddEquipmentMutationFn = Apollo.MutationFunction<AddEquipmentMutationNode, AddEquipmentMutationVariables>;

/**
 * __useAddEquipmentMutation__
 *
 * To run a mutation, you first call `useAddEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEquipmentMutation, { data, loading, error }] = useAddEquipmentMutation({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      mainImage: // value for 'mainImage'
 *      modelTagImage: // value for 'modelTagImage'
 *      location: // value for 'location'
 *      serialNo: // value for 'serialNo'
 *      modelNo: // value for 'modelNo'
 *      manufacturer: // value for 'manufacturer'
 *      barCode: // value for 'barCode'
 *      installedOn: // value for 'installedOn'
 *      warrantyNotes: // value for 'warrantyNotes'
 *      warrantyExpiresOn: // value for 'warrantyExpiresOn'
 *      equipmentCategoryId: // value for 'equipmentCategoryId'
 *      historicalSpend: // value for 'historicalSpend'
 *   },
 * });
 */
export function useAddEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<AddEquipmentMutationNode, AddEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEquipmentMutationNode, AddEquipmentMutationVariables>(AddEquipmentDocument, options);
      }
export type AddEquipmentMutationHookResult = ReturnType<typeof useAddEquipmentMutation>;
export type AddEquipmentMutationResult = Apollo.MutationResult<AddEquipmentMutationNode>;
export type AddEquipmentMutationOptions = Apollo.BaseMutationOptions<AddEquipmentMutationNode, AddEquipmentMutationVariables>;
export const AddExternalExpenseDocument = gql`
    mutation AddExternalExpense($input: AddExternalExpenseMutationInput!) {
  addExternalExpense(input: $input) {
    externalExpense {
      id
    }
  }
}
    `;
export type AddExternalExpenseMutationFn = Apollo.MutationFunction<AddExternalExpenseMutationNode, AddExternalExpenseMutationVariables>;

/**
 * __useAddExternalExpenseMutation__
 *
 * To run a mutation, you first call `useAddExternalExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExternalExpenseMutation, { data, loading, error }] = useAddExternalExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExternalExpenseMutation(baseOptions?: Apollo.MutationHookOptions<AddExternalExpenseMutationNode, AddExternalExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExternalExpenseMutationNode, AddExternalExpenseMutationVariables>(AddExternalExpenseDocument, options);
      }
export type AddExternalExpenseMutationHookResult = ReturnType<typeof useAddExternalExpenseMutation>;
export type AddExternalExpenseMutationResult = Apollo.MutationResult<AddExternalExpenseMutationNode>;
export type AddExternalExpenseMutationOptions = Apollo.BaseMutationOptions<AddExternalExpenseMutationNode, AddExternalExpenseMutationVariables>;
export const ApproveQuoteSetOptionForSpendDocument = gql`
    mutation ApproveQuoteSetOptionForSpend($input: ApproveQuoteSetOptionForSpendInput!) {
  approveQuoteSetOptionForSpend(input: $input) {
    quoteSet {
      workOrder {
        id
      }
      ...QuoteSetDetails
    }
  }
}
    ${QuoteSetDetailsFragmentDoc}`;
export type ApproveQuoteSetOptionForSpendMutationFn = Apollo.MutationFunction<ApproveQuoteSetOptionForSpendMutationNode, ApproveQuoteSetOptionForSpendMutationVariables>;

/**
 * __useApproveQuoteSetOptionForSpendMutation__
 *
 * To run a mutation, you first call `useApproveQuoteSetOptionForSpendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveQuoteSetOptionForSpendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveQuoteSetOptionForSpendMutation, { data, loading, error }] = useApproveQuoteSetOptionForSpendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveQuoteSetOptionForSpendMutation(baseOptions?: Apollo.MutationHookOptions<ApproveQuoteSetOptionForSpendMutationNode, ApproveQuoteSetOptionForSpendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveQuoteSetOptionForSpendMutationNode, ApproveQuoteSetOptionForSpendMutationVariables>(ApproveQuoteSetOptionForSpendDocument, options);
      }
export type ApproveQuoteSetOptionForSpendMutationHookResult = ReturnType<typeof useApproveQuoteSetOptionForSpendMutation>;
export type ApproveQuoteSetOptionForSpendMutationResult = Apollo.MutationResult<ApproveQuoteSetOptionForSpendMutationNode>;
export type ApproveQuoteSetOptionForSpendMutationOptions = Apollo.BaseMutationOptions<ApproveQuoteSetOptionForSpendMutationNode, ApproveQuoteSetOptionForSpendMutationVariables>;
export const ApproveWorkOrderInvoicesDocument = gql`
    mutation ApproveWorkOrderInvoices($arguments: ApproveWorkOrderClientInvoicesArguments!) {
  approveWorkOrderInvoices: approveWorkOrderClientInvoices(arguments: $arguments) {
    ok
  }
}
    `;
export type ApproveWorkOrderInvoicesMutationFn = Apollo.MutationFunction<ApproveWorkOrderInvoicesMutationNode, ApproveWorkOrderInvoicesMutationVariables>;

/**
 * __useApproveWorkOrderInvoicesMutation__
 *
 * To run a mutation, you first call `useApproveWorkOrderInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWorkOrderInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWorkOrderInvoicesMutation, { data, loading, error }] = useApproveWorkOrderInvoicesMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useApproveWorkOrderInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ApproveWorkOrderInvoicesMutationNode, ApproveWorkOrderInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveWorkOrderInvoicesMutationNode, ApproveWorkOrderInvoicesMutationVariables>(ApproveWorkOrderInvoicesDocument, options);
      }
export type ApproveWorkOrderInvoicesMutationHookResult = ReturnType<typeof useApproveWorkOrderInvoicesMutation>;
export type ApproveWorkOrderInvoicesMutationResult = Apollo.MutationResult<ApproveWorkOrderInvoicesMutationNode>;
export type ApproveWorkOrderInvoicesMutationOptions = Apollo.BaseMutationOptions<ApproveWorkOrderInvoicesMutationNode, ApproveWorkOrderInvoicesMutationVariables>;
export const AssignUsersToRoleDocument = gql`
    mutation AssignUsersToRole($input: AssignUsersToRoleMutationInput!) {
  assignUsersToRole(input: $input) {
    ok
  }
}
    `;
export type AssignUsersToRoleMutationFn = Apollo.MutationFunction<AssignUsersToRoleMutationNode, AssignUsersToRoleMutationVariables>;

/**
 * __useAssignUsersToRoleMutation__
 *
 * To run a mutation, you first call `useAssignUsersToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUsersToRoleMutation, { data, loading, error }] = useAssignUsersToRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUsersToRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignUsersToRoleMutationNode, AssignUsersToRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUsersToRoleMutationNode, AssignUsersToRoleMutationVariables>(AssignUsersToRoleDocument, options);
      }
export type AssignUsersToRoleMutationHookResult = ReturnType<typeof useAssignUsersToRoleMutation>;
export type AssignUsersToRoleMutationResult = Apollo.MutationResult<AssignUsersToRoleMutationNode>;
export type AssignUsersToRoleMutationOptions = Apollo.BaseMutationOptions<AssignUsersToRoleMutationNode, AssignUsersToRoleMutationVariables>;
export const AssignWorkOrderToTeamMemberDocument = gql`
    mutation AssignWorkOrderToTeamMember($input: AssignWorkOrderToTeamMemberInput!) {
  assignWorkOrderToTeamMember(input: $input) {
    workOrder {
      ...WorkOrderDetails
    }
  }
}
    ${WorkOrderDetailsFragmentDoc}`;
export type AssignWorkOrderToTeamMemberMutationFn = Apollo.MutationFunction<AssignWorkOrderToTeamMemberMutationNode, AssignWorkOrderToTeamMemberMutationVariables>;

/**
 * __useAssignWorkOrderToTeamMemberMutation__
 *
 * To run a mutation, you first call `useAssignWorkOrderToTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkOrderToTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWorkOrderToTeamMemberMutation, { data, loading, error }] = useAssignWorkOrderToTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignWorkOrderToTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AssignWorkOrderToTeamMemberMutationNode, AssignWorkOrderToTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignWorkOrderToTeamMemberMutationNode, AssignWorkOrderToTeamMemberMutationVariables>(AssignWorkOrderToTeamMemberDocument, options);
      }
export type AssignWorkOrderToTeamMemberMutationHookResult = ReturnType<typeof useAssignWorkOrderToTeamMemberMutation>;
export type AssignWorkOrderToTeamMemberMutationResult = Apollo.MutationResult<AssignWorkOrderToTeamMemberMutationNode>;
export type AssignWorkOrderToTeamMemberMutationOptions = Apollo.BaseMutationOptions<AssignWorkOrderToTeamMemberMutationNode, AssignWorkOrderToTeamMemberMutationVariables>;
export const CancelInviteDocument = gql`
    mutation CancelInvite($inviteId: ID!) {
  cancelInvite(inviteId: $inviteId) {
    ok
  }
}
    `;
export type CancelInviteMutationFn = Apollo.MutationFunction<CancelInviteMutationNode, CancelInviteMutationVariables>;

/**
 * __useCancelInviteMutation__
 *
 * To run a mutation, you first call `useCancelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInviteMutation, { data, loading, error }] = useCancelInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useCancelInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelInviteMutationNode, CancelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInviteMutationNode, CancelInviteMutationVariables>(CancelInviteDocument, options);
      }
export type CancelInviteMutationHookResult = ReturnType<typeof useCancelInviteMutation>;
export type CancelInviteMutationResult = Apollo.MutationResult<CancelInviteMutationNode>;
export type CancelInviteMutationOptions = Apollo.BaseMutationOptions<CancelInviteMutationNode, CancelInviteMutationVariables>;
export const CancelWorkOrderDocument = gql`
    mutation CancelWorkOrder($workOrderId: ID!, $notifyCustomer: Boolean, $notifyVendor: Boolean, $reason: String, $source: WorkOrderCancellationSource, $cancelReason: WorkOrderCancellationReason, $additionalDetails: String) {
  cancelWorkOrder(
    workOrderId: $workOrderId
    notifyCustomer: $notifyCustomer
    notifyVendor: $notifyVendor
    reason: $reason
    source: $source
    cancelReason: $cancelReason
    additionalDetails: $additionalDetails
  ) {
    ok
  }
}
    `;
export type CancelWorkOrderMutationFn = Apollo.MutationFunction<CancelWorkOrderMutationNode, CancelWorkOrderMutationVariables>;

/**
 * __useCancelWorkOrderMutation__
 *
 * To run a mutation, you first call `useCancelWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWorkOrderMutation, { data, loading, error }] = useCancelWorkOrderMutation({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      notifyCustomer: // value for 'notifyCustomer'
 *      notifyVendor: // value for 'notifyVendor'
 *      reason: // value for 'reason'
 *      source: // value for 'source'
 *      cancelReason: // value for 'cancelReason'
 *      additionalDetails: // value for 'additionalDetails'
 *   },
 * });
 */
export function useCancelWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelWorkOrderMutationNode, CancelWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWorkOrderMutationNode, CancelWorkOrderMutationVariables>(CancelWorkOrderDocument, options);
      }
export type CancelWorkOrderMutationHookResult = ReturnType<typeof useCancelWorkOrderMutation>;
export type CancelWorkOrderMutationResult = Apollo.MutationResult<CancelWorkOrderMutationNode>;
export type CancelWorkOrderMutationOptions = Apollo.BaseMutationOptions<CancelWorkOrderMutationNode, CancelWorkOrderMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($arguments: ChangePasswordArguments!) {
  changePassword(arguments: $arguments) {
    ok
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutationNode, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutationNode, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutationNode, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutationNode>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutationNode, ChangePasswordMutationVariables>;
export const ChargePaymentMethodDocument = gql`
    mutation ChargePaymentMethod($input: ChargePaymentMethodInput!) {
  chargePaymentMethod(input: $input) {
    paymentSubmittedInvoices {
      ...ClientInvoiceSummary
    }
  }
}
    ${ClientInvoiceSummaryFragmentDoc}`;
export type ChargePaymentMethodMutationFn = Apollo.MutationFunction<ChargePaymentMethodMutationNode, ChargePaymentMethodMutationVariables>;

/**
 * __useChargePaymentMethodMutation__
 *
 * To run a mutation, you first call `useChargePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChargePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chargePaymentMethodMutation, { data, loading, error }] = useChargePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChargePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ChargePaymentMethodMutationNode, ChargePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChargePaymentMethodMutationNode, ChargePaymentMethodMutationVariables>(ChargePaymentMethodDocument, options);
      }
export type ChargePaymentMethodMutationHookResult = ReturnType<typeof useChargePaymentMethodMutation>;
export type ChargePaymentMethodMutationResult = Apollo.MutationResult<ChargePaymentMethodMutationNode>;
export type ChargePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ChargePaymentMethodMutationNode, ChargePaymentMethodMutationVariables>;
export const CompleteBillingEntityOnboardingStepDocument = gql`
    mutation CompleteBillingEntityOnboardingStep($input: CompleteBillingEntityOnboardingStepMutationInput!) {
  completeBillingEntityOnboardingStep(input: $input) {
    ok
  }
}
    `;
export type CompleteBillingEntityOnboardingStepMutationFn = Apollo.MutationFunction<CompleteBillingEntityOnboardingStepMutationNode, CompleteBillingEntityOnboardingStepMutationVariables>;

/**
 * __useCompleteBillingEntityOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteBillingEntityOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBillingEntityOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBillingEntityOnboardingStepMutation, { data, loading, error }] = useCompleteBillingEntityOnboardingStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteBillingEntityOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteBillingEntityOnboardingStepMutationNode, CompleteBillingEntityOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteBillingEntityOnboardingStepMutationNode, CompleteBillingEntityOnboardingStepMutationVariables>(CompleteBillingEntityOnboardingStepDocument, options);
      }
export type CompleteBillingEntityOnboardingStepMutationHookResult = ReturnType<typeof useCompleteBillingEntityOnboardingStepMutation>;
export type CompleteBillingEntityOnboardingStepMutationResult = Apollo.MutationResult<CompleteBillingEntityOnboardingStepMutationNode>;
export type CompleteBillingEntityOnboardingStepMutationOptions = Apollo.BaseMutationOptions<CompleteBillingEntityOnboardingStepMutationNode, CompleteBillingEntityOnboardingStepMutationVariables>;
export const CompleteClientOnboardingDocument = gql`
    mutation CompleteClientOnboarding($organizationId: ID!) {
  completeClientOnboarding(organizationId: $organizationId) {
    ok
  }
}
    `;
export type CompleteClientOnboardingMutationFn = Apollo.MutationFunction<CompleteClientOnboardingMutationNode, CompleteClientOnboardingMutationVariables>;

/**
 * __useCompleteClientOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteClientOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteClientOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeClientOnboardingMutation, { data, loading, error }] = useCompleteClientOnboardingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompleteClientOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteClientOnboardingMutationNode, CompleteClientOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteClientOnboardingMutationNode, CompleteClientOnboardingMutationVariables>(CompleteClientOnboardingDocument, options);
      }
export type CompleteClientOnboardingMutationHookResult = ReturnType<typeof useCompleteClientOnboardingMutation>;
export type CompleteClientOnboardingMutationResult = Apollo.MutationResult<CompleteClientOnboardingMutationNode>;
export type CompleteClientOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteClientOnboardingMutationNode, CompleteClientOnboardingMutationVariables>;
export const CompleteFacilitiesOnboardingStepDocument = gql`
    mutation CompleteFacilitiesOnboardingStep($input: CompleteFacilitiesOnboardingStepMutationInput!) {
  completeFacilitiesOnboardingStep(input: $input) {
    ok
  }
}
    `;
export type CompleteFacilitiesOnboardingStepMutationFn = Apollo.MutationFunction<CompleteFacilitiesOnboardingStepMutationNode, CompleteFacilitiesOnboardingStepMutationVariables>;

/**
 * __useCompleteFacilitiesOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteFacilitiesOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteFacilitiesOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeFacilitiesOnboardingStepMutation, { data, loading, error }] = useCompleteFacilitiesOnboardingStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteFacilitiesOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteFacilitiesOnboardingStepMutationNode, CompleteFacilitiesOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteFacilitiesOnboardingStepMutationNode, CompleteFacilitiesOnboardingStepMutationVariables>(CompleteFacilitiesOnboardingStepDocument, options);
      }
export type CompleteFacilitiesOnboardingStepMutationHookResult = ReturnType<typeof useCompleteFacilitiesOnboardingStepMutation>;
export type CompleteFacilitiesOnboardingStepMutationResult = Apollo.MutationResult<CompleteFacilitiesOnboardingStepMutationNode>;
export type CompleteFacilitiesOnboardingStepMutationOptions = Apollo.BaseMutationOptions<CompleteFacilitiesOnboardingStepMutationNode, CompleteFacilitiesOnboardingStepMutationVariables>;
export const CompleteGetStartedOnboardingStepDocument = gql`
    mutation CompleteGetStartedOnboardingStep($input: CompleteGetStartedOnboardingStepMutationInput!) {
  completeGetStartedOnboardingStep(input: $input) {
    ok
  }
}
    `;
export type CompleteGetStartedOnboardingStepMutationFn = Apollo.MutationFunction<CompleteGetStartedOnboardingStepMutationNode, CompleteGetStartedOnboardingStepMutationVariables>;

/**
 * __useCompleteGetStartedOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteGetStartedOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGetStartedOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeGetStartedOnboardingStepMutation, { data, loading, error }] = useCompleteGetStartedOnboardingStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteGetStartedOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteGetStartedOnboardingStepMutationNode, CompleteGetStartedOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteGetStartedOnboardingStepMutationNode, CompleteGetStartedOnboardingStepMutationVariables>(CompleteGetStartedOnboardingStepDocument, options);
      }
export type CompleteGetStartedOnboardingStepMutationHookResult = ReturnType<typeof useCompleteGetStartedOnboardingStepMutation>;
export type CompleteGetStartedOnboardingStepMutationResult = Apollo.MutationResult<CompleteGetStartedOnboardingStepMutationNode>;
export type CompleteGetStartedOnboardingStepMutationOptions = Apollo.BaseMutationOptions<CompleteGetStartedOnboardingStepMutationNode, CompleteGetStartedOnboardingStepMutationVariables>;
export const CompleteStaffOnboardingStepDocument = gql`
    mutation CompleteStaffOnboardingStep($input: CompleteStaffOnboardingStepMutationInput!) {
  completeStaffOnboardingStep(input: $input) {
    ok
  }
}
    `;
export type CompleteStaffOnboardingStepMutationFn = Apollo.MutationFunction<CompleteStaffOnboardingStepMutationNode, CompleteStaffOnboardingStepMutationVariables>;

/**
 * __useCompleteStaffOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteStaffOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStaffOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStaffOnboardingStepMutation, { data, loading, error }] = useCompleteStaffOnboardingStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteStaffOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStaffOnboardingStepMutationNode, CompleteStaffOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStaffOnboardingStepMutationNode, CompleteStaffOnboardingStepMutationVariables>(CompleteStaffOnboardingStepDocument, options);
      }
export type CompleteStaffOnboardingStepMutationHookResult = ReturnType<typeof useCompleteStaffOnboardingStepMutation>;
export type CompleteStaffOnboardingStepMutationResult = Apollo.MutationResult<CompleteStaffOnboardingStepMutationNode>;
export type CompleteStaffOnboardingStepMutationOptions = Apollo.BaseMutationOptions<CompleteStaffOnboardingStepMutationNode, CompleteStaffOnboardingStepMutationVariables>;
export const CompleteTroubleshootingSessionDocument = gql`
    mutation CompleteTroubleshootingSession($input: CompleteTroubleshootingSessionMutationInput!) {
  completeTroubleshootingSession(input: $input) {
    ok
  }
}
    `;
export type CompleteTroubleshootingSessionMutationFn = Apollo.MutationFunction<CompleteTroubleshootingSessionMutationNode, CompleteTroubleshootingSessionMutationVariables>;

/**
 * __useCompleteTroubleshootingSessionMutation__
 *
 * To run a mutation, you first call `useCompleteTroubleshootingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTroubleshootingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTroubleshootingSessionMutation, { data, loading, error }] = useCompleteTroubleshootingSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteTroubleshootingSessionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTroubleshootingSessionMutationNode, CompleteTroubleshootingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTroubleshootingSessionMutationNode, CompleteTroubleshootingSessionMutationVariables>(CompleteTroubleshootingSessionDocument, options);
      }
export type CompleteTroubleshootingSessionMutationHookResult = ReturnType<typeof useCompleteTroubleshootingSessionMutation>;
export type CompleteTroubleshootingSessionMutationResult = Apollo.MutationResult<CompleteTroubleshootingSessionMutationNode>;
export type CompleteTroubleshootingSessionMutationOptions = Apollo.BaseMutationOptions<CompleteTroubleshootingSessionMutationNode, CompleteTroubleshootingSessionMutationVariables>;
export const CompleteWorkOrderDocument = gql`
    mutation CompleteWorkOrder($input: ForceWorkOrderCompletionMutationInput!) {
  forceWorkOrderCompletion(input: $input) {
    ok
  }
}
    `;
export type CompleteWorkOrderMutationFn = Apollo.MutationFunction<CompleteWorkOrderMutationNode, CompleteWorkOrderMutationVariables>;

/**
 * __useCompleteWorkOrderMutation__
 *
 * To run a mutation, you first call `useCompleteWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWorkOrderMutation, { data, loading, error }] = useCompleteWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CompleteWorkOrderMutationNode, CompleteWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteWorkOrderMutationNode, CompleteWorkOrderMutationVariables>(CompleteWorkOrderDocument, options);
      }
export type CompleteWorkOrderMutationHookResult = ReturnType<typeof useCompleteWorkOrderMutation>;
export type CompleteWorkOrderMutationResult = Apollo.MutationResult<CompleteWorkOrderMutationNode>;
export type CompleteWorkOrderMutationOptions = Apollo.BaseMutationOptions<CompleteWorkOrderMutationNode, CompleteWorkOrderMutationVariables>;
export const CompleteWorkOrderTeamMemberAssignmentDocument = gql`
    mutation CompleteWorkOrderTeamMemberAssignment($input: CompleteWorkOrderTeamMemberAssignmentInput!) {
  completeWorkOrderTeamMemberAssignment(input: $input) {
    assignment {
      id
    }
  }
}
    `;
export type CompleteWorkOrderTeamMemberAssignmentMutationFn = Apollo.MutationFunction<CompleteWorkOrderTeamMemberAssignmentMutationNode, CompleteWorkOrderTeamMemberAssignmentMutationVariables>;

/**
 * __useCompleteWorkOrderTeamMemberAssignmentMutation__
 *
 * To run a mutation, you first call `useCompleteWorkOrderTeamMemberAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWorkOrderTeamMemberAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWorkOrderTeamMemberAssignmentMutation, { data, loading, error }] = useCompleteWorkOrderTeamMemberAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteWorkOrderTeamMemberAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteWorkOrderTeamMemberAssignmentMutationNode, CompleteWorkOrderTeamMemberAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteWorkOrderTeamMemberAssignmentMutationNode, CompleteWorkOrderTeamMemberAssignmentMutationVariables>(CompleteWorkOrderTeamMemberAssignmentDocument, options);
      }
export type CompleteWorkOrderTeamMemberAssignmentMutationHookResult = ReturnType<typeof useCompleteWorkOrderTeamMemberAssignmentMutation>;
export type CompleteWorkOrderTeamMemberAssignmentMutationResult = Apollo.MutationResult<CompleteWorkOrderTeamMemberAssignmentMutationNode>;
export type CompleteWorkOrderTeamMemberAssignmentMutationOptions = Apollo.BaseMutationOptions<CompleteWorkOrderTeamMemberAssignmentMutationNode, CompleteWorkOrderTeamMemberAssignmentMutationVariables>;
export const CreateBudgetDocument = gql`
    mutation CreateBudget($input: CreateBudgetMutationInput!) {
  createBudget(input: $input) {
    budget {
      id
      name
      endDate
      startDate
      description
    }
  }
}
    `;
export type CreateBudgetMutationFn = Apollo.MutationFunction<CreateBudgetMutationNode, CreateBudgetMutationVariables>;

/**
 * __useCreateBudgetMutation__
 *
 * To run a mutation, you first call `useCreateBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetMutation, { data, loading, error }] = useCreateBudgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBudgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudgetMutationNode, CreateBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBudgetMutationNode, CreateBudgetMutationVariables>(CreateBudgetDocument, options);
      }
export type CreateBudgetMutationHookResult = ReturnType<typeof useCreateBudgetMutation>;
export type CreateBudgetMutationResult = Apollo.MutationResult<CreateBudgetMutationNode>;
export type CreateBudgetMutationOptions = Apollo.BaseMutationOptions<CreateBudgetMutationNode, CreateBudgetMutationVariables>;
export const CreateBusinessUnitDocument = gql`
    mutation CreateBusinessUnit($arguments: CreateBusinessUnitArguments!) {
  createBusinessUnit(arguments: $arguments) {
    businessUnit {
      id
    }
  }
}
    `;
export type CreateBusinessUnitMutationFn = Apollo.MutationFunction<CreateBusinessUnitMutationNode, CreateBusinessUnitMutationVariables>;

/**
 * __useCreateBusinessUnitMutation__
 *
 * To run a mutation, you first call `useCreateBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessUnitMutation, { data, loading, error }] = useCreateBusinessUnitMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useCreateBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessUnitMutationNode, CreateBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessUnitMutationNode, CreateBusinessUnitMutationVariables>(CreateBusinessUnitDocument, options);
      }
export type CreateBusinessUnitMutationHookResult = ReturnType<typeof useCreateBusinessUnitMutation>;
export type CreateBusinessUnitMutationResult = Apollo.MutationResult<CreateBusinessUnitMutationNode>;
export type CreateBusinessUnitMutationOptions = Apollo.BaseMutationOptions<CreateBusinessUnitMutationNode, CreateBusinessUnitMutationVariables>;
export const CreateCyovDispatchDocument = gql`
    mutation CreateCYOVDispatch($input: CreateCYOVDispatchInput!) {
  createCyovDispatch(input: $input) {
    vendorDispatch {
      ...VendorDispatch
    }
  }
}
    ${VendorDispatchFragmentDoc}`;
export type CreateCyovDispatchMutationFn = Apollo.MutationFunction<CreateCyovDispatchMutationNode, CreateCyovDispatchMutationVariables>;

/**
 * __useCreateCyovDispatchMutation__
 *
 * To run a mutation, you first call `useCreateCyovDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCyovDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCyovDispatchMutation, { data, loading, error }] = useCreateCyovDispatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCyovDispatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateCyovDispatchMutationNode, CreateCyovDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCyovDispatchMutationNode, CreateCyovDispatchMutationVariables>(CreateCyovDispatchDocument, options);
      }
export type CreateCyovDispatchMutationHookResult = ReturnType<typeof useCreateCyovDispatchMutation>;
export type CreateCyovDispatchMutationResult = Apollo.MutationResult<CreateCyovDispatchMutationNode>;
export type CreateCyovDispatchMutationOptions = Apollo.BaseMutationOptions<CreateCyovDispatchMutationNode, CreateCyovDispatchMutationVariables>;
export const CreateFacilityDocument = gql`
    mutation CreateFacility($input: CreateFacilityInput!) {
  createFacility(input: $input) {
    facility {
      id
    }
  }
}
    `;
export type CreateFacilityMutationFn = Apollo.MutationFunction<CreateFacilityMutationNode, CreateFacilityMutationVariables>;

/**
 * __useCreateFacilityMutation__
 *
 * To run a mutation, you first call `useCreateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilityMutation, { data, loading, error }] = useCreateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateFacilityMutationNode, CreateFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFacilityMutationNode, CreateFacilityMutationVariables>(CreateFacilityDocument, options);
      }
export type CreateFacilityMutationHookResult = ReturnType<typeof useCreateFacilityMutation>;
export type CreateFacilityMutationResult = Apollo.MutationResult<CreateFacilityMutationNode>;
export type CreateFacilityMutationOptions = Apollo.BaseMutationOptions<CreateFacilityMutationNode, CreateFacilityMutationVariables>;
export const CreateFacilityGroupDocument = gql`
    mutation CreateFacilityGroup($input: CreateFacilityGroupInput!) {
  createFacilityGroup(input: $input) {
    facilityGroup {
      ...FacilityGroupDetails
    }
  }
}
    ${FacilityGroupDetailsFragmentDoc}`;
export type CreateFacilityGroupMutationFn = Apollo.MutationFunction<CreateFacilityGroupMutationNode, CreateFacilityGroupMutationVariables>;

/**
 * __useCreateFacilityGroupMutation__
 *
 * To run a mutation, you first call `useCreateFacilityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilityGroupMutation, { data, loading, error }] = useCreateFacilityGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilityGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateFacilityGroupMutationNode, CreateFacilityGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFacilityGroupMutationNode, CreateFacilityGroupMutationVariables>(CreateFacilityGroupDocument, options);
      }
export type CreateFacilityGroupMutationHookResult = ReturnType<typeof useCreateFacilityGroupMutation>;
export type CreateFacilityGroupMutationResult = Apollo.MutationResult<CreateFacilityGroupMutationNode>;
export type CreateFacilityGroupMutationOptions = Apollo.BaseMutationOptions<CreateFacilityGroupMutationNode, CreateFacilityGroupMutationVariables>;
export const CreateOrUpdateBusinessUnitOnboardingDocument = gql`
    mutation CreateOrUpdateBusinessUnitOnboarding($input: CreateOrUpdateBusinessUnitOnboardingMutationInput!) {
  createOrUpdateBusinessUnitOnboarding(input: $input) {
    businessUnit {
      id
    }
  }
}
    `;
export type CreateOrUpdateBusinessUnitOnboardingMutationFn = Apollo.MutationFunction<CreateOrUpdateBusinessUnitOnboardingMutationNode, CreateOrUpdateBusinessUnitOnboardingMutationVariables>;

/**
 * __useCreateOrUpdateBusinessUnitOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBusinessUnitOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBusinessUnitOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBusinessUnitOnboardingMutation, { data, loading, error }] = useCreateOrUpdateBusinessUnitOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateBusinessUnitOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBusinessUnitOnboardingMutationNode, CreateOrUpdateBusinessUnitOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBusinessUnitOnboardingMutationNode, CreateOrUpdateBusinessUnitOnboardingMutationVariables>(CreateOrUpdateBusinessUnitOnboardingDocument, options);
      }
export type CreateOrUpdateBusinessUnitOnboardingMutationHookResult = ReturnType<typeof useCreateOrUpdateBusinessUnitOnboardingMutation>;
export type CreateOrUpdateBusinessUnitOnboardingMutationResult = Apollo.MutationResult<CreateOrUpdateBusinessUnitOnboardingMutationNode>;
export type CreateOrUpdateBusinessUnitOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBusinessUnitOnboardingMutationNode, CreateOrUpdateBusinessUnitOnboardingMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    role {
      id
    }
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutationNode, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutationNode, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutationNode, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutationNode>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutationNode, CreateRoleMutationVariables>;
export const CreateTroubleshootingSessionDocument = gql`
    mutation CreateTroubleshootingSession($input: CreateTroubleshootingSessionMutationInput!) {
  createTroubleshootingSession(input: $input) {
    troubleshootingSession {
      id
      actions {
        id
        troubleshootingStep {
          id
          order
          stepDescription
          supportLink
        }
      }
    }
  }
}
    `;
export type CreateTroubleshootingSessionMutationFn = Apollo.MutationFunction<CreateTroubleshootingSessionMutationNode, CreateTroubleshootingSessionMutationVariables>;

/**
 * __useCreateTroubleshootingSessionMutation__
 *
 * To run a mutation, you first call `useCreateTroubleshootingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTroubleshootingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTroubleshootingSessionMutation, { data, loading, error }] = useCreateTroubleshootingSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTroubleshootingSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTroubleshootingSessionMutationNode, CreateTroubleshootingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTroubleshootingSessionMutationNode, CreateTroubleshootingSessionMutationVariables>(CreateTroubleshootingSessionDocument, options);
      }
export type CreateTroubleshootingSessionMutationHookResult = ReturnType<typeof useCreateTroubleshootingSessionMutation>;
export type CreateTroubleshootingSessionMutationResult = Apollo.MutationResult<CreateTroubleshootingSessionMutationNode>;
export type CreateTroubleshootingSessionMutationOptions = Apollo.BaseMutationOptions<CreateTroubleshootingSessionMutationNode, CreateTroubleshootingSessionMutationVariables>;
export const CreateUpdateWorkOrderExpenseTypeDocument = gql`
    mutation CreateUpdateWorkOrderExpenseType($input: CreateUpdateWorkOrderExpenseTypeMutationInput!) {
  createUpdateWorkOrderExpenseType(input: $input) {
    workOrderExpenseType {
      id
      workOrderId
      expenseType
      setBy {
        id
      }
      expenseTypeSetThrough
    }
  }
}
    `;
export type CreateUpdateWorkOrderExpenseTypeMutationFn = Apollo.MutationFunction<CreateUpdateWorkOrderExpenseTypeMutationNode, CreateUpdateWorkOrderExpenseTypeMutationVariables>;

/**
 * __useCreateUpdateWorkOrderExpenseTypeMutation__
 *
 * To run a mutation, you first call `useCreateUpdateWorkOrderExpenseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateWorkOrderExpenseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateWorkOrderExpenseTypeMutation, { data, loading, error }] = useCreateUpdateWorkOrderExpenseTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateWorkOrderExpenseTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateWorkOrderExpenseTypeMutationNode, CreateUpdateWorkOrderExpenseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateWorkOrderExpenseTypeMutationNode, CreateUpdateWorkOrderExpenseTypeMutationVariables>(CreateUpdateWorkOrderExpenseTypeDocument, options);
      }
export type CreateUpdateWorkOrderExpenseTypeMutationHookResult = ReturnType<typeof useCreateUpdateWorkOrderExpenseTypeMutation>;
export type CreateUpdateWorkOrderExpenseTypeMutationResult = Apollo.MutationResult<CreateUpdateWorkOrderExpenseTypeMutationNode>;
export type CreateUpdateWorkOrderExpenseTypeMutationOptions = Apollo.BaseMutationOptions<CreateUpdateWorkOrderExpenseTypeMutationNode, CreateUpdateWorkOrderExpenseTypeMutationVariables>;
export const CreateVisitReviewDocument = gql`
    mutation CreateVisitReview($visitReviewRequestId: ID!, $outcome: VisitReviewOutcome!) {
  createVisitReview(
    visitReviewRequestId: $visitReviewRequestId
    outcome: $outcome
  ) {
    ok
  }
}
    `;
export type CreateVisitReviewMutationFn = Apollo.MutationFunction<CreateVisitReviewMutationNode, CreateVisitReviewMutationVariables>;

/**
 * __useCreateVisitReviewMutation__
 *
 * To run a mutation, you first call `useCreateVisitReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitReviewMutation, { data, loading, error }] = useCreateVisitReviewMutation({
 *   variables: {
 *      visitReviewRequestId: // value for 'visitReviewRequestId'
 *      outcome: // value for 'outcome'
 *   },
 * });
 */
export function useCreateVisitReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitReviewMutationNode, CreateVisitReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitReviewMutationNode, CreateVisitReviewMutationVariables>(CreateVisitReviewDocument, options);
      }
export type CreateVisitReviewMutationHookResult = ReturnType<typeof useCreateVisitReviewMutation>;
export type CreateVisitReviewMutationResult = Apollo.MutationResult<CreateVisitReviewMutationNode>;
export type CreateVisitReviewMutationOptions = Apollo.BaseMutationOptions<CreateVisitReviewMutationNode, CreateVisitReviewMutationVariables>;
export const CreateWorkOrderEscalationDocument = gql`
    mutation CreateWorkOrderEscalation($input: CreateWorkOrderEscalationInput!) {
  createWorkOrderEscalation(input: $input) {
    workOrderEscalation {
      id
      workOrder {
        id
        canEscalate: can(perform: ESCALATE)
      }
      kustomerWorkOrderEscalation {
        ticketNumber
        kustomerUrl
      }
    }
  }
}
    `;
export type CreateWorkOrderEscalationMutationFn = Apollo.MutationFunction<CreateWorkOrderEscalationMutationNode, CreateWorkOrderEscalationMutationVariables>;

/**
 * __useCreateWorkOrderEscalationMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderEscalationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderEscalationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderEscalationMutation, { data, loading, error }] = useCreateWorkOrderEscalationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkOrderEscalationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderEscalationMutationNode, CreateWorkOrderEscalationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderEscalationMutationNode, CreateWorkOrderEscalationMutationVariables>(CreateWorkOrderEscalationDocument, options);
      }
export type CreateWorkOrderEscalationMutationHookResult = ReturnType<typeof useCreateWorkOrderEscalationMutation>;
export type CreateWorkOrderEscalationMutationResult = Apollo.MutationResult<CreateWorkOrderEscalationMutationNode>;
export type CreateWorkOrderEscalationMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderEscalationMutationNode, CreateWorkOrderEscalationMutationVariables>;
export const CreateWorkOrderReviewDocument = gql`
    mutation CreateWorkOrderReview($input: CreateWorkOrderReviewArguments!) {
  createWorkOrderReview(arguments: $input) {
    workOrder {
      reviews {
        ...WorkOrderReview
      }
    }
  }
}
    ${WorkOrderReviewFragmentDoc}`;
export type CreateWorkOrderReviewMutationFn = Apollo.MutationFunction<CreateWorkOrderReviewMutationNode, CreateWorkOrderReviewMutationVariables>;

/**
 * __useCreateWorkOrderReviewMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderReviewMutation, { data, loading, error }] = useCreateWorkOrderReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkOrderReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderReviewMutationNode, CreateWorkOrderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderReviewMutationNode, CreateWorkOrderReviewMutationVariables>(CreateWorkOrderReviewDocument, options);
      }
export type CreateWorkOrderReviewMutationHookResult = ReturnType<typeof useCreateWorkOrderReviewMutation>;
export type CreateWorkOrderReviewMutationResult = Apollo.MutationResult<CreateWorkOrderReviewMutationNode>;
export type CreateWorkOrderReviewMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderReviewMutationNode, CreateWorkOrderReviewMutationVariables>;
export const DeactivateFacilityDocument = gql`
    mutation DeactivateFacility($input: DeactivateFacilityInput!) {
  deactivateFacility(input: $input) {
    facility {
      id
      status
    }
  }
}
    `;
export type DeactivateFacilityMutationFn = Apollo.MutationFunction<DeactivateFacilityMutationNode, DeactivateFacilityMutationVariables>;

/**
 * __useDeactivateFacilityMutation__
 *
 * To run a mutation, you first call `useDeactivateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateFacilityMutation, { data, loading, error }] = useDeactivateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateFacilityMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateFacilityMutationNode, DeactivateFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateFacilityMutationNode, DeactivateFacilityMutationVariables>(DeactivateFacilityDocument, options);
      }
export type DeactivateFacilityMutationHookResult = ReturnType<typeof useDeactivateFacilityMutation>;
export type DeactivateFacilityMutationResult = Apollo.MutationResult<DeactivateFacilityMutationNode>;
export type DeactivateFacilityMutationOptions = Apollo.BaseMutationOptions<DeactivateFacilityMutationNode, DeactivateFacilityMutationVariables>;
export const DeleteBusinessUnitDocument = gql`
    mutation DeleteBusinessUnit($input: DeleteBusinessUnitMutationInput!) {
  deleteBusinessUnit(input: $input) {
    ok
  }
}
    `;
export type DeleteBusinessUnitMutationFn = Apollo.MutationFunction<DeleteBusinessUnitMutationNode, DeleteBusinessUnitMutationVariables>;

/**
 * __useDeleteBusinessUnitMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessUnitMutation, { data, loading, error }] = useDeleteBusinessUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessUnitMutationNode, DeleteBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessUnitMutationNode, DeleteBusinessUnitMutationVariables>(DeleteBusinessUnitDocument, options);
      }
export type DeleteBusinessUnitMutationHookResult = ReturnType<typeof useDeleteBusinessUnitMutation>;
export type DeleteBusinessUnitMutationResult = Apollo.MutationResult<DeleteBusinessUnitMutationNode>;
export type DeleteBusinessUnitMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessUnitMutationNode, DeleteBusinessUnitMutationVariables>;
export const DeleteClientReportScheduleDocument = gql`
    mutation DeleteClientReportSchedule($input: DeleteClientReportScheduleMutationInput!) {
  deleteClientReportSchedule(input: $input) {
    ok
  }
}
    `;
export type DeleteClientReportScheduleMutationFn = Apollo.MutationFunction<DeleteClientReportScheduleMutationNode, DeleteClientReportScheduleMutationVariables>;

/**
 * __useDeleteClientReportScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteClientReportScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientReportScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientReportScheduleMutation, { data, loading, error }] = useDeleteClientReportScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientReportScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientReportScheduleMutationNode, DeleteClientReportScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientReportScheduleMutationNode, DeleteClientReportScheduleMutationVariables>(DeleteClientReportScheduleDocument, options);
      }
export type DeleteClientReportScheduleMutationHookResult = ReturnType<typeof useDeleteClientReportScheduleMutation>;
export type DeleteClientReportScheduleMutationResult = Apollo.MutationResult<DeleteClientReportScheduleMutationNode>;
export type DeleteClientReportScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteClientReportScheduleMutationNode, DeleteClientReportScheduleMutationVariables>;
export const DeleteFacilityDocument = gql`
    mutation DeleteFacility($input: DeleteFacilityInput!) {
  deleteFacility(input: $input) {
    facility {
      id
      status
    }
  }
}
    `;
export type DeleteFacilityMutationFn = Apollo.MutationFunction<DeleteFacilityMutationNode, DeleteFacilityMutationVariables>;

/**
 * __useDeleteFacilityMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityMutation, { data, loading, error }] = useDeleteFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFacilityMutationNode, DeleteFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFacilityMutationNode, DeleteFacilityMutationVariables>(DeleteFacilityDocument, options);
      }
export type DeleteFacilityMutationHookResult = ReturnType<typeof useDeleteFacilityMutation>;
export type DeleteFacilityMutationResult = Apollo.MutationResult<DeleteFacilityMutationNode>;
export type DeleteFacilityMutationOptions = Apollo.BaseMutationOptions<DeleteFacilityMutationNode, DeleteFacilityMutationVariables>;
export const DeleteFacilityGroupDocument = gql`
    mutation DeleteFacilityGroup($input: DeleteFacilityGroupInput!) {
  deleteFacilityGroup(input: $input) {
    ok
  }
}
    `;
export type DeleteFacilityGroupMutationFn = Apollo.MutationFunction<DeleteFacilityGroupMutationNode, DeleteFacilityGroupMutationVariables>;

/**
 * __useDeleteFacilityGroupMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityGroupMutation, { data, loading, error }] = useDeleteFacilityGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFacilityGroupMutationNode, DeleteFacilityGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFacilityGroupMutationNode, DeleteFacilityGroupMutationVariables>(DeleteFacilityGroupDocument, options);
      }
export type DeleteFacilityGroupMutationHookResult = ReturnType<typeof useDeleteFacilityGroupMutation>;
export type DeleteFacilityGroupMutationResult = Apollo.MutationResult<DeleteFacilityGroupMutationNode>;
export type DeleteFacilityGroupMutationOptions = Apollo.BaseMutationOptions<DeleteFacilityGroupMutationNode, DeleteFacilityGroupMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($input: DeleteRoleInput!) {
  deleteRole(input: $input) {
    ok
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutationNode, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutationNode, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutationNode, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutationNode>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutationNode, DeleteRoleMutationVariables>;
export const DisputeWorkOrderDocument = gql`
    mutation DisputeWorkOrder($arguments: DisputeWorkOrderArguments!) {
  disputeWorkOrder(arguments: $arguments) {
    workOrder {
      ...WorkOrderDetails
    }
  }
}
    ${WorkOrderDetailsFragmentDoc}`;
export type DisputeWorkOrderMutationFn = Apollo.MutationFunction<DisputeWorkOrderMutationNode, DisputeWorkOrderMutationVariables>;

/**
 * __useDisputeWorkOrderMutation__
 *
 * To run a mutation, you first call `useDisputeWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisputeWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disputeWorkOrderMutation, { data, loading, error }] = useDisputeWorkOrderMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useDisputeWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<DisputeWorkOrderMutationNode, DisputeWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisputeWorkOrderMutationNode, DisputeWorkOrderMutationVariables>(DisputeWorkOrderDocument, options);
      }
export type DisputeWorkOrderMutationHookResult = ReturnType<typeof useDisputeWorkOrderMutation>;
export type DisputeWorkOrderMutationResult = Apollo.MutationResult<DisputeWorkOrderMutationNode>;
export type DisputeWorkOrderMutationOptions = Apollo.BaseMutationOptions<DisputeWorkOrderMutationNode, DisputeWorkOrderMutationVariables>;
export const EditClientMembershipDetailsDocument = gql`
    mutation EditClientMembershipDetails($clientId: ID!, $membershipId: ID!, $firstName: String, $lastName: String, $email: String, $username: String, $phone: String, $roleIds: [ID!], $businessUnitIds: [ID!], $facilityGroupIds: [ID!]) {
  EditClientMembershipDetails: editClientOrganizationMember(
    clientOrganizationId: $clientId
    memberId: $membershipId
    firstName: $firstName
    lastName: $lastName
    email: $email
    username: $username
    phone: $phone
    roleIds: $roleIds
    businessUnitIds: $businessUnitIds
    facilityGroupIds: $facilityGroupIds
  ) {
    member {
      id
      user {
        ...UserSummary
      }
      roles {
        ...RoleSummary
      }
    }
  }
}
    ${UserSummaryFragmentDoc}
${RoleSummaryFragmentDoc}`;
export type EditClientMembershipDetailsMutationFn = Apollo.MutationFunction<EditClientMembershipDetailsMutationNode, EditClientMembershipDetailsMutationVariables>;

/**
 * __useEditClientMembershipDetailsMutation__
 *
 * To run a mutation, you first call `useEditClientMembershipDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientMembershipDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientMembershipDetailsMutation, { data, loading, error }] = useEditClientMembershipDetailsMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      membershipId: // value for 'membershipId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      phone: // value for 'phone'
 *      roleIds: // value for 'roleIds'
 *      businessUnitIds: // value for 'businessUnitIds'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *   },
 * });
 */
export function useEditClientMembershipDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditClientMembershipDetailsMutationNode, EditClientMembershipDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClientMembershipDetailsMutationNode, EditClientMembershipDetailsMutationVariables>(EditClientMembershipDetailsDocument, options);
      }
export type EditClientMembershipDetailsMutationHookResult = ReturnType<typeof useEditClientMembershipDetailsMutation>;
export type EditClientMembershipDetailsMutationResult = Apollo.MutationResult<EditClientMembershipDetailsMutationNode>;
export type EditClientMembershipDetailsMutationOptions = Apollo.BaseMutationOptions<EditClientMembershipDetailsMutationNode, EditClientMembershipDetailsMutationVariables>;
export const EditClientOrganizationMemberDocument = gql`
    mutation EditClientOrganizationMember($clientOrganizationId: ID!, $memberId: ID!, $firstName: String, $lastName: String, $email: String, $phone: String, $businessUnitIds: [ID!], $roleIds: [ID!]) {
  editClientOrganizationMember(
    clientOrganizationId: $clientOrganizationId
    memberId: $memberId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    businessUnitIds: $businessUnitIds
    roleIds: $roleIds
  ) {
    member {
      ...ClientMembershipSummary
    }
  }
}
    ${ClientMembershipSummaryFragmentDoc}`;
export type EditClientOrganizationMemberMutationFn = Apollo.MutationFunction<EditClientOrganizationMemberMutationNode, EditClientOrganizationMemberMutationVariables>;

/**
 * __useEditClientOrganizationMemberMutation__
 *
 * To run a mutation, you first call `useEditClientOrganizationMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientOrganizationMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientOrganizationMemberMutation, { data, loading, error }] = useEditClientOrganizationMemberMutation({
 *   variables: {
 *      clientOrganizationId: // value for 'clientOrganizationId'
 *      memberId: // value for 'memberId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      businessUnitIds: // value for 'businessUnitIds'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useEditClientOrganizationMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditClientOrganizationMemberMutationNode, EditClientOrganizationMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClientOrganizationMemberMutationNode, EditClientOrganizationMemberMutationVariables>(EditClientOrganizationMemberDocument, options);
      }
export type EditClientOrganizationMemberMutationHookResult = ReturnType<typeof useEditClientOrganizationMemberMutation>;
export type EditClientOrganizationMemberMutationResult = Apollo.MutationResult<EditClientOrganizationMemberMutationNode>;
export type EditClientOrganizationMemberMutationOptions = Apollo.BaseMutationOptions<EditClientOrganizationMemberMutationNode, EditClientOrganizationMemberMutationVariables>;
export const EditClientVendorRelationshipInviteDocument = gql`
    mutation EditClientVendorRelationshipInvite($input: EditClientVendorRelationshipInviteInput!) {
  editClientVendorRelationshipInvite(input: $input) {
    invite {
      id
    }
  }
}
    `;
export type EditClientVendorRelationshipInviteMutationFn = Apollo.MutationFunction<EditClientVendorRelationshipInviteMutationNode, EditClientVendorRelationshipInviteMutationVariables>;

/**
 * __useEditClientVendorRelationshipInviteMutation__
 *
 * To run a mutation, you first call `useEditClientVendorRelationshipInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientVendorRelationshipInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientVendorRelationshipInviteMutation, { data, loading, error }] = useEditClientVendorRelationshipInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditClientVendorRelationshipInviteMutation(baseOptions?: Apollo.MutationHookOptions<EditClientVendorRelationshipInviteMutationNode, EditClientVendorRelationshipInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClientVendorRelationshipInviteMutationNode, EditClientVendorRelationshipInviteMutationVariables>(EditClientVendorRelationshipInviteDocument, options);
      }
export type EditClientVendorRelationshipInviteMutationHookResult = ReturnType<typeof useEditClientVendorRelationshipInviteMutation>;
export type EditClientVendorRelationshipInviteMutationResult = Apollo.MutationResult<EditClientVendorRelationshipInviteMutationNode>;
export type EditClientVendorRelationshipInviteMutationOptions = Apollo.BaseMutationOptions<EditClientVendorRelationshipInviteMutationNode, EditClientVendorRelationshipInviteMutationVariables>;
export const EditEquipmentDocument = gql`
    mutation EditEquipment($equipmentId: ID!, $name: String!, $description: String!, $mainImage: Image, $modelTagImage: Image, $location: String!, $serialNo: String!, $modelNo: String!, $manufacturer: String!, $barCode: String!, $installedOn: Date, $warrantyNotes: String, $warrantyExpiresOn: Date, $equipmentCategoryId: ID, $cost: Decimal, $historicalSpend: Decimal) {
  editEquipment(
    equipmentId: $equipmentId
    name: $name
    description: $description
    mainImage: $mainImage
    modelTagImage: $modelTagImage
    location: $location
    serialNo: $serialNo
    modelNo: $modelNo
    manufacturer: $manufacturer
    barCode: $barCode
    installedOn: $installedOn
    warrantyNotes: $warrantyNotes
    warrantyExpiresOn: $warrantyExpiresOn
    equipmentCategoryId: $equipmentCategoryId
    cost: $cost
    historicalSpend: $historicalSpend
  ) {
    ok
    equipment {
      ...EquipmentDetails
    }
  }
}
    ${EquipmentDetailsFragmentDoc}`;
export type EditEquipmentMutationFn = Apollo.MutationFunction<EditEquipmentMutationNode, EditEquipmentMutationVariables>;

/**
 * __useEditEquipmentMutation__
 *
 * To run a mutation, you first call `useEditEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEquipmentMutation, { data, loading, error }] = useEditEquipmentMutation({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      mainImage: // value for 'mainImage'
 *      modelTagImage: // value for 'modelTagImage'
 *      location: // value for 'location'
 *      serialNo: // value for 'serialNo'
 *      modelNo: // value for 'modelNo'
 *      manufacturer: // value for 'manufacturer'
 *      barCode: // value for 'barCode'
 *      installedOn: // value for 'installedOn'
 *      warrantyNotes: // value for 'warrantyNotes'
 *      warrantyExpiresOn: // value for 'warrantyExpiresOn'
 *      equipmentCategoryId: // value for 'equipmentCategoryId'
 *      cost: // value for 'cost'
 *      historicalSpend: // value for 'historicalSpend'
 *   },
 * });
 */
export function useEditEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<EditEquipmentMutationNode, EditEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEquipmentMutationNode, EditEquipmentMutationVariables>(EditEquipmentDocument, options);
      }
export type EditEquipmentMutationHookResult = ReturnType<typeof useEditEquipmentMutation>;
export type EditEquipmentMutationResult = Apollo.MutationResult<EditEquipmentMutationNode>;
export type EditEquipmentMutationOptions = Apollo.BaseMutationOptions<EditEquipmentMutationNode, EditEquipmentMutationVariables>;
export const GetInboundVendorInvoiceValidationDocument = gql`
    query GetInboundVendorInvoiceValidation($workOrderId: ID!, $invoiceFile: String!) {
  inboundVendorInvoiceValidation(
    workOrderId: $workOrderId
    invoiceFile: $invoiceFile
  ) {
    validationResult {
      validationMessage
      canOverride
    }
  }
}
    `;

/**
 * __useGetInboundVendorInvoiceValidationQuery__
 *
 * To run a query within a React component, call `useGetInboundVendorInvoiceValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboundVendorInvoiceValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboundVendorInvoiceValidationQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      invoiceFile: // value for 'invoiceFile'
 *   },
 * });
 */
export function useGetInboundVendorInvoiceValidationQuery(baseOptions: Apollo.QueryHookOptions<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>(GetInboundVendorInvoiceValidationDocument, options);
      }
export function useGetInboundVendorInvoiceValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>(GetInboundVendorInvoiceValidationDocument, options);
        }
export type GetInboundVendorInvoiceValidationQueryHookResult = ReturnType<typeof useGetInboundVendorInvoiceValidationQuery>;
export type GetInboundVendorInvoiceValidationLazyQueryHookResult = ReturnType<typeof useGetInboundVendorInvoiceValidationLazyQuery>;
export type GetInboundVendorInvoiceValidationQueryResult = Apollo.QueryResult<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>;
export const InviteMemberToClientOrganizationDocument = gql`
    mutation InviteMemberToClientOrganization($organizationId: ID!, $phoneNumber: String!, $emailAddress: String!, $assignedFacilityGroupIds: [ID!]!, $assignedRoleIds: [ID!]!, $sendInvite: Boolean, $noExpiry: Boolean, $firstName: String, $lastName: String, $inviteType: InviteType) {
  inviteMemberToClientOrganization(
    organizationId: $organizationId
    phoneNumber: $phoneNumber
    emailAddress: $emailAddress
    assignedFacilityGroupIds: $assignedFacilityGroupIds
    assignedRoleIds: $assignedRoleIds
    sendInvite: $sendInvite
    noExpiry: $noExpiry
    firstName: $firstName
    lastName: $lastName
    inviteType: $inviteType
  ) {
    invite {
      id
    }
  }
}
    `;
export type InviteMemberToClientOrganizationMutationFn = Apollo.MutationFunction<InviteMemberToClientOrganizationMutationNode, InviteMemberToClientOrganizationMutationVariables>;

/**
 * __useInviteMemberToClientOrganizationMutation__
 *
 * To run a mutation, you first call `useInviteMemberToClientOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMemberToClientOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMemberToClientOrganizationMutation, { data, loading, error }] = useInviteMemberToClientOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      phoneNumber: // value for 'phoneNumber'
 *      emailAddress: // value for 'emailAddress'
 *      assignedFacilityGroupIds: // value for 'assignedFacilityGroupIds'
 *      assignedRoleIds: // value for 'assignedRoleIds'
 *      sendInvite: // value for 'sendInvite'
 *      noExpiry: // value for 'noExpiry'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      inviteType: // value for 'inviteType'
 *   },
 * });
 */
export function useInviteMemberToClientOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<InviteMemberToClientOrganizationMutationNode, InviteMemberToClientOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMemberToClientOrganizationMutationNode, InviteMemberToClientOrganizationMutationVariables>(InviteMemberToClientOrganizationDocument, options);
      }
export type InviteMemberToClientOrganizationMutationHookResult = ReturnType<typeof useInviteMemberToClientOrganizationMutation>;
export type InviteMemberToClientOrganizationMutationResult = Apollo.MutationResult<InviteMemberToClientOrganizationMutationNode>;
export type InviteMemberToClientOrganizationMutationOptions = Apollo.BaseMutationOptions<InviteMemberToClientOrganizationMutationNode, InviteMemberToClientOrganizationMutationVariables>;
export const InviteOwnerToOnboardingDocument = gql`
    mutation InviteOwnerToOnboarding($organizationId: ID!, $phoneNumber: String, $email: String!, $ownerFirstName: String!, $ownerLastName: String!, $isResqEssentials: Boolean) {
  inviteOwnerToOnboarding(
    organizationId: $organizationId
    phoneNumber: $phoneNumber
    email: $email
    ownerFirstName: $ownerFirstName
    ownerLastName: $ownerLastName
    isResqEssentials: $isResqEssentials
  ) {
    ok
  }
}
    `;
export type InviteOwnerToOnboardingMutationFn = Apollo.MutationFunction<InviteOwnerToOnboardingMutationNode, InviteOwnerToOnboardingMutationVariables>;

/**
 * __useInviteOwnerToOnboardingMutation__
 *
 * To run a mutation, you first call `useInviteOwnerToOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteOwnerToOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteOwnerToOnboardingMutation, { data, loading, error }] = useInviteOwnerToOnboardingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      ownerFirstName: // value for 'ownerFirstName'
 *      ownerLastName: // value for 'ownerLastName'
 *      isResqEssentials: // value for 'isResqEssentials'
 *   },
 * });
 */
export function useInviteOwnerToOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<InviteOwnerToOnboardingMutationNode, InviteOwnerToOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteOwnerToOnboardingMutationNode, InviteOwnerToOnboardingMutationVariables>(InviteOwnerToOnboardingDocument, options);
      }
export type InviteOwnerToOnboardingMutationHookResult = ReturnType<typeof useInviteOwnerToOnboardingMutation>;
export type InviteOwnerToOnboardingMutationResult = Apollo.MutationResult<InviteOwnerToOnboardingMutationNode>;
export type InviteOwnerToOnboardingMutationOptions = Apollo.BaseMutationOptions<InviteOwnerToOnboardingMutationNode, InviteOwnerToOnboardingMutationVariables>;
export const MarkWorkOrderTeamMemberAssignmentAsUnresolvedDocument = gql`
    mutation MarkWorkOrderTeamMemberAssignmentAsUnresolved($input: MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput!) {
  markWorkOrderTeamMemberAssignmentAsUnresolved(input: $input) {
    assignment {
      id
    }
  }
}
    `;
export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationFn = Apollo.MutationFunction<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode, MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables>;

/**
 * __useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation__
 *
 * To run a mutation, you first call `useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markWorkOrderTeamMemberAssignmentAsUnresolvedMutation, { data, loading, error }] = useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation(baseOptions?: Apollo.MutationHookOptions<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode, MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode, MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables>(MarkWorkOrderTeamMemberAssignmentAsUnresolvedDocument, options);
      }
export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationHookResult = ReturnType<typeof useMarkWorkOrderTeamMemberAssignmentAsUnresolvedMutation>;
export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationResult = Apollo.MutationResult<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode>;
export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationOptions = Apollo.BaseMutationOptions<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode, MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables>;
export const Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentDocument = gql`
    mutation RMC_InternalRequest_CompleteInternalRequestTeamMemberAssignment($input: CompleteInternalRequestTeamMemberAssignmentInput!) {
  completeInternalRequestTeamMemberAssignment(input: $input) {
    assignment {
      id
    }
  }
}
    `;
export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationFn = Apollo.MutationFunction<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode, Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables>;

/**
 * __useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation__
 *
 * To run a mutation, you first call `useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rmcInternalRequestCompleteInternalRequestTeamMemberAssignmentMutation, { data, loading, error }] = useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode, Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode, Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables>(Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentDocument, options);
      }
export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationHookResult = ReturnType<typeof useRmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutation>;
export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationResult = Apollo.MutationResult<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode>;
export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationOptions = Apollo.BaseMutationOptions<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode, Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables>;
export const ReassignWorkOrderToTeamMemberDocument = gql`
    mutation ReassignWorkOrderToTeamMember($input: ReassignWorkOrderToTeamMemberInput!) {
  reassignWorkOrderToTeamMember(input: $input) {
    newAssignment {
      id
    }
  }
}
    `;
export type ReassignWorkOrderToTeamMemberMutationFn = Apollo.MutationFunction<ReassignWorkOrderToTeamMemberMutationNode, ReassignWorkOrderToTeamMemberMutationVariables>;

/**
 * __useReassignWorkOrderToTeamMemberMutation__
 *
 * To run a mutation, you first call `useReassignWorkOrderToTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignWorkOrderToTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignWorkOrderToTeamMemberMutation, { data, loading, error }] = useReassignWorkOrderToTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignWorkOrderToTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<ReassignWorkOrderToTeamMemberMutationNode, ReassignWorkOrderToTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignWorkOrderToTeamMemberMutationNode, ReassignWorkOrderToTeamMemberMutationVariables>(ReassignWorkOrderToTeamMemberDocument, options);
      }
export type ReassignWorkOrderToTeamMemberMutationHookResult = ReturnType<typeof useReassignWorkOrderToTeamMemberMutation>;
export type ReassignWorkOrderToTeamMemberMutationResult = Apollo.MutationResult<ReassignWorkOrderToTeamMemberMutationNode>;
export type ReassignWorkOrderToTeamMemberMutationOptions = Apollo.BaseMutationOptions<ReassignWorkOrderToTeamMemberMutationNode, ReassignWorkOrderToTeamMemberMutationVariables>;
export const ReassignWorkOrderVendorDocument = gql`
    mutation ReassignWorkOrderVendor($input: ReassignWorkOrderVendorInput!) {
  reassignWorkOrderVendor(input: $input) {
    newWorkOrder {
      id
    }
  }
}
    `;
export type ReassignWorkOrderVendorMutationFn = Apollo.MutationFunction<ReassignWorkOrderVendorMutationNode, ReassignWorkOrderVendorMutationVariables>;

/**
 * __useReassignWorkOrderVendorMutation__
 *
 * To run a mutation, you first call `useReassignWorkOrderVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignWorkOrderVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignWorkOrderVendorMutation, { data, loading, error }] = useReassignWorkOrderVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignWorkOrderVendorMutation(baseOptions?: Apollo.MutationHookOptions<ReassignWorkOrderVendorMutationNode, ReassignWorkOrderVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignWorkOrderVendorMutationNode, ReassignWorkOrderVendorMutationVariables>(ReassignWorkOrderVendorDocument, options);
      }
export type ReassignWorkOrderVendorMutationHookResult = ReturnType<typeof useReassignWorkOrderVendorMutation>;
export type ReassignWorkOrderVendorMutationResult = Apollo.MutationResult<ReassignWorkOrderVendorMutationNode>;
export type ReassignWorkOrderVendorMutationOptions = Apollo.BaseMutationOptions<ReassignWorkOrderVendorMutationNode, ReassignWorkOrderVendorMutationVariables>;
export const RejectQuoteSetDocument = gql`
    mutation RejectQuoteSet($input: RejectQuoteSetInput!) {
  rejectQuoteSet(input: $input) {
    quoteSet {
      ...QuoteSetDetails
    }
  }
}
    ${QuoteSetDetailsFragmentDoc}`;
export type RejectQuoteSetMutationFn = Apollo.MutationFunction<RejectQuoteSetMutationNode, RejectQuoteSetMutationVariables>;

/**
 * __useRejectQuoteSetMutation__
 *
 * To run a mutation, you first call `useRejectQuoteSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectQuoteSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectQuoteSetMutation, { data, loading, error }] = useRejectQuoteSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectQuoteSetMutation(baseOptions?: Apollo.MutationHookOptions<RejectQuoteSetMutationNode, RejectQuoteSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectQuoteSetMutationNode, RejectQuoteSetMutationVariables>(RejectQuoteSetDocument, options);
      }
export type RejectQuoteSetMutationHookResult = ReturnType<typeof useRejectQuoteSetMutation>;
export type RejectQuoteSetMutationResult = Apollo.MutationResult<RejectQuoteSetMutationNode>;
export type RejectQuoteSetMutationOptions = Apollo.BaseMutationOptions<RejectQuoteSetMutationNode, RejectQuoteSetMutationVariables>;
export const RejectQuoteSetOptionForSpendDocument = gql`
    mutation RejectQuoteSetOptionForSpend($input: RejectQuoteSetOptionForSpendInput!) {
  rejectQuoteSetOptionForSpend(input: $input) {
    quoteSet {
      ...QuoteSetDetails
    }
  }
}
    ${QuoteSetDetailsFragmentDoc}`;
export type RejectQuoteSetOptionForSpendMutationFn = Apollo.MutationFunction<RejectQuoteSetOptionForSpendMutationNode, RejectQuoteSetOptionForSpendMutationVariables>;

/**
 * __useRejectQuoteSetOptionForSpendMutation__
 *
 * To run a mutation, you first call `useRejectQuoteSetOptionForSpendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectQuoteSetOptionForSpendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectQuoteSetOptionForSpendMutation, { data, loading, error }] = useRejectQuoteSetOptionForSpendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectQuoteSetOptionForSpendMutation(baseOptions?: Apollo.MutationHookOptions<RejectQuoteSetOptionForSpendMutationNode, RejectQuoteSetOptionForSpendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectQuoteSetOptionForSpendMutationNode, RejectQuoteSetOptionForSpendMutationVariables>(RejectQuoteSetOptionForSpendDocument, options);
      }
export type RejectQuoteSetOptionForSpendMutationHookResult = ReturnType<typeof useRejectQuoteSetOptionForSpendMutation>;
export type RejectQuoteSetOptionForSpendMutationResult = Apollo.MutationResult<RejectQuoteSetOptionForSpendMutationNode>;
export type RejectQuoteSetOptionForSpendMutationOptions = Apollo.BaseMutationOptions<RejectQuoteSetOptionForSpendMutationNode, RejectQuoteSetOptionForSpendMutationVariables>;
export const RemoveUserFromClientOrganizationDocument = gql`
    mutation RemoveUserFromClientOrganization($clientOrganizationId: ID!, $userId: ID!) {
  removeUserFromClientOrganization(
    clientOrganizationId: $clientOrganizationId
    userId: $userId
  ) {
    ok
  }
}
    `;
export type RemoveUserFromClientOrganizationMutationFn = Apollo.MutationFunction<RemoveUserFromClientOrganizationMutationNode, RemoveUserFromClientOrganizationMutationVariables>;

/**
 * __useRemoveUserFromClientOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromClientOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromClientOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromClientOrganizationMutation, { data, loading, error }] = useRemoveUserFromClientOrganizationMutation({
 *   variables: {
 *      clientOrganizationId: // value for 'clientOrganizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromClientOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromClientOrganizationMutationNode, RemoveUserFromClientOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromClientOrganizationMutationNode, RemoveUserFromClientOrganizationMutationVariables>(RemoveUserFromClientOrganizationDocument, options);
      }
export type RemoveUserFromClientOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromClientOrganizationMutation>;
export type RemoveUserFromClientOrganizationMutationResult = Apollo.MutationResult<RemoveUserFromClientOrganizationMutationNode>;
export type RemoveUserFromClientOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromClientOrganizationMutationNode, RemoveUserFromClientOrganizationMutationVariables>;
export const RemoveUsersFromRoleDocument = gql`
    mutation RemoveUsersFromRole($input: RemoveUsersFromRoleMutationInput!) {
  removeUsersFromRole(input: $input) {
    ok
  }
}
    `;
export type RemoveUsersFromRoleMutationFn = Apollo.MutationFunction<RemoveUsersFromRoleMutationNode, RemoveUsersFromRoleMutationVariables>;

/**
 * __useRemoveUsersFromRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromRoleMutation, { data, loading, error }] = useRemoveUsersFromRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromRoleMutationNode, RemoveUsersFromRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromRoleMutationNode, RemoveUsersFromRoleMutationVariables>(RemoveUsersFromRoleDocument, options);
      }
export type RemoveUsersFromRoleMutationHookResult = ReturnType<typeof useRemoveUsersFromRoleMutation>;
export type RemoveUsersFromRoleMutationResult = Apollo.MutationResult<RemoveUsersFromRoleMutationNode>;
export type RemoveUsersFromRoleMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromRoleMutationNode, RemoveUsersFromRoleMutationVariables>;
export const RequestDispatchChangesDocument = gql`
    mutation RequestDispatchChanges($input: RequestDispatchChangesMutationInput!) {
  requestDispatchChanges(input: $input) {
    ok
  }
}
    `;
export type RequestDispatchChangesMutationFn = Apollo.MutationFunction<RequestDispatchChangesMutationNode, RequestDispatchChangesMutationVariables>;

/**
 * __useRequestDispatchChangesMutation__
 *
 * To run a mutation, you first call `useRequestDispatchChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDispatchChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDispatchChangesMutation, { data, loading, error }] = useRequestDispatchChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestDispatchChangesMutation(baseOptions?: Apollo.MutationHookOptions<RequestDispatchChangesMutationNode, RequestDispatchChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDispatchChangesMutationNode, RequestDispatchChangesMutationVariables>(RequestDispatchChangesDocument, options);
      }
export type RequestDispatchChangesMutationHookResult = ReturnType<typeof useRequestDispatchChangesMutation>;
export type RequestDispatchChangesMutationResult = Apollo.MutationResult<RequestDispatchChangesMutationNode>;
export type RequestDispatchChangesMutationOptions = Apollo.BaseMutationOptions<RequestDispatchChangesMutationNode, RequestDispatchChangesMutationVariables>;
export const RequestPlannedMaintenanceQuoteDocument = gql`
    mutation RequestPlannedMaintenanceQuote($input: RequestPlannedMaintenanceQuoteMutationInput!) {
  requestPlannedMaintenanceQuote(input: $input) {
    ok
  }
}
    `;
export type RequestPlannedMaintenanceQuoteMutationFn = Apollo.MutationFunction<RequestPlannedMaintenanceQuoteMutationNode, RequestPlannedMaintenanceQuoteMutationVariables>;

/**
 * __useRequestPlannedMaintenanceQuoteMutation__
 *
 * To run a mutation, you first call `useRequestPlannedMaintenanceQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPlannedMaintenanceQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPlannedMaintenanceQuoteMutation, { data, loading, error }] = useRequestPlannedMaintenanceQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPlannedMaintenanceQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RequestPlannedMaintenanceQuoteMutationNode, RequestPlannedMaintenanceQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPlannedMaintenanceQuoteMutationNode, RequestPlannedMaintenanceQuoteMutationVariables>(RequestPlannedMaintenanceQuoteDocument, options);
      }
export type RequestPlannedMaintenanceQuoteMutationHookResult = ReturnType<typeof useRequestPlannedMaintenanceQuoteMutation>;
export type RequestPlannedMaintenanceQuoteMutationResult = Apollo.MutationResult<RequestPlannedMaintenanceQuoteMutationNode>;
export type RequestPlannedMaintenanceQuoteMutationOptions = Apollo.BaseMutationOptions<RequestPlannedMaintenanceQuoteMutationNode, RequestPlannedMaintenanceQuoteMutationVariables>;
export const RescheduleAppointmentDocument = gql`
    mutation RescheduleAppointment($input: RescheduleAppointmentInput!) {
  rescheduleAppointment(input: $input) {
    appointment {
      id
    }
  }
}
    `;
export type RescheduleAppointmentMutationFn = Apollo.MutationFunction<RescheduleAppointmentMutationNode, RescheduleAppointmentMutationVariables>;

/**
 * __useRescheduleAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentMutation, { data, loading, error }] = useRescheduleAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentMutationNode, RescheduleAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentMutationNode, RescheduleAppointmentMutationVariables>(RescheduleAppointmentDocument, options);
      }
export type RescheduleAppointmentMutationHookResult = ReturnType<typeof useRescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationResult = Apollo.MutationResult<RescheduleAppointmentMutationNode>;
export type RescheduleAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentMutationNode, RescheduleAppointmentMutationVariables>;
export const ResendClientVendorRelationshipInviteDocument = gql`
    mutation ResendClientVendorRelationshipInvite($input: ResendClientVendorRelationshipInviteInput!) {
  resendClientVendorRelationshipInvite(input: $input) {
    invite {
      id
    }
  }
}
    `;
export type ResendClientVendorRelationshipInviteMutationFn = Apollo.MutationFunction<ResendClientVendorRelationshipInviteMutationNode, ResendClientVendorRelationshipInviteMutationVariables>;

/**
 * __useResendClientVendorRelationshipInviteMutation__
 *
 * To run a mutation, you first call `useResendClientVendorRelationshipInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendClientVendorRelationshipInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendClientVendorRelationshipInviteMutation, { data, loading, error }] = useResendClientVendorRelationshipInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendClientVendorRelationshipInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendClientVendorRelationshipInviteMutationNode, ResendClientVendorRelationshipInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendClientVendorRelationshipInviteMutationNode, ResendClientVendorRelationshipInviteMutationVariables>(ResendClientVendorRelationshipInviteDocument, options);
      }
export type ResendClientVendorRelationshipInviteMutationHookResult = ReturnType<typeof useResendClientVendorRelationshipInviteMutation>;
export type ResendClientVendorRelationshipInviteMutationResult = Apollo.MutationResult<ResendClientVendorRelationshipInviteMutationNode>;
export type ResendClientVendorRelationshipInviteMutationOptions = Apollo.BaseMutationOptions<ResendClientVendorRelationshipInviteMutationNode, ResendClientVendorRelationshipInviteMutationVariables>;
export const RevokeClientVendorRelationshipInviteDocument = gql`
    mutation RevokeClientVendorRelationshipInvite($input: RevokeClientVendorRelationshipInviteInput!) {
  revokeClientVendorRelationshipInvite(input: $input) {
    ok
  }
}
    `;
export type RevokeClientVendorRelationshipInviteMutationFn = Apollo.MutationFunction<RevokeClientVendorRelationshipInviteMutationNode, RevokeClientVendorRelationshipInviteMutationVariables>;

/**
 * __useRevokeClientVendorRelationshipInviteMutation__
 *
 * To run a mutation, you first call `useRevokeClientVendorRelationshipInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeClientVendorRelationshipInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeClientVendorRelationshipInviteMutation, { data, loading, error }] = useRevokeClientVendorRelationshipInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeClientVendorRelationshipInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeClientVendorRelationshipInviteMutationNode, RevokeClientVendorRelationshipInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeClientVendorRelationshipInviteMutationNode, RevokeClientVendorRelationshipInviteMutationVariables>(RevokeClientVendorRelationshipInviteDocument, options);
      }
export type RevokeClientVendorRelationshipInviteMutationHookResult = ReturnType<typeof useRevokeClientVendorRelationshipInviteMutation>;
export type RevokeClientVendorRelationshipInviteMutationResult = Apollo.MutationResult<RevokeClientVendorRelationshipInviteMutationNode>;
export type RevokeClientVendorRelationshipInviteMutationOptions = Apollo.BaseMutationOptions<RevokeClientVendorRelationshipInviteMutationNode, RevokeClientVendorRelationshipInviteMutationVariables>;
export const SelectQuoteSetOptionDocument = gql`
    mutation SelectQuoteSetOption($input: SelectQuoteSetOptionInput!) {
  selectQuoteSetOption(input: $input) {
    quoteSet {
      workOrder {
        id
      }
      ...QuoteSetDetails
    }
  }
}
    ${QuoteSetDetailsFragmentDoc}`;
export type SelectQuoteSetOptionMutationFn = Apollo.MutationFunction<SelectQuoteSetOptionMutationNode, SelectQuoteSetOptionMutationVariables>;

/**
 * __useSelectQuoteSetOptionMutation__
 *
 * To run a mutation, you first call `useSelectQuoteSetOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectQuoteSetOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectQuoteSetOptionMutation, { data, loading, error }] = useSelectQuoteSetOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectQuoteSetOptionMutation(baseOptions?: Apollo.MutationHookOptions<SelectQuoteSetOptionMutationNode, SelectQuoteSetOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectQuoteSetOptionMutationNode, SelectQuoteSetOptionMutationVariables>(SelectQuoteSetOptionDocument, options);
      }
export type SelectQuoteSetOptionMutationHookResult = ReturnType<typeof useSelectQuoteSetOptionMutation>;
export type SelectQuoteSetOptionMutationResult = Apollo.MutationResult<SelectQuoteSetOptionMutationNode>;
export type SelectQuoteSetOptionMutationOptions = Apollo.BaseMutationOptions<SelectQuoteSetOptionMutationNode, SelectQuoteSetOptionMutationVariables>;
export const SendInviteSmsDocument = gql`
    mutation SendInviteSms($inviteId: ID!) {
  sendInviteSms(inviteId: $inviteId) {
    ok
  }
}
    `;
export type SendInviteSmsMutationFn = Apollo.MutationFunction<SendInviteSmsMutationNode, SendInviteSmsMutationVariables>;

/**
 * __useSendInviteSmsMutation__
 *
 * To run a mutation, you first call `useSendInviteSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteSmsMutation, { data, loading, error }] = useSendInviteSmsMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useSendInviteSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteSmsMutationNode, SendInviteSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteSmsMutationNode, SendInviteSmsMutationVariables>(SendInviteSmsDocument, options);
      }
export type SendInviteSmsMutationHookResult = ReturnType<typeof useSendInviteSmsMutation>;
export type SendInviteSmsMutationResult = Apollo.MutationResult<SendInviteSmsMutationNode>;
export type SendInviteSmsMutationOptions = Apollo.BaseMutationOptions<SendInviteSmsMutationNode, SendInviteSmsMutationVariables>;
export const SetNotificationPreferenceDocument = gql`
    mutation SetNotificationPreference($input: SetNotificationPreferenceInput!) {
  setNotificationPreference(input: $input) {
    notificationPreference {
      ...NotificationPreferenceSummary
    }
  }
}
    ${NotificationPreferenceSummaryFragmentDoc}`;
export type SetNotificationPreferenceMutationFn = Apollo.MutationFunction<SetNotificationPreferenceMutationNode, SetNotificationPreferenceMutationVariables>;

/**
 * __useSetNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationPreferenceMutation, { data, loading, error }] = useSetNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationPreferenceMutationNode, SetNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationPreferenceMutationNode, SetNotificationPreferenceMutationVariables>(SetNotificationPreferenceDocument, options);
      }
export type SetNotificationPreferenceMutationHookResult = ReturnType<typeof useSetNotificationPreferenceMutation>;
export type SetNotificationPreferenceMutationResult = Apollo.MutationResult<SetNotificationPreferenceMutationNode>;
export type SetNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<SetNotificationPreferenceMutationNode, SetNotificationPreferenceMutationVariables>;
export const SetUserNotificationPreferenceDocument = gql`
    mutation SetUserNotificationPreference($input: SetUserNoficationPreferenceMutationInput!) {
  setUserNotificationPreference(input: $input) {
    userNotificationPreference {
      id
      email
      push
      sms
    }
  }
}
    `;
export type SetUserNotificationPreferenceMutationFn = Apollo.MutationFunction<SetUserNotificationPreferenceMutationNode, SetUserNotificationPreferenceMutationVariables>;

/**
 * __useSetUserNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetUserNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserNotificationPreferenceMutation, { data, loading, error }] = useSetUserNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetUserNotificationPreferenceMutationNode, SetUserNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserNotificationPreferenceMutationNode, SetUserNotificationPreferenceMutationVariables>(SetUserNotificationPreferenceDocument, options);
      }
export type SetUserNotificationPreferenceMutationHookResult = ReturnType<typeof useSetUserNotificationPreferenceMutation>;
export type SetUserNotificationPreferenceMutationResult = Apollo.MutationResult<SetUserNotificationPreferenceMutationNode>;
export type SetUserNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<SetUserNotificationPreferenceMutationNode, SetUserNotificationPreferenceMutationVariables>;
export const SetupPreAuthorizedDebitDocument = gql`
    mutation SetupPreAuthorizedDebit($input: SetupPreAuthorizedDebitMutationInput!) {
  setupPreAuthorizedDebit(input: $input) {
    clientSecret
  }
}
    `;
export type SetupPreAuthorizedDebitMutationFn = Apollo.MutationFunction<SetupPreAuthorizedDebitMutationNode, SetupPreAuthorizedDebitMutationVariables>;

/**
 * __useSetupPreAuthorizedDebitMutation__
 *
 * To run a mutation, you first call `useSetupPreAuthorizedDebitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupPreAuthorizedDebitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupPreAuthorizedDebitMutation, { data, loading, error }] = useSetupPreAuthorizedDebitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupPreAuthorizedDebitMutation(baseOptions?: Apollo.MutationHookOptions<SetupPreAuthorizedDebitMutationNode, SetupPreAuthorizedDebitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupPreAuthorizedDebitMutationNode, SetupPreAuthorizedDebitMutationVariables>(SetupPreAuthorizedDebitDocument, options);
      }
export type SetupPreAuthorizedDebitMutationHookResult = ReturnType<typeof useSetupPreAuthorizedDebitMutation>;
export type SetupPreAuthorizedDebitMutationResult = Apollo.MutationResult<SetupPreAuthorizedDebitMutationNode>;
export type SetupPreAuthorizedDebitMutationOptions = Apollo.BaseMutationOptions<SetupPreAuthorizedDebitMutationNode, SetupPreAuthorizedDebitMutationVariables>;
export const SnoozeReviewsDocument = gql`
    mutation SnoozeReviews($input: SnoozeReviewsInput!) {
  snoozeReviews(input: $input) {
    ok
  }
}
    `;
export type SnoozeReviewsMutationFn = Apollo.MutationFunction<SnoozeReviewsMutationNode, SnoozeReviewsMutationVariables>;

/**
 * __useSnoozeReviewsMutation__
 *
 * To run a mutation, you first call `useSnoozeReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeReviewsMutation, { data, loading, error }] = useSnoozeReviewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeReviewsMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeReviewsMutationNode, SnoozeReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeReviewsMutationNode, SnoozeReviewsMutationVariables>(SnoozeReviewsDocument, options);
      }
export type SnoozeReviewsMutationHookResult = ReturnType<typeof useSnoozeReviewsMutation>;
export type SnoozeReviewsMutationResult = Apollo.MutationResult<SnoozeReviewsMutationNode>;
export type SnoozeReviewsMutationOptions = Apollo.BaseMutationOptions<SnoozeReviewsMutationNode, SnoozeReviewsMutationVariables>;
export const SubmitQuoteFeedbackDocument = gql`
    mutation SubmitQuoteFeedback($arguments: SubmitQuoteFeedbackArguments!) {
  submitQuoteFeedback(arguments: $arguments) {
    quote {
      ...QuoteSummary
    }
  }
}
    ${QuoteSummaryFragmentDoc}`;
export type SubmitQuoteFeedbackMutationFn = Apollo.MutationFunction<SubmitQuoteFeedbackMutationNode, SubmitQuoteFeedbackMutationVariables>;

/**
 * __useSubmitQuoteFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitQuoteFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuoteFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuoteFeedbackMutation, { data, loading, error }] = useSubmitQuoteFeedbackMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useSubmitQuoteFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQuoteFeedbackMutationNode, SubmitQuoteFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQuoteFeedbackMutationNode, SubmitQuoteFeedbackMutationVariables>(SubmitQuoteFeedbackDocument, options);
      }
export type SubmitQuoteFeedbackMutationHookResult = ReturnType<typeof useSubmitQuoteFeedbackMutation>;
export type SubmitQuoteFeedbackMutationResult = Apollo.MutationResult<SubmitQuoteFeedbackMutationNode>;
export type SubmitQuoteFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitQuoteFeedbackMutationNode, SubmitQuoteFeedbackMutationVariables>;
export const UpdateBusinessUnitDocument = gql`
    mutation UpdateBusinessUnit($arguments: UpdateBusinessUnitArguments!) {
  updateBusinessUnit(arguments: $arguments) {
    businessUnit {
      ...BusinessUnitDetails
    }
  }
}
    ${BusinessUnitDetailsFragmentDoc}`;
export type UpdateBusinessUnitMutationFn = Apollo.MutationFunction<UpdateBusinessUnitMutationNode, UpdateBusinessUnitMutationVariables>;

/**
 * __useUpdateBusinessUnitMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUnitMutation, { data, loading, error }] = useUpdateBusinessUnitMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useUpdateBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUnitMutationNode, UpdateBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUnitMutationNode, UpdateBusinessUnitMutationVariables>(UpdateBusinessUnitDocument, options);
      }
export type UpdateBusinessUnitMutationHookResult = ReturnType<typeof useUpdateBusinessUnitMutation>;
export type UpdateBusinessUnitMutationResult = Apollo.MutationResult<UpdateBusinessUnitMutationNode>;
export type UpdateBusinessUnitMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUnitMutationNode, UpdateBusinessUnitMutationVariables>;
export const UpdateClientReportScheduleDocument = gql`
    mutation UpdateClientReportSchedule($input: UpdateClientReportScheduleMutationInput!) {
  updateClientReportSchedule(input: $input) {
    schedule {
      ...ClientReportScheduleDetails
    }
  }
}
    ${ClientReportScheduleDetailsFragmentDoc}`;
export type UpdateClientReportScheduleMutationFn = Apollo.MutationFunction<UpdateClientReportScheduleMutationNode, UpdateClientReportScheduleMutationVariables>;

/**
 * __useUpdateClientReportScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateClientReportScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientReportScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientReportScheduleMutation, { data, loading, error }] = useUpdateClientReportScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientReportScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientReportScheduleMutationNode, UpdateClientReportScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientReportScheduleMutationNode, UpdateClientReportScheduleMutationVariables>(UpdateClientReportScheduleDocument, options);
      }
export type UpdateClientReportScheduleMutationHookResult = ReturnType<typeof useUpdateClientReportScheduleMutation>;
export type UpdateClientReportScheduleMutationResult = Apollo.MutationResult<UpdateClientReportScheduleMutationNode>;
export type UpdateClientReportScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateClientReportScheduleMutationNode, UpdateClientReportScheduleMutationVariables>;
export const UpdateFacilityDocument = gql`
    mutation UpdateFacility($arguments: UpdateFacilityArguments!) {
  updateFacility(arguments: $arguments) {
    facility {
      ...FacilityDetails
    }
  }
}
    ${FacilityDetailsFragmentDoc}`;
export type UpdateFacilityMutationFn = Apollo.MutationFunction<UpdateFacilityMutationNode, UpdateFacilityMutationVariables>;

/**
 * __useUpdateFacilityMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityMutation, { data, loading, error }] = useUpdateFacilityMutation({
 *   variables: {
 *      arguments: // value for 'arguments'
 *   },
 * });
 */
export function useUpdateFacilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFacilityMutationNode, UpdateFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFacilityMutationNode, UpdateFacilityMutationVariables>(UpdateFacilityDocument, options);
      }
export type UpdateFacilityMutationHookResult = ReturnType<typeof useUpdateFacilityMutation>;
export type UpdateFacilityMutationResult = Apollo.MutationResult<UpdateFacilityMutationNode>;
export type UpdateFacilityMutationOptions = Apollo.BaseMutationOptions<UpdateFacilityMutationNode, UpdateFacilityMutationVariables>;
export const UpdateFacilityGroupDocument = gql`
    mutation UpdateFacilityGroup($input: UpdateFacilityGroupInput!) {
  updateFacilityGroup(input: $input) {
    facilityGroup {
      ...FacilityGroupDetails
    }
  }
}
    ${FacilityGroupDetailsFragmentDoc}`;
export type UpdateFacilityGroupMutationFn = Apollo.MutationFunction<UpdateFacilityGroupMutationNode, UpdateFacilityGroupMutationVariables>;

/**
 * __useUpdateFacilityGroupMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityGroupMutation, { data, loading, error }] = useUpdateFacilityGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilityGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFacilityGroupMutationNode, UpdateFacilityGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFacilityGroupMutationNode, UpdateFacilityGroupMutationVariables>(UpdateFacilityGroupDocument, options);
      }
export type UpdateFacilityGroupMutationHookResult = ReturnType<typeof useUpdateFacilityGroupMutation>;
export type UpdateFacilityGroupMutationResult = Apollo.MutationResult<UpdateFacilityGroupMutationNode>;
export type UpdateFacilityGroupMutationOptions = Apollo.BaseMutationOptions<UpdateFacilityGroupMutationNode, UpdateFacilityGroupMutationVariables>;
export const UpdateInternalRequestTeamMemberAssignmentsDocument = gql`
    mutation UpdateInternalRequestTeamMemberAssignments($input: UpdateInternalRequestTeamMemberAssignmentsInput!) {
  updateInternalRequestTeamMemberAssignments(input: $input) {
    internalRequest {
      id
    }
  }
}
    `;
export type UpdateInternalRequestTeamMemberAssignmentsMutationFn = Apollo.MutationFunction<UpdateInternalRequestTeamMemberAssignmentsMutationNode, UpdateInternalRequestTeamMemberAssignmentsMutationVariables>;

/**
 * __useUpdateInternalRequestTeamMemberAssignmentsMutation__
 *
 * To run a mutation, you first call `useUpdateInternalRequestTeamMemberAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalRequestTeamMemberAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalRequestTeamMemberAssignmentsMutation, { data, loading, error }] = useUpdateInternalRequestTeamMemberAssignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInternalRequestTeamMemberAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalRequestTeamMemberAssignmentsMutationNode, UpdateInternalRequestTeamMemberAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalRequestTeamMemberAssignmentsMutationNode, UpdateInternalRequestTeamMemberAssignmentsMutationVariables>(UpdateInternalRequestTeamMemberAssignmentsDocument, options);
      }
export type UpdateInternalRequestTeamMemberAssignmentsMutationHookResult = ReturnType<typeof useUpdateInternalRequestTeamMemberAssignmentsMutation>;
export type UpdateInternalRequestTeamMemberAssignmentsMutationResult = Apollo.MutationResult<UpdateInternalRequestTeamMemberAssignmentsMutationNode>;
export type UpdateInternalRequestTeamMemberAssignmentsMutationOptions = Apollo.BaseMutationOptions<UpdateInternalRequestTeamMemberAssignmentsMutationNode, UpdateInternalRequestTeamMemberAssignmentsMutationVariables>;
export const UpdateInvoiceApprovalSettingsDocument = gql`
    mutation UpdateInvoiceApprovalSettings($input: UpdateInvoiceApprovalSettingsInput!) {
  updateInvoiceApprovalSettings(input: $input) {
    invoiceApprovalSettings {
      ...InvoiceApprovalSettings
    }
  }
}
    ${InvoiceApprovalSettingsFragmentDoc}`;
export type UpdateInvoiceApprovalSettingsMutationFn = Apollo.MutationFunction<UpdateInvoiceApprovalSettingsMutationNode, UpdateInvoiceApprovalSettingsMutationVariables>;

/**
 * __useUpdateInvoiceApprovalSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceApprovalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceApprovalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceApprovalSettingsMutation, { data, loading, error }] = useUpdateInvoiceApprovalSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceApprovalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceApprovalSettingsMutationNode, UpdateInvoiceApprovalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceApprovalSettingsMutationNode, UpdateInvoiceApprovalSettingsMutationVariables>(UpdateInvoiceApprovalSettingsDocument, options);
      }
export type UpdateInvoiceApprovalSettingsMutationHookResult = ReturnType<typeof useUpdateInvoiceApprovalSettingsMutation>;
export type UpdateInvoiceApprovalSettingsMutationResult = Apollo.MutationResult<UpdateInvoiceApprovalSettingsMutationNode>;
export type UpdateInvoiceApprovalSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceApprovalSettingsMutationNode, UpdateInvoiceApprovalSettingsMutationVariables>;
export const UpdateQuoteAcceptanceSettingsDocument = gql`
    mutation UpdateQuoteAcceptanceSettings($input: UpdateQuoteAcceptanceSettingsInput!) {
  updateQuoteAcceptanceSettings(input: $input) {
    quoteAcceptanceSettings {
      ...QuoteAcceptanceSettings
    }
  }
}
    ${QuoteAcceptanceSettingsFragmentDoc}`;
export type UpdateQuoteAcceptanceSettingsMutationFn = Apollo.MutationFunction<UpdateQuoteAcceptanceSettingsMutationNode, UpdateQuoteAcceptanceSettingsMutationVariables>;

/**
 * __useUpdateQuoteAcceptanceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteAcceptanceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteAcceptanceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteAcceptanceSettingsMutation, { data, loading, error }] = useUpdateQuoteAcceptanceSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteAcceptanceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteAcceptanceSettingsMutationNode, UpdateQuoteAcceptanceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteAcceptanceSettingsMutationNode, UpdateQuoteAcceptanceSettingsMutationVariables>(UpdateQuoteAcceptanceSettingsDocument, options);
      }
export type UpdateQuoteAcceptanceSettingsMutationHookResult = ReturnType<typeof useUpdateQuoteAcceptanceSettingsMutation>;
export type UpdateQuoteAcceptanceSettingsMutationResult = Apollo.MutationResult<UpdateQuoteAcceptanceSettingsMutationNode>;
export type UpdateQuoteAcceptanceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteAcceptanceSettingsMutationNode, UpdateQuoteAcceptanceSettingsMutationVariables>;
export const UpdateQuoteApprovalThresholdsDocument = gql`
    mutation UpdateQuoteApprovalThresholds($input: UpdateQuoteApprovalThresholdsInput!) {
  updateQuoteApprovalThresholds(input: $input) {
    ok
  }
}
    `;
export type UpdateQuoteApprovalThresholdsMutationFn = Apollo.MutationFunction<UpdateQuoteApprovalThresholdsMutationNode, UpdateQuoteApprovalThresholdsMutationVariables>;

/**
 * __useUpdateQuoteApprovalThresholdsMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteApprovalThresholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteApprovalThresholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteApprovalThresholdsMutation, { data, loading, error }] = useUpdateQuoteApprovalThresholdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteApprovalThresholdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteApprovalThresholdsMutationNode, UpdateQuoteApprovalThresholdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteApprovalThresholdsMutationNode, UpdateQuoteApprovalThresholdsMutationVariables>(UpdateQuoteApprovalThresholdsDocument, options);
      }
export type UpdateQuoteApprovalThresholdsMutationHookResult = ReturnType<typeof useUpdateQuoteApprovalThresholdsMutation>;
export type UpdateQuoteApprovalThresholdsMutationResult = Apollo.MutationResult<UpdateQuoteApprovalThresholdsMutationNode>;
export type UpdateQuoteApprovalThresholdsMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteApprovalThresholdsMutationNode, UpdateQuoteApprovalThresholdsMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    role {
      ...RoleDetails
    }
  }
}
    ${RoleDetailsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutationNode, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutationNode, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutationNode, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutationNode>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutationNode, UpdateRoleMutationVariables>;
export const UpdateTroubleshootingActionDocument = gql`
    mutation UpdateTroubleshootingAction($input: UpdateTroubleshootingActionMutationInput!) {
  updateTroubleshootingAction(input: $input) {
    ok
  }
}
    `;
export type UpdateTroubleshootingActionMutationFn = Apollo.MutationFunction<UpdateTroubleshootingActionMutationNode, UpdateTroubleshootingActionMutationVariables>;

/**
 * __useUpdateTroubleshootingActionMutation__
 *
 * To run a mutation, you first call `useUpdateTroubleshootingActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTroubleshootingActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTroubleshootingActionMutation, { data, loading, error }] = useUpdateTroubleshootingActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTroubleshootingActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTroubleshootingActionMutationNode, UpdateTroubleshootingActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTroubleshootingActionMutationNode, UpdateTroubleshootingActionMutationVariables>(UpdateTroubleshootingActionDocument, options);
      }
export type UpdateTroubleshootingActionMutationHookResult = ReturnType<typeof useUpdateTroubleshootingActionMutation>;
export type UpdateTroubleshootingActionMutationResult = Apollo.MutationResult<UpdateTroubleshootingActionMutationNode>;
export type UpdateTroubleshootingActionMutationOptions = Apollo.BaseMutationOptions<UpdateTroubleshootingActionMutationNode, UpdateTroubleshootingActionMutationVariables>;
export const UpdateWorkOrderNteDocument = gql`
    mutation UpdateWorkOrderNTE($input: UpdateWorkOrderNTEInput!) {
  updateWorkOrderNte(input: $input) {
    spendApproval {
      id
      approvedAmount
    }
  }
}
    `;
export type UpdateWorkOrderNteMutationFn = Apollo.MutationFunction<UpdateWorkOrderNteMutationNode, UpdateWorkOrderNteMutationVariables>;

/**
 * __useUpdateWorkOrderNteMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderNteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderNteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderNteMutation, { data, loading, error }] = useUpdateWorkOrderNteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOrderNteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderNteMutationNode, UpdateWorkOrderNteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderNteMutationNode, UpdateWorkOrderNteMutationVariables>(UpdateWorkOrderNteDocument, options);
      }
export type UpdateWorkOrderNteMutationHookResult = ReturnType<typeof useUpdateWorkOrderNteMutation>;
export type UpdateWorkOrderNteMutationResult = Apollo.MutationResult<UpdateWorkOrderNteMutationNode>;
export type UpdateWorkOrderNteMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderNteMutationNode, UpdateWorkOrderNteMutationVariables>;
export const UploadAfterImagesDocument = gql`
    mutation UploadAfterImages($appointmentId: ID!, $images: [Image]!) {
  uploadAfterImages(appointmentId: $appointmentId, images: $images) {
    ok
  }
}
    `;
export type UploadAfterImagesMutationFn = Apollo.MutationFunction<UploadAfterImagesMutationNode, UploadAfterImagesMutationVariables>;

/**
 * __useUploadAfterImagesMutation__
 *
 * To run a mutation, you first call `useUploadAfterImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAfterImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAfterImagesMutation, { data, loading, error }] = useUploadAfterImagesMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUploadAfterImagesMutation(baseOptions?: Apollo.MutationHookOptions<UploadAfterImagesMutationNode, UploadAfterImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAfterImagesMutationNode, UploadAfterImagesMutationVariables>(UploadAfterImagesDocument, options);
      }
export type UploadAfterImagesMutationHookResult = ReturnType<typeof useUploadAfterImagesMutation>;
export type UploadAfterImagesMutationResult = Apollo.MutationResult<UploadAfterImagesMutationNode>;
export type UploadAfterImagesMutationOptions = Apollo.BaseMutationOptions<UploadAfterImagesMutationNode, UploadAfterImagesMutationVariables>;
export const UploadVendorInvoiceDocument = gql`
    mutation UploadVendorInvoice($input: UploadVendorInvoiceInput!) {
  uploadVendorInvoice(input: $input) {
    inboundVendorInvoice {
      workOrder {
        id
      }
      invoiceFile {
        key
      }
    }
  }
}
    `;
export type UploadVendorInvoiceMutationFn = Apollo.MutationFunction<UploadVendorInvoiceMutationNode, UploadVendorInvoiceMutationVariables>;

/**
 * __useUploadVendorInvoiceMutation__
 *
 * To run a mutation, you first call `useUploadVendorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVendorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVendorInvoiceMutation, { data, loading, error }] = useUploadVendorInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadVendorInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UploadVendorInvoiceMutationNode, UploadVendorInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVendorInvoiceMutationNode, UploadVendorInvoiceMutationVariables>(UploadVendorInvoiceDocument, options);
      }
export type UploadVendorInvoiceMutationHookResult = ReturnType<typeof useUploadVendorInvoiceMutation>;
export type UploadVendorInvoiceMutationResult = Apollo.MutationResult<UploadVendorInvoiceMutationNode>;
export type UploadVendorInvoiceMutationOptions = Apollo.BaseMutationOptions<UploadVendorInvoiceMutationNode, UploadVendorInvoiceMutationVariables>;
export const CreateUpdateExternalReferenceDocument = gql`
    mutation CreateUpdateExternalReference($input: CreateUpdateExternalReferenceMutationInput!) {
  createUpdateExternalReference(input: $input) {
    ok
  }
}
    `;
export type CreateUpdateExternalReferenceMutationFn = Apollo.MutationFunction<CreateUpdateExternalReferenceMutationNode, CreateUpdateExternalReferenceMutationVariables>;

/**
 * __useCreateUpdateExternalReferenceMutation__
 *
 * To run a mutation, you first call `useCreateUpdateExternalReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateExternalReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateExternalReferenceMutation, { data, loading, error }] = useCreateUpdateExternalReferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateExternalReferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateExternalReferenceMutationNode, CreateUpdateExternalReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateExternalReferenceMutationNode, CreateUpdateExternalReferenceMutationVariables>(CreateUpdateExternalReferenceDocument, options);
      }
export type CreateUpdateExternalReferenceMutationHookResult = ReturnType<typeof useCreateUpdateExternalReferenceMutation>;
export type CreateUpdateExternalReferenceMutationResult = Apollo.MutationResult<CreateUpdateExternalReferenceMutationNode>;
export type CreateUpdateExternalReferenceMutationOptions = Apollo.BaseMutationOptions<CreateUpdateExternalReferenceMutationNode, CreateUpdateExternalReferenceMutationVariables>;
export const DetermineTroubleshootingPlanDocument = gql`
    query DetermineTroubleshootingPlan($clientId: ID!, $equipmentCategoryId: ID, $taxonomyId: ID) {
  determineTroubleshootingPlan(
    clientId: $clientId
    equipmentCategoryId: $equipmentCategoryId
    taxonomyId: $taxonomyId
  ) {
    id
    troubleshootingPlan {
      id
      troubleshootingSteps {
        id
        order
        stepDescription
        supportLink
      }
    }
  }
}
    `;

/**
 * __useDetermineTroubleshootingPlanQuery__
 *
 * To run a query within a React component, call `useDetermineTroubleshootingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetermineTroubleshootingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetermineTroubleshootingPlanQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      equipmentCategoryId: // value for 'equipmentCategoryId'
 *      taxonomyId: // value for 'taxonomyId'
 *   },
 * });
 */
export function useDetermineTroubleshootingPlanQuery(baseOptions: Apollo.QueryHookOptions<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>(DetermineTroubleshootingPlanDocument, options);
      }
export function useDetermineTroubleshootingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>(DetermineTroubleshootingPlanDocument, options);
        }
export type DetermineTroubleshootingPlanQueryHookResult = ReturnType<typeof useDetermineTroubleshootingPlanQuery>;
export type DetermineTroubleshootingPlanLazyQueryHookResult = ReturnType<typeof useDetermineTroubleshootingPlanLazyQuery>;
export type DetermineTroubleshootingPlanQueryResult = Apollo.QueryResult<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>;
export const GetActivityFeedEntriesDocument = gql`
    query GetActivityFeedEntries($workOrderId: ID!, $first: Int, $after: String) {
  activityFeed(
    workOrderId: $workOrderId
    first: $first
    after: $after
    orderBy: "-created_at"
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ActivityFeedEntrySummary
      }
    }
  }
}
    ${ActivityFeedEntrySummaryFragmentDoc}`;

/**
 * __useGetActivityFeedEntriesQuery__
 *
 * To run a query within a React component, call `useGetActivityFeedEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityFeedEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityFeedEntriesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetActivityFeedEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>(GetActivityFeedEntriesDocument, options);
      }
export function useGetActivityFeedEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>(GetActivityFeedEntriesDocument, options);
        }
export type GetActivityFeedEntriesQueryHookResult = ReturnType<typeof useGetActivityFeedEntriesQuery>;
export type GetActivityFeedEntriesLazyQueryHookResult = ReturnType<typeof useGetActivityFeedEntriesLazyQuery>;
export type GetActivityFeedEntriesQueryResult = Apollo.QueryResult<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>;
export const GetAppointmentDocument = gql`
    query GetAppointment($id: ID!) {
  appointment(id: $id) {
    ...AppointmentSummary
    workOrder {
      id
      code
      title
      facility {
        ...FacilitySummary
      }
      vendor {
        ...VendorSummary
      }
    }
  }
}
    ${AppointmentSummaryFragmentDoc}
${FacilitySummaryFragmentDoc}
${VendorSummaryFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQueryNode, GetAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQueryNode, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQueryNode, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQueryNode, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQueryNode, GetAppointmentQueryVariables>;
export const GetBusinessUnitDetailsDocument = gql`
    query GetBusinessUnitDetails($businessUnitId: ID!) {
  businessUnit(id: $businessUnitId) {
    ...BusinessUnitDetails
  }
}
    ${BusinessUnitDetailsFragmentDoc}`;

/**
 * __useGetBusinessUnitDetailsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitDetailsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetBusinessUnitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>(GetBusinessUnitDetailsDocument, options);
      }
export function useGetBusinessUnitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>(GetBusinessUnitDetailsDocument, options);
        }
export type GetBusinessUnitDetailsQueryHookResult = ReturnType<typeof useGetBusinessUnitDetailsQuery>;
export type GetBusinessUnitDetailsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitDetailsLazyQuery>;
export type GetBusinessUnitDetailsQueryResult = Apollo.QueryResult<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>;
export const GetBusinessUnitsDocument = gql`
    query GetBusinessUnits($clientId: ID!, $first: Int!, $skip: Int, $onlyAccessible: Boolean) {
  businessUnits(
    client: $clientId
    first: $first
    skip: $skip
    onlyAccessible: $onlyAccessible
  ) {
    totalCount
    edges {
      node {
        ...BusinessUnitSummary
      }
    }
  }
}
    ${BusinessUnitSummaryFragmentDoc}`;

/**
 * __useGetBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      onlyAccessible: // value for 'onlyAccessible'
 *   },
 * });
 */
export function useGetBusinessUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
      }
export function useGetBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
        }
export type GetBusinessUnitsQueryHookResult = ReturnType<typeof useGetBusinessUnitsQuery>;
export type GetBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitsLazyQuery>;
export type GetBusinessUnitsQueryResult = Apollo.QueryResult<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>;
export const GetCanWorkOrderBeForceCompletedDocument = gql`
    query GetCanWorkOrderBeForceCompleted($workOrderId: ID!) {
  workOrder(id: $workOrderId) {
    canBeForceCompleted: can(perform: FORCE_COMPLETE_JOB)
  }
}
    `;

/**
 * __useGetCanWorkOrderBeForceCompletedQuery__
 *
 * To run a query within a React component, call `useGetCanWorkOrderBeForceCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanWorkOrderBeForceCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanWorkOrderBeForceCompletedQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetCanWorkOrderBeForceCompletedQuery(baseOptions: Apollo.QueryHookOptions<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>(GetCanWorkOrderBeForceCompletedDocument, options);
      }
export function useGetCanWorkOrderBeForceCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>(GetCanWorkOrderBeForceCompletedDocument, options);
        }
export type GetCanWorkOrderBeForceCompletedQueryHookResult = ReturnType<typeof useGetCanWorkOrderBeForceCompletedQuery>;
export type GetCanWorkOrderBeForceCompletedLazyQueryHookResult = ReturnType<typeof useGetCanWorkOrderBeForceCompletedLazyQuery>;
export type GetCanWorkOrderBeForceCompletedQueryResult = Apollo.QueryResult<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>;
export const GetCitiesDocument = gql`
    query GetCities($query: String, $provinceId: ID!, $first: Int!) {
  cities(province: $provinceId, name: $query, orderBy: "name", first: $first) {
    edges {
      node {
        ...CitySummary
      }
    }
  }
}
    ${CitySummaryFragmentDoc}`;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      provinceId: // value for 'provinceId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesQueryNode, GetCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQueryNode, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQueryNode, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQueryNode, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQueryNode, GetCitiesQueryVariables>;
export const GetClientDetailsDocument = gql`
    query GetClientDetails($id: ID!) {
  clientOrganization(id: $id) {
    ...ClientDetails
  }
}
    ${ClientDetailsFragmentDoc}`;

/**
 * __useGetClientDetailsQuery__
 *
 * To run a query within a React component, call `useGetClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
      }
export function useGetClientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>(GetClientDetailsDocument, options);
        }
export type GetClientDetailsQueryHookResult = ReturnType<typeof useGetClientDetailsQuery>;
export type GetClientDetailsLazyQueryHookResult = ReturnType<typeof useGetClientDetailsLazyQuery>;
export type GetClientDetailsQueryResult = Apollo.QueryResult<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>;
export const GetClientFeaturesDocument = gql`
    query GetClientFeatures($organizationId: ID, $businessUnitId: ID, $facilityId: ID) {
  clientFeatures(
    organizationId: $organizationId
    businessUnitId: $businessUnitId
    facilityId: $facilityId
  )
}
    `;

/**
 * __useGetClientFeaturesQuery__
 *
 * To run a query within a React component, call `useGetClientFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientFeaturesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      businessUnitId: // value for 'businessUnitId'
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetClientFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>(GetClientFeaturesDocument, options);
      }
export function useGetClientFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>(GetClientFeaturesDocument, options);
        }
export type GetClientFeaturesQueryHookResult = ReturnType<typeof useGetClientFeaturesQuery>;
export type GetClientFeaturesLazyQueryHookResult = ReturnType<typeof useGetClientFeaturesLazyQuery>;
export type GetClientFeaturesQueryResult = Apollo.QueryResult<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>;
export const GetClientInvoicesDocument = gql`
    query GetClientInvoices($first: Int, $skip: Int, $query: String = "", $clientOrganizationId: ID!, $businessUnitId: ID, $orderBy: String, $facilityGroupIds: [ID], $status: [ClientInvoiceStatus!], $serviceCategory: [ServiceCategory!], $isMaintenancePlan: Boolean, $isSubscriptionInvoice: Boolean, $startDate: Date, $endDate: Date, $completedOnStartDate: Date, $completedOnEndDate: Date, $paidAtStartDate: Date, $paidAtEndDate: Date, $expenseTypes: [ExpenseType], $assignedVendorIds: [ID], $isApproved: Boolean, $isDisputed: Boolean, $overtimeApproved: Boolean, $dueAtDate: Date) {
  clientInvoices(
    first: $first
    query: $query
    skip: $skip
    clientOrganizationId: $clientOrganizationId
    orderBy: $orderBy
    facilityGroupIds: $facilityGroupIds
    status: $status
    serviceCategory: $serviceCategory
    isMaintenancePlan: $isMaintenancePlan
    isSubscriptionInvoice: $isSubscriptionInvoice
    startDate: $startDate
    endDate: $endDate
    completedOnStartDate: $completedOnStartDate
    completedOnEndDate: $completedOnEndDate
    paidAtStartDate: $paidAtStartDate
    paidAtEndDate: $paidAtEndDate
    businessUnitId: $businessUnitId
    expenseTypes: $expenseTypes
    assignedVendorIds: $assignedVendorIds
    isApproved: $isApproved
    overtimeApproved: $overtimeApproved
    isDisputed: $isDisputed
    dueAtDate: $dueAtDate
  ) {
    totalCount
    total
    edges {
      node {
        ...ClientInvoiceSummary
      }
    }
  }
}
    ${ClientInvoiceSummaryFragmentDoc}`;

/**
 * __useGetClientInvoicesQuery__
 *
 * To run a query within a React component, call `useGetClientInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInvoicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      clientOrganizationId: // value for 'clientOrganizationId'
 *      businessUnitId: // value for 'businessUnitId'
 *      orderBy: // value for 'orderBy'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      status: // value for 'status'
 *      serviceCategory: // value for 'serviceCategory'
 *      isMaintenancePlan: // value for 'isMaintenancePlan'
 *      isSubscriptionInvoice: // value for 'isSubscriptionInvoice'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      completedOnStartDate: // value for 'completedOnStartDate'
 *      completedOnEndDate: // value for 'completedOnEndDate'
 *      paidAtStartDate: // value for 'paidAtStartDate'
 *      paidAtEndDate: // value for 'paidAtEndDate'
 *      expenseTypes: // value for 'expenseTypes'
 *      assignedVendorIds: // value for 'assignedVendorIds'
 *      isApproved: // value for 'isApproved'
 *      isDisputed: // value for 'isDisputed'
 *      overtimeApproved: // value for 'overtimeApproved'
 *      dueAtDate: // value for 'dueAtDate'
 *   },
 * });
 */
export function useGetClientInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>(GetClientInvoicesDocument, options);
      }
export function useGetClientInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>(GetClientInvoicesDocument, options);
        }
export type GetClientInvoicesQueryHookResult = ReturnType<typeof useGetClientInvoicesQuery>;
export type GetClientInvoicesLazyQueryHookResult = ReturnType<typeof useGetClientInvoicesLazyQuery>;
export type GetClientInvoicesQueryResult = Apollo.QueryResult<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>;
export const GetClientMembershipsDocument = gql`
    query GetClientMemberships($clientId: ID!, $facilityIds: [ID!], $roleIds: [ID!], $query: String, $onlyColleaguesOfUser: Boolean, $excludeClientUsersWithResqEmails: Boolean, $permissions: [Permission!], $first: Int!, $skip: Int) {
  clientMemberships: clientOrganizationMembers(
    organizationId: $clientId
    facilityIds: $facilityIds
    roleIds: $roleIds
    query: $query
    onlyColleaguesOfUser: $onlyColleaguesOfUser
    excludeClientUsersWithResqEmails: $excludeClientUsersWithResqEmails
    permissions: $permissions
    first: $first
    skip: $skip
  ) {
    totalCount
    edges {
      node {
        ...ClientMembershipSummary
      }
    }
  }
}
    ${ClientMembershipSummaryFragmentDoc}`;

/**
 * __useGetClientMembershipsQuery__
 *
 * To run a query within a React component, call `useGetClientMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientMembershipsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityIds: // value for 'facilityIds'
 *      roleIds: // value for 'roleIds'
 *      query: // value for 'query'
 *      onlyColleaguesOfUser: // value for 'onlyColleaguesOfUser'
 *      excludeClientUsersWithResqEmails: // value for 'excludeClientUsersWithResqEmails'
 *      permissions: // value for 'permissions'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetClientMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetClientMembershipsQueryNode, GetClientMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientMembershipsQueryNode, GetClientMembershipsQueryVariables>(GetClientMembershipsDocument, options);
      }
export function useGetClientMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientMembershipsQueryNode, GetClientMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientMembershipsQueryNode, GetClientMembershipsQueryVariables>(GetClientMembershipsDocument, options);
        }
export type GetClientMembershipsQueryHookResult = ReturnType<typeof useGetClientMembershipsQuery>;
export type GetClientMembershipsLazyQueryHookResult = ReturnType<typeof useGetClientMembershipsLazyQuery>;
export type GetClientMembershipsQueryResult = Apollo.QueryResult<GetClientMembershipsQueryNode, GetClientMembershipsQueryVariables>;
export const GetClientMetricsDocument = gql`
    query GetClientMetrics($clientId: ID!, $facilityGroupIds: [ID!], $periodStart: DateTime!, $periodEnd: DateTime!, $lastPeriodStart: DateTime, $lastPeriodEnd: DateTime, $serviceTypes: [ServiceType!], $serviceCategories: [ServiceCategory!], $userTz: String) {
  clientMetrics(
    clientId: $clientId
    facilityGroupIds: $facilityGroupIds
    periodStart: $periodStart
    periodEnd: $periodEnd
    lastPeriodStart: $lastPeriodStart
    lastPeriodEnd: $lastPeriodEnd
    serviceTypes: $serviceTypes
    serviceCategories: $serviceCategories
    userTz: $userTz
  ) {
    clientId
    combinedSpend {
      ...SpendByPeriod
    }
    combinedUninvoiced {
      ...UninvoicedByPeriod
    }
    serviceCategorySpend {
      ...SpendByServiceCategory
    }
    mostServicedEquipment {
      ...EquipmentServiceCount
    }
    lastMonthSpendComparison {
      ...PeriodicSpendComparison
    }
    spendThisPeriod
    topSpendWorkOrders {
      ...TopSpendWorkOrders
    }
    topSpendFacilities {
      ...TopSpendFacilities
    }
    averageMonthlyFacilitySpend {
      date
      avgRepairSpend
      avgMpSpend
    }
    workOrdersAwaitingPayment {
      overdueCount
      awaitingPayment
    }
  }
}
    ${SpendByPeriodFragmentDoc}
${UninvoicedByPeriodFragmentDoc}
${SpendByServiceCategoryFragmentDoc}
${EquipmentServiceCountFragmentDoc}
${PeriodicSpendComparisonFragmentDoc}
${TopSpendWorkOrdersFragmentDoc}
${TopSpendFacilitiesFragmentDoc}`;

/**
 * __useGetClientMetricsQuery__
 *
 * To run a query within a React component, call `useGetClientMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientMetricsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      lastPeriodStart: // value for 'lastPeriodStart'
 *      lastPeriodEnd: // value for 'lastPeriodEnd'
 *      serviceTypes: // value for 'serviceTypes'
 *      serviceCategories: // value for 'serviceCategories'
 *      userTz: // value for 'userTz'
 *   },
 * });
 */
export function useGetClientMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>(GetClientMetricsDocument, options);
      }
export function useGetClientMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>(GetClientMetricsDocument, options);
        }
export type GetClientMetricsQueryHookResult = ReturnType<typeof useGetClientMetricsQuery>;
export type GetClientMetricsLazyQueryHookResult = ReturnType<typeof useGetClientMetricsLazyQuery>;
export type GetClientMetricsQueryResult = Apollo.QueryResult<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>;
export const GetClientOrganizationMembersDocument = gql`
    query GetClientOrganizationMembers($clientId: ID!, $facilityIds: [ID], $roleIds: [ID!], $onlyColleaguesOfUser: Boolean, $query: String = "", $orderBy: String, $first: Int!, $skip: Int, $facilityGroupIds: [ID]) {
  clientOrganizationMembers(
    organizationId: $clientId
    facilityIds: $facilityIds
    roleIds: $roleIds
    onlyColleaguesOfUser: $onlyColleaguesOfUser
    query: $query
    orderBy: $orderBy
    first: $first
    skip: $skip
    facilityGroupIds: $facilityGroupIds
  ) {
    totalCount
    edges {
      node {
        ...ClientMembershipSummary
      }
    }
  }
}
    ${ClientMembershipSummaryFragmentDoc}`;

/**
 * __useGetClientOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useGetClientOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrganizationMembersQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityIds: // value for 'facilityIds'
 *      roleIds: // value for 'roleIds'
 *      onlyColleaguesOfUser: // value for 'onlyColleaguesOfUser'
 *      query: // value for 'query'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *   },
 * });
 */
export function useGetClientOrganizationMembersQuery(baseOptions: Apollo.QueryHookOptions<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>(GetClientOrganizationMembersDocument, options);
      }
export function useGetClientOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>(GetClientOrganizationMembersDocument, options);
        }
export type GetClientOrganizationMembersQueryHookResult = ReturnType<typeof useGetClientOrganizationMembersQuery>;
export type GetClientOrganizationMembersLazyQueryHookResult = ReturnType<typeof useGetClientOrganizationMembersLazyQuery>;
export type GetClientOrganizationMembersQueryResult = Apollo.QueryResult<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>;
export const GetClientPerformanceMetricsDocument = gql`
    query GetClientPerformanceMetrics($clientId: ID!, $facilityGroupIds: [ID!], $periodStart: DateTime!, $periodEnd: DateTime!, $serviceTypes: [ServiceType!], $serviceCategories: [ServiceCategory!]) {
  clientMetrics(
    clientId: $clientId
    facilityGroupIds: $facilityGroupIds
    periodStart: $periodStart
    periodEnd: $periodEnd
    serviceTypes: $serviceTypes
    serviceCategories: $serviceCategories
  ) {
    clientId
    quotesAwaitingClientApproval
    invoicesAwaitingClientApproval
    workOrdersAwaitingTriage
    workOrdersCompleted
    workOrdersSubmitted {
      urgentCount
      nonUrgentCount
    }
    averageSchedulingSpeed {
      hasData
      months
      days
      hours
      minutes
    }
    reviewSummary {
      goodReviewCount
      badReviewCount
      goodReviewTags
      badReviewTags
    }
    workOrdersByStatus {
      submitted {
        onDemand
        maintenancePlan
      }
      scheduled {
        onDemand
        maintenancePlan
      }
      onHold {
        onDemand
        maintenancePlan
      }
      completed {
        onDemand
        maintenancePlan
      }
      invoiced {
        onDemand
        maintenancePlan
      }
    }
    workOrdersByCategory {
      serviceCategory
      count
    }
    transactingFacilities
  }
}
    `;

/**
 * __useGetClientPerformanceMetricsQuery__
 *
 * To run a query within a React component, call `useGetClientPerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPerformanceMetricsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      serviceTypes: // value for 'serviceTypes'
 *      serviceCategories: // value for 'serviceCategories'
 *   },
 * });
 */
export function useGetClientPerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>(GetClientPerformanceMetricsDocument, options);
      }
export function useGetClientPerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>(GetClientPerformanceMetricsDocument, options);
        }
export type GetClientPerformanceMetricsQueryHookResult = ReturnType<typeof useGetClientPerformanceMetricsQuery>;
export type GetClientPerformanceMetricsLazyQueryHookResult = ReturnType<typeof useGetClientPerformanceMetricsLazyQuery>;
export type GetClientPerformanceMetricsQueryResult = Apollo.QueryResult<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>;
export const GetClientReportSchedulesDocument = gql`
    query GetClientReportSchedules($organizationId: ID!) {
  clientReportSchedules(organizationId: $organizationId) {
    edges {
      node {
        ...ClientReportScheduleDetails
      }
    }
  }
}
    ${ClientReportScheduleDetailsFragmentDoc}`;

/**
 * __useGetClientReportSchedulesQuery__
 *
 * To run a query within a React component, call `useGetClientReportSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientReportSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientReportSchedulesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetClientReportSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>(GetClientReportSchedulesDocument, options);
      }
export function useGetClientReportSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>(GetClientReportSchedulesDocument, options);
        }
export type GetClientReportSchedulesQueryHookResult = ReturnType<typeof useGetClientReportSchedulesQuery>;
export type GetClientReportSchedulesLazyQueryHookResult = ReturnType<typeof useGetClientReportSchedulesLazyQuery>;
export type GetClientReportSchedulesQueryResult = Apollo.QueryResult<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>;
export const GetClientReportsDocument = gql`
    query GetClientReports($organizationId: ID!, $reportType: [ClientReportType], $orderBy: String = "-generated_on") {
  clientReports(
    organizationId: $organizationId
    reportType: $reportType
    orderBy: $orderBy
  ) {
    totalCount
    edges {
      node {
        ...ClientReportDetails
      }
    }
  }
}
    ${ClientReportDetailsFragmentDoc}`;

/**
 * __useGetClientReportsQuery__
 *
 * To run a query within a React component, call `useGetClientReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      reportType: // value for 'reportType'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetClientReportsQuery(baseOptions: Apollo.QueryHookOptions<GetClientReportsQueryNode, GetClientReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientReportsQueryNode, GetClientReportsQueryVariables>(GetClientReportsDocument, options);
      }
export function useGetClientReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientReportsQueryNode, GetClientReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientReportsQueryNode, GetClientReportsQueryVariables>(GetClientReportsDocument, options);
        }
export type GetClientReportsQueryHookResult = ReturnType<typeof useGetClientReportsQuery>;
export type GetClientReportsLazyQueryHookResult = ReturnType<typeof useGetClientReportsLazyQuery>;
export type GetClientReportsQueryResult = Apollo.QueryResult<GetClientReportsQueryNode, GetClientReportsQueryVariables>;
export const GetClientStatementsDocument = gql`
    query GetClientStatements($clientId: ID!, $businessUnitId: ID!, $first: Int!, $skip: Int) {
  clientStatements(
    organization: $clientId
    businessUnit: $businessUnitId
    first: $first
    skip: $skip
  ) {
    totalCount
    edges {
      node {
        ...ClientMonthlyStatementSummary
      }
    }
  }
}
    ${ClientMonthlyStatementSummaryFragmentDoc}`;

/**
 * __useGetClientStatementsQuery__
 *
 * To run a query within a React component, call `useGetClientStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientStatementsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      businessUnitId: // value for 'businessUnitId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetClientStatementsQuery(baseOptions: Apollo.QueryHookOptions<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>(GetClientStatementsDocument, options);
      }
export function useGetClientStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>(GetClientStatementsDocument, options);
        }
export type GetClientStatementsQueryHookResult = ReturnType<typeof useGetClientStatementsQuery>;
export type GetClientStatementsLazyQueryHookResult = ReturnType<typeof useGetClientStatementsLazyQuery>;
export type GetClientStatementsQueryResult = Apollo.QueryResult<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    edges {
      node {
        ...CountrySummary
      }
    }
  }
}
    ${CountrySummaryFragmentDoc}`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQueryNode, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQueryNode, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQueryNode, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQueryNode, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQueryNode, GetCountriesQueryVariables>;
export const GetClientPreferredSpendThresholdDocument = gql`
    query GetClientPreferredSpendThreshold($organizationId: ID!, $serviceCategory: ServiceCategory!) {
  clientPreferredSpendThreshold(
    organizationId: $organizationId
    serviceCategory: $serviceCategory
  ) {
    approvalRequiredThreshold
    approvalRequiredOvertimeThreshold
  }
}
    `;

/**
 * __useGetClientPreferredSpendThresholdQuery__
 *
 * To run a query within a React component, call `useGetClientPreferredSpendThresholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPreferredSpendThresholdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPreferredSpendThresholdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      serviceCategory: // value for 'serviceCategory'
 *   },
 * });
 */
export function useGetClientPreferredSpendThresholdQuery(baseOptions: Apollo.QueryHookOptions<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>(GetClientPreferredSpendThresholdDocument, options);
      }
export function useGetClientPreferredSpendThresholdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>(GetClientPreferredSpendThresholdDocument, options);
        }
export type GetClientPreferredSpendThresholdQueryHookResult = ReturnType<typeof useGetClientPreferredSpendThresholdQuery>;
export type GetClientPreferredSpendThresholdLazyQueryHookResult = ReturnType<typeof useGetClientPreferredSpendThresholdLazyQuery>;
export type GetClientPreferredSpendThresholdQueryResult = Apollo.QueryResult<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>;
export const GetDisabledFacilityCategoriesDocument = gql`
    query GetDisabledFacilityCategories($facilityId: ID!) {
  facility(id: $facilityId) {
    id
    disabledCategories
  }
}
    `;

/**
 * __useGetDisabledFacilityCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDisabledFacilityCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledFacilityCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledFacilityCategoriesQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetDisabledFacilityCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetDisabledFacilityCategoriesQueryNode, GetDisabledFacilityCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisabledFacilityCategoriesQueryNode, GetDisabledFacilityCategoriesQueryVariables>(GetDisabledFacilityCategoriesDocument, options);
      }
export function useGetDisabledFacilityCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisabledFacilityCategoriesQueryNode, GetDisabledFacilityCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisabledFacilityCategoriesQueryNode, GetDisabledFacilityCategoriesQueryVariables>(GetDisabledFacilityCategoriesDocument, options);
        }
export type GetDisabledFacilityCategoriesQueryHookResult = ReturnType<typeof useGetDisabledFacilityCategoriesQuery>;
export type GetDisabledFacilityCategoriesLazyQueryHookResult = ReturnType<typeof useGetDisabledFacilityCategoriesLazyQuery>;
export type GetDisabledFacilityCategoriesQueryResult = Apollo.QueryResult<GetDisabledFacilityCategoriesQueryNode, GetDisabledFacilityCategoriesQueryVariables>;
export const GetEquipmentDocument = gql`
    query GetEquipment($clientId: ID!, $facilityIds: [ID!], $facilityGroupIds: [ID!], $serviceCategories: [ServiceCategory], $serviceStartDate: Date, $serviceEndDate: Date, $query: String, $first: Int, $skip: Int, $orderBy: String, $equipmentId: ID) {
  equipments(
    facility_Organization: $clientId
    facility_In: $facilityIds
    facilityGroupIds: $facilityGroupIds
    serviceCategory: $serviceCategories
    serviceStartDate: $serviceStartDate
    serviceEndDate: $serviceEndDate
    query: $query
    first: $first
    skip: $skip
    orderBy: $orderBy
    id: $equipmentId
  ) {
    totalCount
    edges {
      node {
        ...EquipmentSummary
      }
    }
  }
}
    ${EquipmentSummaryFragmentDoc}`;

/**
 * __useGetEquipmentQuery__
 *
 * To run a query within a React component, call `useGetEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityIds: // value for 'facilityIds'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      serviceCategories: // value for 'serviceCategories'
 *      serviceStartDate: // value for 'serviceStartDate'
 *      serviceEndDate: // value for 'serviceEndDate'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useGetEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentQueryNode, GetEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentQueryNode, GetEquipmentQueryVariables>(GetEquipmentDocument, options);
      }
export function useGetEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentQueryNode, GetEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentQueryNode, GetEquipmentQueryVariables>(GetEquipmentDocument, options);
        }
export type GetEquipmentQueryHookResult = ReturnType<typeof useGetEquipmentQuery>;
export type GetEquipmentLazyQueryHookResult = ReturnType<typeof useGetEquipmentLazyQuery>;
export type GetEquipmentQueryResult = Apollo.QueryResult<GetEquipmentQueryNode, GetEquipmentQueryVariables>;
export const GetEquipmentDetailsDocument = gql`
    query GetEquipmentDetails($id: ID!) {
  equipment(id: $id) {
    ...EquipmentDetails
  }
}
    ${EquipmentDetailsFragmentDoc}`;

/**
 * __useGetEquipmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>(GetEquipmentDetailsDocument, options);
      }
export function useGetEquipmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>(GetEquipmentDetailsDocument, options);
        }
export type GetEquipmentDetailsQueryHookResult = ReturnType<typeof useGetEquipmentDetailsQuery>;
export type GetEquipmentDetailsLazyQueryHookResult = ReturnType<typeof useGetEquipmentDetailsLazyQuery>;
export type GetEquipmentDetailsQueryResult = Apollo.QueryResult<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>;
export const GetEquipmentShortVersionDocument = gql`
    query GetEquipmentShortVersion($clientId: ID!, $facilityIds: [ID!], $facilityGroupIds: [ID!], $serviceCategories: [ServiceCategory], $serviceStartDate: Date, $serviceEndDate: Date, $hasOngoingIncident: Boolean, $hasSensor: Boolean, $query: String, $first: Int, $skip: Int, $orderBy: String, $equipmentId: ID, $incidentStatus: [IncidentStatus!]) {
  equipments(
    facility_Organization: $clientId
    facility_In: $facilityIds
    facilityGroupIds: $facilityGroupIds
    serviceCategory: $serviceCategories
    serviceStartDate: $serviceStartDate
    serviceEndDate: $serviceEndDate
    hasOngoingIncident: $hasOngoingIncident
    hasSensor: $hasSensor
    query: $query
    first: $first
    skip: $skip
    orderBy: $orderBy
    id: $equipmentId
  ) {
    totalCount
    edges {
      node {
        ...EquipmentSummaryShortVersion
      }
    }
  }
}
    ${EquipmentSummaryShortVersionFragmentDoc}`;

/**
 * __useGetEquipmentShortVersionQuery__
 *
 * To run a query within a React component, call `useGetEquipmentShortVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentShortVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentShortVersionQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityIds: // value for 'facilityIds'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      serviceCategories: // value for 'serviceCategories'
 *      serviceStartDate: // value for 'serviceStartDate'
 *      serviceEndDate: // value for 'serviceEndDate'
 *      hasOngoingIncident: // value for 'hasOngoingIncident'
 *      hasSensor: // value for 'hasSensor'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      equipmentId: // value for 'equipmentId'
 *      incidentStatus: // value for 'incidentStatus'
 *   },
 * });
 */
export function useGetEquipmentShortVersionQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>(GetEquipmentShortVersionDocument, options);
      }
export function useGetEquipmentShortVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>(GetEquipmentShortVersionDocument, options);
        }
export type GetEquipmentShortVersionQueryHookResult = ReturnType<typeof useGetEquipmentShortVersionQuery>;
export type GetEquipmentShortVersionLazyQueryHookResult = ReturnType<typeof useGetEquipmentShortVersionLazyQuery>;
export type GetEquipmentShortVersionQueryResult = Apollo.QueryResult<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>;
export const GetEquipmentSymptomsDocument = gql`
    query GetEquipmentSymptoms($id: ID!) {
  equipment(id: $id) {
    id
    symptoms {
      id
      description
    }
  }
}
    `;

/**
 * __useGetEquipmentSymptomsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentSymptomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentSymptomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentSymptomsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentSymptomsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>(GetEquipmentSymptomsDocument, options);
      }
export function useGetEquipmentSymptomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>(GetEquipmentSymptomsDocument, options);
        }
export type GetEquipmentSymptomsQueryHookResult = ReturnType<typeof useGetEquipmentSymptomsQuery>;
export type GetEquipmentSymptomsLazyQueryHookResult = ReturnType<typeof useGetEquipmentSymptomsLazyQuery>;
export type GetEquipmentSymptomsQueryResult = Apollo.QueryResult<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>;
export const GetEquipmentWorkOrdersDocument = gql`
    query GetEquipmentWorkOrders($equipmentId: ID!, $after: String, $first: Int) {
  workOrders(
    equipment: $equipmentId
    after: $after
    first: $first
    orderBy: "-submitted_to_marketplace_at"
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...WorkOrderForSpendReporting
      }
    }
  }
}
    ${WorkOrderForSpendReportingFragmentDoc}`;

/**
 * __useGetEquipmentWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetEquipmentWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentWorkOrdersQuery({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEquipmentWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>(GetEquipmentWorkOrdersDocument, options);
      }
export function useGetEquipmentWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>(GetEquipmentWorkOrdersDocument, options);
        }
export type GetEquipmentWorkOrdersQueryHookResult = ReturnType<typeof useGetEquipmentWorkOrdersQuery>;
export type GetEquipmentWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetEquipmentWorkOrdersLazyQuery>;
export type GetEquipmentWorkOrdersQueryResult = Apollo.QueryResult<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>;
export const GetExpenseTypePermissionsDocument = gql`
    query GetExpenseTypePermissions($id: ID!) {
  clientOrganization(id: $id) {
    id
    canUpdateExpenseType: can(perform: UPDATE_EXPENSE_TYPE)
  }
}
    `;

/**
 * __useGetExpenseTypePermissionsQuery__
 *
 * To run a query within a React component, call `useGetExpenseTypePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseTypePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseTypePermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExpenseTypePermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>(GetExpenseTypePermissionsDocument, options);
      }
export function useGetExpenseTypePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>(GetExpenseTypePermissionsDocument, options);
        }
export type GetExpenseTypePermissionsQueryHookResult = ReturnType<typeof useGetExpenseTypePermissionsQuery>;
export type GetExpenseTypePermissionsLazyQueryHookResult = ReturnType<typeof useGetExpenseTypePermissionsLazyQuery>;
export type GetExpenseTypePermissionsQueryResult = Apollo.QueryResult<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>;
export const GetFacilitiesDocument = gql`
    query GetFacilities($clientId: ID!, $businessUnitId: ID, $first: Int!, $skip: Int, $status: String, $query: String = "", $entityId: ID) {
  facilities(
    organizationId: $clientId
    businessUnitId: $businessUnitId
    first: $first
    skip: $skip
    query: $query
    orderBy: "name"
    status: $status
    entityId: $entityId
  ) {
    totalCount
    edges {
      node {
        ...FacilitySummary
      }
    }
  }
}
    ${FacilitySummaryFragmentDoc}`;

/**
 * __useGetFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilitiesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      businessUnitId: // value for 'businessUnitId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      status: // value for 'status'
 *      query: // value for 'query'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>(GetFacilitiesDocument, options);
      }
export function useGetFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>(GetFacilitiesDocument, options);
        }
export type GetFacilitiesQueryHookResult = ReturnType<typeof useGetFacilitiesQuery>;
export type GetFacilitiesLazyQueryHookResult = ReturnType<typeof useGetFacilitiesLazyQuery>;
export type GetFacilitiesQueryResult = Apollo.QueryResult<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>;
export const GetFacilityDetailsDocument = gql`
    query GetFacilityDetails($facilityId: ID!) {
  facility(id: $facilityId) {
    ...FacilityDetails
  }
}
    ${FacilityDetailsFragmentDoc}`;

/**
 * __useGetFacilityDetailsQuery__
 *
 * To run a query within a React component, call `useGetFacilityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityDetailsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetFacilityDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>(GetFacilityDetailsDocument, options);
      }
export function useGetFacilityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>(GetFacilityDetailsDocument, options);
        }
export type GetFacilityDetailsQueryHookResult = ReturnType<typeof useGetFacilityDetailsQuery>;
export type GetFacilityDetailsLazyQueryHookResult = ReturnType<typeof useGetFacilityDetailsLazyQuery>;
export type GetFacilityDetailsQueryResult = Apollo.QueryResult<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>;
export const GetFacilityGroupAllMembershipsDocument = gql`
    query GetFacilityGroupAllMemberships($id: ID!) {
  facilityGroup(id: $id) {
    id
    allMemberships {
      ...FacilityGroupMembershipDetails
    }
  }
}
    ${FacilityGroupMembershipDetailsFragmentDoc}`;

/**
 * __useGetFacilityGroupAllMembershipsQuery__
 *
 * To run a query within a React component, call `useGetFacilityGroupAllMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityGroupAllMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityGroupAllMembershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFacilityGroupAllMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>(GetFacilityGroupAllMembershipsDocument, options);
      }
export function useGetFacilityGroupAllMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>(GetFacilityGroupAllMembershipsDocument, options);
        }
export type GetFacilityGroupAllMembershipsQueryHookResult = ReturnType<typeof useGetFacilityGroupAllMembershipsQuery>;
export type GetFacilityGroupAllMembershipsLazyQueryHookResult = ReturnType<typeof useGetFacilityGroupAllMembershipsLazyQuery>;
export type GetFacilityGroupAllMembershipsQueryResult = Apollo.QueryResult<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>;
export const GetFacilityGroupsDocument = gql`
    query GetFacilityGroups($clientId: ID, $isRoot: Boolean, $parentId: ID, $excludeLeaf: Boolean) {
  facilityGroups(
    organizationId: $clientId
    isRoot: $isRoot
    parentId: $parentId
    excludeLeaf: $excludeLeaf
    first: 100
  ) {
    edges {
      node {
        ...FacilityGroupDetails
      }
    }
  }
}
    ${FacilityGroupDetailsFragmentDoc}`;

/**
 * __useGetFacilityGroupsQuery__
 *
 * To run a query within a React component, call `useGetFacilityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityGroupsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      isRoot: // value for 'isRoot'
 *      parentId: // value for 'parentId'
 *      excludeLeaf: // value for 'excludeLeaf'
 *   },
 * });
 */
export function useGetFacilityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>(GetFacilityGroupsDocument, options);
      }
export function useGetFacilityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>(GetFacilityGroupsDocument, options);
        }
export type GetFacilityGroupsQueryHookResult = ReturnType<typeof useGetFacilityGroupsQuery>;
export type GetFacilityGroupsLazyQueryHookResult = ReturnType<typeof useGetFacilityGroupsLazyQuery>;
export type GetFacilityGroupsQueryResult = Apollo.QueryResult<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>;
export const GetFacilityGroupsForBudgetCreationDocument = gql`
    query GetFacilityGroupsForBudgetCreation($clientId: ID!, $isRoot: Boolean, $parentId: ID) {
  facilityGroups(
    organizationId: $clientId
    isRoot: $isRoot
    parentId: $parentId
    first: 100
  ) {
    edges {
      node {
        ...FacilityGroupForBudgetCreation
      }
    }
  }
}
    ${FacilityGroupForBudgetCreationFragmentDoc}`;

/**
 * __useGetFacilityGroupsForBudgetCreationQuery__
 *
 * To run a query within a React component, call `useGetFacilityGroupsForBudgetCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityGroupsForBudgetCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityGroupsForBudgetCreationQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      isRoot: // value for 'isRoot'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetFacilityGroupsForBudgetCreationQuery(baseOptions: Apollo.QueryHookOptions<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>(GetFacilityGroupsForBudgetCreationDocument, options);
      }
export function useGetFacilityGroupsForBudgetCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>(GetFacilityGroupsForBudgetCreationDocument, options);
        }
export type GetFacilityGroupsForBudgetCreationQueryHookResult = ReturnType<typeof useGetFacilityGroupsForBudgetCreationQuery>;
export type GetFacilityGroupsForBudgetCreationLazyQueryHookResult = ReturnType<typeof useGetFacilityGroupsForBudgetCreationLazyQuery>;
export type GetFacilityGroupsForBudgetCreationQueryResult = Apollo.QueryResult<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>;
export const GetFacilityGroupsForSelectionDocument = gql`
    query GetFacilityGroupsForSelection($clientId: ID, $onlyAccessible: Boolean, $first: Int!, $after: String, $name: String) {
  facilityGroups(
    organizationId: $clientId
    onlyAccessible: $onlyAccessible
    first: $first
    after: $after
    nameOrFacilityName: $name
  ) {
    pageInfo {
      endCursor
    }
    edges {
      node {
        ...FacilityGroupForSelection
      }
    }
  }
}
    ${FacilityGroupForSelectionFragmentDoc}`;

/**
 * __useGetFacilityGroupsForSelectionQuery__
 *
 * To run a query within a React component, call `useGetFacilityGroupsForSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityGroupsForSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityGroupsForSelectionQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      onlyAccessible: // value for 'onlyAccessible'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFacilityGroupsForSelectionQuery(baseOptions: Apollo.QueryHookOptions<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>(GetFacilityGroupsForSelectionDocument, options);
      }
export function useGetFacilityGroupsForSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>(GetFacilityGroupsForSelectionDocument, options);
        }
export type GetFacilityGroupsForSelectionQueryHookResult = ReturnType<typeof useGetFacilityGroupsForSelectionQuery>;
export type GetFacilityGroupsForSelectionLazyQueryHookResult = ReturnType<typeof useGetFacilityGroupsForSelectionLazyQuery>;
export type GetFacilityGroupsForSelectionQueryResult = Apollo.QueryResult<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>;
export const GetInvitesDocument = gql`
    query GetInvites($clientId: ID!, $first: Int!, $skip: Int) {
  invites(organizationId: $clientId, first: $first, skip: $skip) {
    totalCount
    edges {
      node {
        ...InviteSummary
      }
    }
  }
}
    ${InviteSummaryFragmentDoc}`;

/**
 * __useGetInvitesQuery__
 *
 * To run a query within a React component, call `useGetInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetInvitesQueryNode, GetInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitesQueryNode, GetInvitesQueryVariables>(GetInvitesDocument, options);
      }
export function useGetInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitesQueryNode, GetInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitesQueryNode, GetInvitesQueryVariables>(GetInvitesDocument, options);
        }
export type GetInvitesQueryHookResult = ReturnType<typeof useGetInvitesQuery>;
export type GetInvitesLazyQueryHookResult = ReturnType<typeof useGetInvitesLazyQuery>;
export type GetInvitesQueryResult = Apollo.QueryResult<GetInvitesQueryNode, GetInvitesQueryVariables>;
export const GetInvoiceApprovalSettingsDocument = gql`
    query GetInvoiceApprovalSettings($clientId: ID!) {
  invoiceApprovalSettings(clientId: $clientId) {
    ...InvoiceApprovalSettings
  }
}
    ${InvoiceApprovalSettingsFragmentDoc}`;

/**
 * __useGetInvoiceApprovalSettingsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceApprovalSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceApprovalSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceApprovalSettingsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetInvoiceApprovalSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>(GetInvoiceApprovalSettingsDocument, options);
      }
export function useGetInvoiceApprovalSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>(GetInvoiceApprovalSettingsDocument, options);
        }
export type GetInvoiceApprovalSettingsQueryHookResult = ReturnType<typeof useGetInvoiceApprovalSettingsQuery>;
export type GetInvoiceApprovalSettingsLazyQueryHookResult = ReturnType<typeof useGetInvoiceApprovalSettingsLazyQuery>;
export type GetInvoiceApprovalSettingsQueryResult = Apollo.QueryResult<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>;
export const InvoicePaymentsPreviewDocument = gql`
    query InvoicePaymentsPreview($workOrderIds: [ID!]!) {
  invoicePaymentsPreview(workOrderIds: $workOrderIds) {
    total
    invoiceCount
    workOrderCount
    creditCardPreviews {
      total
      creditCardLastFour
      brand
      workOrders {
        id
        code
      }
      facilityPreviews {
        total
        invoiceCount
        workOrderCount
        facility {
          id
          name
        }
      }
    }
    eftPreviews {
      total
      accountNumberLastFour
      workOrders {
        id
        code
      }
      facilityPreviews {
        total
        invoiceCount
        workOrderCount
        facility {
          id
          name
        }
      }
    }
    achPreviews {
      total
      accountNumberLastFour
      workOrders {
        id
        code
      }
      facilityPreviews {
        total
        invoiceCount
        workOrderCount
        facility {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInvoicePaymentsPreviewQuery__
 *
 * To run a query within a React component, call `useInvoicePaymentsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePaymentsPreviewQuery({
 *   variables: {
 *      workOrderIds: // value for 'workOrderIds'
 *   },
 * });
 */
export function useInvoicePaymentsPreviewQuery(baseOptions: Apollo.QueryHookOptions<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>(InvoicePaymentsPreviewDocument, options);
      }
export function useInvoicePaymentsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>(InvoicePaymentsPreviewDocument, options);
        }
export type InvoicePaymentsPreviewQueryHookResult = ReturnType<typeof useInvoicePaymentsPreviewQuery>;
export type InvoicePaymentsPreviewLazyQueryHookResult = ReturnType<typeof useInvoicePaymentsPreviewLazyQuery>;
export type InvoicePaymentsPreviewQueryResult = Apollo.QueryResult<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>;
export const InvoicePaymentsPreviewPreEftDocument = gql`
    query InvoicePaymentsPreviewPreEFT($workOrderIds: [ID!]!) {
  invoicePaymentsPreview(workOrderIds: $workOrderIds) {
    total
    invoiceCount
    creditCardPreviews {
      total
      creditCardLastFour
      workOrders {
        id
        code
      }
      facilityPreviews {
        total
        invoiceCount
        facility {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInvoicePaymentsPreviewPreEftQuery__
 *
 * To run a query within a React component, call `useInvoicePaymentsPreviewPreEftQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentsPreviewPreEftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePaymentsPreviewPreEftQuery({
 *   variables: {
 *      workOrderIds: // value for 'workOrderIds'
 *   },
 * });
 */
export function useInvoicePaymentsPreviewPreEftQuery(baseOptions: Apollo.QueryHookOptions<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>(InvoicePaymentsPreviewPreEftDocument, options);
      }
export function useInvoicePaymentsPreviewPreEftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>(InvoicePaymentsPreviewPreEftDocument, options);
        }
export type InvoicePaymentsPreviewPreEftQueryHookResult = ReturnType<typeof useInvoicePaymentsPreviewPreEftQuery>;
export type InvoicePaymentsPreviewPreEftLazyQueryHookResult = ReturnType<typeof useInvoicePaymentsPreviewPreEftLazyQuery>;
export type InvoicePaymentsPreviewPreEftQueryResult = Apollo.QueryResult<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>;
export const GetMaintenancePlanDetailsDocument = gql`
    query GetMaintenancePlanDetails($id: ID!) {
  maintenancePlan(id: $id) {
    ...MaintenancePlanDetails
  }
}
    ${MaintenancePlanDetailsFragmentDoc}`;

/**
 * __useGetMaintenancePlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetMaintenancePlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenancePlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenancePlanDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaintenancePlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>(GetMaintenancePlanDetailsDocument, options);
      }
export function useGetMaintenancePlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>(GetMaintenancePlanDetailsDocument, options);
        }
export type GetMaintenancePlanDetailsQueryHookResult = ReturnType<typeof useGetMaintenancePlanDetailsQuery>;
export type GetMaintenancePlanDetailsLazyQueryHookResult = ReturnType<typeof useGetMaintenancePlanDetailsLazyQuery>;
export type GetMaintenancePlanDetailsQueryResult = Apollo.QueryResult<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>;
export const GetMaintenancePlanTypesDocument = gql`
    query GetMaintenancePlanTypes {
  maintenancePlanTypes {
    edges {
      node {
        ...MaintenancePlanTypeSummary
      }
    }
  }
}
    ${MaintenancePlanTypeSummaryFragmentDoc}`;

/**
 * __useGetMaintenancePlanTypesQuery__
 *
 * To run a query within a React component, call `useGetMaintenancePlanTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenancePlanTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenancePlanTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaintenancePlanTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>(GetMaintenancePlanTypesDocument, options);
      }
export function useGetMaintenancePlanTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>(GetMaintenancePlanTypesDocument, options);
        }
export type GetMaintenancePlanTypesQueryHookResult = ReturnType<typeof useGetMaintenancePlanTypesQuery>;
export type GetMaintenancePlanTypesLazyQueryHookResult = ReturnType<typeof useGetMaintenancePlanTypesLazyQuery>;
export type GetMaintenancePlanTypesQueryResult = Apollo.QueryResult<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>;
export const GetMaintenancePlansDocument = gql`
    query GetMaintenancePlans($clientId: ID!, $facilityGroupIds: [ID], $facilityId: ID, $maintenancePlanTypeIds: [ID!], $serviceCategories: [ServiceCategory], $first: Int!, $skip: Int) {
  maintenancePlans(
    organization: $clientId
    facilityGroupIds: $facilityGroupIds
    facilityId: $facilityId
    maintenancePlanType_In: $maintenancePlanTypeIds
    status: [ACTIVE]
    first: $first
    skip: $skip
    orderBy: "facility__name"
    serviceCategories: $serviceCategories
  ) {
    totalCount
    edges {
      node {
        ...MaintenancePlanSummary
      }
    }
  }
}
    ${MaintenancePlanSummaryFragmentDoc}`;

/**
 * __useGetMaintenancePlansQuery__
 *
 * To run a query within a React component, call `useGetMaintenancePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenancePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenancePlansQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      facilityId: // value for 'facilityId'
 *      maintenancePlanTypeIds: // value for 'maintenancePlanTypeIds'
 *      serviceCategories: // value for 'serviceCategories'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetMaintenancePlansQuery(baseOptions: Apollo.QueryHookOptions<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>(GetMaintenancePlansDocument, options);
      }
export function useGetMaintenancePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>(GetMaintenancePlansDocument, options);
        }
export type GetMaintenancePlansQueryHookResult = ReturnType<typeof useGetMaintenancePlansQuery>;
export type GetMaintenancePlansLazyQueryHookResult = ReturnType<typeof useGetMaintenancePlansLazyQuery>;
export type GetMaintenancePlansQueryResult = Apollo.QueryResult<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>;
export const GetManufacturersDocument = gql`
    query GetManufacturers($first: Int, $query: String) {
  equipmentManufacturers(first: $first, query: $query) {
    totalCount
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetManufacturersQuery__
 *
 * To run a query within a React component, call `useGetManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetManufacturersQuery(baseOptions?: Apollo.QueryHookOptions<GetManufacturersQueryNode, GetManufacturersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManufacturersQueryNode, GetManufacturersQueryVariables>(GetManufacturersDocument, options);
      }
export function useGetManufacturersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturersQueryNode, GetManufacturersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManufacturersQueryNode, GetManufacturersQueryVariables>(GetManufacturersDocument, options);
        }
export type GetManufacturersQueryHookResult = ReturnType<typeof useGetManufacturersQuery>;
export type GetManufacturersLazyQueryHookResult = ReturnType<typeof useGetManufacturersLazyQuery>;
export type GetManufacturersQueryResult = Apollo.QueryResult<GetManufacturersQueryNode, GetManufacturersQueryVariables>;
export const GetNotificationPreferencesDocument = gql`
    query GetNotificationPreferences($userId: ID) {
  notificationPreferences(userId: $userId) {
    totalCount
    edges {
      node {
        ...NotificationPreferenceSummary
      }
    }
  }
}
    ${NotificationPreferenceSummaryFragmentDoc}`;

/**
 * __useGetNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationPreferencesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationPreferencesQueryNode, GetNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationPreferencesQueryNode, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
      }
export function useGetNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationPreferencesQueryNode, GetNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationPreferencesQueryNode, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
        }
export type GetNotificationPreferencesQueryHookResult = ReturnType<typeof useGetNotificationPreferencesQuery>;
export type GetNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetNotificationPreferencesLazyQuery>;
export type GetNotificationPreferencesQueryResult = Apollo.QueryResult<GetNotificationPreferencesQueryNode, GetNotificationPreferencesQueryVariables>;
export const GetOvertimeStatusDocument = gql`
    query GetOvertimeStatus($facilityId: ID!) {
  overtimeStatus(facilityId: $facilityId) {
    isOvertime
  }
}
    `;

/**
 * __useGetOvertimeStatusQuery__
 *
 * To run a query within a React component, call `useGetOvertimeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOvertimeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOvertimeStatusQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetOvertimeStatusQuery(baseOptions: Apollo.QueryHookOptions<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>(GetOvertimeStatusDocument, options);
      }
export function useGetOvertimeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>(GetOvertimeStatusDocument, options);
        }
export type GetOvertimeStatusQueryHookResult = ReturnType<typeof useGetOvertimeStatusQuery>;
export type GetOvertimeStatusLazyQueryHookResult = ReturnType<typeof useGetOvertimeStatusLazyQuery>;
export type GetOvertimeStatusQueryResult = Apollo.QueryResult<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>;
export const GetPaymentMethodsDocument = gql`
    query GetPaymentMethods($organizationId: ID!, $first: Int, $skip: Int) {
  paymentMethods(organizationId: $organizationId, first: $first, skip: $skip) {
    totalCount
    edges {
      node {
        ...PaymentMethodSummary
      }
    }
  }
}
    ${PaymentMethodSummaryFragmentDoc}`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>;
export const GetProvincesDocument = gql`
    query GetProvinces($countryId: ID!) {
  provinces(country: $countryId, orderBy: "name") {
    edges {
      node {
        ...ProvinceSummary
      }
    }
  }
}
    ${ProvinceSummaryFragmentDoc}`;

/**
 * __useGetProvincesQuery__
 *
 * To run a query within a React component, call `useGetProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvincesQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetProvincesQuery(baseOptions: Apollo.QueryHookOptions<GetProvincesQueryNode, GetProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvincesQueryNode, GetProvincesQueryVariables>(GetProvincesDocument, options);
      }
export function useGetProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvincesQueryNode, GetProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvincesQueryNode, GetProvincesQueryVariables>(GetProvincesDocument, options);
        }
export type GetProvincesQueryHookResult = ReturnType<typeof useGetProvincesQuery>;
export type GetProvincesLazyQueryHookResult = ReturnType<typeof useGetProvincesLazyQuery>;
export type GetProvincesQueryResult = Apollo.QueryResult<GetProvincesQueryNode, GetProvincesQueryVariables>;
export const GetQuoteAcceptanceSettingsDocument = gql`
    query GetQuoteAcceptanceSettings($clientId: ID!) {
  quoteAcceptanceSettings(clientId: $clientId) {
    ...QuoteAcceptanceSettings
  }
}
    ${QuoteAcceptanceSettingsFragmentDoc}`;

/**
 * __useGetQuoteAcceptanceSettingsQuery__
 *
 * To run a query within a React component, call `useGetQuoteAcceptanceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteAcceptanceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteAcceptanceSettingsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetQuoteAcceptanceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>(GetQuoteAcceptanceSettingsDocument, options);
      }
export function useGetQuoteAcceptanceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>(GetQuoteAcceptanceSettingsDocument, options);
        }
export type GetQuoteAcceptanceSettingsQueryHookResult = ReturnType<typeof useGetQuoteAcceptanceSettingsQuery>;
export type GetQuoteAcceptanceSettingsLazyQueryHookResult = ReturnType<typeof useGetQuoteAcceptanceSettingsLazyQuery>;
export type GetQuoteAcceptanceSettingsQueryResult = Apollo.QueryResult<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>;
export const GetQuoteApprovalThresholdsDocument = gql`
    query GetQuoteApprovalThresholds($clientId: ID!, $roleIds: [ID!], $threshold: Decimal) {
  quoteApprovalThresholds(
    clientId: $clientId
    roleIds: $roleIds
    threshold: $threshold
  ) {
    edges {
      node {
        ...QuoteApprovalThresholdSummary
      }
    }
  }
}
    ${QuoteApprovalThresholdSummaryFragmentDoc}`;

/**
 * __useGetQuoteApprovalThresholdsQuery__
 *
 * To run a query within a React component, call `useGetQuoteApprovalThresholdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteApprovalThresholdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteApprovalThresholdsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      roleIds: // value for 'roleIds'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useGetQuoteApprovalThresholdsQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>(GetQuoteApprovalThresholdsDocument, options);
      }
export function useGetQuoteApprovalThresholdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>(GetQuoteApprovalThresholdsDocument, options);
        }
export type GetQuoteApprovalThresholdsQueryHookResult = ReturnType<typeof useGetQuoteApprovalThresholdsQuery>;
export type GetQuoteApprovalThresholdsLazyQueryHookResult = ReturnType<typeof useGetQuoteApprovalThresholdsLazyQuery>;
export type GetQuoteApprovalThresholdsQueryResult = Apollo.QueryResult<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>;
export const GetQuoteSetsDocument = gql`
    query GetQuoteSets($workOrderId: ID!, $statuses: [QuoteSetStatus!]!) {
  quoteSets(workOrderId: $workOrderId, statuses: $statuses) {
    edges {
      node {
        ...QuoteSetDetails
      }
    }
  }
}
    ${QuoteSetDetailsFragmentDoc}`;

/**
 * __useGetQuoteSetsQuery__
 *
 * To run a query within a React component, call `useGetQuoteSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteSetsQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetQuoteSetsQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>(GetQuoteSetsDocument, options);
      }
export function useGetQuoteSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>(GetQuoteSetsDocument, options);
        }
export type GetQuoteSetsQueryHookResult = ReturnType<typeof useGetQuoteSetsQuery>;
export type GetQuoteSetsLazyQueryHookResult = ReturnType<typeof useGetQuoteSetsLazyQuery>;
export type GetQuoteSetsQueryResult = Apollo.QueryResult<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>;
export const GetReviewRequestsDocument = gql`
    query GetReviewRequests($workOrder: ID, $statusIn: [ReviewRequestStatus!], $orderBy: String, $isDueForReminder: Boolean) {
  reviewRequests(
    workOrder: $workOrder
    statusIn: $statusIn
    orderBy: $orderBy
    isDueForReminder: $isDueForReminder
  ) {
    edges {
      node {
        ...ReviewRequest
      }
    }
  }
}
    ${ReviewRequestFragmentDoc}`;

/**
 * __useGetReviewRequestsQuery__
 *
 * To run a query within a React component, call `useGetReviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewRequestsQuery({
 *   variables: {
 *      workOrder: // value for 'workOrder'
 *      statusIn: // value for 'statusIn'
 *      orderBy: // value for 'orderBy'
 *      isDueForReminder: // value for 'isDueForReminder'
 *   },
 * });
 */
export function useGetReviewRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>(GetReviewRequestsDocument, options);
      }
export function useGetReviewRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>(GetReviewRequestsDocument, options);
        }
export type GetReviewRequestsQueryHookResult = ReturnType<typeof useGetReviewRequestsQuery>;
export type GetReviewRequestsLazyQueryHookResult = ReturnType<typeof useGetReviewRequestsLazyQuery>;
export type GetReviewRequestsQueryResult = Apollo.QueryResult<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>;
export const GetRoleDetailsDocument = gql`
    query GetRoleDetails($roleId: ID!) {
  role(id: $roleId) {
    ...RoleDetails
  }
}
    ${RoleDetailsFragmentDoc}`;

/**
 * __useGetRoleDetailsQuery__
 *
 * To run a query within a React component, call `useGetRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleDetailsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRoleDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>(GetRoleDetailsDocument, options);
      }
export function useGetRoleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>(GetRoleDetailsDocument, options);
        }
export type GetRoleDetailsQueryHookResult = ReturnType<typeof useGetRoleDetailsQuery>;
export type GetRoleDetailsLazyQueryHookResult = ReturnType<typeof useGetRoleDetailsLazyQuery>;
export type GetRoleDetailsQueryResult = Apollo.QueryResult<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles($clientId: ID!, $first: Int, $skip: Int, $onlySubsetOfUser: Boolean) {
  roles(
    organizationId: $clientId
    first: $first
    skip: $skip
    onlySubsetOfUser: $onlySubsetOfUser
  ) {
    totalCount
    edges {
      node {
        ...RoleSummary
      }
    }
  }
}
    ${RoleSummaryFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      onlySubsetOfUser: // value for 'onlySubsetOfUser'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQueryNode, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQueryNode, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQueryNode, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQueryNode, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQueryNode, GetRolesQueryVariables>;
export const GetSourcingPartsHoldsDocument = gql`
    query GetSourcingPartsHolds($workOrder: ID!) {
  sourcingPartsHolds(workOrder: $workOrder) {
    edges {
      node {
        id
        permissions {
          fulfill
        }
        vendor {
          id
          name
        }
        partsEstimatedDateStart
        partsEstimatedDateEnd
      }
    }
  }
}
    `;

/**
 * __useGetSourcingPartsHoldsQuery__
 *
 * To run a query within a React component, call `useGetSourcingPartsHoldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingPartsHoldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingPartsHoldsQuery({
 *   variables: {
 *      workOrder: // value for 'workOrder'
 *   },
 * });
 */
export function useGetSourcingPartsHoldsQuery(baseOptions: Apollo.QueryHookOptions<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>(GetSourcingPartsHoldsDocument, options);
      }
export function useGetSourcingPartsHoldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>(GetSourcingPartsHoldsDocument, options);
        }
export type GetSourcingPartsHoldsQueryHookResult = ReturnType<typeof useGetSourcingPartsHoldsQuery>;
export type GetSourcingPartsHoldsLazyQueryHookResult = ReturnType<typeof useGetSourcingPartsHoldsLazyQuery>;
export type GetSourcingPartsHoldsQueryResult = Apollo.QueryResult<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>;
export const GetStripeCustomersDocument = gql`
    query GetStripeCustomers($organizationId: ID) {
  stripeCustomers(organizationId: $organizationId) {
    edges {
      node {
        id
        account
      }
    }
  }
}
    `;

/**
 * __useGetStripeCustomersQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetStripeCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>(GetStripeCustomersDocument, options);
      }
export function useGetStripeCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>(GetStripeCustomersDocument, options);
        }
export type GetStripeCustomersQueryHookResult = ReturnType<typeof useGetStripeCustomersQuery>;
export type GetStripeCustomersLazyQueryHookResult = ReturnType<typeof useGetStripeCustomersLazyQuery>;
export type GetStripeCustomersQueryResult = Apollo.QueryResult<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!) {
  user(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQueryNode, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQueryNode, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQueryNode, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQueryNode, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQueryNode, GetUserQueryVariables>;
export const GetUserNotificationPreferencesDocument = gql`
    query GetUserNotificationPreferences {
  userNotificationPreferences {
    totalCount
    edges {
      node {
        id
        notificationName
        email
        push
        sms
        emailConfigurable
        pushConfigurable
        smsConfigurable
        emailImplemented
        pushImplemented
        smsImplemented
      }
    }
  }
}
    `;

/**
 * __useGetUserNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>(GetUserNotificationPreferencesDocument, options);
      }
export function useGetUserNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>(GetUserNotificationPreferencesDocument, options);
        }
export type GetUserNotificationPreferencesQueryHookResult = ReturnType<typeof useGetUserNotificationPreferencesQuery>;
export type GetUserNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserNotificationPreferencesLazyQuery>;
export type GetUserNotificationPreferencesQueryResult = Apollo.QueryResult<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>;
export const GetUserSummaryDocument = gql`
    query GetUserSummary($id: ID!) {
  user(id: $id) {
    ...UserSummary
  }
}
    ${UserSummaryFragmentDoc}`;

/**
 * __useGetUserSummaryQuery__
 *
 * To run a query within a React component, call `useGetUserSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>(GetUserSummaryDocument, options);
      }
export function useGetUserSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>(GetUserSummaryDocument, options);
        }
export type GetUserSummaryQueryHookResult = ReturnType<typeof useGetUserSummaryQuery>;
export type GetUserSummaryLazyQueryHookResult = ReturnType<typeof useGetUserSummaryLazyQuery>;
export type GetUserSummaryQueryResult = Apollo.QueryResult<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>;
export const GetVisitReviewRequestsDocument = gql`
    query GetVisitReviewRequests($appointment: ID, $statusIn: [VisitReviewRequestStatus!], $orderBy: String) {
  visitReviewRequests(
    appointment: $appointment
    statusIn: $statusIn
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...VisitReviewRequest
      }
    }
  }
}
    ${VisitReviewRequestFragmentDoc}`;

/**
 * __useGetVisitReviewRequestsQuery__
 *
 * To run a query within a React component, call `useGetVisitReviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitReviewRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitReviewRequestsQuery({
 *   variables: {
 *      appointment: // value for 'appointment'
 *      statusIn: // value for 'statusIn'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetVisitReviewRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>(GetVisitReviewRequestsDocument, options);
      }
export function useGetVisitReviewRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>(GetVisitReviewRequestsDocument, options);
        }
export type GetVisitReviewRequestsQueryHookResult = ReturnType<typeof useGetVisitReviewRequestsQuery>;
export type GetVisitReviewRequestsLazyQueryHookResult = ReturnType<typeof useGetVisitReviewRequestsLazyQuery>;
export type GetVisitReviewRequestsQueryResult = Apollo.QueryResult<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>;
export const GetVisitsDocument = gql`
    query GetVisits($workOrder: ID!, $orderBy: String) {
  visits(workOrder: $workOrder, orderBy: $orderBy) {
    edges {
      node {
        id
        vendor {
          id
          name
        }
        appointment {
          id
          startsAt
          endsAt
        }
        startedAt
        endedAt
        visitedBy {
          ...UserSummary
        }
        facilityManagerName
        notes
        recommendations
        beforeImages {
          id
          url
        }
        afterImages {
          id
          url
        }
        outcome
      }
    }
  }
}
    ${UserSummaryFragmentDoc}`;

/**
 * __useGetVisitsQuery__
 *
 * To run a query within a React component, call `useGetVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitsQuery({
 *   variables: {
 *      workOrder: // value for 'workOrder'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetVisitsQuery(baseOptions: Apollo.QueryHookOptions<GetVisitsQueryNode, GetVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitsQueryNode, GetVisitsQueryVariables>(GetVisitsDocument, options);
      }
export function useGetVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitsQueryNode, GetVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitsQueryNode, GetVisitsQueryVariables>(GetVisitsDocument, options);
        }
export type GetVisitsQueryHookResult = ReturnType<typeof useGetVisitsQuery>;
export type GetVisitsLazyQueryHookResult = ReturnType<typeof useGetVisitsLazyQuery>;
export type GetVisitsQueryResult = Apollo.QueryResult<GetVisitsQueryNode, GetVisitsQueryVariables>;
export const GetWorkOrderActivitiesDocument = gql`
    query GetWorkOrderActivities($workOrderId: ID!) {
  activities(
    workOrderId: $workOrderId
    orderBy: "-started_at"
    first: 100
    skip: 0
  ) {
    edges {
      node {
        id
        activityType
        startedAt
        endedAt
        cancelledAt
        dueAt
        ... on ResqReviewActivity {
          reviewType
        }
        ... on AppointmentActivity {
          appointment {
            ...AppointmentSummary
          }
        }
      }
    }
  }
}
    ${AppointmentSummaryFragmentDoc}`;

/**
 * __useGetWorkOrderActivitiesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderActivitiesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetWorkOrderActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>(GetWorkOrderActivitiesDocument, options);
      }
export function useGetWorkOrderActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>(GetWorkOrderActivitiesDocument, options);
        }
export type GetWorkOrderActivitiesQueryHookResult = ReturnType<typeof useGetWorkOrderActivitiesQuery>;
export type GetWorkOrderActivitiesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderActivitiesLazyQuery>;
export type GetWorkOrderActivitiesQueryResult = Apollo.QueryResult<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>;
export const GetWorkOrderCancellationDetailDocument = gql`
    query getWorkOrderCancellationDetail($workOrderId: ID!) {
  workOrderCancellationDetail(workOrder: $workOrderId) {
    edges {
      node {
        id
        cancelReason
      }
    }
  }
}
    `;

/**
 * __useGetWorkOrderCancellationDetailQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderCancellationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderCancellationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderCancellationDetailQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetWorkOrderCancellationDetailQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>(GetWorkOrderCancellationDetailDocument, options);
      }
export function useGetWorkOrderCancellationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>(GetWorkOrderCancellationDetailDocument, options);
        }
export type GetWorkOrderCancellationDetailQueryHookResult = ReturnType<typeof useGetWorkOrderCancellationDetailQuery>;
export type GetWorkOrderCancellationDetailLazyQueryHookResult = ReturnType<typeof useGetWorkOrderCancellationDetailLazyQuery>;
export type GetWorkOrderCancellationDetailQueryResult = Apollo.QueryResult<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>;
export const GetWorkOrderClientInvoicesDocument = gql`
    query GetWorkOrderClientInvoices($workOrderId: ID!) {
  clientInvoices(workOrderId: $workOrderId) {
    edges {
      node {
        ...ClientInvoiceSummary
      }
    }
  }
}
    ${ClientInvoiceSummaryFragmentDoc}`;

/**
 * __useGetWorkOrderClientInvoicesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderClientInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderClientInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderClientInvoicesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetWorkOrderClientInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>(GetWorkOrderClientInvoicesDocument, options);
      }
export function useGetWorkOrderClientInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>(GetWorkOrderClientInvoicesDocument, options);
        }
export type GetWorkOrderClientInvoicesQueryHookResult = ReturnType<typeof useGetWorkOrderClientInvoicesQuery>;
export type GetWorkOrderClientInvoicesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderClientInvoicesLazyQuery>;
export type GetWorkOrderClientInvoicesQueryResult = Apollo.QueryResult<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>;
export const GetWorkOrderDetailsDocument = gql`
    query GetWorkOrderDetails($workOrderId: ID!) {
  workOrder(id: $workOrderId) {
    ...WorkOrderDetails
  }
  clientInvoices(workOrderId: $workOrderId) {
    edges {
      node {
        ...ClientInvoiceSummary
      }
    }
  }
  spendApprovalOnWorkOrder(workOrderId: $workOrderId) {
    ...SpendApproval
  }
}
    ${WorkOrderDetailsFragmentDoc}
${ClientInvoiceSummaryFragmentDoc}
${SpendApprovalFragmentDoc}`;

/**
 * __useGetWorkOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderDetailsQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetWorkOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderDetailsQueryNode, GetWorkOrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderDetailsQueryNode, GetWorkOrderDetailsQueryVariables>(GetWorkOrderDetailsDocument, options);
      }
export function useGetWorkOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderDetailsQueryNode, GetWorkOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderDetailsQueryNode, GetWorkOrderDetailsQueryVariables>(GetWorkOrderDetailsDocument, options);
        }
export type GetWorkOrderDetailsQueryHookResult = ReturnType<typeof useGetWorkOrderDetailsQuery>;
export type GetWorkOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderDetailsLazyQuery>;
export type GetWorkOrderDetailsQueryResult = Apollo.QueryResult<GetWorkOrderDetailsQueryNode, GetWorkOrderDetailsQueryVariables>;
export const GetWorkOrderReviewFeedbackItemsDocument = gql`
    query GetWorkOrderReviewFeedbackItems {
  workOrderReviewFeedback {
    edges {
      node {
        ...ReviewFeedback
      }
    }
  }
}
    ${ReviewFeedbackFragmentDoc}`;

/**
 * __useGetWorkOrderReviewFeedbackItemsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderReviewFeedbackItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderReviewFeedbackItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderReviewFeedbackItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkOrderReviewFeedbackItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>(GetWorkOrderReviewFeedbackItemsDocument, options);
      }
export function useGetWorkOrderReviewFeedbackItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>(GetWorkOrderReviewFeedbackItemsDocument, options);
        }
export type GetWorkOrderReviewFeedbackItemsQueryHookResult = ReturnType<typeof useGetWorkOrderReviewFeedbackItemsQuery>;
export type GetWorkOrderReviewFeedbackItemsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderReviewFeedbackItemsLazyQuery>;
export type GetWorkOrderReviewFeedbackItemsQueryResult = Apollo.QueryResult<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>;
export const GetWorkOrderSummaryDocument = gql`
    query GetWorkOrderSummary($workOrderId: ID!) {
  workOrder(id: $workOrderId) {
    ...WorkOrderSummary
    vendor {
      id
      profile {
        id
        phone
      }
    }
  }
}
    ${WorkOrderSummaryFragmentDoc}`;

/**
 * __useGetWorkOrderSummaryQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderSummaryQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetWorkOrderSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>(GetWorkOrderSummaryDocument, options);
      }
export function useGetWorkOrderSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>(GetWorkOrderSummaryDocument, options);
        }
export type GetWorkOrderSummaryQueryHookResult = ReturnType<typeof useGetWorkOrderSummaryQuery>;
export type GetWorkOrderSummaryLazyQueryHookResult = ReturnType<typeof useGetWorkOrderSummaryLazyQuery>;
export type GetWorkOrderSummaryQueryResult = Apollo.QueryResult<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>;
export const GetWorkOrderVendorsDocument = gql`
    query GetWorkOrderVendors($skip: Int, $clientId: ID!) {
  workOrders(skip: $skip, facility_Organization: $clientId) {
    totalCount
    edges {
      node {
        vendor {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkOrderVendorsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderVendorsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetWorkOrderVendorsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>(GetWorkOrderVendorsDocument, options);
      }
export function useGetWorkOrderVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>(GetWorkOrderVendorsDocument, options);
        }
export type GetWorkOrderVendorsQueryHookResult = ReturnType<typeof useGetWorkOrderVendorsQuery>;
export type GetWorkOrderVendorsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderVendorsLazyQuery>;
export type GetWorkOrderVendorsQueryResult = Apollo.QueryResult<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>;
export const GetWorkOrdersDocument = gql`
    query GetWorkOrders($first: Int!, $skip: Int, $query: String = "", $clientId: ID!, $status: [ClientWorkOrderStatus!], $onHold: Boolean, $holdReason: [WorkOrderHoldReason!], $orderBy: String, $startDate: Date, $endDate: Date, $equipment: ID, $facilityGroupIds: [ID], $facility: ID, $serviceCategory: [ServiceCategory!], $isMaintenancePlan: Boolean, $isCancelled: Boolean, $isSatisfied: Boolean, $completedOnStartDate: Date, $completedOnEndDate: Date, $raisedOnStartDate: Date, $raisedOnEndDate: Date, $assignedVendorIds: [ID], $assignedUserIds: [ID], $overtimeApproved: Boolean, $hasActionableQuoteForClient: ID, $expectedServiceTimeline: [ExpectedServiceTimeline!]) {
  workOrders(
    first: $first
    skip: $skip
    query: $query
    facility_Organization: $clientId
    clientStatus_In: $status
    onHold: $onHold
    holdReason_In: $holdReason
    orderBy: $orderBy
    facility: $facility
    scheduledForEnd: $endDate
    scheduledForStart: $startDate
    equipment: $equipment
    facilityGroupIds: $facilityGroupIds
    serviceCategory: $serviceCategory
    isMaintenancePlan: $isMaintenancePlan
    isCancelled: $isCancelled
    isSatisfied: $isSatisfied
    completedOnStartDate: $completedOnStartDate
    completedOnEndDate: $completedOnEndDate
    raisedOnStartDate: $raisedOnStartDate
    raisedOnEndDate: $raisedOnEndDate
    assignedVendorIds: $assignedVendorIds
    assignedUserIds: $assignedUserIds
    overtimeApproved: $overtimeApproved
    hasActionableQuoteForClient: $hasActionableQuoteForClient
    expectedServiceTimeline_In: $expectedServiceTimeline
  ) {
    totalCount
    edges {
      node {
        ...WorkOrderSummary
      }
    }
  }
}
    ${WorkOrderSummaryFragmentDoc}`;

/**
 * __useGetWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      clientId: // value for 'clientId'
 *      status: // value for 'status'
 *      onHold: // value for 'onHold'
 *      holdReason: // value for 'holdReason'
 *      orderBy: // value for 'orderBy'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      equipment: // value for 'equipment'
 *      facilityGroupIds: // value for 'facilityGroupIds'
 *      facility: // value for 'facility'
 *      serviceCategory: // value for 'serviceCategory'
 *      isMaintenancePlan: // value for 'isMaintenancePlan'
 *      isCancelled: // value for 'isCancelled'
 *      isSatisfied: // value for 'isSatisfied'
 *      completedOnStartDate: // value for 'completedOnStartDate'
 *      completedOnEndDate: // value for 'completedOnEndDate'
 *      raisedOnStartDate: // value for 'raisedOnStartDate'
 *      raisedOnEndDate: // value for 'raisedOnEndDate'
 *      assignedVendorIds: // value for 'assignedVendorIds'
 *      assignedUserIds: // value for 'assignedUserIds'
 *      overtimeApproved: // value for 'overtimeApproved'
 *      hasActionableQuoteForClient: // value for 'hasActionableQuoteForClient'
 *      expectedServiceTimeline: // value for 'expectedServiceTimeline'
 *   },
 * });
 */
export function useGetWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
      }
export function useGetWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
        }
export type GetWorkOrdersQueryHookResult = ReturnType<typeof useGetWorkOrdersQuery>;
export type GetWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersLazyQuery>;
export type GetWorkOrdersQueryResult = Apollo.QueryResult<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>;
export const GetFeatureFlagsDocument = gql`
    query GetFeatureFlags($facilityId: ID, $organizationId: ID) {
  featureFlags(facilityId: $facilityId, organizationId: $organizationId)
}
    `;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    ...SessionDetails
  }
  realMe {
    ...RealSessionDetails
  }
}
    ${SessionDetailsFragmentDoc}
${RealSessionDetailsFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQueryNode, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQueryNode, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQueryNode, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQueryNode, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQueryNode, GetMeQueryVariables>;
export const GetSchemaHashDocument = gql`
    query GetSchemaHash {
  schemaHash
}
    `;

/**
 * __useGetSchemaHashQuery__
 *
 * To run a query within a React component, call `useGetSchemaHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemaHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchemaHashQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchemaHashQuery(baseOptions?: Apollo.QueryHookOptions<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>(GetSchemaHashDocument, options);
      }
export function useGetSchemaHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>(GetSchemaHashDocument, options);
        }
export type GetSchemaHashQueryHookResult = ReturnType<typeof useGetSchemaHashQuery>;
export type GetSchemaHashLazyQueryHookResult = ReturnType<typeof useGetSchemaHashLazyQuery>;
export type GetSchemaHashQueryResult = Apollo.QueryResult<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>;